import { notebookTr } from './notebook.tr.js';
/**
 * Turkish catalog and the catalog types. `tr` is the source of truth for keys; every other locale must provide the
 * same keys (enforced by the type and by a test). Plural forms use Intl.PluralRules categories.
 */

export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };
export type Entry = string | PluralForms;

export const tr = {
  ...notebookTr,
  'app.loading': 'Yükleniyor…',
  'nav.messages': 'Mesajlar',
  'nav.unreadChats': { one: '{count} okunmamış sohbet', other: '{count} okunmamış sohbet' },
  'nav.newRequests': { one: '{count} yeni istek', other: '{count} yeni istek' },
  'nav.somethingNew': 'yeni',
  'chat.listMenu': 'Sohbet listesi menüsü',
  'notifications.offBanner': 'Mesaj ve arama bildirimleri kapalı.',
  'notifications.turnOn': 'Aç',
  'nav.calls': 'Aramalar',
  'nav.spaces': 'Alanlar',
  'nav.discover': 'Keşfet',
  'nav.ai': 'Yapay Zekâ',
  'nav.settings': 'Ayarlar',
  'nav.you': 'Siz',
  'shell.moreSections': 'Diğer bölümler',
  'update.ready': 'Yeni sürüm hazır.',
  'update.reload': 'Yenile',
  'auth.login.title': 'Giriş yap',
  'auth.register.title': 'Hesap oluştur',
  'auth.identifier': 'E-posta veya kullanıcı adı',
  'auth.email': 'E-posta',
  'auth.username': 'Kullanıcı adı',
  'auth.password': 'Parola',
  'auth.showPassword': 'Parolayı göster',
  'auth.hidePassword': 'Parolayı gizle',
  'auth.passwordHint': 'En az 10 karakter',
  'auth.displayName': 'Görünen ad',
  'auth.birthDate': 'Doğum tarihi',
  'auth.birthDateHint': 'Yaşına uygun güvenlik ayarlarını belirlemek için kullanılır; profilinde gösterilmez.',
  'auth.day': 'Gün',
  'auth.month': 'Ay',
  'auth.year': 'Yıl',
  'auth.country': 'Ülke',
  'auth.acceptTerms': 'Kullanım koşullarını ve gizlilik bildirimini okudum, kabul ediyorum.',
  'auth.acceptTermsStart': '',
  'auth.termsLink': 'Kullanım Koşulları',
  'auth.acceptTermsAnd': 'ile',
  'auth.privacyLink': 'Gizlilik Bildirimi',
  'auth.acceptTermsEnd': '’ni okudum, kabul ediyorum.',
  'auth.acceptFirst': 'Devam etmek için koşulları kabul et.',
  'auth.emailSuggest': 'Bunu mu demek istedin?',
  'admin.email.fix': 'E-postayı düzelt',
  'admin.email.new': 'Yeni e-posta adresi',
  'admin.email.save': 'Kaydet ve doğrulama gönder',
  'admin.email.changed': '{name} için e-posta {email} olarak düzeltildi; doğrulama e-postası gönderildi.',
  'admin.email.typo': 'Yazım hatası olabilir: {email}?',
  'auth.registering': 'Hesabın oluşturuluyor…',
  'auth.submitLogin': 'Giriş yap',
  'auth.submitRegister': 'Hesap oluştur',
  'auth.noAccount': 'Hesabın yok mu?',
  'auth.haveAccount': 'Zaten hesabın var mı?',
  'auth.logout': 'Çıkış yap',
  'auth.or': 'veya',
  'auth.forgotLink': 'Parolamı unuttum',
  'auth.forgot.title': 'Parolanı sıfırla',
  'auth.forgot.body': 'Hesabının e-posta adresini yaz. Bir hesap varsa sıfırlama bağlantısı göndereceğiz.',
  'auth.forgot.submit': 'Bağlantı gönder',
  'auth.forgot.sent': 'Bu adrese kayıtlı bir hesap varsa sıfırlama bağlantısı gönderildi. Bağlantı 30 dakika geçerli.',
  'auth.reset.title': 'Yeni parola belirle',
  'auth.reset.newPassword': 'Yeni parola',
  'auth.reset.submit': 'Parolayı değiştir',
  'auth.reset.done': 'Parolan değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Yeni parolanla giriş yapabilirsin.',
  'reset.steps': 'Adımlar',
  'reset.step1': 'Hesabını bul',
  'reset.step2': 'Kodu gir',
  'reset.step3': 'Tamam',
  'reset.intro': 'Kayıtlı e-posta adresini ya da kullanıcı adını yaz; sana 6 haneli bir kod ve bağlantı gönderelim.',
  'reset.sendCode': 'Kod gönder',
  'reset.privacy': 'Güvenliğin için hesap olup olmadığını söylemeyiz; kod yalnızca hesabın kayıtlı e-posta adresine gider.',
  'reset.codeTitle': 'Kodu gir, yeni parolanı belirle',
  'reset.sent': '"{login}" bir hesaba aitse kayıtlı e-posta adresine 6 haneli bir kod gönderdik. Kod 30 dakika geçerli. Gelen kutunda yoksa Spam / Gereksiz klasörüne bak.',
  'reset.code': 'E-postadaki 6 haneli kod',
  'reset.noMail': 'E-posta gelmedi mi?',
  'reset.resend': 'Tekrar gönder',
  'reset.resendIn': '{seconds} sn sonra tekrar gönder',
  'reset.otherAccount': 'Başka bir adres ya da kullanıcı adı dene',
  'reset.remembered': 'Parolanı hatırladın mı?',
  'reset.doneTitle': 'Parolan yenilendi',
  'reset.toLogin': 'Giriş yap',
  'reset.linkIntro': 'Yeni parolanı belirle; bütün cihazlarda oturumların kapanır.',
  'reset.linkBroken': 'Bu bağlantı açılamadı: süresi dolmuş, kullanılmış ya da e-posta programın bağlantıyı bozmuş olabilir. Yeni bir kod isteyebilirsin.',
  'reset.startAgain': 'Yeni kod iste',
  'reset.strength.0': 'Çok kısa',
  'reset.strength.1': 'Zayıf',
  'reset.strength.2': 'Orta',
  'reset.strength.3': 'İyi',
  'reset.strength.4': 'Güçlü',
  'reset.tip.length': 'en az 10 karakter',
  'reset.tip.mix': 'büyük ve küçük harf karıştır',
  'reset.tip.digit': 'bir rakam ekle',
  'reset.tip.symbol': 'bir işaret ekle (!, ?, -)',
  'mail.reset.codeLabel': 'Uygulamada bu kodu girerek de parolanı sıfırlayabilirsin:',
  'auth.verify.title': 'E-posta doğrulama',
  'auth.verify.ready': 'Hesabının e-posta adresini doğrulamak için aşağıdaki düğmeye bas.',
  'auth.verify.button': 'E-postamı doğrula',
  'auth.verify.sent': 'Yeni bağlantı e-posta adresine gönderildi. En son gelen e-postadaki bağlantıyı kullan.',
  'auth.verify.missing': 'Bağlantı eksik açıldı: e-posta programı bağlantının bir kısmını kesmiş olabilir. E-postadaki “E-postamı doğrula” bağlantısını uzun basıp kopyalayarak tarayıcıya yapıştır ya da giriş yapıp yeni bağlantı iste.',
  'auth.verify.working': 'Doğrulanıyor…',
  'auth.verify.success': 'E-posta adresin doğrulandı.',
  'auth.verify.continue': 'Uygulamaya dön',
  'auth.passkey.login': 'Passkey ile giriş yap',
  'auth.passkey.unsupported': 'Bu tarayıcı passkey desteklemiyor.',
  'auth.passkey.cancelled': 'Passkey işlemi iptal edildi.',
  'banner.emailUnverified': 'E-posta adresini doğrula: {email}',
  'banner.resend': 'Bağlantıyı tekrar gönder',
  'banner.resent': 'Doğrulama bağlantısı gönderildi.',
  'emailCode.label': 'E-postadaki 6 haneli kodu gir',
  'emailCode.verify': 'Doğrula',
  'passkeys.title': 'Passkey’ler',
  'passkeys.body': 'Parola yerine cihazının kilidiyle (parmak izi, yüz, PIN) giriş yap.',
  'passkeys.add': 'Passkey ekle',
  'passkeys.empty': 'Henüz passkey eklemedin.',
  'passkeys.created': 'Eklendi: {date}',
  'passkeys.lastUsed': 'Son kullanım: {date}',
  'passkeys.remove': 'Kaldır',
  'passkeys.added': 'Passkey eklendi.',
  'passkeys.synced': 'Senkronize',
  'mail.verify.subject': '{brand}: e-posta adresini doğrula',
  'mail.verify.body': 'Merhaba {name},\n\n{brand} hesabının e-posta adresini doğrulamak için aşağıdaki bağlantıyı kullan. Bağlantı 24 saat geçerli.',
  'mail.verify.cta': 'E-postamı doğrula',
  'mail.orLink': 'Ya da bu bağlantıyı aç:',
  'mail.codeLabel': 'Uygulamada bu kodu girerek de doğrulayabilirsin:',
  'mail.reset.subject': '{brand}: parola sıfırlama',
  'mail.reset.body': 'Merhaba {name},\n\nParolanı sıfırlamak için aşağıdaki kodu uygulamaya gir ya da bağlantıya dokun. İkisi de 30 dakika geçerli ve tek kullanımlık. Bu isteği sen yapmadıysan bu e-postayı yok sayabilirsin; parolan değişmez.',
  'mail.reset.cta': 'Parolamı sıfırla',
  'mail.passwordChanged.subject': '{brand}: parolan değiştirildi',
  'mail.passwordChanged.body': 'Merhaba {name},\n\n{brand} hesabının parolası az önce değiştirildi ve tüm cihazlardaki oturumlar kapatıldı. Bunu sen yapmadıysan hemen destek ekibiyle iletişime geç.',
  'mail.passwordChanged.cta': 'Giriş yap',
  'mail.newDevice.subject': '{brand}: yeni bir cihazdan giriş yapıldı',
  'mail.newDevice.body': 'Merhaba {name},\n\n{brand} hesabına yeni bir cihazdan giriş yapıldı.\n\nCihaz: {device}\nZaman: {time}\nIP adresi: {ip}\n\nBu sen değilsen hemen Ayarlar › Cihazlar\'dan bu oturumu kapat ve parolanı değiştir.',
  'mail.newDevice.cta': 'Cihazlarımı gör',
  'mail.newLead.subject': '{brand} sitesinden yeni form: {form} · {name}',
  'mail.newLead.body': 'dijitalapp.com üzerinden yeni bir form gönderildi.\n\nForm: {form}\nAd soyad: {name}\nE-posta: {email}\nTelefon: {phone}\nİlgilendiği: {topic}\n\nMesaj:\n{message}',
  'mail.newLead.cta': 'Panelde aç',
  'mail.test.subject': '{brand}: test e-postası',
  'mail.test.body': 'Merhaba {name},\n\nBu, {brand} yönetim panelinden gönderilen bir test e-postasıdır. Bunu okuyabiliyorsan e-posta gönderimi çalışıyor.',
  'mail.test.cta': 'Paneli aç',
  'mail.footer': 'Bu e-posta {brand} hesabınla ilgili bir işlem nedeniyle otomatik gönderildi.',
  'mail.appealAccepted.subject': '{brand}: itirazın kabul edildi',
  'mail.appealAccepted.body': 'Merhaba {name},\n\nAskıya alma kararına itirazın incelendi ve kabul edildi. Hesabın yeniden açıldı; giriş yapabilirsin.\n\nİnceleme notu: {note}',
  'mail.appealAccepted.cta': 'Giriş yap',
  'mail.appealRejected.subject': '{brand}: itirazın hakkında karar',
  'mail.appealRejected.body': 'Merhaba {name},\n\nAskıya alma kararına itirazın incelendi; karar değişmedi. Hesabın askıda kalıyor.\n\nİnceleme notu: {note}',
  'mail.appealRejected.cta': 'Kullanım koşulları',
  'mail.opsAlert.subject': '{brand} uyarısı: {alert}',
  'mail.opsAlert.body': 'Merhaba {name},\n\n{alert}.\n\nAyrıntı: {detail}\nZaman: {time}\n\nAynı uyarı bir saat içinde tekrar gönderilmez. Canlı rakamlar yönetim panelinde, Sistem sekmesinde.',
  'mail.opsAlert.cta': 'Sistem durumunu aç',
  'error.ACCOUNT_SUSPENDED': 'Hesabın askıya alındı. Haksız olduğunu düşünüyorsan aşağıdan itiraz edebilirsin.',
  'report.conversation': 'Grubu bildir',
  'report.channel': 'Kanalı bildir',
  'report.conversationNote': 'Bildirim grubun/kanalın sahibine ilişkilendirilir; seçtiğin son mesajlar kanıt olarak gider.',
  'appeal.title': 'Askıya almaya itiraz',
  'appeal.body': 'Neden haksız olduğunu düşündüğünü yaz; inceleme ekibi bakar ve sana e-posta ile döner. Aynı anda tek itiraz açık olabilir.',
  'appeal.text': 'İtirazın (en az 20 karakter)',
  'appeal.submit': 'İtirazı gönder',
  'appeal.sent': 'İtirazın alındı. Sonucu e-posta ile bildireceğiz.',
  'admin.reports.type.conversation': 'Grup/Kanal',
  'admin.reports.conversation': '{type}: {title} ({members} üye) — sahibi @{owner}',
  'admin.reports.convType.group': 'Grup',
  'admin.reports.convType.channel': 'Kanal',
  'admin.reports.convType.community': 'Topluluk',
  'admin.notes.title': 'Moderatör notları',
  'admin.notes.empty': 'Bu kişi için not yok.',
  'admin.notes.add': 'Not ekle',
  'admin.notes.placeholder': 'Yalnızca ekip görür; kişiye gösterilmez.',
  'admin.notes.forReport': 'bu rapor için',
  'admin.appeals.title': 'İtirazlar',
  'admin.appeals.empty': 'Bekleyen itiraz yok.',
  'admin.appeals.reason': 'Askıya alma gerekçesi: {reason}',
  'admin.appeals.accept': 'Kabul et (hesabı aç)',
  'admin.appeals.reject': 'Reddet',
  'admin.appeals.note': 'Karar notu (kişiye e-postayla gider)',
  'admin.appeals.filter': 'İtiraz durumu',
  'admin.appeals.status.pending': 'Bekleyen',
  'admin.appeals.status.accepted': 'Kabul edilen',
  'admin.appeals.status.rejected': 'Reddedilen',
  'mail.accountDeletion.subject': '{brand}: hesabın silinmek üzere',
  'mail.accountDeletion.body': 'Merhaba {name},\n\nHesabının silinmesini istedin. Tüm oturumların kapatıldı. {days} gün içinde ({date} tarihine kadar) yeniden giriş yaparsan silme isteği iptal olur; yapmazsan hesabın ve kişisel verilerin kalıcı olarak silinir.\n\nBunu sen istemediysen hemen giriş yap ve parolanı değiştir.',
  'mail.accountDeletion.cta': 'Giriş yap ve vazgeç',
  'settings.account.data': 'Verilerin',
  'settings.account.export': 'Verilerimi indir',
  'settings.account.exportHint': 'Profil, ayarlar, kişiler, gönderdiğin mesajlar, hikâyeler, takvim ve siparişler tek bir JSON dosyasında. Şifreli mesajların içeriği sunucuda olmadığı için dosyada yoktur. Günde en fazla 3 kez.',
  'settings.account.delete': 'Hesabımı sil',
  'settings.account.deleteHint': 'Tüm oturumların hemen kapanır. 30 gün içinde yeniden giriş yaparsan silme iptal olur; yapmazsan hesabın ve kişisel verilerin kalıcı olarak silinir. Gönderdiğin mesajlar karşı tarafta "Silinmiş hesap" olarak kalır.',
  'settings.account.deleteConfirm': 'Silmek için parolanı yaz',
  'settings.account.deleteButton': 'Hesabı sil',
  'settings.account.deleteDone': 'Silme isteğin alındı. Oturumun kapatıldı; {date} tarihinden önce giriş yaparsan hesabın kalır.',
  'mail.guardian.subject': '{brand}: {child} için veli/vasi onayı',
  'mail.guardian.body': 'Merhaba,\n\n{child} (@{username}, {age} yaşında) {brand} hesabı açtı. Bulunduğu ülkenin kurallarına göre {consentBelow} yaşından küçükler, bir veli ya da yasal vasi onay verene kadar mesajlaşamaz.\n\nBu kişinin velisi ya da yasal vasisi sen isen aşağıdaki bağlantıdan hesabı inceleyip onay verebilir ya da reddedebilirsin. Bağlantı 7 gün geçerlidir ve bir kez kullanılır.\n\nBu e-posta sana yanlışlıkla geldiyse bir şey yapmana gerek yok; hesap kısıtlı kalır.',
  'mail.guardian.cta': 'Hesabı incele ve karar ver',
  'mail.guardianGranted.subject': '{brand}: veli onayın verildi',
  'mail.guardianGranted.body': 'Merhaba {name},\n\nVelin/vasin {brand} hesabın için onay verdi. Artık mesajlaşabilirsin. Yaşına uygun güvenlik ayarların açık kalır.',
  'mail.guardianGranted.cta': 'Uygulamayı aç',
  'mail.guardianDenied.subject': '{brand}: veli onayı verilmedi',
  'mail.guardianDenied.body': 'Merhaba {name},\n\nVelin/vasin {brand} hesabın için onay vermedi. Hesabın kısıtlı kalır: mesajlaşamazsın. İstersen uygulamadan başka bir veli/vasi e-postası girip yeniden isteyebilir ya da hesabını kapatabilirsin.',
  'mail.guardianDenied.cta': 'Uygulamayı aç',
  'mail.familyLink.subject': '{brand}: {child} seni Aile Merkezi’ne davet ediyor',
  'mail.familyLink.body': 'Merhaba,\n\n{child} (@{username}) seni {brand} Aile Merkezi’ne veli olarak davet ediyor.\n\nKendi {brand} hesabınla bağlandığında çocuğunun kimlerle mesajlaşabileceğine sen karar verirsin: eklemek istediği kişiler senin onayına gelir, listede olmayan kimse ona yazamaz ve onu arayamaz. Mesajlarının içeriğini göremezsin; bu, çocuğunun mahremiyeti için böyle tasarlandı.\n\nBağlantı 7 gün geçerlidir ve bir kez kullanılır. Hesabın yoksa önce ücretsiz bir hesap açabilirsin.\n\nBu e-posta sana yanlışlıkla geldiyse bir şey yapmana gerek yok.',
  'mail.familyLink.cta': 'Aile Merkezi’ne bağlan',
  'guardian.wait.title': 'Veli/vasi onayı bekleniyor',
  'guardian.wait.body': 'Bulunduğun ülkede {consentBelow} yaşından küçükler, bir veli ya da yasal vasi onay verene kadar mesajlaşamaz. Velinin e-postasını yaz; ona bir bağlantı gönderelim.',
  'guardian.wait.sentTo': 'Bağlantı {email} adresine gönderildi ({date}). Velin e-postayı bulamazsa spam klasörüne bakmasını söyle.',
  'guardian.wait.denied': 'Velin onay vermedi. Başka bir veli/vasi e-postası girip yeniden isteyebilirsin.',
  'guardian.email': 'Veli/vasi e-postası',
  'guardian.send': 'Bağlantı gönder',
  'guardian.resend': 'Yeniden gönder',
  'guardian.change': 'E-postayı değiştir',
  'guardian.sent': 'Gönderildi',
  'guardian.register.field': 'Veli/vasi e-postası (isteğe bağlı)',
  'guardian.register.hint': 'Yaşın gereği bir veli ya da yasal vasi onay vermeden mesajlaşamazsın. E-postasını şimdi yazarsan bağlantı hemen gider; sonra da girebilirsin.',
  'guardian.page.title': 'Veli/vasi onayı',
  'guardian.page.intro': '{child} (@{username}, {age} yaşında) {brand} hesabı açtı. {country} kurallarına göre {consentBelow} yaşından küçükler, bir veli ya da yasal vasi onay verene kadar mesajlaşamaz.',
  'guardian.page.means': 'Onay verirsen: mesajlaşma açılır. Yaşına göre zorunlu güvenlik ayarları değişmez: profili aramada görünmez, tanımadığı kişiler ona yazamaz, konum paylaşamaz, reklam görmez, satın alma yapamaz. Onayını istediğin zaman geri çekmek için bize yazabilirsin.',
  'guardian.page.name': 'Adın soyadın',
  'guardian.page.confirm': 'Bu kişinin velisi ya da yasal vasisiyim; yukarıdakileri okudum.',
  'guardian.page.grant': 'Onay veriyorum',
  'guardian.page.deny': 'Onay vermiyorum',
  'guardian.page.granted': 'Onay kaydedildi. {child} artık mesajlaşabilir; ona e-posta ile haber verdik.',
  'guardian.page.denied': 'Kararın kaydedildi. Hesap kısıtlı kalacak; {child} bilgilendirildi.',
  'guardian.page.already': 'Bu bağlantı için karar zaten verilmiş.',
  'guardian.page.invalid': 'Bu bağlantı geçersiz, kullanılmış ya da süresi dolmuş. {brand} kullanıcısı uygulamadan yeni bir bağlantı gönderebilir.',
  'admin.guardian.pending': 'Veli onayı bekliyor',
  'admin.guardian.granted': 'Veli onayı var',
  'admin.guardian.record': 'Veli onayını kaydet',
  'admin.guardian.revoke': 'Veli onayını geri al',
  'admin.guardian.note': 'Onayın nasıl alındığını yaz (ör. imzalı form, doğrulanmış arama):',
  'chat.title': 'Sohbetler',
  'chat.search': 'Sohbetlerde ara',
  'chat.new': 'Yeni sohbet',
  'chat.empty': 'Henüz sohbetin yok. Kişiler bölümünden @kullanıcıadı ile birini ekleyip sohbet başlat.',
  'chat.select': 'Bir sohbet seç',
  'chat.selectBody': 'Soldaki listeden bir sohbet seç ya da yeni bir sohbet başlat.',
  'chat.self': 'Kendime not',
  'chat.selfHint': 'Yalnızca sen görürsün · notlar, dosyalar, bağlantılar',
  'chat.selfNew': 'Kendime not',
  'chat.selfNewDesc': 'Kendine notlar, dosyalar ve bağlantılar gönder; tüm cihazlarında açılır.',
  'chat.formatHint': 'Biçim: *kalın* _eğik_ ~üstü çizili~ `kod`',
  'chat.placeholder': 'Mesaj yaz',
  'chat.send': 'Gönder',
  'chat.draft': 'Taslak',
  'chatSearch.open': 'Sohbette ara',
  'chatSearch.placeholder': 'Bu sohbette ara…',
  'chatSearch.position': '{at}/{count}',
  'chatSearch.none': 'Sonuç yok',
  'chatSearch.older': 'Daha eski sonuç',
  'chatSearch.newer': 'Daha yeni sonuç',
  'chatSearch.encryptedNote': 'Şifreli mesajlar yalnızca bu cihazda, yüklenmiş mesajlar içinde aranır.',
  'chatSearch.searchOlder': 'Daha eskilerde de ara',
  'chatSearch.many': 'En yeni 100 sonuç gösteriliyor; aramayı daraltabilirsin.',
  'viewOnce.photo': 'Tek görümlük fotoğraf',
  'viewOnce.video': 'Tek görümlük video',
  'viewOnce.media': 'Tek görümlük medya',
  'viewOnce.tapToOpen': 'Açmak için dokun',
  'viewOnce.opened': 'Açıldı',
  'viewOnce.openedCount': '{count} kişi açtı',
  'viewOnce.notOpened': 'Henüz açılmadı',
  'viewOnce.expired': 'Süresi doldu',
  'viewOnce.gone': 'Bu medya artık açılamıyor.',
  'viewOnce.loading': 'Açılıyor…',
  'viewOnce.notice': 'Kapatınca bir daha açılamaz. Ekran görüntüsü alınması engellenemez.',
  'viewOnce.toggle': 'Tek görümlük',
  'viewOnce.toggleOn': 'Tek görümlük: alıcı yalnızca bir kez açabilir, açıklama eklenmez.',
  'videoNote.title': 'Görüntülü not',
  'videoNote.menu': 'Görüntülü not',
  'videoNote.label': 'Görüntülü not',
  'videoNote.hint': 'Kayda başlamak için kırmızı düğmeye bas (en fazla 1 dakika).',
  'videoNote.start': 'Kaydı başlat',
  'videoNote.stop': 'Kaydı bitir',
  'videoNote.again': 'Yeniden çek',
  'videoNote.broken': 'Kayıt sırasında görüntü durdu, bu yüzden not gönderilmedi. Yeniden kaydet ve kayıt bitene dek ekranda kal.',
  'export.title': 'Sohbeti dışa aktar',
  'export.intro': 'Tüm sohbet, WhatsApp biçiminde bir metin dosyası ve medyasıyla birlikte tek bir .zip dosyası olarak bu cihaza kaydedilir. Bu dosya daha sonra "Sohbet içe aktar" ile geri yüklenebilir.',
  'export.encrypted': 'Bu sohbet uçtan uca şifreli: mesajlar bu cihazda çözülür; bu cihazda okunamayanlar dosyada "okunamadı" olarak geçer.',
  'export.includeMedia': 'Fotoğraf, video, ses ve dosyaları dahil et',
  'export.warning': 'Dosyada mesajlar şifresiz durur: kiminle paylaşırsan sohbeti okuyabilir.',
  'export.start': 'Dışa aktar',
  'export.progress': '{messages} mesaj, {media} medya hazırlandı…',
  'export.done': '"{name}" indirildi.',
  'export.failed': 'Dışa aktarma tamamlanamadı. Bağlantını kontrol edip yeniden dene.',
  'export.tooLarge': 'Sohbet tek dosya için çok büyük. Medyasız dışa aktarmayı dene.',
  'export.mediaOmitted': 'Medya dahil edilmedi',
  'export.unreadable': '🔒 (bu cihazda okunamadı)',
  'export.failedMedia': 'indirilemedi',
  'export.poll': '📊 Anket',
  'export.timer': 'Kaybolan mesaj ayarı değişti',
  'callLink.title': 'Görüşmeye katıl',
  'callLink.section': 'Görüşme bağlantısı',
  'callLink.hint': 'Bağlantıyı açan kişi gruba katılır ve doğrudan grubun görüşmesine girer. Onay açıkken her katılımı sen onaylarsın.',
  'callLink.none': 'Etkin görüşme bağlantısı yok.',
  'callLink.kind': 'Görüşme türü',
  'callLink.video': 'Görüntülü görüşme',
  'callLink.voice': 'Sesli görüşme',
  'callLink.create': 'Bağlantı oluştur ve paylaş',
  'callLink.resetNote': 'Yeni bağlantı oluşturmak eskisini geçersiz kılar.',
  'callLink.join': 'Görüşmeye katıl',
  'callLink.inCall': 'şu an {count} kişi görüşmede',
  'callLink.notStarted': 'görüşme henüz başlamadı',
  'callLink.waiting': 'İsteğin yöneticilere gitti. Onaylandığında görüşme bu sayfadan kendiliğinden açılır.',
  'callLink.privacyNote': 'Katıldığında gruba da katılmış olursun: grup üyeleri adını ve kullanıcı adını görebilir.',
  'callLink.share': 'Görüşme bağlantısını paylaş',
  'callLink.copied': 'Bağlantı kopyalandı. Katılmak isteyenleri buradan onaylarsın.',
  'callLink.shared': 'Bağlantı paylaşıldı. Katılmak isteyenleri buradan onaylarsın.',
  'callLink.copyFailed': 'Bağlantı kopyalanamadı.',
  'callLink.requests': 'Katılmak isteyenler',
  'story.video': 'Video hikâye',
  'story.replyQuoteVideo': 'Video hikâyene',
  'story.soundOn': 'Sesi aç',
  'story.videoUnsupported': 'Bu tarayıcı video hikâyeyi hazırlayamıyor. Fotoğraf ya da yazı paylaşabilirsin.',
  'story.videoTooLarge': 'Video çok büyük. Daha kısa ya da daha düşük çözünürlüklü bir video seç.',
  'story.videoUnreadable': 'Bu video okunamadı. MP4 ya da WebM bir video seç.',
  'story.videoTrimmed': 'Videonun ilk 30 saniyesi paylaşılır.',
  'story.videoPreparing': 'Video hazırlanıyor… %{percent} (bu ekranda kal)',
  'story.videoFailed': 'Video hazırlanamadı. Yeniden dene.',
  'story.changeVideo': 'Videoyu değiştir',
  'broadcast.title': 'Toplu mesaj listeleri',
  'broadcast.new': 'Yeni liste',
  'broadcast.intro': 'Bir mesajı birçok kişiye aynı anda gönder. Her kişi mesajı seninle olan birebir sohbetinde normal bir mesaj olarak alır; listede başka kimlerin olduğunu görmez. Yalnızca seni kişilerine eklemiş olanlar alır.',
  'broadcast.none': 'Henüz liste yok.',
  'broadcast.empty': 'Listede kimse yok',
  'broadcast.reach': '{reach}/{count} kişi alır',
  'broadcast.sendsTo': '{count} kişiye gidecek',
  'broadcast.unreachable': '{count} kişi seni kişilerine eklemediği (ya da aranızda engel olduğu) için almaz.',
  'broadcast.placeholder': 'Listeye mesaj yaz…',
  'broadcast.attach': 'Dosya ekle',
  'broadcast.send': '{count} kişiye gönder',
  'broadcast.sending': 'Gönderiliyor… {done}/{total}',
  'broadcast.sent': '{count} kişiye gönderildi. Mesajlar ilgili sohbetlerde görünür.',
  'broadcast.sentSome': '{done} kişiye gönderildi, {failed} kişiye gönderilemedi.',
  'broadcast.edit': 'Listeyi düzenle',
  'broadcast.name': 'Liste adı',
  'broadcast.people': 'Kişiler',
  'broadcast.picked': '{count}/{max} kişi seçildi',
  'broadcast.delete': 'Listeyi sil',
  'broadcast.deleteSure': 'Evet, sil',
  'privacy.showTyping': '"Yazıyor…" bilgimi göster',
  'privacy.showTypingHint': 'Kapalıyken kimse yazdığını görmez; sen başkalarının yazdığını görmeye devam edersin. Yalnızca yöneticiler kapatabilir.',
  'privacy.encryptedLinkPreviews': 'Şifreli sohbetlerde bağlantı önizlemesi',
  'privacy.encryptedLinkPreviewsHint': 'Gönderdiğin bağlantılar başlık, açıklama ve resimle görünür. Önizleme için sayfayı sunucumuz okur, bu yüzden hangi bağlantıyı paylaştığını sunucu görür; kime gönderdiğini ve mesajın kendisini görmez. Önizleme mesajın içinde şifreli gider.',
  'adminOps.tts.provider': 'Seslendirme (ElevenLabs)',
  'adminOps.tts.off': 'Kapalı (ELEVENLABS_API_KEY yok)',
  'adminOps.tts.keyNoProvider': 'Anahtar var; açmak için TTS_PROVIDER=elevenlabs',
  'adminOps.tts.keyMissing': 'TTS_PROVIDER=elevenlabs ama ELEVENLABS_API_KEY yok',
  'adminOps.calls.cloudflare': 'Kurumsal ağ desteği (Cloudflare TURN, 443)',
  'adminOps.calls.cloudflareHint': 'Açıkken aramalar Cloudflare aktarmasını da kullanır (443 üzerinden TLS dahil); yalnızca web portlarına izin veren kurum ve okul ağlarında aramalar çalışır. Kullanım Cloudflare tarafından ücretlendirilir.',
  'adminOps.calls.cloudflareNoKey': 'Sunucuda CLOUDFLARE_TURN_KEY_ID ve CLOUDFLARE_TURN_API_TOKEN yok; eklenince açılabilir.',
  'adminOps.calls.relayOnlySwitch': 'Yalnızca aktarma (IP gizleme)',
  'adminOps.calls.relayOnlyHint': 'Tüm görüşme medyası aktarma sunucusundan geçer; taraflar birbirinin IP adresini görmez. Biraz daha fazla gecikme ve trafik demektir.',
  'adminOps.flag.turn_cloudflare': 'Kurumsal ağ desteği (Cloudflare TURN)',
  'adminOps.flag.turn_cloudflare.desc': 'Aramalar Cloudflare aktarmasını da kullanır (443 dahil)',
  'adminOps.flag.calls_relay_only': 'Yalnızca aktarma',
  'adminOps.flag.calls_relay_only.desc': 'Görüşme medyası hep aktarmadan geçer (IP gizlenir)',
  'adminOps.calls.cloudflareReady': 'Cloudflare aktarması hazır: {urls}',
  'adminOps.calls.cloudflareFailed': "Cloudflare kimlik bilgisi alınamadı ({error}). Anahtar kimliğini ve token'ı kontrol et; aramalar şimdilik yalnız kendi aktarmamızı kullanıyor.",
  'errorScreen.notFound.title': 'Bu sayfayı bulamadık',
  'errorScreen.notFound.text': 'Adres yanlış yazılmış ya da sayfa kaldırılmış olabilir.',
  'errorScreen.crashed.title': 'Bir şeyler ters gitti',
  'errorScreen.crashed.text': 'Bu sayfa beklenmedik bir hatayla karşılaştı. Yeniden denemek genellikle sorunu giderir.',
  'errorScreen.unavailable.title': 'Kısa bir ara veriyoruz',
  'errorScreen.unavailable.text': 'DijitalApp şu an güncelleniyor ya da kısa süreliğine ulaşılamıyor. Birkaç saniye içinde kendiliğinden yeniden deneyeceğiz.',
  'errorScreen.offline.title': 'İnternet bağlantısı yok',
  'errorScreen.offline.text': 'Bağlantın geri geldiğinde kaldığın yerden devam edeceksin.',
  'errorScreen.retrying': '{seconds} sn içinde yeniden denenecek',
  'errorScreen.home': 'Ana sayfaya dön',
  'errorScreen.back': 'Geri dön',
  'market.nav': 'Market',
  'market.title': 'DijitalApp Market',
  'market.intro': "DijitalApp'ine yeni yetenekler ekle. Ücretsiz uygulamalar tek dokunuşla eklenir; Pro uygulamalar bir kez satın alınır, Plus ve Business olanlar planla açılır.",
  'store.heroTitle': 'Uygulamalarla DijitalApp\'ini genişlet',
  'store.heroStats': '{apps} uygulama · {free} ücretsiz · {mine} tanesi sende',
  'store.updates': { one: '{count} yeni sürüm', other: '{count} yeni sürüm' },
  'store.updatedShort': 'Yeni sürüm',
  'store.newVersion': 'Yeni sürüm: v{version}',
  'store.sort': 'Sıralama',
  'store.sort.popular': 'En popüler',
  'store.sort.rating': 'En yüksek puan',
  'store.sort.new': 'En yeni',
  'store.sort.name': 'Ada göre',
  'store.noRatings': 'Henüz puan yok',
  'store.starsLabel': '5 üzerinden {value} yıldız',
  'store.ratingsCount': { one: '{count} değerlendirme', other: '{count} değerlendirme' },
  'store.users': 'Kullanıcı',
  'store.version': 'Sürüm',
  'store.price': 'Fiyat',
  'store.whatsNew': 'Yenilikler',
  'store.versionHistory': 'Sürüm geçmişi ({count})',
  'store.hideHistory': 'Geçmişi gizle',
  'store.about': 'Bu uygulama hakkında',
  'store.ratings': 'Puanlar ve yorumlar',
  'store.yourRating': 'Puanın',
  'store.nStars': { one: '{count} yıldız', other: '{count} yıldız' },
  'store.rateIt': 'Bu uygulamayı puanla',
  'store.yourReview': 'Senin değerlendirmen',
  'store.reviewPlaceholder': 'Deneyimini paylaş (isteğe bağlı)',
  'store.sendReview': 'Gönder',
  'store.updateReview': 'Güncelle',
  'store.deleteReview': 'Değerlendirmeyi sil',
  'store.installToRate': 'Puan vermek için önce uygulamayı ekle.',
  'store.noReviews': 'Henüz yorum yok.',
  'store.you': 'Sen',
  'store.appPage': 'Uygulama sayfası',
  'store.dev.verified': 'Doğrulanmış geliştirici',
  'store.dev.verifiedHint': 'DijitalApp ekibi bu geliştiricinin kimliğini ve iletişim bilgilerini doğruladı.',
  'store.dev.official': 'Resmî',
  'store.dev.section': 'Geliştirici iletişim bilgileri',
  'store.dev.supportHint': 'Uygulamayla ilgili soru ve önerilerini doğrudan geliştiriciye iletebilirsin.',
  'store.dev.website': 'Web sitesi',
  'store.dev.email': 'Destek e-postası',
  'store.dev.privacy': 'Gizlilik politikası',
  'store.dev.address': 'Adres',
  'store.dev.country': 'Ülke',
  'store.dev.about': 'Geliştirici hakkında',
  'store.dev.allApps': { one: 'Geliştiricinin uygulaması ({count})', other: 'Geliştiricinin tüm uygulamaları ({count})' },
  'store.dev.page': 'Geliştirici sayfası',
  'store.dev.since': '{year} yılından beri Market\'te',
  'store.dev.apps': 'Uygulamalar',
  'store.dev.appsCount': { one: '{count} uygulama', other: '{count} uygulama' },
  'store.dev.noApps': 'Bu geliştiricinin Market\'te henüz uygulaması yok.',
  'store.dev.join': 'Geliştirici misin? Uygulamanı Market\'e gönder',
  'devp.title': 'Geliştirici konsolu',
  'devp.intro': 'Uygulamanı DijitalApp Market\'te yayınlamak için bir geliştirici profili oluştur, uygulamanı ve sürümlerini incelemeye gönder. Her uygulama ve her sürüm, yayına çıkmadan önce DijitalApp ekibince incelenir.',
  'devp.off': 'Geliştirici programı şu an kapalı. Açıldığında buradan başvurabileceksin.',
  'devp.rulesTitle': 'Kurallar',
  'devp.rule1': 'Başvuru için 18 yaşını doldurmuş, e-postası doğrulanmış ve kısıtlaması olmayan bir hesap gerekir.',
  'devp.rule2': 'Uygulamalar yalnızca konum, hareket ve kamera izni isteyebilir; mesajlarına, kişilerine, hesabına ve yapay zekâya erişemez.',
  'devp.rule3': 'Her uygulamanın bir gizlilik politikası ve destek e-postası olmalı; "DijitalApp" adını ya da resmî görünen adları kullanamazsın.',
  'devp.rule4': '"Doğrulanmış geliştirici" rozetini yalnızca DijitalApp ekibi verir; adını değiştirirsen rozet yeniden incelenir.',
  'devp.profile': 'Geliştirici profili',
  'devp.apply': 'Başvur',
  'devp.save': 'Kaydet',
  'devp.saved': 'Kaydedildi.',
  'devp.slug': 'Kısa ad (sayfa adresin)',
  'devp.name': 'Görünen ad',
  'devp.website': 'Web sitesi (https, isteğe bağlı)',
  'devp.supportEmail': 'Destek e-postası',
  'devp.privacyUrl': 'Gizlilik politikası adresi (https)',
  'devp.address': 'Adres (isteğe bağlı)',
  'devp.country': 'Ülke kodu (ör. TR)',
  'devp.aboutTr': 'Hakkında (Türkçe)',
  'devp.aboutEn': 'Hakkında (İngilizce, isteğe bağlı)',
  'devp.status.pending': 'İncelemede',
  'devp.status.active': 'Onaylandı',
  'devp.status.rejected': 'Reddedildi',
  'devp.status.suspended': 'Askıya alındı',
  'devp.note': 'Ekibin notu: {note}',
  'devp.apps': 'Uygulamalarım',
  'devp.newApp': 'Yeni uygulama',
  'devp.appId': 'Uygulama kimliği (küçük harf, rakam ve tire)',
  'devp.appName': 'Uygulama adı',
  'devp.summary': 'Kısa açıklama (10–80 karakter)',
  'devp.description': 'Ayrıntılı açıklama',
  'devp.category': 'Kategori',
  'devp.permissions': 'İstediği izinler',
  'devp.homepageUrl': 'Uygulama sayfası (https, isteğe bağlı)',
  'devp.create': 'Taslak oluştur',
  'devp.edit': 'Düzenle',
  'devp.cancel': 'Vazgeç',
  'devp.sub.draft': 'Taslak',
  'devp.sub.submitted': 'Gönderildi',
  'devp.sub.in_review': 'İnceleniyor',
  'devp.sub.approved': 'Onaylandı',
  'devp.sub.rejected': 'Reddedildi',
  'devp.sub.suspended': 'Askıda',
  'devp.versions': 'Sürümler',
  'devp.addVersion': 'Sürüm ekle',
  'devp.version': 'Sürüm numarası',
  'devp.notesTr': 'Sürüm notları (Türkçe)',
  'devp.notesEn': 'Sürüm notları (İngilizce, isteğe bağlı)',
  'devp.bundleUrl': 'Paket adresi (https)',
  'devp.bundleSha256': 'Paketin SHA-256 özeti',
  'devp.submit': 'İncelemeye gönder',
  'devp.noApps': 'Henüz uygulama yok.',
  'devp.needsApproval': 'Uygulama gönderebilmek için geliştirici profilinin onaylanmasını bekle.',
  'devp.approvedNote': 'Onaylanan uygulamalar, üçüncü taraf uygulamaların güvenle çalışacağı ortam hazır olduğunda Market\'te yayınlanır.',
  'devadm.title': 'Geliştiriciler',
  'devadm.intro': 'Geliştirici profillerini onayla, "Doğrulanmış geliştirici" rozetini ver ve gönderilen uygulamaları incele.',
  'devadm.off': 'Üçüncü taraf geliştirici programı kapalı (market_developers bayrağı). Kullanıcılar başvuramaz ve uygulama gönderemez. Açmadan önce güvenli çalışma ortamı (sandbox), inceleme politikası, ödemeler ve geliştirici sözleşmesi kararlaştırılmalı.',
  'devadm.on': 'Geliştirici programı açık: kullanıcılar başvurabilir ve uygulama gönderebilir.',
  'devadm.queue': 'İnceleme kuyruğu',
  'devadm.developers': 'Geliştiriciler',
  'devadm.filter.waiting': 'Bekleyenler',
  'devadm.filter.all': 'Tümü',
  'devadm.emptyQueue': 'İncelenecek uygulama yok.',
  'devadm.emptyDevs': 'Henüz geliştirici yok.',
  'devadm.inReview': 'İncelemeye al',
  'devadm.approve': 'Onayla',
  'devadm.reject': 'Reddet',
  'devadm.suspend': 'Askıya al',
  'devadm.reinstate': 'Yeniden etkinleştir',
  'devadm.verify': 'Rozet ver',
  'devadm.unverify': 'Rozeti kaldır',
  'devadm.reasonPrompt': 'Nedeni (geliştirici görür):',
  'devadm.subsCount': { one: '{count} gönderim', other: '{count} gönderim' },
  'devadm.verifiedBy': 'Rozeti veren: @{username}',
  'devadm.submittedAt': 'Gönderildi: {date}',
  'devadm.bundle': 'Paket',
  'devadm.officialHint': 'DijitalApp\'in kendi geliştirici profili: her zaman doğrulanmış, askıya alınamaz. Bilgilerini buradan düzenleyebilirsin.',
  'store.admin.offered': 'Sunulan uygulama',
  'store.admin.installs': 'Toplam kurulum',
  'store.admin.installs30d': 'Son 30 günde kurulum',
  'store.admin.ratings': 'Değerlendirme',
  'store.admin.plus30d': { one: 'son 30 gün +{count}', other: 'son 30 gün +{count}' },
  'store.admin.hiddenCount': { one: '{count} gizli yorum', other: '{count} gizli yorum' },
  'store.admin.versions': 'Sürümler',
  'store.admin.reviews': 'Yorumlar',
  'store.admin.offeredSwitch': '{name} Market\'te sunulsun',
  'store.admin.release': 'Yeni sürüm yayınla',
  'store.admin.versionNumber': 'Sürüm numarası (şu an: {current})',
  'store.admin.notesTr': 'Sürüm notları (Türkçe)',
  'store.admin.notesEn': 'Sürüm notları (İngilizce, isteğe bağlı)',
  'store.admin.releaseHint': 'Uygulamayı ekleyenlerde "Yeni sürüm" işareti çıkar; açınca notları görürler.',
  'store.admin.publish': 'Yayınla',
  'store.admin.deleteVersionConfirm': 'v{version} silinsin mi?',
  'store.admin.hideReason': 'Gizleme nedeni (yorumu yazan kişi görmez, kayıtlarda kalır):',
  'store.admin.hidden': 'Gizli · {reason}',
  'store.admin.hide': 'Gizle',
  'store.admin.show': 'Yeniden göster',
  'market.mine': 'Uygulamalarım',
  'market.all': 'Tüm uygulamalar',
  'market.free': 'Ücretsiz',
  'market.price': '{price}',
  'market.featured': 'Öne çıkan',
  'market.uses': 'Kullandıkları:',
  'market.installs': { one: '{count} kişi ekledi', other: '{count} kişi ekledi' },
  'market.add': 'Ekle',
  'market.open': 'Aç',
  'market.remove': 'Kaldır',
  'market.soon': 'Yakında',
  'admin.tab.payments': 'Ödemeler',
  'common.saved': 'Kaydedildi',
  'error.PAYMENT_UNAVAILABLE': 'Ödeme şu an yapılamıyor. Biraz sonra tekrar dene.',
  'error.PAYMENT_ALREADY_OWNED': 'Bu zaten sende var.',
  'error.PAYMENT_NOT_ALLOWED': 'Satın alma yalnızca yetişkin hesaplarında yapılabilir.',
  'market.buy': 'Satın al · {price}',
  'market.plansLink': 'Plus ve Business planlarını gör →',
  'plans.title': 'Planlar',
  'plans.heroTitle': 'Sana uygun planı seç',
  'plans.comingSoon': 'Ücretli planlar yakında açılıyor. Özellikleri şimdiden inceleyebilirsin.',
  'plans.save': '%{percent} tasarruf',
  'plans.popular': 'En çok tercih edilen',
  'plans.freePrice': '₺0',
  'plans.forever': 'her zaman',
  'plans.perMonthNote': 'Aylık yaklaşık {price}',
  'plans.priceSoon': 'Fiyat yakında',
  'plans.yourPlan': 'Şu anki planın',
  'plans.included': 'Herkese açık',
  'plans.choose': '{plan} planına geç',
  'plans.free.lead': 'Mesajlaşmanın tamamı, herkese',
  'plans.free.f1': 'Sınırsız mesaj, sesli ve görüntülü arama',
  'plans.free.f2': 'Uçtan uca şifreli sohbetler',
  'plans.free.f3': 'Gruplar, kanallar, topluluklar',
  'plans.free.f4': 'Ücretsiz Market uygulamaları',
  'paymentsAdmin.priceDisplay': 'Fiyatların gösterimi',
  'paymentsAdmin.priceDisplay.auto': 'Otomatik: yalnızca ödemeler açıkken',
  'paymentsAdmin.priceDisplay.always': 'Her zaman göster',
  'paymentsAdmin.priceDisplay.hidden': 'Gizle (planlar görünür, fiyatlar görünmez)',
  'paymentsAdmin.priceDisplayHint': 'Planlar sayfası ve Market’teki Pro uygulama fiyatları buna göre gösterilir.',
  'plans.intro': 'Plus ve Business, Market’teki ek uygulamaları ve daha yüksek sınırları açar. Ödeme, seçilen sağlayıcının güvenli sayfasında yapılır; kart bilgin DijitalApp’e hiç gelmez.',
  'plans.current': 'Şu anki planın: {plan}',
  'plans.until': '{date} tarihine kadar',
  'plans.unavailable': 'Ödemeler henüz açık değil.',
  'plans.minor': 'Satın alma yalnızca yetişkin hesaplarında yapılabilir.',
  'plans.period': 'Süre',
  'plans.period.month': 'Aylık',
  'plans.period.year': 'Yıllık',
  'plans.per.month': 'ay',
  'plans.per.year': 'yıl',
  'plans.noPrice': 'Fiyat belirlenmedi',
  'plans.buy': 'Satın al',
  'plans.extend': 'Uzat',
  'plans.starting': 'Yönlendiriliyor…',
  'plans.testMode': 'Test modu açık: gerçek para çekilmez.',
  'plans.legal': 'Ödeme {provider} altyapısıyla alınır. Satın alma, kullanım koşullarına tabidir.',
  'plans.plus.lead': 'Bireysel kullanım için ek uygulamalar',
  'plans.plus.f1': 'Plus uygulamaları (sesten yazıya, sohbet özeti)',
  'plans.plus.f2': 'Daha yüksek medya ve grup sınırları',
  'plans.plus.f3': 'Öncelikli destek',
  'plans.plus.f4': 'Reklamsız deneyim',
  'plans.business.lead': 'İşletmeler ve ekipler için',
  'plans.business.f1': 'Plus’taki her şey',
  'plans.business.f2': 'Otomatik yanıt, randevu ve katalog',
  'plans.business.f3': 'İşletme asistanı ve rezervasyon sayfası',
  'plans.business.f4': 'Çoklu temsilci ve işletme profili',
  'payment.paid.title': 'Ödeme alındı',
  'payment.paid.body': '{what} hesabına tanımlandı ({amount}).',
  'payment.pending.title': 'Ödeme onayı bekleniyor',
  'payment.pending.body': 'Sağlayıcıdan onay gelince bu sayfa kendiliğinden güncellenir.',
  'payment.pending.late': 'Onay henüz gelmedi. Kartından çekim yapıldıysa birkaç dakika içinde tanımlanır; bu sayfaya sonra tekrar bakabilirsin.',
  'payment.failed.title': 'Ödeme tamamlanmadı',
  'payment.failed.body': 'Para çekilmedi. İstersen tekrar deneyebilirsin.',
  'payment.refunded': 'Bu ödeme iade edildi',
  'payment.retry': 'Tekrar dene',
  'payment.orderNo': 'Sipariş no: {id}',
  'payment.status.pending': 'Bekliyor',
  'payment.status.paid': 'Ödendi',
  'payment.status.failed': 'Başarısız',
  'payment.status.expired': 'Süresi doldu',
  'payment.status.refunded': 'İade edildi',
  'paymentsAdmin.title': 'Ödemeler',
  'paymentsAdmin.intro': 'Sağlayıcı anahtarları sunucudaki ortam dosyasında durur; burada yalnızca hangisinin kullanılacağı seçilir. Varsayılan: kapalı.',
  'paymentsAdmin.flagOff': 'Ödemeler özelliği kapalı. Sağlayıcıyı seçtikten sonra Sistem › Özellikler’den "Ödemeler" bayrağını aç.',
  'paymentsAdmin.provider': 'Ödeme sağlayıcısı',
  'paymentsAdmin.off': 'Kapalı',
  'paymentsAdmin.noKeys': 'anahtarlar sunucuda yok',
  'paymentsAdmin.keys': 'Sunucudaki anahtarlar: iyzico {iyzico} · PayTR {paytr}',
  'paymentsAdmin.testMode': 'Test modu',
  'paymentsAdmin.testMode.desc': 'PayTR’de test işlemi olarak gönderilir; iyzico’da sandbox anahtarları kullanılıyorsa zaten test ortamıdır.',
  'paymentsAdmin.prices': 'Plan fiyatları (KDV dahil)',
  'paymentsAdmin.callbacks': 'PayTR panelinde Bildirim URL: https://web.dijitalapp.com/api/v1/payments/callback/paytr — iyzico geri dönüş adresi otomatik gönderilir.',
  'paymentsAdmin.stat.paid30': 'ödeme (30 gün)',
  'paymentsAdmin.stat.revenue30': 'tahsilat (30 gün)',
  'paymentsAdmin.stat.pending': 'bekleyen',
  'paymentsAdmin.stat.failed30': 'başarısız (30 gün)',
  'paymentsAdmin.orders': 'Siparişler',
  'paymentsAdmin.status': 'Durum',
  'paymentsAdmin.all': 'Tümü',
  'paymentsAdmin.noOrders': 'Henüz sipariş yok.',
  'paymentsAdmin.col.date': 'Tarih',
  'paymentsAdmin.col.buyer': 'Alıcı',
  'paymentsAdmin.col.item': 'Ürün',
  'paymentsAdmin.col.amount': 'Tutar',
  'paymentsAdmin.col.provider': 'Sağlayıcı',
  'market.moreSoon': 'Yeni uygulamalar yolda. Bir fikrin mi var?',
  'market.notInstalled': "{name} henüz eklenmemiş. Market'ten ekleyebilirsin.",
  'market.category.tools': 'Araçlar',
  'radio.world': 'Dünya',
  'radio.worldwide': 'Dünyadan istasyonlar',
  'radio.searchingWorld': 'Dünyadaki istasyonlara bakılıyor…',
  'radio.close': 'Radyoyu kapat',
  'radio.openApp': '{name} çalıyor, radyoyu aç',
  'radio.failedShort': 'Yayına ulaşılamadı',
  'market.app.nearby.name': 'Yakınımda',
  'market.app.nearby.desc': 'Eczane, hastane, ATM, benzinlik, market, cami, yemek, otopark, istasyon ve karakol: en yakınları, uzaklığı ve yol tarifiyle.',
  'market.app.language.name': 'Dil Öğrenme',
  'market.app.language.desc': 'Her gün birkaç dakikayla İngilizce: kelime kartları, dinleme, cümle kurma, akıllı tekrar, günlük hedef ve seri.',
  // ---- Dil Öğrenme (Market app) ----
  'lang.pos.noun': 'isim',
  'lang.pos.verb': 'fiil',
  'lang.pos.adj': 'sıfat',
  'lang.pos.adv': 'zarf',
  'lang.pos.pron': 'zamir',
  'lang.pos.num': 'sayı',
  'lang.pos.prep': 'edat',
  'lang.pos.conj': 'bağlaç',
  'lang.pos.interj': 'ünlem',
  'lang.pos.phrase': 'kalıp',
  'lang.listen': 'Dinle',
  'lang.listenSlow': 'Yavaş dinle',
  'lang.listenSentence': 'Cümleyi dinle',
  'lang.quit': 'Dersten çık',
  'lang.quitConfirm': 'Dersten çıkılsın mı? Bu dersteki ilerleme kaydedilmez.',
  'lang.progress': 'Ders ilerlemesi',
  'lang.correct': 'Harika, doğru! 🎉',
  'lang.almost': 'Neredeyse! Küçük bir yazım farkı var.',
  'lang.wrong': 'Olsun, birlikte öğreniyoruz.',
  'lang.rightAnswer': 'Doğrusu:',
  'lang.continue': 'Devam',
  'lang.gotIt': 'Anladım',
  'lang.newWord': 'Yeni kelime',
  'lang.q.meaning': 'Anlamı hangisi?',
  'lang.q.word': '{lang} karşılığı hangisi?',
  'lang.q.listen': 'Ne duydun?',
  'lang.q.typeHeard': 'Duyduğunu yaz',
  'lang.q.typeWord': '{lang} olarak yaz',
  'lang.q.order': 'Cümleyi kur',
  'lang.q.match': 'Eşleri bul',
  'lang.options': 'Seçenekler',
  'lang.typeHere': 'Buraya yaz…',
  'lang.check': 'Kontrol et',
  'lang.yourSentence': 'Senin cümlen',
  'lang.tapWords': 'Aşağıdaki kelimelere sırayla dokun',
  'lang.wordBank': 'Kelimeler',
  'lang.meanings': 'Anlamlar',
  'lang.matched': '{word} eşleşti',
  'lang.done.lesson': 'Ders tamam!',
  'lang.done.review': 'Tekrar tamam!',
  'lang.done.accuracy': 'doğruluk',
  'lang.done.goal': 'Bugünkü hedefine ulaştın. Kendinle gurur duy! 🏆',
  'lang.done.streak': { one: 'Serin {count} güne çıktı. Böyle devam! 🔥', other: 'Serin {count} güne çıktı. Böyle devam! 🔥' },
  'lang.done.more': 'Hedef çoktan tamam; her fazla dakika bir artı. 🌱',
  'lang.done.toGoal': 'Bugünkü hedefine {xp} XP kaldı.',
  'lang.nextLesson': 'Sıradaki ders',
  'lang.reviewMore': 'Tekrara devam ({count})',
  'lang.backHome': 'Ana sayfa',
  'lang.lessonN': 'Ders {n}',
  'lang.lessonsDone': '{done}/{total} ders',
  'lang.practiceUnit': 'Bu üniteyi pratik et',
  'lang.words': { one: '{count} kelime', other: '{count} kelime' },
  'lang.settings': 'Ayarlar',
  'lang.goalOf': 'Bugün {xp} / {goal} XP',
  'lang.streak': { one: '{count} günlük seri', other: '{count} günlük seri' },
  'lang.streakDays': { one: 'gün seri', other: 'gün seri' },
  'lang.streakSafe': 'Bugün de buradasın, serin güvende.',
  'lang.streakKeep': 'Bugün kısa bir ders serini sürdürür.',
  'lang.streakStart': 'İlk dersle serin başlasın.',
  'lang.week': 'Bu hafta',
  'lang.dayXp': '{day}: {xp} XP',
  'lang.totalXp': 'Toplam {xp} XP',
  'lang.wordsLearned': { one: '{count} kelime öğrenildi', other: '{count} kelime öğrenildi' },
  'lang.offline': 'Çevrimdışısın; ilerlemen bu cihazda, bağlantı gelince eşitlenecek.',
  'lang.offlinePending': { one: 'Çevrimdışısın; {count} ders bağlantı gelince gönderilecek.', other: 'Çevrimdışısın; {count} ders bağlantı gelince gönderilecek.' },
  'lang.noVoice': 'Bu cihazda {lang} ses bulunamadı; dinleme soruları okuma ve yazmaya dönüştü.',
  'lang.firstLesson': 'İlk dersin',
  'lang.continueLesson': 'Sıradaki ders',
  'lang.allDone': 'Bütün dersleri bitirdin! 🎓 Tekrarlarla bildiklerini taze tut.',
  'lang.review': 'Tekrar et',
  'lang.dueCount': { one: 'Bugün {count} kelime seni bekliyor', other: 'Bugün {count} kelime seni bekliyor' },
  'lang.noneDue': 'Şimdilik tekrar yok, hepsi taze 🌿',
  'lang.reviewLater': 'Öğrendiğin kelimeler burada tekrar edilir',
  'lang.units': 'Üniteler',
  'lang.unitDone': 'Ünite tamam',
  'lang.footer': 'Kelimeler ve örnek cümleler DijitalApp ekibince yazıldı. Sesler cihazının kendi sesiyle okunur; hiçbir yere gönderilmez.',
  'lang.dailyGoal': 'Günlük hedef',
  'lang.goal.easy': 'Rahat',
  'lang.goal.steady': 'Düzenli',
  'lang.goal.serious': 'Ciddi',
  'lang.goal.intense': 'Yoğun',
  'lang.goalXp': 'günde {xp} XP',
  'lang.reminder': 'Günlük hatırlatma',
  'lang.reminderHint': 'Her gün seçtiğin saatte nazik bir bildirim gelir (Planlayıcı’da görünür).',
  'lang.reminderTime': 'Saat',
  'lang.reminderTitle': '{lang} pratiği zamanı',
  'lang.reminderBody': 'Günlük hedefin: {goal} XP',
  'lang.reminderMark': 'Dil Öğrenme hatırlatması',
  'lang.voice': 'Ses',
  'lang.voiceLooking': 'Cihazındaki sesler aranıyor…',
  'lang.voiceOk': 'Kelimeler “{name}” sesiyle okunuyor.',
  'lang.startOver': 'Baştan başla',
  'lang.startOverHint': 'Bu dildeki XP’n, serin, derslerin ve tekrarların silinir. Geri alınamaz.',
  'lang.startOverConfirm': 'Bütün ilerlemen silinsin mi? Bu geri alınamaz.',
  // ---- end Dil Öğrenme ----
  'nearby.startTitle': 'Yakınında ne var?',
  'nearby.startText': 'Konumunu kullan ya da bir yer ara; en yakın eczaneleri, hastaneleri, ATM\'leri ve dahasını gösterelim.',
  'nearby.useLocation': 'Konumumu kullan',
  'nearby.locating': 'Konum bulunuyor…',
  'nearby.searchPlace': 'Ya da semt, ilçe, şehir ara',
  'nearby.private': 'Tam konumun cihazında kalır; sunucuya yalnızca yaklaşık 1 km\'ye yuvarlanmış bir nokta gider.',
  'nearby.aroundYou': 'Çevrende',
  'nearby.around': 'Çevresinde',
  'nearby.here': 'Bulunduğun yer',
  'nearby.refresh': 'Konumumu yenile',
  'nearby.changePlace': 'Başka bir yer seç',
  'nearby.radar': { one: 'Çevredeki 1 yer', other: 'Çevredeki {count} yer' },
  'nearby.categories': 'Ne arıyorsun?',
  'nearby.cat.pharmacy': 'Eczane',
  'nearby.cat.health': 'Sağlık',
  'nearby.cat.atm': 'ATM, banka',
  'nearby.cat.fuel': 'Akaryakıt',
  'nearby.cat.market': 'Market',
  'nearby.cat.mosque': 'Cami',
  'nearby.cat.food': 'Yemek',
  'nearby.cat.parking': 'Otopark',
  'nearby.cat.transit': 'İstasyon',
  'nearby.cat.police': 'Emniyet',
  'nearby.kind.pharmacy': 'Eczane',
  'nearby.kind.health': 'Sağlık kuruluşu',
  'nearby.kind.atm': 'ATM',
  'nearby.kind.fuel': 'Akaryakıt istasyonu',
  'nearby.kind.market': 'Market',
  'nearby.kind.mosque': 'Cami',
  'nearby.kind.food': 'Yemek yeri',
  'nearby.kind.parking': 'Otopark',
  'nearby.kind.transit': 'İstasyon',
  'nearby.kind.police': 'Emniyet',
  'nearby.metres': { one: '{count} m', other: '{count} m' },
  'nearby.km': '{km} km',
  'nearby.walk': { one: 'yürüyerek 1 dk', other: 'yürüyerek {count} dk' },
  'nearby.open247': '7/24 açık',
  'nearby.none': 'Yakında bu türden bir yer bulunamadı. Başka bir kategori dene.',
  'nearby.sourceBusy': 'OpenStreetMap şu an yoğun. Biraz sonra yeniden dene.',
  'nearby.directions': '{name} için yol tarifi',
  'nearby.directionsShort': 'Yol tarifi',
  'nearby.call': '{name} ara',
  'nearby.callShort': 'Ara',
  'nearby.share': '{name} konumunu sohbete gönder',
  'nearby.shareShort': 'Sohbete gönder',
  'nearby.source': 'Veriler: © OpenStreetMap katkıcıları (ODbL). Nöbetçi eczane bilgisi değildir; açılış saatleri değişmiş olabilir.',
  'nearby.viewMap': 'Harita',
  'nearby.viewList': 'Liste',
  'nearby.view': 'Görünüm',
  'nearby.zoomIn': 'Yakınlaştır',
  'nearby.zoomOut': 'Uzaklaştır',
  'nearby.recenter': 'Konumuma dön',
  'nearby.mapLabel': 'Çevredeki yerlerin haritası. Yerlerin listesi haritanın altında.',
  'nearby.mapAttribution': '© OpenStreetMap katkıda bulunanlar',
  'nearby.radius': 'Ne kadar yakın?',
  'nearby.filter': 'Sonuçlarda ara',
  'nearby.noneIn': '“{category}” için bu mesafede bir yer bulunamadı.',
  'nearby.noMatch': '“{q}” ile eşleşen bir yer yok.',
  'nearby.widen': '{km} km içinde ara',
  'nearby.stale': 'Daha önce kaydedilen sonuçlar ({when}); yenileri hazırlanıyor.',
  'nearby.loadingPlaces': 'Yerler yükleniyor…',
  'nearby.pickOnMap': 'Haritadan seç',
  'nearby.pickHint': 'Haritayı kaydırarak aradığın noktayı ortadaki işarete getir.',
  'nearby.useCenter': 'Bu noktayı kullan',
  'nearby.searchArea': 'Bu bölgede ara',
  'nearby.deniedTitle': 'Konum izni kapalı',
  'nearby.deniedHelp': 'Açmak için adres çubuğundaki kilit ya da ayar simgesine dokun, Konum iznini “İzin ver” yap ve sayfayı yenile. iPhone’da: Ayarlar › Gizlilik ve Güvenlik › Konum Servisleri. Dilersen bir yer arayabilir ya da haritadan seçebilirsin.',
  'market.app.photo-editor.name': 'Fotoğraf Düzenle',
  'market.app.photo-editor.desc': 'Kırp, döndür, ışığı ve rengi ayarla, hazır filtreler uygula, üzerine çiz ve yaz; sonra kaydet ya da sohbete gönder.',
  'market.app.quiz.name': 'Yarışmalar',
  'market.app.quiz.desc': 'Kahoot tarzı canlı bilgi yarışması: kendi sorularını hazırla, sohbette ya da kodla başlat, geri sayım, sıralama ve konfetili kürsüyle oyna; istersen tek başına pratik yap.',
  'livequiz.title': 'Yarışmalar',
  'livequiz.heroTitle': 'Canlı bilgi yarışması',
  'livequiz.heroText': 'Sorularını hazırla, bir sohbette başlat; herkes telefonundan katılsın, en hızlı doğru cevap kazansın.',
  'livequiz.newQuiz': 'Yeni yarışma',
  'livequiz.editQuiz': 'Yarışmayı düzenle',
  'livequiz.haveCode': 'Kodun mu var? Hemen katıl',
  'livequiz.join': 'Katıl',
  'livequiz.codeNotFound': 'Bu koda ait, katılabileceğin bir oyun bulunamadı.',
  'livequiz.running': 'Devam eden oyunlar',
  'livequiz.youHost': 'Sunucu sensin',
  'livequiz.youPlay': 'Oynuyorsun',
  'livequiz.phase.lobby': 'Katılım bekleniyor',
  'livequiz.phase.question': 'Soru sorulurken',
  'livequiz.phase.reveal': 'Cevap açıklandı',
  'livequiz.phase.leaderboard': 'Sıralama',
  'livequiz.phase.finished': 'Bitti',
  'livequiz.mine': 'Yarışmalarım',
  'livequiz.empty': 'Henüz bir yarışman yok. İlkini birkaç dakikada hazırlayabilirsin.',
  'livequiz.makeFirst': 'İlk yarışmanı hazırla',
  'livequiz.questionCount': { one: '{count} soru', other: '{count} soru' },
  'livequiz.editNamed': '"{title}" yarışmasını düzenle',
  'livequiz.deleteNamed': '"{title}" yarışmasını sil',
  'livequiz.deleteConfirm': '"{title}" silinsin mi? Bu geri alınamaz.',
  'livequiz.play': 'Oynat',
  'livequiz.practice': 'Tek başına pratik',
  'livequiz.practiceText': { one: 'Genel kültür sorularıyla kendini dene: {count} hazır sorudan rastgele 10 tanesi.', other: 'Genel kültür sorularıyla kendini dene: {count} hazır sorudan rastgele 10 tanesi.' },
  'livequiz.category': 'Konu',
  'livequiz.cat.all': 'Karışık',
  'livequiz.cat.geo': 'Coğrafya',
  'livequiz.cat.history': 'Tarih',
  'livequiz.cat.science': 'Bilim',
  'livequiz.cat.arts': 'Sanat',
  'livequiz.cat.sport': 'Spor',
  'livequiz.cat.general': 'Genel',
  'livequiz.practiceStart': 'Pratiğe başla',
  'livequiz.fair': 'Süreyi sunucu tutar, doğru cevaplar açıklanana kadar kimseye gitmez. Sohbetteki oyuna yalnızca o sohbetin üyeleri, kodlu oyuna yalnızca rehberindekiler katılabilir.',
  'livequiz.startTitle': '"{title}" nerede oynansın?',
  'livequiz.where': 'Oyunun yeri',
  'livequiz.byCode': 'Kodla oyna',
  'livequiz.byCodeHint': 'Rehberindeki kişiler altı haneli kodla katılır',
  'livequiz.searchChats': 'Sohbet ara',
  'livequiz.groupMembers': { one: '{count} üye', other: '{count} üye' },
  'livequiz.postResults': 'Oyun bitince sonuçları sohbete gönder',
  'livequiz.openLobby': 'Lobiyi aç',
  'livequiz.startInChat': 'Sohbette başlat',
  'livequiz.inviteText': '🎯 Canlı yarışma başlıyor: {title}\nKatılmak için karttaki Katıl düğmesine dokun 👇',
  'livequiz.resultsText': '🏆 {title} yarışması bitti! İşte kürsü:',
  'livequiz.resultsSent': 'Sonuçlar sohbete gönderildi.',
  'livequiz.sendResults': 'Sonuçları sohbete gönder',
  'livequiz.shareText': '🎯 "{title}" yarışmasına katıl! DijitalApp › Yarışmalar › Kodla katıl: {code}',
  'livequiz.copied': 'Davet metni kopyalandı.',
  'livequiz.gone': 'Bu oyun artık yok ya da sana açık değil.',
  'livequiz.back': 'Yarışmalara dön',
  'livequiz.inChat': 'Sohbette canlı oyun',
  'livequiz.hostedBy': 'Sunan: {name}',
  'livequiz.code': 'Katılım kodu',
  'livequiz.codeLabel': 'Katılım kodu: {code}',
  'livequiz.shareCode': 'Kodu paylaş',
  'livequiz.playersJoined': { one: '{count} oyuncu', other: '{count} oyuncu' },
  'livequiz.waitChat': 'Sohbetteki karttan katılan herkes burada görünecek.',
  'livequiz.waitCode': 'Kodu paylaş; katılanlar burada görünecek.',
  'livequiz.beFirst': 'İlk katılan sen ol!',
  'livequiz.start': 'Başlat',
  'livequiz.end': 'Oyunu bitir',
  'livequiz.endConfirm': 'Oyun herkes için bitsin mi?',
  'livequiz.waitingHost': 'Katıldın! Sunucunun başlatması bekleniyor…',
  'livequiz.noPlayersYet': 'Başlatmak için en az bir oyuncu katılmalı.',
  'livequiz.paused': '{name} bağlantıyı kaybetti; oyun onu bekliyor.',
  'livequiz.pausedHost': 'Bağlantın koptu; oyun seni bekliyor.',
  'livequiz.questionOf': 'Soru {n}/{total}',
  'livequiz.points': { one: '{count} puan', other: '{count} puan' },
  'livequiz.secondsLeft': { one: '{count} saniye kaldı', other: '{count} saniye kaldı' },
  'livequiz.answer': 'Cevap',
  'livequiz.noPoints': 'Puansız soru',
  'livequiz.doublePoints': 'Çift puan!',
  'livequiz.multiHint': 'Birden fazla doğru var',
  'livequiz.answeredShort': 'cevapladı',
  'livequiz.options': 'Seçenekler',
  'livequiz.submit': 'Cevabı gönder',
  'livequiz.answerTaken': 'Cevabın alındı. Diğerleri bekleniyor…',
  'livequiz.timeUp': 'Süre doldu!',
  'livequiz.tooLate': 'Süre dolduğu için cevabın sayılmadı.',
  'livequiz.alreadyAnswered': 'Bu soruya zaten cevap verdin.',
  'livequiz.right': 'Doğru! +{points} puan',
  'livequiz.wrong': 'Bu sefer olmadı',
  'livequiz.noAnswer': 'Cevap vermedin',
  'livequiz.skip': 'Süreyi bitir',
  'livequiz.showStandings': 'Sıralamayı göster',
  'livequiz.standings': 'Sıralama',
  'livequiz.rankNow': 'Şu an {rank}. sıradasın',
  'livequiz.nextQuestion': 'Sonraki soru',
  'livequiz.showPodium': 'Kürsüyü göster',
  'livequiz.waitingNext': 'Sıradaki soru geliyor…',
  'livequiz.final': 'Sonuçlar',
  'livequiz.myRank': { one: '{count} oyuncu arasında {rank}. oldun · {points} puan', other: '{count} oyuncu arasında {rank}. oldun · {points} puan' },
  'livequiz.nobodyPlayed': 'Bu oyunda kimse oynamadı.',
  'livequiz.ended.host_ended': 'Sunucu oyunu erken bitirdi.',
  'livequiz.ended.host_left': 'Sunucu ayrıldığı için oyun bitti.',
  'livequiz.ended.expired': 'Oyun uzun süre beklediği için kapandı.',
  'livequiz.done': 'Tamam',
  'livequiz.you': '{name} (sen)',
  'livequiz.again': 'Yeniden oyna',
  'livequiz.seeResult': 'Sonucu gör',
  'livequiz.practiceScore': '{total} sorudan {right} doğru · {points} puan',
  'livequiz.practiceVerdict.0': 'Isınma turu bitti!',
  'livequiz.practiceVerdict.1': 'Fena değil, devam!',
  'livequiz.practiceVerdict.2': 'Harika gidiyorsun!',
  'livequiz.practiceVerdict.3': 'Muhteşem, tam bir bilgi küpüsün!',
  'livequiz.starsOf': { one: '3 üzerinden {count} yıldız', other: '3 üzerinden {count} yıldız' },
  'livequiz.quizTitle': 'Yarışmanın adı',
  'livequiz.quizTitlePlaceholder': 'Örneğin: Cuma akşamı genel kültür',
  'livequiz.questionN': 'Soru {n}',
  'livequiz.moveUp': 'Yukarı taşı',
  'livequiz.moveDown': 'Aşağı taşı',
  'livequiz.duplicate': 'Soruyu çoğalt',
  'livequiz.removeQuestion': 'Soruyu sil',
  'livequiz.questionText': 'Soru',
  'livequiz.questionPlaceholder': 'Sorunu yaz',
  'livequiz.imageAlt': '{n}. sorunun fotoğrafı',
  'livequiz.removeImage': 'Fotoğrafı kaldır',
  'livequiz.uploading': 'Yükleniyor…',
  'livequiz.addImage': 'Fotoğraf ekle',
  'livequiz.optionsLegend': 'Seçenekler (doğruları işaretle)',
  'livequiz.optionN': '{n}. seçenek',
  'livequiz.markRight': '{n}. seçenek doğru',
  'livequiz.removeOption': '{n}. seçeneği kaldır',
  'livequiz.addOption': 'Seçenek ekle',
  'livequiz.markHint': 'Doğru cevabın yanındaki tike dokun; birden fazla doğru seçebilirsin.',
  'livequiz.multiRight': { one: '{count} doğru cevap seçili', other: '{count} doğru cevap seçili: oyuncular hepsini bulmalı.' },
  'livequiz.timeLimit': 'Süre',
  'livequiz.seconds': { one: '{count} saniye', other: '{count} saniye' },
  'livequiz.pointsLabel': 'Puan',
  'livequiz.pointsStandard': 'Standart (1000)',
  'livequiz.pointsDouble': 'Çift puan (2000)',
  'livequiz.pointsNone': 'Puansız',
  'livequiz.fixQuestion': 'Soruyu ve tüm seçenekleri doldur, en az bir doğru işaretle.',
  'livequiz.addQuestion': 'Soru ekle',
  'livequiz.addFromBank': 'Hazır sorulardan 5 tane ekle',
  'livequiz.needTitle': 'Yarışmaya bir ad ver ve en az bir soru ekle.',
  'livequiz.save': 'Kaydet',
  'livequiz.cardPhase.lobby': 'Canlı yarışma · katılım açık',
  'livequiz.cardPhase.question': 'Canlı yarışma · oynanıyor',
  'livequiz.cardPhase.reveal': 'Canlı yarışma · oynanıyor',
  'livequiz.cardPhase.leaderboard': 'Canlı yarışma · oynanıyor',
  'livequiz.cardPhase.finished': 'Yarışma bitti',
  'livequiz.cardOpen': 'Oyuna dön',
  'livequiz.cardFinished': 'Sonuçları gör',
  'livequiz.cardGone': 'Bu yarışma artık açık değil.',
  'market.app.series-events.name': 'Seri Etkinlikler',
  'market.app.series-events.desc': 'Gruplarında ve kanallarında tekrarlayan buluşmalar: her hafta, iki haftada bir ya da ayın 2. cuması. Kart sohbete kendiliğinden düşer, herkes katılımını bildirir, hatırlatma gelir.',
  'series.hero.badge': 'Tekrarlayan etkinlikler',
  'series.hero.title': 'Topluluğun her hafta bir araya gelsin',
  'series.hero.text': 'Bir kez kur: her buluşmanın kartı gruba kendiliğinden düşer, herkes katılımını bildirir, gelenlere hatırlatma gider.',
  'series.new': 'Yeni seri',
  'series.title': 'Seri',
  'series.noGroup': 'Seri kurmak için bir grubun ya da kanalın olmalı.',
  'series.noGroupAdmin': 'Gruplarında seriyi yöneticiler kuruyor. Yöneticiler dilerse üyelere de izin verebilir.',
  'series.tabs': 'Seri Etkinlikler bölümleri',
  'series.tab.upcoming': 'Yaklaşan',
  'series.tab.mine': 'Serilerim',
  'series.tab.history': 'Geçmiş',
  'series.today': 'Bugün',
  'series.tomorrow': 'Yarın',
  'series.group': 'Grup',
  'series.channel': 'Kanal',
  'series.when': 'Ne zaman',
  'series.place': 'Yer',
  'series.card': 'Sohbet kartı',
  'series.organiser': 'Düzenleyen',
  'series.place.online': 'Çevrim içi bağlantı',
  'series.place.callIn': 'Grupta sesli görüşme',
  'series.status.skipped': 'Atlandı',
  'series.status.cancelled': 'İptal',
  'series.status.edited': 'Değişti',
  'series.empty.upcoming': 'Yaklaşan buluşma yok',
  'series.empty.upcomingText': 'Gruplarında bir seri kurulduğunda buluşmalar burada görünür; tek dokunuşla katılımını bildirirsin.',
  'series.empty.mine': 'Henüz seri kurmadın',
  'series.empty.mineText': 'Kitap kulübü, haftalık toplantı, oyun gecesi… "Yeni seri" ile ilkini kur.',
  'series.empty.history': 'Geçmiş katılım yok',
  'series.empty.historyText': 'Katılım bildirdiğin buluşmalar bittikçe burada birikir.',
  'series.stats.went': 'katıldığın',
  'series.stats.answered': 'yanıtladığın',
  'series.stats.series': 'seri',
  'series.nextOn': 'Sıradaki: {date}',
  'series.nextOnes': 'Sıradaki buluşmalar',
  'series.attendees': 'Katılımcılar',
  'series.noAnswers': 'Henüz kimse yanıt vermedi.',
  'series.openChat': 'Sohbette aç',
  'series.addToCalendar': 'Takvimime ekle',
  'series.addedToPlanner': 'Buluşma Planlayıcı\'na eklendi.',
  'series.inGroup': 'Grup: {group}',
  'series.seeSeries': 'Seriyi gör',
  'series.manage': 'Yönet',
  'series.editOne': 'Bu buluşmayı düzenle',
  'series.editOneHint': 'Yalnızca bu buluşma değişir; serinin diğer buluşmaları olduğu gibi kalır. Kart sohbetteyse o da güncellenir.',
  'series.skip': 'Bu buluşmayı atla',
  'series.restore': 'Geri al',
  'series.card.posted': 'Kart sohbette',
  'series.card.failed': 'Kart sohbete gönderilemedi (düzenleyen grupta yazamıyor olabilir).',
  'series.card.soon': 'Kart birazdan sohbete düşecek',
  'series.card.at': 'Kart {date} sohbete düşecek',
  'series.cardLead': 'Kart sohbete {when} düşer',
  'series.by': '{name} kurdu',
  'series.noReminders': 'Hatırlatma yok',
  'series.ics': 'Takvim dosyası (.ics)',
  'series.editSeries': 'Seriyi düzenle',
  'series.editFromHint': 'Ya da seriyi belli bir buluşmadan itibaren değiştir (bu ve sonrakiler):',
  'series.fromDate': '{date} ve sonrası',
  'series.cancelSeries': 'Seriyi iptal et',
  'series.cancelConfirm': 'Seri iptal edilsin mi? Yeni kart gönderilmez, sohbetteki gelecek kartlar "iptal" olarak işaretlenir.',
  'series.cancelled': 'Seri iptal edildi.',
  'series.created': 'Seri kuruldu. Kartlar zamanı gelince sohbete düşecek.',
  'series.savedFrom': 'Seri bu buluşmadan itibaren güncellendi.',
  'series.minutes': { one: '{count} dakika', other: '{count} dakika' },
  'series.hours': { one: '{count} saat', other: '{count} saat' },
  'series.hoursMinutes': '{h} sa {m} dk',
  'series.before.start': 'başlarken',
  'series.before.minutes': { one: '{count} dakika önce', other: '{count} dakika önce' },
  'series.before.hours': { one: '{count} saat önce', other: '{count} saat önce' },
  'series.before.days': { one: '{count} gün önce', other: '{count} gün önce' },
  'series.rule.weekly': 'Her hafta {days}',
  'series.rule.everyWeeks': '{n} haftada bir {days}',
  'series.rule.monthlyDay': 'Her ayın {day}. günü',
  'series.rule.everyMonthsDay': '{n} ayda bir, ayın {day}. günü',
  'series.rule.monthlyNth': 'Her ayın {nth} {day} günü',
  'series.rule.everyMonthsNth': '{n} ayda bir, ayın {nth} {day} günü',
  'series.rule.times': { one: '{count} kez', other: '{count} kez' },
  'series.rule.until': '{date} tarihine kadar',
  'series.nth.1': '1.',
  'series.nth.2': '2.',
  'series.nth.3': '3.',
  'series.nth.4': '4.',
  'series.nth.-1': 'son',
  'series.cover.aurora': 'Kutup ışığı',
  'series.cover.sunset': 'Gün batımı',
  'series.cover.ocean': 'Okyanus',
  'series.cover.forest': 'Orman',
  'series.cover.berry': 'Böğürtlen',
  'series.cover.night': 'Gece',
  'series.cover.gold': 'Altın',
  'series.cover.rose': 'Gül',
  'series.form.group': 'Grup ya da kanal',
  'series.form.membersCanCreate': 'Bu grupta üyeler de seri kurabilsin',
  'series.form.title': 'Başlık',
  'series.form.titlePlaceholder': 'Ör. Kitap kulübü',
  'series.form.description': 'Açıklama',
  'series.form.descriptionPlaceholder': 'Neler yapacağız, ne getirelim?',
  'series.form.cover': 'Kapak',
  'series.form.date': 'İlk tarih',
  'series.form.time': 'Saat',
  'series.form.duration': 'Süre',
  'series.form.timeZone': 'Saat dilimi',
  'series.form.repeat': 'Tekrar',
  'series.form.weekly': 'Haftalık',
  'series.form.monthly': 'Aylık',
  'series.form.every': 'Sıklık',
  'series.form.weeks': { one: 'Her hafta', other: '{count} haftada bir' },
  'series.form.months': { one: 'Her ay', other: '{count} ayda bir' },
  'series.form.days': 'Günler',
  'series.form.pickDay': 'En az bir gün seç.',
  'series.form.monthEnd': 'Daha kısa aylarda ayın son gününe denk gelir.',
  'series.form.ends': 'Bitiş',
  'series.form.ends.never': 'Hiç',
  'series.form.ends.until': 'Tarihte',
  'series.form.ends.count': 'N kez',
  'series.form.untilDate': 'Son tarih',
  'series.form.countLabel': 'Kaç kez',
  'series.form.place': 'Nerede',
  'series.form.place.none': 'Belirtme',
  'series.form.place.call': 'Sesli görüşme',
  'series.form.place.link': 'Bağlantı',
  'series.form.link': 'Çevrim içi bağlantı',
  'series.form.callHint': 'Buluşma, grubun kendi sesli görüşmesinde yapılır; kartta böyle yazar.',
  'series.form.reminders': 'Hatırlatmalar',
  'series.form.remindersHint': 'Katılıyorum ya da Belki diyenlere gider (en fazla 3), bildirim ayarlarına uyarak.',
  'series.form.lead': 'Kart sohbete ne zaman düşsün',
  'series.form.fromNote': 'Değişiklikler bu buluşmadan itibaren geçerli olur; önceki buluşmalar olduğu gibi kalır.',
  'series.form.create': 'Seriyi kur',
  'series.chip': 'Seri etkinlik',
  // ---- Kargo Takip (Market app "cargo") ----
  'market.app.cargo.name': 'Kargo Takip',
  'market.app.cargo.desc': 'Bütün kargoların tek yerde: numarayı ekle ya da barkodu okut, firmanın resmî takip sayfasını tek dokunuşla aç, durumu işaretle, sohbete gönder.',
  'cargo.heroKicker': 'Kargoların',
  'cargo.heroActive': { one: '1 gönderi yolda', other: '{count} gönderi yolda' },
  'cargo.heroOut': { one: '1 tanesi dağıtımda, kapın çalabilir', other: '{count} tanesi dağıtımda, kapın çalabilir' },
  'cargo.heroProblem': { one: '1 gönderide sorun var', other: '{count} gönderide sorun var' },
  'cargo.heroEmpty': 'Şu an yolda bir gönderin yok',
  'cargo.honest': 'Durumu sen işaretlersin; güncel bilgi her zaman kargo firmasının kendi sitesindedir. DijitalApp firmaların sitelerine senin yerine bağlanmaz.',
  'cargo.addTitle': 'Gönderi ekle',
  'cargo.number': 'Takip numarası',
  'cargo.numberPlaceholder': 'Numarayı yapıştır ya da yaz',
  'cargo.scan': 'Barkodu okut',
  'cargo.name': 'Ad (isteğe bağlı)',
  'cargo.namePlaceholder': 'Ör. Kulaklık',
  'cargo.carrier': 'Kargo firması',
  'cargo.detected': '{name} olarak tanındı',
  'cargo.choose': 'Numaradan firmayı kesin bilemiyoruz; hangisi olduğunu sen seç.',
  'cargo.several': 'Bu numara birden çok firmaya uyuyor; hangisi olduğunu sen seç.',
  'cargo.noCarrier': 'Firma seçilmedi',
  'cargo.later': 'Sonra seçerim',
  'cargo.badNumber': 'Takip numarası 6–40 harf ve rakamdan oluşur.',
  'cargo.add': 'Ekle',
  'cargo.added': 'Gönderi eklendi 📦',
  'cargo.duplicate': 'Bu gönderi zaten listende',
  'cargo.tabActive': 'Yoldakiler',
  'cargo.tabArchive': 'Arşiv',
  'cargo.emptyTitle': 'İlk kargonu ekle',
  'cargo.emptyText': 'Takip numarasını yapıştır ya da etiketteki barkodu okut; hangi firmada, ne durumda, hepsini tek yerden izle.',
  'cargo.archiveEmpty': 'Arşivde gönderi yok. Teslim edilenleri arşive kaldırınca burada görürsün.',
  'cargo.track': 'Kargom nerede?',
  'cargo.trackAria': '{name} gönderisini {carrier} sitesinde aç',
  'cargo.opensOn': '{domain} adresinde açılır',
  'cargo.opensOnCopy': '{domain} adresinde açılır, numara kopyalanır',
  'cargo.pickToTrack': 'Takip sayfasını açmak için firmayı seç',
  'cargo.copied': 'Takip numarası kopyalandı',
  'cargo.copiedPaste': 'Takip numarası kopyalandı, sayfada yapıştırman yeterli',
  'cargo.copy': 'Numarayı kopyala',
  'cargo.status': 'Durum',
  'cargo.statusHint': 'Firmanın sitesinde gördüğün durumu işaretle.',
  'cargo.status.preparing': 'Hazırlanıyor',
  'cargo.status.in_transit': 'Yolda',
  'cargo.status.out_for_delivery': 'Dağıtımda',
  'cargo.status.delivered': 'Teslim edildi',
  'cargo.status.problem': 'Sorun var',
  'cargo.since': '{when} işaretlendi',
  'cargo.note': 'Not',
  'cargo.notePlaceholder': 'Ör. Kapıcıya bırakılacak',
  'cargo.saved': 'Kaydedildi',
  'cargo.remind': 'Yarın tekrar bak',
  'cargo.reminder': 'Hatırlatma: {when}',
  'cargo.remindSet': 'Yarın sabah 10:00\'da hatırlatacağız ⏰',
  'cargo.remindOff': 'Hatırlatmayı kaldır',
  'cargo.remindTitle': '📦 Kargoya bak: {name}',
  'cargo.remindBody': 'Takip numarası: {number}',
  'cargo.share': 'Sohbete gönder',
  'cargo.shareNumber': 'Takip no',
  'cargo.shareFooter': 'DijitalApp Kargo Takip ile paylaşıldı',
  'cargo.archiveIt': 'Arşive kaldır',
  'cargo.unarchive': 'Arşivden çıkar',
  'cargo.archived': 'Arşive kaldırıldı',
  'cargo.delete': 'Sil',
  'cargo.deleteConfirm': 'Bu gönderi listeden silinsin mi?',
  'cargo.deleted': 'Gönderi silindi',
  'cargo.details': 'Ayrıntılar',
  'cargo.hideDetails': 'Ayrıntıları gizle',
  'cargo.deliveredAsk': 'Teslim edildi 🎉 Arşive kaldıralım mı?',
  'cargo.changeCarrier': 'Firma',
  'cargo.scanTitle': 'Barkodu okut',
  'cargo.scanHint': 'Etiketteki barkodu ya da karekodu çerçevenin içine getir.',
  'cargo.scanQrOnly': 'Bu cihazın tarayıcısı yalnızca karekod okuyabiliyor; çizgili barkod için numarayı elle yazabilirsin.',
  'cargo.scanNothing': 'Okunan kodda bir takip numarası bulamadık.',
  'cargo.scanned': 'Numara okundu',
  'cargo.admin.button': 'Kargo firmaları',
  'cargo.admin.title': 'Kargo firmaları',
  'cargo.admin.intro': 'Takip sayfası https olmalı ve firmanın kendi alan adında olmalı. Adreste {number} varsa takip numarası oraya yazılır; yoksa sayfa açılır ve numara kopyalanır. Numara biçimini yalnızca o firmaya özgüyse doldur: boş kalırsa uygulama firmayı kullanıcıya sorar. Sunucu firmaların sitelerine hiç bağlanmaz.',
  'cargo.admin.id': 'Kimlik',
  'cargo.admin.name': 'Ad',
  'cargo.admin.letter': 'Harf',
  'cargo.admin.color': 'Renk',
  'cargo.admin.domain': 'Alan adı',
  'cargo.admin.domainFixed': 'Bilinen firmaların alan adı sabittir',
  'cargo.admin.trackUrl': 'Takip sayfası',
  'cargo.admin.pattern': 'Numara biçimi (isteğe bağlı)',
  'cargo.admin.enabled': 'Listede',
  'cargo.admin.deepLink': 'Numara adrese yazılır',
  'cargo.admin.copyMode': 'Sayfa açılır, numara kopyalanır',
  'cargo.admin.tryNumber': 'Örnek numara',
  'cargo.admin.tryResult': 'Açılacak adres',
  'cargo.admin.matches': 'Bu biçime uyuyor',
  'cargo.admin.noMatch': 'Bu biçime uymuyor',
  'cargo.admin.add': 'Firma ekle',
  'cargo.admin.remove': 'Kaldır',
  'cargo.admin.up': 'Yukarı taşı',
  'cargo.admin.down': 'Aşağı taşı',
  'cargo.admin.reset': 'Yerleşik listeye dön',
  'cargo.admin.save': 'Kaydet',
  'cargo.admin.saved': 'Kargo firmaları kaydedildi',
  'cargo.admin.newName': 'Yeni kargo',
  // ---- end Kargo Takip ----
  'photo.startTitle': 'Bir fotoğraf seç',
  'photo.startText': 'Kırp, ışığını ve rengini ayarla, filtre uygula, üzerine çiz ya da yazı ekle.',
  'photo.pick': 'Fotoğraf seç',
  'photo.camera': 'Fotoğraf çek',
  'photo.openFailed': 'Bu fotoğraf açılamadı. Başka bir fotoğraf dene.',
  'photo.private': 'Fotoğrafın bu cihazda düzenlenir; sen sohbete göndermedikçe hiçbir yere gitmez.',
  'photo.undo': 'Geri al',
  'photo.redo': 'Yinele',
  'photo.compare': 'Önce / sonra',
  'photo.another': 'Başka fotoğraf',
  'photo.save': 'Kaydet',
  'photo.share': 'Paylaş',
  'photo.send': 'Sohbete gönder',
  'photo.saved': 'Fotoğraf kaydedildi.',
  'photo.canvas': 'Düzenlenen fotoğraf',
  'photo.tools': 'Araçlar',
  'photo.tool.crop': 'Kırp',
  'photo.tool.adjust': 'Ayarla',
  'photo.tool.filters': 'Filtreler',
  'photo.tool.draw': 'Çiz',
  'photo.tool.text': 'Yazı',
  'photo.shape': 'Biçim',
  'photo.free': 'Serbest',
  'photo.rotate': 'Döndür',
  'photo.mirror': 'Aynala',
  'photo.uncrop': 'Kırpmayı kaldır',
  'photo.adjust.brightness': 'Parlaklık',
  'photo.adjust.contrast': 'Kontrast',
  'photo.adjust.saturation': 'Doygunluk',
  'photo.adjust.warmth': 'Sıcaklık',
  'photo.adjust.vignette': 'Vinyet',
  'photo.resetAdjust': 'Ayarları sıfırla',
  'photo.filter.original': 'Orijinal',
  'photo.filter.vivid': 'Canlı',
  'photo.filter.warm': 'Sıcak',
  'photo.filter.cool': 'Serin',
  'photo.filter.mono': 'Siyah beyaz',
  'photo.filter.noir': 'Noir',
  'photo.filter.sepia': 'Sepya',
  'photo.filter.fade': 'Soluk',
  'photo.filter.drama': 'Dram',
  'photo.colour': 'Renk',
  'photo.penSize': 'Kalem kalınlığı',
  'photo.drawHint': 'Fotoğrafın üzerinde parmağınla ya da fareyle çiz.',
  'photo.clearDrawing': 'Çizimleri sil',
  'photo.addText': 'Yazı ekle',
  'photo.textHint': 'Düzenlemek için bir yazıya dokun; sürükleyerek yerini değiştir.',
  'photo.textSample': 'Yazın buraya',
  'photo.textValue': 'Yazı',
  'photo.textSize': 'Yazı boyutu',
  'photo.textBand': 'Arkasına zemin koy',
  'photo.removeText': 'Yazıyı sil',
  // PDF Tools and Document Scanner (Market, Pro)
  'pdf.heroTitle': 'Belgelerin cebinde',
  'pdf.heroText': 'Kâğıdı tara, köşeleri kendiliğinden düzelsin; fotoğraflardan PDF yap, PDF birleştir, ayır, küçült. Hepsi bu cihazda.',
  'pdf.scanNow': 'Belge tara',
  'pdf.openPdf': 'PDF aç',
  'pdf.tool.scan': 'Belge tara',
  'pdf.tool.images': 'Fotoğraflardan PDF',
  'pdf.tool.merge': 'PDF birleştir',
  'pdf.tool.split': 'Sayfa ayır ya da çıkar',
  'pdf.tool.compress': 'PDF küçült',
  'pdf.tool.toImages': "PDF'ten görsele",
  'pdf.toolText.scan': 'Kamerayla çok sayfa; köşe bulma, düzeltme ve temiz görünüm',
  'pdf.toolText.images': 'Galeriden seç, sırala, A4 ya da Letter PDF yap',
  'pdf.toolText.merge': "Birden çok PDF'i ve fotoğrafı tek dosyada topla",
  'pdf.toolText.split': 'İstediğin sayfaları yeni bir PDF yap ya da her sayfayı ayrı kaydet',
  'pdf.toolText.compress': 'İçindeki fotoğrafları yeniden sıkıştır, dosya küçülsün',
  'pdf.toolText.toImages': 'Taranmış sayfaları JPEG olarak kaydet',
  'pdf.goalHint.scan': 'Bir sayfaya dokun: köşeleri ve görünümü ayarla.',
  'pdf.goalHint.images': 'Sürükle ya da oklarla sırala; fotoğrafa dokunup kırp.',
  'pdf.goalHint.merge': 'Başka PDF ya da fotoğraf ekle, sırala, birleştir.',
  'pdf.goalHint.split': 'Yeni dosyaya girecek sayfaları seç.',
  'pdf.goalHint.compress': 'Küçültülecek sayfalar; istersen sırala ya da çıkar.',
  'pdf.goalHint.toImages': 'Görsel olarak kaydedilecek sayfaları seç.',
  'pdf.continue': { one: 'Sayfalara dön (1 sayfa)', other: 'Sayfalara dön ({count} sayfa)' },
  'pdf.private': 'Belgelerin bu cihazda işlenir, sunucuya yüklenmez; yalnızca sohbete gönderdiğinde paylaşılır.',
  'pdf.camera': 'Belge tarayıcı',
  'pdf.cameraDenied': 'Kameraya ulaşılamadı. Tarayıcıda kamera iznini aç ya da telefonunun kamerasıyla çek.',
  'pdf.useSystemCamera': 'Telefonun kamerasıyla çek',
  'pdf.cameraStarting': 'Kamera açılıyor…',
  'pdf.paperFound': 'Kâğıt bulundu, çekebilirsin',
  'pdf.lookingForPaper': 'Kâğıdı koyu bir zemine koy, tamamı görünsün',
  'pdf.manualHint': 'Elle kırpma: köşeleri çektikten sonra ayarlarsın',
  'pdf.autoCrop': 'Otomatik',
  'pdf.manualCrop': 'Elle',
  'pdf.takePage': 'Sayfa {n} çek',
  'pdf.cameraDone': { one: 'Bitti, 1 sayfa', other: 'Bitti, {count} sayfa' },
  'pdf.done': 'Bitti',
  'pdf.pages': 'Sayfalar',
  'pdf.pageN': 'Sayfa {n}',
  'pdf.deletePage': 'Sayfayı sil',
  'pdf.editMode': 'Düzenleme',
  'pdf.corners': 'Köşeler',
  'pdf.result': 'Sonuç',
  'pdf.originalPhoto': 'Çekilen fotoğraf',
  'pdf.resultPreview': 'Düzeltilmiş sayfa',
  'pdf.corner.tl': 'Sol üst köşe',
  'pdf.corner.tr': 'Sağ üst köşe',
  'pdf.corner.br': 'Sağ alt köşe',
  'pdf.corner.bl': 'Sol alt köşe',
  'pdf.findPaper': 'Kâğıdı bul',
  'pdf.wholePhoto': 'Fotoğrafın tamamı',
  'pdf.cornersHint': 'Köşeleri kâğıdın köşelerine sürükle (ya da seçip ok tuşlarıyla kaydır); sayfa düz bir dikdörtgene çevrilir.',
  'pdf.noPaperFound': 'Kâğıt bulunamadı. Köşeleri elle sürükleyebilirsin.',
  'pdf.look': 'Görünüm',
  'pdf.look.document': 'Belge',
  'pdf.look.original': 'Orijinal',
  'pdf.look.gray': 'Gri',
  'pdf.look.vivid': 'Canlı renk',
  'pdf.turnLeft': 'Sola döndür',
  'pdf.turnRight': 'Sağa döndür',
  'pdf.pagesCount': { one: '1 sayfa', other: '{count} sayfa' },
  'pdf.selectedOf': { one: '1 sayfa seçili', other: '{count} sayfa seçili' },
  'pdf.select': 'Seç',
  'pdf.selectAll': 'Tümünü seç',
  'pdf.selectNone': 'Seçimi kaldır',
  'pdf.deleteSelected': 'Seçilenleri sil',
  'pdf.selected': 'seçili',
  'pdf.notSelected': 'seçili değil',
  'pdf.addPages': 'Sayfa ekle',
  'pdf.addScan': 'Tara',
  'pdf.addImages': 'Fotoğraf',
  'pdf.addPdf': 'PDF',
  'pdf.photoPage': 'fotoğraf',
  'pdf.pageLabel': 'Sayfa {n} ({source})',
  'pdf.editPage': 'Sayfa {n}: kırp ve görünümü değiştir',
  'pdf.pdfPageHint': 'PDF sayfaları olduğu gibi kalır: döndürebilir, sıralayabilir, silebilir ya da seçebilirsin.',
  'pdf.moveEarlier': 'Sayfa {n}: öne al',
  'pdf.moveLater': 'Sayfa {n}: arkaya al',
  'pdf.turnPage': 'Sayfa {n}: döndür',
  'pdf.deletePageN': 'Sayfa {n}: sil',
  'pdf.saveImages': 'Görsel olarak kaydet',
  'pdf.saveImagesN': { one: '1 sayfayı görsel kaydet', other: '{count} sayfayı görsel kaydet' },
  'pdf.compressN': { one: 'Küçült (1 sayfa)', other: 'Küçült ({count} sayfa)' },
  'pdf.mergeN': { one: 'Birleştir (1 sayfa)', other: 'Birleştir ({count} sayfa)' },
  'pdf.extractN': { one: '1 sayfayı ayır', other: '{count} sayfayı ayır' },
  'pdf.makePdfN': { one: 'PDF yap (1 sayfa)', other: 'PDF yap ({count} sayfa)' },
  'pdf.options': 'PDF ayarları',
  'pdf.fileName': 'Dosya adı',
  'pdf.paper': 'Kâğıt',
  'pdf.paper.a4': 'A4',
  'pdf.paper.letter': 'Letter',
  'pdf.paper.fit': 'Fotoğraf boyu',
  'pdf.margin': 'Kenar boşluğu',
  'pdf.margin.none': 'Yok',
  'pdf.margin.small': 'Dar',
  'pdf.margin.normal': 'Normal',
  'pdf.quality': 'Kalite',
  'pdf.quality.high': 'Yüksek',
  'pdf.quality.balanced': 'Dengeli',
  'pdf.quality.small': 'Küçük dosya',
  'pdf.qualityHint.high': 'Baskıya uygun keskinlik; dosya daha büyük olur.',
  'pdf.qualityHint.balanced': 'Ekranda net, paylaşmaya uygun boyut.',
  'pdf.qualityHint.small': 'En küçük dosya; e-posta ve sohbet için ideal. PDF içindeki fotoğraflar da küçültülür.',
  'pdf.separate': { one: 'Her sayfayı ayrı PDF yap', other: 'Her sayfayı ayrı PDF yap ({count} dosya)' },
  'pdf.make': 'Oluştur',
  'pdf.working': 'Hazırlanıyor… {done} / {total}',
  'pdf.buildFailed': 'PDF oluşturulamadı. Sayfa sayısını azaltıp yeniden dene.',
  'pdf.imageFailed': { one: '1 fotoğraf açılamadı.', other: '{count} fotoğraf açılamadı.' },
  'pdf.error.encrypted': "\"{name}\" parolayla korunuyor; korumalı PDF'ler açılamıyor.",
  'pdf.error.damaged': '"{name}" okunamadı; dosya bozuk ya da PDF değil.',
  'pdf.error.empty': '"{name}" içinde sayfa yok.',
  'pdf.error.unsupported': '"{name}" bu cihazda açılamayacak kadar büyük ya da desteklenmeyen bir biçimde.',
  'pdf.imagesSaved': { one: '1 görsel kaydedildi.', other: '{count} görsel kaydedildi.' },
  'pdf.imagesSkipped': { one: '1 sayfa yalnızca yazı ve çizim içerdiği için görsele çevrilemedi.', other: '{count} sayfa yalnızca yazı ve çizim içerdiği için görsele çevrilemedi.' },
  'pdf.fileReady': 'PDF hazır',
  'pdf.filesReady': { one: '1 PDF hazır', other: '{count} PDF hazır' },
  'pdf.smallerBy': '%{pct} küçüldü (önce {before})',
  'pdf.notSmaller': 'zaten sıkıştırılmış',
  'pdf.kb': '{n} KB',
  'pdf.mb': '{n} MB',
  'pdf.preview': 'Önizle',
  'pdf.download': 'Cihaza kaydet',
  'pdf.share': 'Paylaş',
  'pdf.send': 'Sohbete gönder',
  'pdf.previewOf': '{name}: önizle',
  'pdf.downloadOf': '{name}: cihaza kaydet',
  'pdf.shareOf': '{name}: paylaş',
  'pdf.sendOf': '{name}: sohbete gönder',
  'pdf.backToPages': 'Sayfalara dön',
  'pdf.newDocument': 'Yeni belge',
  'pdf.scanName': 'Tarama',
  'pdf.imageName': 'Sayfa',
  'pdf.suffix.merged': 'birlesik',
  'pdf.suffix.small': 'kucuk',
  'pdf.suffix.pages': 'sayfalar',
  'sendToChat.title': 'Sohbete gönder',
  'sendToChat.caption': 'Açıklama ekle (isteğe bağlı)',
  'sendToChat.pick': 'Sohbet seç',
  'sendToChat.send': { one: '1 sohbete gönder', other: '{count} sohbete gönder' },
  'sendToChat.done': { one: '1 sohbete gönderildi.', other: '{count} sohbete gönderildi.' },
  'sendToChat.partial': { one: '1 sohbete gönderilemedi.', other: '{count} sohbete gönderilemedi.' },
  'radio.official': 'Resmî',
  'radio.sleep': 'Uyku zamanlayıcısı',
  'radio.sleepIn': { one: '{count} dakika sonra kapat', other: '{count} dakika sonra kapat' },
  'radio.sleepLeft': { one: 'Uyku zamanlayıcısı: {count} dakika kaldı', other: 'Uyku zamanlayıcısı: {count} dakika kaldı' },
  'radio.minutesShort': { one: '{count} dk', other: '{count} dk' },
  'radio.sleepOff': 'Zamanlayıcıyı kapat',
  'exam.scoringYear': '{year} katsayılarıyla hesaplanır.',
  'exam.admin.button': 'Katsayılar',
  'exam.admin.title': 'Sınav puanı katsayıları',
  'exam.admin.intro': 'Uygulama puanları bu sayılarla hesaplar. ÖSYM her yıl sonuçlara göre katsayıları açıkladığında burayı güncelle; kaydettiğin an tüm kullanıcılarda geçerli olur.',
  'exam.admin.year': 'Sınav yılı',
  'exam.admin.tyt': 'TYT: net başına puan',
  'exam.admin.ayt': 'AYT / YDT: net başına puan',
  'exam.admin.rules': 'Oranlar ve barajlar',
  'exam.admin.tytShare': 'TYT’nin alan puanındaki payı (%)',
  'exam.admin.obpFactor': 'OBP katsayısı',
  'exam.admin.obpFactorPlaced': 'OBP katsayısı (geçen yıl yerleşen)',
  'exam.admin.minTyt': 'TYT barajı',
  'exam.admin.minField': 'Lisans barajı (alan puanı)',
  'exam.admin.saved': '{year} katsayıları kaydedildi.',
  'exam.admin.defaults': 'Varsayılanlara dön',
  'minutes.saving': 'Kaydediliyor…',
  'minutes.saved': 'Kaydedildi',
  'minutes.saveFailed': 'Kaydedilemedi',
  'quakeAlert.cardTitle': 'Yakınımda büyük deprem uyarısı',
  'quakeAlert.hint': 'Seçtiğin büyüklükte bir deprem yakınında olursa uygulama kapalıyken de bildirim gelsin.',
  'quakeAlert.onFor': 'Açık · {place} çevresinde {km} km, {magnitude} ve üzeri',
  'quakeAlert.distance': 'Uzaklık',
  'quakeAlert.within': '{km} km içinde',
  'quakeAlert.strength': 'Büyüklük',
  'quakeAlert.atLeast': '{magnitude} ve üzeri',
  'quakeAlert.turnOn': 'Uyarıyı aç',
  'quakeAlert.on': 'Deprem uyarısı açıldı.',
  'quakeAlert.off': 'Deprem uyarısı kapatıldı.',
  'quakeAlert.note': 'Veriler AFAD\'dan dakikada bir alınır; uyarı, deprem AFAD listesine düştükten sonra gelir. Erken uyarı sistemi değildir.',
  'quakeAlert.title': '⚠️ {magnitude} büyüklüğünde deprem: {place}',
  'quakeAlert.body': '{km} km uzakta · {time} · {depth} km derinlik',
  'quakeAlert.more': { one: '+{count} deprem daha', other: '+{count} deprem daha' },
  'prayerAlert.title': 'Ezan bildirimleri',
  'prayerAlert.hint': 'Seçtiğin vakitlerde, uygulama kapalıyken de bildirim gelsin.',
  'prayerAlert.onFor': 'Açık · {place} vakitlerine göre',
  'prayerAlert.allowFirst': 'Bildirimlere izin vermedin; bildirim gelmez.',
  'prayerAlert.openSettings': 'Bildirim ayarları',
  'prayerAlert.which': 'Hangi vakitler',
  'prayerAlert.when': 'Ne zaman',
  'prayerAlert.atTime': 'Vakit girince',
  'prayerAlert.minutesBefore': '{minutes} dakika önce',
  'prayerAlert.moved': 'Bildirimler {place} için kurulu; buradaki yere göre almak için güncelle.',
  'prayerAlert.turnOn': 'Bildirimleri aç',
  'prayerAlert.update': 'Güncelle',
  'prayerAlert.turnOff': 'Kapat',
  'prayerAlert.turnedOn': 'Ezan bildirimleri açıldı.',
  'prayerAlert.updated': 'Ezan bildirimleri güncellendi.',
  'prayerAlert.turnedOff': 'Ezan bildirimleri kapatıldı.',
  'prayerAlert.now': '🕌 {name} vakti girdi',
  'prayerAlert.before': '🕌 {name} vaktine {minutes} dakika',
  'prayerAlert.sunrise': '🌅 Güneş doğuyor ({time}): sabah namazının vakti çıkıyor',
  'market.app.medicines.name': 'İlaç Hatırlatıcı',
  'market.app.medicines.desc': 'İlaçlarını saatinde hatırlat; bugünkü dozlarını işaretle. Uygulama kapalıyken de bildirim gelir.',
  'meds.off': 'Takvim bu sunucuda kapalı; ilaç hatırlatıcı takvimle çalışır.',
  'meds.title': 'İlaçlarım',
  'meds.new': 'Yeni ilaç',
  'meds.name': 'İlacın adı',
  'meds.namePlaceholder': 'Örn. Parol',
  'meds.dose': 'Doz',
  'meds.dosePlaceholder': 'Örn. 1 tablet, tok karnına',
  'meds.times': 'Saatler',
  'meds.time': '{n}. saat',
  'meds.removeTime': 'Saati kaldır',
  'meds.addTime': 'Saat ekle',
  'meds.when': 'Ne zaman',
  'meds.schedule.daily': 'Her gün',
  'meds.schedule.days': 'Seçili günler',
  'meds.schedule.alternate': 'Gün aşırı',
  'meds.weekdays': 'Günler',
  'meds.forDays': 'Kaç gün (boş: süresiz)',
  'meds.forever': 'Süresiz',
  'meds.note': 'Not',
  'meds.notePlaceholder': 'Örn. doktor kontrolüne kadar',
  'meds.save': 'Hatırlatmayı kur',
  'meds.saveHint': 'Her saat için Planlayıcı\'ya tekrarlayan bir etkinlik eklenir; bildirim tam saatinde gelir.',
  'meds.mark': 'İlaç hatırlatıcı',
  'meds.today': 'Bugün',
  'meds.progress': '{taken}/{total} doz alındı',
  'meds.nothingToday': 'Bugün alınacak ilaç yok',
  'meds.takenOf': '{time} {name}',
  'meds.late': 'Gecikti',
  'meds.taken': 'Alındı',
  'meds.add': 'İlaç ekle',
  'meds.list': 'İlaçlarım',
  'meds.daily': 'Her gün',
  'meds.alternate': 'Gün aşırı',
  'meds.until': '{date} tarihine kadar',
  'meds.remove': '{name} hatırlatmasını sil',
  'meds.removeConfirm': '{name} için hatırlatmalar silinsin mi?',
  'meds.empty': 'Henüz ilaç eklemedin.',
  'meds.note2': 'Hatırlatmalar Planlayıcı\'da da görünür. "Alındı" işaretleri bu cihazda tutulur.',
  'meds.inPlanner': 'Takvimi aç',
  'sos.locationOff': 'Konum paylaşımın gizlilik ayarlarında kapalı; acil mesajla konumun gitmez.',
  'sos.locationTurnOn': 'Konum paylaşımını aç',
  'market.app.sos.name': 'Acil Durum',
  'market.app.sos.desc': 'Tek dokunuşla 112; basılı tutunca seçtiğin kişilere acil mesaj ve canlı konum.',
  'sos.call112': '112\'yi ara',
  'sos.call112Hint': 'Ambulans, itfaiye, polis, jandarma, AFAD',
  'sos.people': 'Acil durum kişilerin',
  'sos.noPeople': 'Henüz kimseyi seçmedin. Acil durumda haber verilecek kişileri seç.',
  'sos.choose': 'Kişi seç (en çok {max})',
  'sos.message': 'Acil durum mesajı',
  'sos.defaultText': '🆘 ACİL DURUM: Yardıma ihtiyacım var. Konumum aşağıda.',
  'sos.live': 'Canlı konumumu 1 saat paylaş',
  'sos.hold': '2 saniye basılı tut',
  'sos.chooseFirst': 'Önce kişi seç',
  'sos.sending': 'Gönderiliyor…',
  'sos.sent': { one: 'Acil mesaj ve konumun {count} kişiye gönderildi.', other: 'Acil mesaj ve konumun {count} kişiye gönderildi.' },
  'sos.sentNoLocation': { one: 'Acil mesaj {count} kişiye gönderildi; konum alınamadı.', other: 'Acil mesaj {count} kişiye gönderildi; konum alınamadı.' },
  'sos.failed': 'Mesaj gönderilemedi. 112\'yi ara.',
  'sos.imSafe': 'Güvendeyim',
  'sos.safeText': '✅ Güvendeyim, merak etmeyin.',
  'sos.safeSent': { one: '"Güvendeyim" {count} kişiye gönderildi.', other: '"Güvendeyim" {count} kişiye gönderildi.' },
  'sos.numbers': 'Önemli numaralar',
  'sos.n112': 'Acil Çağrı (tüm acil durumlar)',
  'sos.n183': 'ALO 183 Aile, Kadın, Çocuk ve Engelli Destek',
  'sos.note': 'Hayati tehlikede önce 112\'yi ara. Seçtiğin kişiler yalnızca bu cihazda saklanır; mesajlar normal sohbetlerinden gider.',
  'market.app.zakat.name': 'Zekât ve Fitre',
  'market.app.zakat.desc': 'Zekâtını, fitreni ve fidyeni Diyanet\'in açıkladığı tutarlarla kolayca hesapla.',
  'zakat.tab.zakat': 'Zekât',
  'zakat.tab.fitre': 'Fitre',
  'zakat.tab.fidye': 'Fidye',
  'zakat.yourZakat': 'Vereceğin zekât',
  'zakat.needGold': 'Nisabı hesaplamak için gram altın fiyatını yaz.',
  'zakat.due': 'Net varlığın {net}, nisap {nisab}: zekât düşüyor (kırkta bir).',
  'zakat.notDue': 'Net varlığın {net}, nisap {nisab}: zekât düşmüyor.',
  'zakat.goldAlt': 'İstersen altından da verebilirsin: {grams} g.',
  'zakat.goldPrice': 'Altın fiyatı',
  'zakat.goldGram': 'Gram altın (TL)',
  'zakat.goldHint': 'Bugünkü satış fiyatını yaz.',
  'zakat.goldFromPanel': '{date} tarihli fiyat: {price}. Güncelini yazabilirsin.',
  'zakat.nisabIs': 'Nisap: {grams} g altın = {amount}',
  'zakat.assets': 'Varlıkların',
  'zakat.debtsTitle': 'Borçların',
  'zakat.asset.cash': 'Nakit',
  'zakat.assetHint.cash': 'Elindeki para',
  'zakat.asset.bank': 'Banka',
  'zakat.assetHint.bank': 'Vadeli ve vadesiz hesaplar',
  'zakat.asset.foreign': 'Döviz',
  'zakat.assetHint.foreign': 'TL karşılığı',
  'zakat.asset.goldGrams': 'Altın',
  'zakat.assetHint.goldGrams': 'Gram olarak (ziynet dahil)',
  'zakat.asset.silver': 'Gümüş ve diğer madenler',
  'zakat.assetHint.silver': 'TL karşılığı',
  'zakat.asset.stocks': 'Hisse ve fon',
  'zakat.assetHint.stocks': 'Güncel değeri',
  'zakat.asset.trade': 'Ticari mallar',
  'zakat.assetHint.trade': 'Satış için elde tutulan mallar',
  'zakat.asset.receivables': 'Alacaklar',
  'zakat.assetHint.receivables': 'Geri alınması umulanlar',
  'zakat.asset.debts': 'Borçlar',
  'zakat.assetHint.debts': 'Ödenmesi gereken borçlar',
  'zakat.conditions': 'Zekât; temel ihtiyaçlar ve borçlar dışında nisap miktarı mala sahip olunup üzerinden bir kameri yıl geçince verilir. Bu hesap yol göstericidir; özel durumlar için bir din görevlisine danış. Girdiklerin yalnızca bu cihazda saklanır.',
  'zakat.fitreTotal': 'Toplam fitre',
  'zakat.perPerson': 'Kişi başı {amount} ({year} Diyanet)',
  'zakat.notAnnounced': 'Bu yılın tutarı henüz girilmedi.',
  'zakat.people': 'Kişi sayısı',
  'zakat.peopleHint': 'Sen ve bakmakla yükümlü olduğun kişiler',
  'zakat.fitreNote': 'Gösterilen en az tutardır; imkânı olan buğday yerine hurma, üzüm gibi daha yüksek değerden verebilir. Bayram namazından önce verilmesi faziletlidir.',
  'zakat.fidyeTotal': 'Toplam fidye',
  'zakat.perDay': 'Günlük {amount} ({year} Diyanet)',
  'zakat.days': 'Gün sayısı',
  'zakat.daysHint': 'Tutulamayan oruç günleri',
  'zakat.fidyeNote': 'Fidye, sürekli hastalık ya da yaşlılık nedeniyle oruç tutamayanlar içindir; her gün için bir fitre miktarı.',
  'tasks.off': 'Görevler bu sunucuda kapalı.',
  'tasks.placeholder': 'Yeni görev ekle',
  'tasks.add': 'Ekle',
  'tasks.due': 'Ne zaman',
  'tasks.due.today': 'Bugün',
  'tasks.due.tomorrow': 'Yarın',
  'tasks.due.week': 'Bu hafta',
  'tasks.due.none': 'Tarihsiz',
  'tasks.empty': 'Bekleyen görevin yok. Yukarıdan ekleyebilirsin.',
  'tasks.section.late': 'Gecikmiş',
  'tasks.section.today': 'Bugün',
  'tasks.section.tomorrow': 'Yarın',
  'tasks.section.later': 'Yaklaşan',
  'tasks.section.someday': 'Tarihsiz',
  'tasks.from': '{name} atadı',
  'tasks.delete': '{title} görevini sil',
  'tasks.showDone': 'Tamamlananları göster',
  'tasks.hideDone': 'Tamamlananları gizle',
  'tasks.noneDone': 'Henüz tamamlanan görev yok.',
  'tasks.planner': 'Grup görevleri, atamalar ve takvim için Planlayıcı\'yı aç',
  'minutes.new': 'Yeni tutanak',
  'minutes.empty': 'Henüz tutanak yok. İlk toplantının notlarını tutmaya başla.',
  'minutes.local': 'Tutanakların hesabında saklanır, tüm cihazlarında görünür. Görevler Planlayıcı\'ya, metin sohbete paylaşılabilir.',
  'minutes.untitled': 'Adsız toplantı',
  'minutes.counts': '{people} katılımcı, {actions} görev',
  'minutes.all': 'Tüm tutanaklar',
  'minutes.share': 'Paylaş',
  'minutes.print': 'Yazdır / PDF',
  'minutes.delete': 'Tutanağı sil',
  'minutes.deleteConfirm': 'Bu tutanak silinsin mi?',
  'minutes.title': 'Başlık',
  'minutes.titlePlaceholder': 'Toplantı başlığı',
  'minutes.when': 'Tarih ve saat',
  'minutes.place': 'Yer',
  'minutes.placePlaceholder': 'Toplantı odası ya da çevrim içi',
  'minutes.people': 'Katılımcılar',
  'minutes.addPerson': 'Katılımcı ekle',
  'minutes.personPlaceholder': 'Ad yaz (virgülle birden çok)',
  'minutes.removePerson': '{name} çıkar',
  'minutes.agenda': 'Gündem',
  'minutes.notes': 'Notlar',
  'minutes.notesPlaceholder': 'Konuşulanlar…',
  'minutes.decisions': 'Kararlar',
  'minutes.addDecision': 'Karar ekle',
  'minutes.decisionPlaceholder': 'Alınan karar',
  'minutes.removeDecision': 'Kararı sil',
  'minutes.actions': 'Görevler',
  'minutes.action': 'Görev',
  'minutes.actionPlaceholder': 'Yapılacak iş',
  'minutes.owner': 'Sorumlu',
  'minutes.due': 'Son gün',
  'minutes.addAction': 'Görev ekle',
  'minutes.removeAction': 'Görevi sil',
  'minutes.inPlanner': 'Planlayıcı\'da',
  'minutes.toPlanner': { one: '{count} görevi Planlayıcı\'ya ekle', other: '{count} görevi Planlayıcı\'ya ekle' },
  'minutes.added': { one: '{count} görev Planlayıcı\'ya eklendi.', other: '{count} görev Planlayıcı\'ya eklendi.' },
  'minutes.fromMeeting': 'Toplantı: {title}',
  'minutes.copied': 'Tutanak panoya kopyalandı; bir sohbete yapıştırabilirsin.',
  'minutes.shareFailed': 'Paylaşılamadı.',
  'minutes.full': 'Cihazda yer kalmadı; eski tutanakları silmeyi dene.',
  'exam.tyt': 'TYT',
  'exam.ayt': 'AYT / YDT',
  'exam.fieldPick': 'Puan türü',
  'exam.field.say': 'SAY',
  'exam.field.ea': 'EA',
  'exam.field.soz': 'SÖZ',
  'exam.field.dil': 'DİL',
  'exam.questions': { one: '{count} soru', other: '{count} soru' },
  'exam.right': 'Doğru',
  'exam.wrong': 'Yanlış',
  'exam.net': 'Net',
  'exam.tytScore': 'TYT puanı',
  'exam.fieldScore': '{field} puanı',
  'exam.withObp': 'OBP ile {score}',
  'exam.tytLow': 'TYT puanın {min} altında: AYT puanları hesaplanmaz, tercih yapamazsın.',
  'exam.fieldLow': 'Ön lisans tercihleri açık. Lisans için bu puan türünde {min} gerekir.',
  'exam.allOpen': 'Hem ön lisans hem lisans tercihleri bu puan türünde açık.',
  'exam.obp': 'Okul puanı (OBP)',
  'exam.diploma': 'Diploma notu (50–100)',
  'exam.diplomaRange': 'Diploma notu 50 ile 100 arasında olmalı.',
  'exam.obpIs': 'OBP {obp}; puanına {bonus} eklenir.',
  'exam.placedLastYear': 'Geçen yıl bir programa yerleştim (OBP yarıya iner)',
  'exam.saveTrial': 'Denemeyi kaydet',
  'exam.clear': 'Temizle',
  'exam.trials': 'Kayıtlı denemeler',
  'exam.removeTrial': 'Denemeyi sil',
  'exam.disclaimer': 'Puanlar tahminidir: ÖSYM kesin puanları her yıl adayların sonuçlarına göre (standart sapma) hesaplar. Dört yanlış bir doğruyu götürür. Girdiklerin yalnızca bu cihazda saklanır.',
  'exam.subject.turkish': 'Türkçe',
  'exam.subject.social': 'Sosyal Bilimler',
  'exam.subject.math': 'Temel Matematik',
  'exam.subject.science': 'Fen Bilimleri',
  'exam.subject.aytMath': 'Matematik',
  'exam.subject.physics': 'Fizik',
  'exam.subject.chemistry': 'Kimya',
  'exam.subject.biology': 'Biyoloji',
  'exam.subject.literature': 'Türk Dili ve Edebiyatı',
  'exam.subject.history1': 'Tarih-1',
  'exam.subject.geography1': 'Coğrafya-1',
  'exam.subject.history2': 'Tarih-2',
  'exam.subject.geography2': 'Coğrafya-2',
  'exam.subject.philosophy': 'Felsefe Grubu',
  'exam.subject.religion': 'Din Kültürü',
  'exam.subject.language': 'Yabancı Dil (YDT)',
  'games.all': 'Tüm oyunlar',
  'games.offline': 'İnternet olmadan da oynanır; reklam yok. En iyi sonuçların bu cihazda saklanır.',
  'games.level': 'Zorluk',
  'games.level.easy': 'Kolay',
  'games.level.medium': 'Orta',
  'games.level.hard': 'Zor',
  'games.mistakes': { one: '{count} hata', other: '{count} hata' },
  'games.moves': { one: '{count} hamle', other: '{count} hamle' },
  'games.best': 'En iyi: {value}',
  'games.bestMoves': { one: 'En iyi: {count} hamle', other: 'En iyi: {count} hamle' },
  'games.won': 'Tebrikler! {time} sürede bitirdin.',
  'games.newBest': 'Yeni rekor!',
  'games.again': 'Yeniden oyna',
  'games.newGame': 'Yeni oyun',
  'games.erase': 'Sil',
  'games.sudoku.name': 'Sudoku',
  'games.sudoku.desc': 'Her satır, sütun ve kutuya 1–9 arası rakamlar.',
  'games.sudoku.cell': '{row}. satır, {col}. sütun: {value}',
  'games.mines.name': 'Mayın Tarlası',
  'games.mines.desc': 'Sayılara bakarak mayınlara basmadan alanı aç.',
  'games.mines.hint': 'İlk dokunuş her zaman güvenli. Bayrak için basılı tut.',
  'games.mines.mine': 'Mayın',
  'games.mines.flag': 'Bayraklı',
  'games.mines.closed': 'Kapalı kare',
  'games.mines.lost': 'Mayına bastın! Bir daha dene.',
  'games.mines.flagMode': 'Bayrak koyma modu',
  'games.words.name': 'Kelime Avı',
  'games.words.desc': 'Harflerin arasına gizlenmiş kelimeleri bul.',
  'games.words.theme': 'Tema',
  'games.words.theme.fruits': 'Meyveler',
  'games.words.theme.animals': 'Hayvanlar',
  'games.words.theme.cities': 'Şehirler',
  'games.words.found': '{found}/{total} kelime',
  'games.words.hint': 'Kelimenin ilk harfine, sonra son harfine dokun.',
  'games.memory.name': 'Hafıza',
  'games.memory.desc': 'Kartları çevir, eşleri en az hamlede bul.',
  'games.memory.hidden': 'Kapalı kart',
  'games.memory.won': { one: 'Tebrikler! {count} hamlede, {time} sürede.', other: 'Tebrikler! {count} hamlede, {time} sürede.' },
  'radio.search': 'İstasyon ya da tür ara',
  'radio.genres': 'Türler',
  'radio.all': 'Tümü',
  'radio.favourites': 'Favoriler',
  'radio.genre.pop': 'Pop',
  'radio.genre.news': 'Haber',
  'radio.genre.rock': 'Rock',
  'radio.genre.jazz': 'Caz',
  'radio.genre.classical': 'Klasik',
  'radio.genre.turkishfolk': 'Türkü',
  'radio.genre.religious': 'Dinî',
  'radio.genre.arabesk': 'Arabesk',
  'radio.none': 'Aramana uyan istasyon yok.',
  'radio.noFavourites': 'Henüz favorin yok. Bir istasyonun kalbine dokun.',
  'radio.favourite': '{name} favorilere ekle',
  'radio.unfavourite': '{name} favorilerden çıkar',
  'radio.nowPlaying': 'Çalan',
  'radio.live': 'Canlı yayın',
  'radio.connecting': 'Bağlanıyor…',
  'radio.failed': 'Yayına ulaşılamadı. Başka bir istasyon dene.',
  'radio.paused': 'Duraklatıldı',
  'radio.play': 'Çal',
  'radio.pause': 'Duraklat',
  'radio.source': "İstasyonlar: TRT'nin ve Diyanet'in kendi yayınları, dünyadan seçilmiş kanallar ve Radio Browser. Yayınlar doğrudan radyonun sunucusundan gelir.",
  'quakes.biggestDay': 'Son 24 saatin en büyüğü',
  'quakes.biggestWeek': 'Son 7 günün en büyüğü',
  'quakes.count': { one: '{count} deprem', other: '{count} deprem' },
  'quakes.period': 'Dönem',
  'quakes.lastDay': 'Son 24 saat',
  'quakes.lastWeek': 'Son 7 gün',
  'quakes.minMagnitude': 'En az büyüklük',
  'quakes.all': 'Tümü',
  'quakes.near': 'Yakınımda ({km} km)',
  'quakes.none': 'Bu seçimde deprem yok.',
  'quakes.depth': '{km} km derinlik',
  'quakes.away': '{km} km uzakta',
  'quakes.justNow': 'Az önce',
  'quakes.minutesAgo': { one: '{count} dk önce', other: '{count} dk önce' },
  'quakes.hoursAgo': { one: '{count} sa önce', other: '{count} sa önce' },
  'quakes.unknownPlace': 'Bilinmeyen yer',
  'quakes.source': 'Veriler: AFAD (resmî). Yer bilgisi haritada açılır.',
  'weather.places': 'Yerler',
  'weather.here': 'Konumum',
  'weather.addCity': 'Şehir ekle',
  'weather.searchCity': 'Şehir ya da ilçe ara',
  'weather.remove': '{name} kaldır',
  'weather.start': 'Bulunduğun yerin hava durumunu görmek için konumunu kullan ya da bir şehir ara.',
  'weather.useLocation': 'Konumumu kullan',
  'weather.locating': 'Konum alınıyor…',
  'weather.today': 'Bugün',
  'weather.now': 'Şimdi',
  'weather.hourly': 'Saatlik',
  'weather.daily': '10 günlük',
  'weather.highLow': 'En yüksek {high}, en düşük {low}',
  'weather.feels': 'hissedilen {temp}',
  'weather.feelsLike': 'Hissedilen',
  'weather.humidity': 'Nem',
  'weather.wind': 'Rüzgâr',
  'weather.uv': 'UV endeksi',
  'weather.sunrise': 'Gün doğumu',
  'weather.sunset': 'Gün batımı',
  'weather.source': 'Veriler: Open-Meteo',
  'weather.code.clear': 'Açık',
  'weather.code.partly': 'Parçalı bulutlu',
  'weather.code.cloudy': 'Bulutlu',
  'weather.code.fog': 'Sisli',
  'weather.code.drizzle': 'Çisenti',
  'weather.code.rain': 'Yağmurlu',
  'weather.code.snow': 'Karlı',
  'weather.code.storm': 'Gök gürültülü fırtına',
  'market.category.religion': 'Din ve Maneviyat',
  'market.category.news': 'Gündem',
  'market.category.games': 'Oyunlar',
  'market.category.media': 'Medya',
  'market.category.creative': 'Stüdyo',
  'market.category.developer': 'Geliştirici',
  'market.category.nearby': 'Yakınımda',
  'store.featured': 'Öne çıkanlar',
  'store.modules': 'DijitalApp modülleri',
  'store.module.by': 'DijitalApp',
  'store.module.edu.desc': 'Okulun ve kursun duyuruları, ödevleri, ders programı ve görüşmeleri; tüm çocukların tek yerde.',
  'store.categories': 'Kategoriler',
  'market.app.weather.name': 'Hava Durumu',
  'market.app.weather.desc': 'Bulunduğun yerin saatlik ve 10 günlük hava durumu, yağış, rüzgâr ve UV; dilediğin şehirleri ekle.',
  'market.app.earthquakes.name': 'Deprem',
  'market.app.earthquakes.desc': 'Türkiye ve çevresindeki son depremler: büyüklük, derinlik, yer ve sana uzaklığı; anında güncellenir.',
  'market.app.radio.name': 'Radyo',
  'market.app.radio.desc': 'TRT, Diyanet, Türkiye ve dünya radyoları; sohbet ederken de çalar, favoriler ve uyku zamanlayıcı ile.',
  'market.app.games.name': 'Oyunlar',
  'market.app.games.desc': 'Sudoku, Mayın Tarlası, Kelime Avı ve Hafıza: reklamsız, internet olmadan da oynanan zekâ oyunları.',
  'market.app.exam-score.name': 'Puan Hesaplama',
  'market.app.exam-score.desc': 'YKS (TYT, AYT, YDT) net ve tahmini puanını okul puanınla birlikte hesapla; denemelerini kaydet.',
  'market.app.tasks.name': 'Görevler',
  'market.app.tasks.desc': 'Yapılacaklarını gün gün düzenle; Planlayıcı ile aynı liste, tüm cihazlarında.',
  'market.app.meeting-notes.name': 'Toplantı Tutanakları',
  'market.app.meeting-notes.desc': 'Katılımcılar, gündem, kararlar ve görevlerle düzenli tutanak; sohbete paylaş ya da yazdır.',
  'market.category.productivity': 'Verimlilik',
  'market.category.education': 'Eğitim',
  'market.category.fun': 'Eğlence',
  'market.permission.location': 'konum (yalnızca cihazında)',
  'market.permission.motion': 'hareket sensörleri',
  'market.admin.title': 'Market uygulamaları',
  'market.admin.intro': "Kapattığın uygulama Market'te görünmez ve yeni eklenemez; daha önce ekleyenler kullanmaya devam eder.",
  'market.admin.paid': 'Ücretli (ödeme altyapısı bekliyor)',
  'market.app.compass.name': 'Pusula',
  'market.app.compass.desc': 'Telefonunun sensörleriyle gerçek zamanlı pusula ve kıble yönü. Konumun yalnızca cihazında kullanılır.',
  'admin.tab.market': 'Market',
  'compass.intro': 'Pusulayı başlatınca telefonunun yönünü gösterir.',
  'compass.start': 'Pusulayı başlat',
  'compass.noSensor': 'Bu cihazda pusula sensörü yok. Telefonundan açmayı dene; kıble yönünü yine de öğrenebilirsin.',
  'compass.denied': 'Hareket sensörlerine izin verilmedi. Yeniden deneyip izin verebilirsin.',
  'compass.calibrate': 'Yön tutarsızsa telefonunu havada 8 çizer gibi birkaç kez döndür. Metal ve mıknatıslardan uzak tut.',
  'compass.qibla': 'Kıble yönü',
  'compass.qiblaNote': 'Konumun yalnızca bu cihazda, kıble açısını hesaplamak için kullanılır; hiçbir yere gönderilmez.',
  'compass.findQibla': 'Kıble yönünü bul',
  'compass.locating': 'Konum alınıyor…',
  'compass.qiblaAt': 'Kıble, kuzeyden {degrees}° ({point}) yönünde.',
  'compass.distance': "Kâbe'ye yaklaşık {km} km",
  'compass.facingQibla': 'Kıbleye dönüksün ✓',
  'compass.noLocation': 'Konum alınamadı. Konum servislerinin açık olduğundan emin ol.',
  'compass.locationDenied': 'Konum izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'compass.point.n': 'Kuzey',
  'compass.point.ne': 'Kuzeydoğu',
  'compass.point.e': 'Doğu',
  'compass.point.se': 'Güneydoğu',
  'compass.point.s': 'Güney',
  'compass.point.sw': 'Güneybatı',
  'compass.point.w': 'Batı',
  'compass.point.nw': 'Kuzeybatı',
  'compass.short.n': 'K',
  'compass.short.e': 'D',
  'compass.short.s': 'G',
  'compass.short.w': 'B',
  'viewer.fit': 'Ekrana sığdır',
  'viewer.dragHint': 'Sürükleyerek gezin; tekerlek ya da +/− ile yakınlaştır',
  'feedback.title': 'Bize yaz',
  'feedback.intro': 'Fikirlerin, karşılaştığın hatalar ya da Market için önerilerin bizim için çok değerli. Ekibimiz hepsini okur ve yanıtlar.',
  'feedback.category': 'Konu',
  'feedback.cat.idea': 'Fikir',
  'feedback.cat.bug': 'Hata bildirimi',
  'feedback.cat.market': 'Market önerisi',
  'feedback.cat.other': 'Diğer',
  'feedback.subject': 'Başlık',
  'feedback.body': 'Mesajın',
  'feedback.placeholder.idea': 'Neyi daha iyi yapabiliriz? Aklındaki özelliği anlat.',
  'feedback.placeholder.bug': 'Ne oldu, ne bekliyordun? Hangi cihaz ve tarayıcıda?',
  'feedback.placeholder.market': "Market'te hangi uygulamayı görmek istersin?",
  'feedback.placeholder.other': 'Bize iletmek istediğin her şey…',
  'feedback.screenshot': 'Ekran görüntüsü ekle',
  'feedback.send': 'Gönder',
  'feedback.sending': 'Gönderiliyor…',
  'feedback.thanks': 'Teşekkürler! Mesajın ekibimize ulaştı. Yanıt verdiğimizde bildirim alacaksın.',
  'feedback.privacy': 'Mesajını yalnızca DijitalApp ekibi görür. Ekran görüntülerinden konum ve cihaz bilgileri silinir.',
  'feedback.mine': 'Gönderdiklerim',
  'feedback.none': 'Henüz bir şey göndermedin.',
  'feedback.teamReply': 'DijitalApp ekibinin yanıtı',
  'feedback.status.new': 'Yeni',
  'feedback.status.reviewing': 'İnceleniyor',
  'feedback.status.planned': 'Planlandı',
  'feedback.status.done': 'Yapıldı',
  'feedback.status.closed': 'Kapandı',
  'feedback.admin.title': 'Geri bildirimler',
  'feedback.admin.intro': 'Kullanıcıların "Bize yaz" ile gönderdikleri. Yanıt yazdığında kişiye bildirim gider ve yanıtı kendi sayfasında görür.',
  'feedback.admin.filter': 'Durum',
  'feedback.admin.open': 'Açık olanlar',
  'feedback.admin.all': 'Tümü',
  'feedback.admin.empty': 'Bu filtrede geri bildirim yok.',
  'feedback.admin.viewShot': 'Ekran görüntüsünü aç',
  'feedback.admin.status': 'Durum',
  'feedback.admin.reply': 'Yanıt',
  'feedback.admin.replyPlaceholder': 'Kişiye yanıtın…',
  'feedback.admin.replyNote': 'Kişi bildirim alır.',
  'feedback.admin.sendReply': 'Yanıtı gönder',
  'admin.tab.feedback': 'Geri bildirimler',
  'market.suggest': 'Bize yaz',
  'errorScreen.report': 'Sorunu bildir',
  'market.tier.label': 'Seviye',
  'market.tier.all': 'Tümü',
  'market.tier.free': 'Ücretsiz',
  'market.tier.pro': 'Pro',
  'market.tier.plus': 'Plus',
  'market.tier.business': 'Business',
  'market.needs': '{plan} gerekli',
  'market.planHint': 'Bu uygulama bir üyelik planıyla açılır.',
  'market.category.business': 'İşletme',
  'market.permission.camera': 'kamera',
  'market.permission.ai': 'yapay zekâ',
  'admin.plan': 'Üyelik planı',
  'admin.planName.free': 'Ücretsiz',
  'admin.planName.plus': 'Plus',
  'admin.planName.business': 'Business',
  'admin.planName.premium': 'Premium (Plus)',
  'market.app.prayer-times.name': 'Namaz vakitleri',
  'market.app.prayer-times.desc': 'Bulunduğun yerin namaz vakitleri ve bir sonraki vakte kalan süre. Hesap cihazında yapılır, konumun hiçbir yere gitmez.',
  'market.app.qr.name': 'QR kod',
  'market.app.qr.desc': 'Bağlantı, Wi-Fi, metin ya da kişi kartı için QR kod oluştur; kamerayla QR kod okut.',
  'market.app.currency.name': 'Döviz kurları',
  'market.app.currency.desc': 'Türkiye Cumhuriyet Merkez Bankası kurlarıyla dolar, euro, sterlin ve diğerleri; hızlı çevirici.',
  'market.app.converter.name': 'Çevirici ve hesap makinesi',
  'market.app.converter.desc': 'Uzunluk, ağırlık, sıcaklık, hacim, alan, hız ve veri birimlerini çevir; günlük hesaplar için hesap makinesi.',
  'market.app.level.name': 'Su terazisi ve cetvel',
  'market.app.level.desc': 'Telefonun sensörleriyle su terazisi; ekranda ayarlanabilir cetvel.',
  'market.app.theme-packs.name': 'Tema Paketleri',
  'market.app.theme-packs.desc': 'Sekiz özenle tasarlanmış tema: açık ve koyu renkler, sohbet balonları ve çizim duvar kâğıtları; tüm uygulamaya ya da yalnızca sohbetlere.',
  'tp.title': 'Sohbetlerin, senin renklerinde',
  'tp.lead': 'Her paket açık ve koyu mod için ayrı tasarlandı: yüzeyler, yazılar, sohbet balonları ve kendine özgü bir duvar kâğıdı. Seç, tek dokunuşla uygula; tüm cihazların aynı olur.',
  'tp.current.app': 'Şu an: {name} · tüm uygulamada',
  'tp.current.chats': 'Şu an: {name} · yalnızca sohbetlerde',
  'tp.current.none': 'Şu an varsayılan görünüm kullanılıyor.',
  'tp.revert': 'Varsayılana dön',
  'tp.revertShort': 'Kaldır',
  'tp.revertNamed': '{name} temasını kaldır, varsayılana dön',
  'tp.saveFailed': 'Tema kaydedilemedi. Bağlantını kontrol edip yeniden dene.',
  'tp.scope': 'Nerede uygulansın?',
  'tp.scope.app': 'Tüm uygulama',
  'tp.scope.chats': 'Yalnızca sohbetler',
  'tp.scope.app.hint': 'Menüler, listeler, kartlar ve düğmeler de temanın renklerini alır.',
  'tp.scope.chats.hint': 'Uygulama olduğu gibi kalır; sohbetlerin duvar kâğıdı ve balonları temadan gelir.',
  'tp.previewMode': 'Önizleme',
  'tp.light': 'Açık',
  'tp.dark': 'Koyu',
  'tp.gallery': 'Tema paketleri',
  'tp.inUse': 'Kullanılıyor',
  'tp.apply': 'Uygula',
  'tp.applyNamed': '{name} temasını uygula',
  'tp.notes.title': 'Bilmekte fayda var',
  'tp.notes.sync': 'Seçtiğin tema hesabına kaydedilir; telefonda, tablette ve bilgisayarda aynı görünür.',
  'tp.notes.keep': 'Kendi duvar kâğıdın ve balon renklerin saklanır; varsayılana döndüğünde geri gelir.',
  'tp.notes.chat': 'Bir sohbete ya da gruba özel seçilen görünüm her zaman önce gelir.',
  'tp.notes.contrast': 'Her paketin yazı ve balon renkleri, açık ve koyu modda erişilebilirlik ölçütüne (WCAG AA) göre ölçüldü.',
  'tp.notes.settings': 'Ayarlar › Görünüm',
  'tp.preview.name': 'Elif',
  'tp.preview.online': 'çevrimiçi',
  'tp.preview.mine': 'Harika görünüyor! 😍',
  'tp.preview.compose': 'Mesaj yaz',
  'tp.pack.gece-mavisi.name': 'Gece Mavisi',
  'tp.pack.gece-mavisi.desc': 'Yıldızlı bir gecenin derin laciverti; hilal ve küçük yıldızlar.',
  'tp.pack.gece-mavisi.line': 'Bu gece yıldızlar çok parlak ✨',
  'tp.pack.lale.name': 'Lale',
  'tp.pack.lale.desc': 'Baharın en sevilen çiçeği: sıcak kırmızılar ve yeşil saplar.',
  'tp.pack.lale.line': 'Emirgân’da laleler açmış 🌷',
  'tp.pack.kapadokya.name': 'Kapadokya',
  'tp.pack.kapadokya.desc': 'Gün doğumunda balonlar, peri bacaları ve toprak tonları.',
  'tp.pack.kapadokya.line': 'Sabah balonlar havalandı 🎈',
  'tp.pack.ege.name': 'Ege',
  'tp.pack.ege.desc': 'Turkuaz dalgalar, beyaz köpük ve yaz güneşi.',
  'tp.pack.ege.line': 'Deniz bugün çarşaf gibi 🌊',
  'tp.pack.orman.name': 'Orman',
  'tp.pack.orman.desc': 'Yaprak yeşilleri, serin bir gölge ve sakin bir yürüyüş.',
  'tp.pack.orman.line': 'Hafta sonu yürüyüşe var mısın? 🌿',
  'tp.pack.kum.name': 'Kum',
  'tp.pack.kum.desc': 'Çöl kumulları, altın sarısı ve yumuşak bir sıcaklık.',
  'tp.pack.kum.line': 'Gün batımı kumda bambaşka ☀️',
  'tp.pack.gul-kurusu.name': 'Gül Kurusu',
  'tp.pack.gul-kurusu.desc': 'Zarif, tozlu pembe güller ve yumuşak tonlar.',
  'tp.pack.gul-kurusu.line': 'Çiçekler için çok teşekkürler 🌹',
  'tp.pack.grafit.name': 'Grafit',
  'tp.pack.grafit.desc': 'Sade ve modern; dikkatini dağıtmayan griler.',
  'tp.pack.grafit.line': 'Toplantı notlarını gönderdim.',
  'tp.settingsNote.app': '{name} tema paketi tüm uygulamada açık: duvar kâğıdı, balonlar ve renkler paketten geliyor. Aşağıdaki seçimlerin saklanıyor, paketi kapatınca geri gelir.',
  'tp.settingsNote.chats': '{name} tema paketi sohbetlerde açık: duvar kâğıdı ve balonlar paketten geliyor. Aşağıdaki seçimlerin saklanıyor, paketi kapatınca geri gelir.',
  'tp.settingsOpen': 'Tema Paketleri',
  'tp.settingsOff': 'Paketi kapat',
  'market.app.pdf-tools.name': 'PDF araçları',
  'market.app.pdf-tools.desc': "Belgeyi kamerayla tara (köşeler kendiliğinden düzelir), fotoğraflardan PDF yap; PDF birleştir, ayır, döndür, küçült. Hepsi cihazında.",
  'market.app.voice-to-text.name': 'Sesli mesajı yazıya dök',
  'market.app.voice-to-text.desc': 'Gelen sesli mesajları okumak istediğinde yazıya çevirir.',
  'market.app.chat-summary.name': 'Akıllı sohbet özeti',
  'market.app.chat-summary.desc': 'Kalabalık gruplarda kaçırdıklarını birkaç cümlede özetler.',
  'market.app.auto-replies.name': 'Otomatik yanıtlar',
  'market.app.auto-replies.desc': 'Karşılama ve "şu an müsait değilim" mesajları, hazır yanıtlar.',
  'market.app.booking.name': 'Randevu sayfası',
  'market.app.booking.desc': 'Müşterilerin bir bağlantıdan uygun saatleri görüp randevu alması.',
  'market.app.catalog.name': 'Ürün kataloğu',
  'market.app.catalog.desc': 'Ürün ve hizmetlerini sohbette paylaşılabilen bir vitrinde göster.',
  'prayer.intro': 'Namaz vakitlerini bulunduğun yere göre hesaplamak için konumuna bir kez izin ver.',
  'prayer.locationNote': 'Konumun yalnızca bu cihazda kullanılır ve saklanır; hiçbir yere gönderilmez.',
  'prayer.useLocation': 'Konumumu kullan',
  'prayer.updateLocation': 'Konumu güncelle',
  'prayer.next': '{name} vaktine kalan',
  'prayer.today': 'Bugünün vakitleri',
  'prayer.method': 'Diyanet yöntemiyle (imsak 18°, yatsı 17°, temkin dakikaları) bu cihazda hesaplanır. Resmî takvimle 1–2 dakika fark olabilir.',
  'prayer.name.fajr': 'İmsak',
  'prayer.name.sunrise': 'Güneş',
  'prayer.name.dhuhr': 'Öğle',
  'prayer.name.asr': 'İkindi',
  'prayer.name.maghrib': 'Akşam',
  'prayer.name.isha': 'Yatsı',
  'qrApp.make': 'Oluştur',
  'qrApp.scan': 'Okut',
  'qrApp.kind': 'Tür',
  'qrApp.kind.link': 'Bağlantı',
  'qrApp.kind.text': 'Metin',
  'qrApp.kind.wifi': 'Wi-Fi',
  'qrApp.kind.contact': 'Kişi',
  'qrApp.ssid': 'Ağ adı (SSID)',
  'qrApp.security': 'Güvenlik',
  'qrApp.open': 'Şifresiz',
  'qrApp.password': 'Şifre',
  'qrApp.name': 'Ad soyad',
  'qrApp.phone': 'Telefon',
  'qrApp.email': 'E-posta',
  'qrApp.code': 'QR kod',
  'qrApp.save': 'Resim olarak kaydet',
  'qrApp.tooLong': 'Metin bir QR kod için fazla uzun.',
  'qrApp.fill': 'Bilgileri girince QR kod burada görünür.',
  'qrApp.found': 'QR kodda yazan:',
  'qrApp.openLink': 'Bağlantıyı aç',
  'qrApp.copy': 'Kopyala',
  'qrApp.again': 'Yeniden okut',
  'qrApp.linkWarning': 'Bağlantıyı açmadan önce adresin tanıdık olduğundan emin ol; QR kodlar her yere götürebilir.',
  'currency.amount': 'Tutar',
  'currency.from': 'Kaynak birim',
  'currency.to': 'Hedef birim',
  'currency.swap': 'Yönü değiştir',
  'currency.currency': 'Döviz',
  'currency.buying': 'Alış',
  'currency.selling': 'Satış',
  'currency.source': 'Kaynak: Türkiye Cumhuriyet Merkez Bankası gösterge niteliğindeki kurlar ({date}). Bankaların ve döviz bürolarının kurları farklı olabilir.',
  'converter.units': 'Birim çevirici',
  'converter.calculator': 'Hesap makinesi',
  'converter.quantity': 'Ölçü',
  'converter.value': 'Değer',
  'converter.q.length': 'Uzunluk',
  'converter.q.weight': 'Ağırlık',
  'converter.q.volume': 'Hacim',
  'converter.q.area': 'Alan',
  'converter.q.speed': 'Hız',
  'converter.q.data': 'Veri',
  'converter.q.temperature': 'Sıcaklık',
  'level.level': 'Su terazisi',
  'level.ruler': 'Cetvel',
  'level.start': 'Su terazisini başlat',
  'level.intro': 'Telefonunu bir yüzeye koy; kabarcık ortadaysa yüzey düzdür.',
  'level.flat': 'Düz ✓',
  'level.noSensor': 'Bu cihazda hareket sensörü yok. Telefonundan açmayı dene.',
  'level.calibrate': 'Cetveli ayarla',
  'level.calibrateHint': 'Bir banka kartını ekrandaki gri dikdörtgenin üstüne koy ve kaydırıcıyla kartın genişliğine eşitle. Ayar bu cihazda saklanır.',
  'currency.loading': "Kurlar Merkez Bankası'ndan alınıyor…",
  'market.search': 'Uygulama ara',
  'market.noResults': '“{query}” ile eşleşen uygulama yok.',
  'prayer.chooseCity': 'Şehir seç',
  'prayer.orChoose': 'Ya da konum paylaşmadan şehrini listeden seç:',
  'prayer.fromLocation': 'Konumuna en yakın il',
  'prayer.chosenCity': 'Seçtiğin şehir',
  'prayer.welcome': 'Vakitler seni bekliyor',
  'prayer.phase.night': 'Gece',
  'prayer.phase.dawn': 'Tan yeri ağarıyor',
  'prayer.phase.sunrise': 'Güneş doğuyor',
  'prayer.phase.morning': 'Kuşluk vakti',
  'prayer.phase.noon': 'Öğle',
  'prayer.phase.afternoon': 'İkindi',
  'prayer.phase.sunset': 'Gün batıyor',
  'prayer.phase.dusk': 'Akşam',
  'prayer.endsIn': '{name} vaktinin çıkmasına {time}',
  'prayer.beginsAt': 'Vakit girişi {time}',
  'prayer.tomorrow': 'yarın',
  'prayer.sunrise': 'Güneş doğuşu',
  'prayer.sunset': 'Güneş batışı',
  'prayer.dayLength': 'Gündüz {time}',
  'prayer.nightLength': 'Gece {time}',
  'prayer.hm': '{h} sa {m} dk',
  'prayer.m': '{m} dk',
  'prayer.status.now': 'Şimdi',
  'prayer.inTime': '{time} sonra',
  'prayer.hijriNote': "Hicrî tarih Ümmü'l-Kurâ takvimine göredir; Diyanet takviminden bir gün farklı olabilir.",
  'prayer.textOfDay.ayah': 'Günün ayeti',
  'prayer.textOfDay.hadith': 'Günün hadisi',
  'prayer.text.ayah': 'Ayet',
  'prayer.text.hadith': 'Hadis',
  'prayer.meal': 'Meali',
  'prayer.narrator': 'Rivayet eden: {name}',
  'prayer.prevText': 'Önceki',
  'prayer.nextText': 'Sonraki',
  'prayer.textCount': '{n} / {total}',
  'prayer.qibla': 'Kıble yönü',
  'prayer.qiblaAt': 'Kuzeyden {degrees}°',
  'prayer.openCompass': 'Pusulada aç',
  'prayer.getCompass': 'Pusulayı ekle',
  'prayer.place': 'Yer',
  'e2ee.settingsIntro': 'Mesajların ve aramaların uçtan uca şifreli: yalnız sen ve konuştuğun kişiler okuyabilir, DijitalApp bile göremez. Senin bir şey yapman gerekmez.',
  'e2ee.linked': 'Bağlı',
  'e2ee.notLinked': 'Bağlı değil',
  'e2ee.backup.title': 'Mesajların için bir yedek parolası belirle',
  'e2ee.backup.short': 'yeni bir cihazda eski mesajlarını açmak için',
  'e2ee.backup.why': 'Şifreli mesajlarının anahtarları bu parolayla korunur. Yeni bir cihazda telefonun yanında değilse bu parolayla eski mesajlarını açarsın.',
  'e2ee.backup.status': 'Mesaj yedeği',
  'e2ee.backup.on': 'Parolayla korunuyor',
  'e2ee.backup.off': 'Parola belirlenmedi',
  'e2ee.backup.set': 'Yedek parolası belirle',
  'e2ee.backup.change': 'Yedek parolasını değiştir',
  'e2ee.backup.saved': 'Yedek parolan kaydedildi.',
  'e2ee.backup.password': 'Yedek parolası',
  'e2ee.backup.again': 'Yedek parolası (tekrar)',
  'e2ee.backup.min': 'En az {min} karakter. Hesap şifrenden farklı olsun.',
  'e2ee.backup.mismatch': 'İki parola aynı değil.',
  'e2ee.backup.note': 'Bu parola cihazından çıkmaz; DijitalApp onu bilmez. Unutursan kimse geri getiremez, ama telefonundan onaylayarak yine bağlanabilirsin.',
  'e2ee.link.phoneTitle': 'Telefonundan onayla',
  'e2ee.link.phoneBody': "DijitalApp'in açık olduğu telefonunda (ya da diğer cihazında) gelen isteği kabul et; QR kodu okut ya da iki ekrandaki emojilerin aynı olduğunu onayla.",
  'e2ee.link.phoneAction': 'Telefonuma istek gönder',
  'e2ee.link.passwordTitle': 'Yedek parolanı gir',
  'e2ee.link.passwordBody': 'Telefonun yanında değilse, mesajların için belirlediğin yedek parolası yeter.',
  'e2ee.link.passwordAction': 'Bağla',
  'e2ee.link.wrongPassword': 'Yedek parolası doğru değil.',
  'e2ee.link.forgot': 'Telefonuma ulaşamıyorum ve yedek parolamı hatırlamıyorum',
  'e2ee.link.noDevice': 'Başka cihazıma ulaşamıyorum',
  'e2ee.link.resetTitle': 'Şifrelemeyi baştan başlat',
  'e2ee.link.resetBody': 'Son çare: bu cihazda şifreleme yeniden kurulur. Eski şifreli mesajlar açılmaz ve kişilerin sohbette "güvenlik kodu değişti" notu görür.',
  'e2ee.link.accountPassword': 'Hesap şifren',
  'e2ee.link.newBackupPassword': 'Yeni yedek parolası',
  'e2ee.link.resetAction': 'Baştan başlat',
  'error.BOOKING_SLOT_TAKEN': 'Bu saat az önce doldu; başka bir saat seç.',
  'business.chat.booked': '📅 Randevu aldım: {when}',
  'business.chat.cancelled': '❌ Randevu iptal edildi: {when}',
  'business.day.0': 'Pazartesi',
  'business.day.1': 'Salı',
  'business.day.2': 'Çarşamba',
  'business.day.3': 'Perşembe',
  'business.day.4': 'Cuma',
  'business.day.5': 'Cumartesi',
  'business.day.6': 'Pazar',
  'business.hours': 'Çalışma saatleri',
  'business.opens': '{day} açılış',
  'business.closes': '{day} kapanış',
  'business.closed': 'Kapalı',
  'business.hoursInvalid': 'Kapanış saati açılıştan sonra olmalı.',
  'business.timeZone': 'Saatler {zone} saat dilimine göre (bu cihazın saat dilimi).',
  'business.share': 'Paylaş',
  'business.preview': 'Müşterinin gördüğü sayfayı aç',
  'business.reachable': 'Sayfan açıkken rehberinde olmayan kişiler de sana mesaj yazabilir; engellediğin kişiler yazamaz.',
  'business.saved': 'Kaydedildi',
  'business.edit': 'Düzenle',
  'business.delete': 'Sil',
  'autoReply.greeting': 'Karşılama mesajı',
  'autoReply.greetingHint': 'Sana ilk kez (ya da {days} günden uzun aradan sonra) yazan kişiye otomatik gider.',
  'autoReply.greetingExample': 'Merhaba! Bize yazdığınız için teşekkürler, en kısa sürede dönüyoruz.',
  'autoReply.away': 'Uzakta mesajı',
  'autoReply.awayHint': 'Çalışma saatleri dışında yazan kişiye otomatik gider (aynı sohbete en fazla {hours} saatte bir).',
  'autoReply.awayExample': 'Şu an kapalıyız. Hafta içi 09:00–18:00 arası yanıt veriyoruz.',
  'autoReply.when': 'Ne zaman gönderilsin',
  'autoReply.outsideHours': 'Çalışma saatleri dışında',
  'autoReply.always': 'Her zaman',
  'autoReply.e2eeNote': 'Uçtan uca şifreli sohbetlere otomatik yanıt gönderilmez: o sohbetleri DijitalApp okuyamaz ve senin yerine yazamaz.',
  'autoReply.quick': 'Hızlı yanıtlar',
  'autoReply.quickHint': 'Bir sohbette / ve kısayolu yaz (ör. /fiyat), kayıtlı metin hazır gelsin.',
  'autoReply.shortcut': 'kısayol',
  'autoReply.quickText': 'Gönderilecek metin',
  'autoReply.addQuick': 'Hızlı yanıt ekle',
  'autoReply.shortcutInvalid': 'Kısayol boşluksuz harf ve rakamlardan oluşmalı (en çok 24); metin boş olamaz.',
  'autoReply.shortcutDuplicate': 'Aynı kısayol iki kez kullanılmış.',
  'booking.enabled': 'Randevu sayfası açık',
  'booking.enabledHint': 'Bağlantıyı alan herkes boş saatlerinden birini seçebilir.',
  'booking.link': 'Randevu sayfanın bağlantısı',
  'booking.title': 'Hizmet adı',
  'booking.titleExample': 'Ör. Saç kesimi, Danışmanlık görüşmesi',
  'booking.description': 'Açıklama (isteğe bağlı)',
  'booking.duration': 'Süre',
  'booking.buffer': 'Arada boş bırak',
  'booking.noBuffer': 'Ara yok',
  'booking.notice': 'En erken',
  'booking.anyTime': 'Hemen alınabilir',
  'booking.ahead': 'En ileri',
  'booking.minutes': '{count} dk',
  'booking.hours': '{count} saat önceden',
  'booking.days': '{count} gün sonrasına kadar',
  'booking.appointments': 'Randevular',
  'booking.none': 'Henüz randevu yok. Bağlantını müşterilerinle paylaş.',
  'booking.cancel': 'İptal et',
  'booking.cancelConfirm': '{when} randevusu iptal edilsin mi? Karşı taraf sohbette haberdar edilir.',
  'booking.cancelledByOwner': 'İşletme iptal etti',
  'booking.cancelledByCustomer': 'Müşteri iptal etti',
  'booking.ownPage': 'Bu senin randevu sayfan; müşterilerin böyle görür.',
  'booking.pickDay': 'Gün seç',
  'booking.pickTime': '{day} için saat seç',
  'booking.noTimes': 'Önümüzdeki günlerde boş saat yok.',
  'booking.zoneNote': 'Saatler işletmenin saat dilimine ({zone}) göredir.',
  'booking.note': 'Not (isteğe bağlı)',
  'booking.confirm': 'Randevuyu al',
  'booking.toldInChat': '{name} sohbetinizde haberdar edilir.',
  'booking.done': 'Randevun alındı: {when}',
  'booking.yours': 'Buradaki randevuların',
  'booking.noneYours': 'Bu işletmede randevun yok.',
  'catalog.enabled': 'Katalog açık',
  'catalog.enabledHint': 'Bağlantıyı alan herkes görünür ürünlerini görebilir ve sana sorabilir.',
  'catalog.link': 'Kataloğunun bağlantısı',
  'catalog.title': 'Katalog adı',
  'catalog.titleExample': 'Ör. Ayşe’nin Pastanesi',
  'catalog.intro': 'Kısa tanıtım (isteğe bağlı)',
  'catalog.addItem': 'Ürün ekle',
  'catalog.count': '{count} / {max} ürün',
  'catalog.empty': 'Henüz ürün yok. İlk ürününü ekle.',
  'catalog.newItem': 'Yeni ürün',
  'catalog.editItem': 'Ürünü düzenle',
  'catalog.name': 'Ürün adı',
  'catalog.description': 'Açıklama',
  'catalog.price': 'Fiyat (₺)',
  'catalog.priceHint': 'Boş bırakırsan fiyat gösterilmez.',
  'catalog.priceInvalid': 'Geçerli bir fiyat yaz (ör. 450 ya da 1.250,50).',
  'catalog.photo': 'Fotoğraf',
  'catalog.visible': 'Katalogda göster',
  'catalog.visibleHint': 'Kapalıysa yalnız sen görürsün.',
  'catalog.noPrice': 'Fiyat yok',
  'catalog.hidden': 'gizli',
  'catalog.up': 'Yukarı taşı',
  'catalog.down': 'Aşağı taşı',
  'catalog.deleteConfirm': '“{name}” silinsin mi?',
  'catalog.message': 'Mesaj gönder',
  'catalog.ask': 'Bunu sor',
  'catalog.askText': 'Merhaba, “{name}” hakkında bilgi almak istiyorum.',
  'catalog.askPriced': 'Merhaba, “{name}” ({price}) hakkında bilgi almak istiyorum.',
  'catalog.askShop': 'Merhaba, kataloğunuzu gördüm.',
  'catalog.previewOff': 'Kataloğun kapalı: şu an yalnız sen görüyorsun.',
  'catalog.search': 'Ürün ara',
  'catalog.emptyPublic': 'Bu katalogda henüz ürün yok.',
  'info.encryptedFile': 'Şifreli dosya',
  'compass.holdFlat': 'Telefonu yere paralel, düz tut: eğikken yön yanlış çıkar.',
  'compass.uncalibrated': 'Pusula kalibre değil: telefonu havada birkaç kez 8 çizerek salla, mıknatıs ve metallerden uzak dur.',
  'compass.noSensorQibla': 'Bu cihazda pusula yok. Kuzeyi bir pusula ya da haritayla bul; kıble kuzeyden saat yönünde {degrees}°.',
  'compass.verifyNote': 'Telefon pusulaları metal eşya, mıknatıs ve elektronik cihazlardan etkilenir. Kıbleyi bir kez bilinen bir yönle (ör. caminin mihrabı) karşılaştırman önerilir.',
  'invite.short': 'Arkadaşlarını davet et',
  'invite.shortDesc': 'Bağlantını paylaş, katılınca hemen yazışın',
  'admin.chatInvite.title': 'Sohbet listesindeki davet şeridi',
  'admin.chatInvite.hint': 'Herkesin sohbet listesinin en altında sabit duran, davet sayfasını açan şerit.',
  'admin.chatInvite.enabled': 'Şeridi göster',
  'admin.chatInvite.barTitle': 'Başlık',
  'admin.chatInvite.subtitle': 'Alt yazı (isteğe bağlı)',
  'admin.chatInvite.offHint': 'Kapalıyken şerit kimsenin listesinde görünmez.',
  'admin.chatInvite.saved': 'Kaydedildi; herkesin listesinde birkaç saniye içinde güncellenir.',
  'gif.topics': 'GIF konuları',
  'gif.trending': 'Popüler',
  'gif.recent': 'Son kullanılanlar',
  'gif.noRecent': 'Henüz GIF göndermedin.',
  'gif.none': 'Bu aramada GIF bulunamadı. Başka bir kelime dene.',
  'gif.topic.hello': 'Merhaba',
  'gif.topic.thanks': 'Teşekkürler',
  'gif.topic.haha': 'Kahkaha',
  'gif.topic.love': 'Sevgi',
  'gif.topic.congrats': 'Tebrikler',
  'gif.topic.applause': 'Alkış',
  'gif.topic.ok': 'Tamam',
  'gif.topic.sad': 'Üzgün',
  'gif.topic.wow': 'Vay canına',
  'gif.topic.morning': 'Günaydın',
  'gif.topic.night': 'İyi geceler',
  'gif.topic.birthday': 'Doğum günü',
  'compass.declination': 'Manyetik sapma düzeltildi ({degrees}°, NOAA Dünya Manyetik Modeli WMM2025): pusula gerçek kuzeye göre gösterir.',
  'report.encryptedNote': 'Bu sohbet uçtan uca şifreli: bildirdiğin ve eklemeyi seçtiğin mesajlar senin cihazında çözülüp yalnız inceleme ekibine gönderilir. Diğer mesajlar şifreli kalır.',
  'admin.reports.encrypted': 'şifreli mesaj (içerik gönderilmedi)',
  'admin.reports.decrypted': 'bildirenin cihazında çözüldü',
  'admin.reports.decryptedHint': 'Uçtan uca şifreli bir mesaj; metni bildiren kişinin cihazı çözüp gönderdi.',
  'admin.tab.safety': 'Özel Bölge',
  'safety.cat.terror': 'Terör / bomba',
  'safety.cat.coup': 'Darbe / kalkışma',
  'safety.cat.murder': 'Cinayet / şiddet',
  'safety.cat.weapons': 'Silah',
  'safety.cat.drugs': 'Uyuşturucu / yasaklı madde',
  'safety.cat.trafficking': 'İnsan ticareti / kaçakçılık',
  'safety.cat.sexual_exploitation': 'Fuhuş / cinsel sömürü',
  'safety.cat.other_crime': 'Diğer yasa dışı',
  'safety.status.new': 'Yeni',
  'safety.status.reviewing': 'İnceleniyor',
  'safety.status.false_positive': 'Yanlış alarm',
  'safety.status.confirmed': 'Doğrulandı',
  'safety.status.escalated': 'Yetkililere iletildi',
  'safety.chat.direct': 'birebir sohbet',
  'safety.chat.group': 'grup',
  'safety.chat.channel': 'kanal',
  'safety.kind': 'Kural türü',
  'safety.kind.word': 'Kelime',
  'safety.kind.phrase': 'İfade',
  'safety.kind.pattern': 'Desen',
  'safety.kindHint.word': 'Kelimenin kökünü yaz: Türkçe ekli halleri de yakalanır (ör. "bomba" → bombayı, bombalar; "bombastik" yakalanmaz).',
  'safety.kindHint.phrase': 'Kelimeler bu sırayla, aralarında en çok iki kelimeyle geçerse yakalanır (ör. "silah sat" → "silahı yarın satıyorum").',
  'safety.kindHint.pattern': 'İleri düzey: düzenli ifade. Küçük harfli, Türkçe karakterleri sadeleştirilmiş metinde aranır (ç→c, ş→s, ı→i…).',
  'safety.kindExample.word': 'ör. patlayıcı',
  'safety.kindExample.phrase': 'ör. kiralık katil',
  'safety.kindExample.pattern': 'ör. \\b\\d+ ?gr\\w* kokain',
  'safety.pattern': 'Kural',
  'safety.weight': 'Ağırlık',
  'safety.weightN': '{n} puan',
  'safety.add': 'Kural ekle',
  'safety.addRule': '{category} için kural ekle',
  'safety.ruleOn': 'Kural açık',
  'safety.ruleDeleteConfirm': '"{pattern}" kuralı silinsin mi?',
  'safety.categories': 'Kategoriler',
  'safety.categoryOn': 'Bu kategori açık',
  'safety.threshold': 'Eşik puanı',
  'safety.thresholdHint': 'Bir mesajda eşleşen kuralların puanları toplamı eşiğe ulaşınca tespit kaydedilir. Tek başına 1 puanlık bir kelime (ör. "darbe aldım") yeterli olmaz.',
  'safety.view.queue': 'Tespitler',
  'safety.view.rules': 'Kurallar',
  'safety.view.test': 'Kural deneme',
  'safety.on': 'İzleme açık',
  'safety.off': 'İzleme kapalı',
  'safety.turnOn': 'İzlemeyi aç',
  'safety.turnOff': 'İzlemeyi kapat',
  'safety.enableConfirm': 'İzleme açılınca uçtan uca şifreli olmayan sohbetlerdeki yeni mesajlar kurallara göre kontrol edilir. Kullanım koşulları ve gizlilik metninde bunun yazdığından emin ol. Açılsın mı?',
  'safety.retention': 'Saklama süresi',
  'safety.days': '{n} gün',
  'safety.scope': 'Yalnız uçtan uca şifreli olmayan sohbetlerdeki yeni ve düzenlenen mesajlar kontrol edilir; hiçbir mesaj engellenmez veya değiştirilmez, gönderene bildirilmez. Şifreli sohbetler okunamaz: oradaki içerik yalnız kullanıcıların bildirimleriyle (Raporlar) gelir.',
  'safety.stat.open': 'açık tespit',
  'safety.stat.last30': 'son 30 günde',
  'safety.stat.confirmed': 'doğrulanan / iletilen',
  'safety.stat.falsePositive': 'yanlış alarm',
  'safety.ai.title': 'Yapay zekâ görüşü',
  'safety.ai.ask': 'AI’ya sor',
  'safety.ai.askAgain': 'Tekrar sor',
  'safety.ai.thinking': 'Değerlendiriyor…',
  'safety.ai.hint': 'Bu mesaj ve çevresindeki şifresiz mesajlar değerlendirme için Anthropic’e gönderilir. Karar sizindir.',
  'safety.ai.refused': 'Değerlendirmedi',
  'safety.ai.likelyFalsePositive': 'Muhtemelen yanlış alarm',
  'safety.ai.risk.none': 'Risk yok',
  'safety.ai.risk.low': 'Düşük risk',
  'safety.ai.risk.medium': 'Orta risk',
  'safety.ai.risk.high': 'Yüksek risk',
  'safety.ai.risk.critical': 'Kritik risk',
  'safety.ai.advice.dismiss': 'Öneri: kapat',
  'safety.ai.advice.monitor': 'Öneri: takipte tut',
  'safety.ai.advice.review': 'Öneri: yakından incele',
  'safety.ai.advice.escalate': 'Öneri: yetkililere ilet',
  'safety.ai.on': 'Yapay zekâ görüşü açık ({model}): açılan bir tespitte “AI’ya sor”a basınca çalışır. Bu ay {used}/{limit}.',
  'safety.ai.off': 'Yapay zekâ görüşü kapalı. Açmak için sunucuda SAFETY_AI=anthropic ve ANTHROPIC_API_KEY gerekir.',
  'safety.score': '{score} puan',
  'safety.matched': 'Eşleşen kelimeler',
  'safety.openMessage': 'Mesajı ve bağlamı aç',
  'safety.open': 'Aç',
  'safety.auditNote': 'Açmak için gerekçe yazılır; her açılış denetim kaydına geçer.',
  'safety.reasonPrompt': 'Neden açıyorsun? (en az 10 karakter, denetim kaydına yazılır)',
  'safety.reasonExample': 'ör. yüksek puanlı terör tespiti, inceleme',
  'safety.encrypted': 'şifreli mesaj (okunamaz)',
  'safety.noText': 'metin yok',
  'safety.note': 'İnceleme notu (isteğe bağlı)',
  'safety.reviewedBy': '{name} · {date}',
  'safety.filterStatus': 'Duruma göre',
  'safety.filterCategory': 'Kategoriye göre',
  'safety.open.only': 'Açık olanlar',
  'safety.all': 'Hepsi',
  'safety.allCategories': 'Tüm kategoriler',
  'safety.empty': 'Bu filtrede tespit yok.',
  'safety.emptyOff': 'İzleme kapalı: yeni tespit yapılmıyor.',
  'safety.more': 'Daha fazla',
  'safety.testHint': 'Bir metni şu anki kurallarla dene: hangi kategoride kaç puan aldığını görürsün. Hiçbir şey kaydedilmez.',
  'safety.testText': 'Denenecek metin',
  'safety.test': 'Dene',
  'safety.testNone': 'Hiçbir kural eşleşmedi.',
  'safety.wouldFlag': 'tespit edilirdi',
  'chat.typing': '{name} yazıyor…',
  'chat.loadOlder': 'Önceki mesajları yükle',
  'status.title': 'Durumun',
  'status.auto': 'Otomatik',
  'status.autoHint': 'Uygulamayı kullanırken Çevrimiçi, bir süre işlem yapmazsan Boşta, çıkınca Çevrimdışı.',
  'status.online': 'Çevrimiçi',
  'status.idle': 'Boşta',
  'status.dnd': 'Rahatsız etmeyin',
  'status.dndHint': 'Mesaj bildirimleri ve sesleri susar; aramalar yine gelir.',
  'status.busy': 'Meşgul',
  'status.busyHint': 'Başkaları şu an meşgul olduğunu görür.',
  'status.away': 'Dışarıda',
  'status.awayHint': 'Başkaları bir süre uzakta olduğunu görür.',
  'status.inCall': 'Görüşmede',
  'status.onCall': 'Aramada',
  'status.offline': 'Çevrimdışı',
  'status.invisible': 'Görünmez',
  'status.invisibleHint': 'Uygulamayı kullanırken başkalarına çevrimdışı görünürsün.',
  'status.forHowLong': 'Ne kadar süreyle?',
  'status.for.30m': '30 dakika',
  'status.for.1h': '1 saat',
  'status.for.2h': '2 saat',
  'status.for.today': 'Bugün',
  'status.for.week': 'Bu hafta',
  'status.for.forever': 'Ben değiştirene kadar',
  'status.until': '{time} kadar',
  'status.profile': 'Profil ve hesap',
  'privacy.shareCallStatus': 'Görüşmedeyken “Görüşmede” / “Aramada” göster',
  'privacy.shareCallStatusHint': 'Görüntülü görüşmede “Görüşmede”, sesli aramada “Aramada” görünürsün. Kapatırsan yalnızca çevrimiçi görünürsün.',
  'linkOffer.title': 'Bağlantı önizlemesi kapalı',
  'linkOffer.body': 'Açarsan önizleme için sayfayı sunucumuz okur; mesajın ve kime gittiği yine şifreli kalır.',
  'linkOffer.turnOn': 'Aç',
  'viewer.save': 'Resmi kaydet',
  'viewer.saveAs': 'Farklı kaydet…',
  'viewer.copy': 'Resmi kopyala',
  'viewer.share': 'Paylaş',
  'viewer.copied': 'Resim kopyalandı',
  'viewer.saved': 'Resim kaydedildi',
  'viewer.failed': 'Bu işlem yapılamadı. Tekrar dene.',
  'a11y.skipToContent': 'İçeriğe geç',
  'a11y.mainNav': 'Ana menü',
  'palette.title': 'Hızlı geçiş',
  'palette.short': 'Ara',
  'palette.placeholder': 'Sohbet, kişi, sayfa ya da ayar ara…',
  'palette.nothing': 'Sonuç yok.',
  'palette.move': 'gez',
  'palette.open': 'aç',
  'palette.toggle': 'aç / kapat',
  'palette.group.chats': 'Sohbetler',
  'palette.group.pages': 'Sayfalar',
  'palette.group.settings': 'Ayarlar',
  'palette.group.actions': 'İşlemler',
  'palette.settings': 'Ayarlar',
  'palette.group': 'Grup',
  'palette.channel': 'Kanal',
  'palette.darkTheme': 'Koyu temaya geç',
  'palette.lightTheme': 'Açık temaya geç',
  'jumpDate.title': 'Tarihe git',
  'jumpDate.quick': 'Hızlı seçim',
  'jumpDate.today': 'Bugün',
  'jumpDate.yesterday': 'Dün',
  'jumpDate.week': 'Bir hafta önce',
  'jumpDate.month': 'Bir ay önce',
  'jumpDate.year': 'Bir yıl önce',
  'jumpDate.first': 'En başa',
  'jumpDate.pick': 'Gün seç',
  'jumpDate.since': 'Bu sohbette {date} tarihinden beri mesaj var.',
  'jumpDate.go': 'Git',
  'jumpDate.nothing': 'Bu tarihte ya da sonrasında mesaj yok.',
  'chat.unreadMark': '{count} okunmamış mesaj',
  'chat.toNewest': 'En yeni mesajlara git',
  'chat.today': 'Bugün',
  'chat.yesterday': 'Dün',
  'chat.you': 'Sen',
  'chat.kindGroup': 'Grup',
  'chat.kindChannel': 'Kanal',
  'chat.noMessages': 'Henüz mesaj yok. İlk mesajı sen yaz.',
  'chat.status.queued': 'Gönderilmeyi bekliyor',
  'chat.status.sending': 'Gönderiliyor',
  'chat.status.sent': 'Gönderildi',
  'chat.status.delivered': 'İletildi',
  'chat.status.read': 'Okundu',
  'chat.status.failed': 'Gönderilemedi',
  'chat.retry': 'Tekrar dene',
  'chat.discard': 'Sil',
  'chat.cannotSend': 'Bu kişiye şu an mesaj gönderemezsin.',
  'chat.waitForReply': 'Bu kişi seni kişilerine eklediğinde ya da sana yazdığında cevap verebilirsin.',
  'chat.verifyToSend': 'Mesaj göndermek için önce e-posta adresini doğrula.',
  'chat.restrictedToSend': 'Mesajlaşma veli/vasi onayı tamamlandığında açılır.',
  'chat.encryptionNotice': 'Bu sohbet uçtan uca şifreli değil: mesajlar sunucuya şifreli bağlantıyla (TLS) gider ve sunucuda saklanır. Uçtan uca şifrelemeyi sağ üstteki ⋯ menüsünden açabilirsin.',
  'chat.unread': { one: '{count} okunmamış mesaj', other: '{count} okunmamış mesaj' },
  'common.back': 'Geri',
  'chats.filter.all': 'Tümü',
  'chats.filter.unread': 'Okunmamış',
  'chats.filter.groups': 'Gruplar',
  'chats.filterEmpty': 'Burada gösterilecek sohbet yok.',
  'chats.menu': 'Sohbet seçenekleri',
  'chats.pin': 'Sohbeti sabitle',
  'chats.unpin': 'Sabitlemeyi kaldır',
  'chats.pinned': 'Sabitlendi',
  'chats.archive': 'Arşivle',
  'chats.unarchive': 'Arşivden çıkar',
  'chats.clear': 'Sohbeti temizle',
  'chats.clearConfirm': 'Bu sohbetteki mesajlar yalnız senin cihazlarından silinsin mi? Karşı taraf etkilenmez.',
  'chats.delete': 'Sohbeti sil',
  'chats.deleteConfirm': 'Sohbet senin için silinsin mi? Mesajlar yalnız senden silinir; yeni mesaj gelirse sohbet geri gelir.',
  'chats.leaveGroup': 'Gruptan çık',
  'chats.leaveChannel': 'Kanaldan çık',
  'chats.leaveConfirm': 'Çıkmak istediğine emin misin?',
  'chats.swipe.read': 'Okundu',
  'chats.swipe.unread': 'Okunmadı',
  'chats.swipe.pin': 'Sabitle',
  'chats.swipe.unpin': 'Sabitten çıkar',
  'chats.swipe.unarchive': 'Arşivden çıkar',
  'chats.swipe.delete': 'Sil',
  'chats.swipe.leave': 'Çık',
  'chats.archivedToast': 'Sohbet arşivlendi',
  'chats.unarchivedToast': 'Sohbet arşivden çıkarıldı',
  'chats.undo': 'Geri al',
  'info.contactTitle': 'Kişi bilgisi',
  'info.search': 'Ara',
  'info.shared': 'Medya, bağlantılar ve belgeler',
  'info.tab.media': 'Medya',
  'info.tab.links': 'Bağlantılar',
  'info.tab.docs': 'Belgeler',
  'info.tab.voice': 'Sesli',
  'info.voiceMessage': 'Sesli mesaj · {date}',
  'info.sharedNone': 'Henüz yok (yüklenen mesajlarda).',
  'info.starred': 'Yıldızlı mesajlar',
  'info.notifications': 'Bildirimler',
  'info.notificationsOn': 'Açık',
  'info.encryption': 'Şifreleme',
  'info.encryptionOn': 'Mesajlar ve aramalar uçtan uca şifreli. Doğrulamak için dokun.',
  'info.commonGroups': 'Ortak gruplar',
  'info.noCommonGroups': 'Ortak grubunuz yok.',
  'info.block': '{name} kişisini engelle',
  'info.unblock': '{name} kişisinin engelini kaldır',
  'info.blockConfirm': '{name} engellensin mi? Sana mesaj gönderemez ve seni arayamaz.',
  'info.report': '{name} kişisini şikâyet et',
  'chats.archived': 'Arşivlenmiş',
  'chats.archiveNote': 'Arşivdeki sohbetler yeni mesaj gelse de arşivde kalır. Bildirimler ayarlarına göre gelmeye devam eder.',
  'chats.archiveEmpty': 'Arşivde sohbet yok.',
  'chats.markRead': 'Okundu olarak işaretle',
  'chats.markUnread': 'Okunmadı olarak işaretle',
  'chats.markedUnread': 'Okunmadı olarak işaretlendi',
  'chats.addToFolder': 'Klasöre ekle',
  'chats.folders': 'Sohbet klasörleri',
  'chats.folders.intro': 'Klasörler sohbet listeni sekmelere ayırır: iş, aile, okul… Sadece sen görürsün; tüm cihazlarında aynıdır.',
  'chats.folders.none': 'Henüz klasörün yok.',
  'chats.folders.manage': 'Klasörleri düzenle',
  'chats.folders.new': 'Yeni klasör',
  'chats.folders.edit': 'Klasörü düzenle',
  'chats.folders.delete': 'Klasörü sil',
  'chats.folders.deleteConfirm': '"{name}" klasörü silinsin mi? İçindeki sohbetler silinmez.',
  'chats.folders.up': 'Yukarı taşı',
  'chats.folders.down': 'Aşağı taşı',
  'chats.folders.name': 'Klasör adı',
  'chats.folders.namePlaceholder': 'Örn. İş, Aile, Okul',
  'chats.folders.icon': 'Klasör simgesi',
  'chats.folders.types': 'Otomatik ekle',
  'chats.folders.type.direct': 'Tüm birebir sohbetler',
  'chats.folders.type.group': 'Tüm gruplar',
  'chats.folders.type.channel': 'Tüm kanallar',
  'chats.folders.excludeMuted': 'Sessizdekileri gösterme',
  'chats.folders.excludeRead': 'Okunmuşları gösterme',
  'chats.folders.chats': { one: 'Seçilen sohbetler ({count})', other: 'Seçilen sohbetler ({count})' },
  'chats.folders.count': { one: '{count} sohbet', other: '{count} sohbet' },
  'chats.folders.emptyHint': 'Bir sohbet türü ya da en az bir sohbet seç.',
  'timer.hours': { one: '{count} saat', other: '{count} saat' },
  'timer.days': { one: '{count} gün', other: '{count} gün' },
  'timer.title': 'Kaybolan mesajlar',
  'timer.intro': 'Açıldığında, bundan sonra gönderilen yeni mesajlar seçilen süre dolunca herkesin cihazından ve sunucudan silinir.',
  'timer.off': 'Kapalı',
  'timer.note': 'Mevcut mesajlar etkilenmez. Karşı taraf ekran görüntüsü alabilir veya mesajı başka yere kaydedebilir.',
  'timer.noticeOn': '{name} kaybolan mesajları açtı. Yeni mesajlar {time} sonra silinecek.',
  'timer.noticeOff': '{name} kaybolan mesajları kapattı.',
  'timer.noticeOnYou': 'Kaybolan mesajları açtın. Yeni mesajlar {time} sonra silinecek.',
  'timer.noticeOffYou': 'Kaybolan mesajları kapattın.',
  'timer.active': 'Kaybolan mesajlar: {time}',
  'timer.menu': 'Kaybolan mesajlar',
  'poll.create': 'Anket oluştur',
  'attach.document': 'Belge',
  'attach.media': 'Fotoğraflar ve videolar',
  'attach.audio': 'Ses',
  'attach.contact': 'Kişi',
  'attach.poll': 'Anket',
  'attach.event': 'Etkinlik',
  'event.create': 'Etkinlik oluştur',
  'sticker.new': 'Yeni çıkartma',
  'sticker.newShort': 'Yeni',
  'sticker.mine': 'Çıkartmalarım',
  'sticker.pack': 'Hazır çıkartmalar',
  'sticker.sendMine': 'Çıkartmayı gönder',
  'sticker.delete': 'Çıkartmayı sil',
  'sticker.deleteConfirm': 'Bu çıkartma koleksiyonundan silinsin mi? Gönderdiklerin sohbetlerde kalır.',
  'sticker.pick': 'Fotoğraf seç',
  'sticker.pickHint': 'Kendi fotoğrafından çıkartma yap; sonra yerleştir, büyüt, yazı ekle.',
  'sticker.preview': 'Çıkartma önizlemesi',
  'sticker.dragHint': 'Sürükleyerek yerleştir',
  'sticker.zoom': 'Yakınlaştır',
  'sticker.shape': 'Biçim',
  'sticker.shape.circle': 'Yuvarlak',
  'sticker.shape.rounded': 'Oval köşe',
  'sticker.shape.square': 'Kare',
  'sticker.caption': 'Yazı (isteğe bağlı)',
  'sticker.captionPlaceholder': 'Örn. Harika!',
  'sticker.another': 'Başka fotoğraf',
  'sticker.save': 'Kaydet',
  'sticker.saveSend': 'Kaydet ve gönder',
  'sticker.badPicture': 'Bu fotoğraf açılamadı. Başka bir fotoğraf dene.',
  'event.title': 'Etkinlik adı',
  'event.titlePlaceholder': 'Örn. Veli toplantısı',
  'event.date': 'Tarih',
  'event.start': 'Başlangıç',
  'event.end': 'Bitiş (isteğe bağlı)',
  'event.location': 'Yer (isteğe bağlı)',
  'event.locationPlaceholder': 'Adres ya da çevrim içi bağlantı',
  'event.description': 'Açıklama (isteğe bağlı)',
  'event.send': 'Gönder',
  'event.badTime': 'Tarih ve saati kontrol et.',
  'event.endBeforeStart': 'Bitiş, başlangıçtan sonra olmalı.',
  'event.answer': 'Katılım',
  'event.rsvp.going': 'Katılıyorum',
  'event.rsvp.maybe': 'Belki',
  'event.rsvp.no': 'Katılmıyorum',
  'event.addToCalendar': 'Takvime ekle',
  'event.cancel': 'Etkinliği iptal et',
  'event.cancelConfirm': 'Etkinlik iptal edilsin mi? Herkes görür; yanıtlar kapanır.',
  'event.cancelled': 'Bu etkinlik iptal edildi.',
  'event.past': 'Etkinlik sona erdi.',
  'event.goingList': { one: '{count} kişi katılıyor', other: '{count} kişi katılıyor' },
  'poll.menu': 'Anket',
  'poll.question': 'Soru',
  'poll.questionPlaceholder': 'Ne sormak istiyorsun?',
  'poll.options': 'Seçenekler',
  'poll.option': 'Seçenek {n}',
  'poll.removeOption': 'Seçeneği kaldır',
  'poll.duplicate': 'Aynı seçenek iki kez yazılmış.',
  'poll.allowMultiple': 'Birden fazla cevaba izin ver',
  'poll.makeAnonymous': 'Anonim anket (kimin neyi seçtiği görünmez)',
  'poll.send': 'Anketi gönder',
  'poll.single': 'Tek seçim',
  'poll.multiple': 'Birden fazla seçim',
  'poll.anonymous': 'Anonim',
  'poll.closed': 'Sona erdi',
  'poll.percent': '%{pct}',
  'poll.voters': { one: '{count} kişi oy verdi', other: '{count} kişi oy verdi' },
  'poll.votes': { one: '{count} oy', other: '{count} oy' },
  'poll.seeVotes': 'Oyları gör',
  'poll.close': 'Anketi bitir',
  'poll.closeConfirm': 'Anket bitirilsin mi? Sonuçlar kalır, artık oy verilemez.',
  'poll.notInE2ee': 'Anketler uçtan uca şifreli sohbetlerde kullanılamaz (soru ve seçenekler sunucuda okunur olurdu).',
  'schedule.menu': 'Zamanlanmış gönder',
  'schedule.title': 'Ne zaman gönderilsin?',
  'schedule.inHour': '1 saat sonra',
  'schedule.tonight': 'Bu akşam',
  'schedule.tomorrowMorning': 'Yarın sabah',
  'schedule.mondayMorning': 'Pazartesi sabah',
  'schedule.custom': 'Tarih ve saat seç',
  'schedule.confirm': 'Zamanla',
  'schedule.tooSoon': 'En az 1 dakika sonrasını seç.',
  'schedule.done': 'Mesaj zamanlandı: {when}',
  'schedule.banner': { one: '{count} zamanlanmış mesaj', other: '{count} zamanlanmış mesaj' },
  'schedule.listTitle': 'Zamanlanmış mesajlar',
  'schedule.none': 'Bu sohbette zamanlanmış mesajın yok.',
  'schedule.failed': 'Gönderilemedi',
  'schedule.sendNow': 'Şimdi gönder',
  'schedule.changeTime': 'Zamanı değiştir',
  'schedule.delete': 'Sil',
  'schedule.hint': 'Basılı tut ya da sağ tıkla: zamanla',
  'mention.suggestions': 'Bahsedilecek kişiler',
  'mention.badge': 'Senden bahsedildi',
  'chat.attachMenu': 'Ekle',
  'chat.attachFile': 'Fotoğraf, video veya dosya',
  'chat.back': 'Sohbetlere dön',
  'contacts.title': 'Kişiler',
  'contacts.add': 'Ekle',
  'contacts.addLabel': 'Kullanıcı adıyla kişi ekle',
  'contacts.usernamePlaceholder': '@kullanıcıadı',
  'contacts.added': '{name} kişilerine eklendi.',
  'contacts.empty': 'Henüz kişin yok.',
  'contacts.message': 'Mesaj',
  'contacts.block': 'Engelle',
  'contacts.unblock': 'Engeli kaldır',
  'contacts.blocked': 'Engellendi',
  'contacts.hint': 'Birini eklemek onun sana yazabilmesini sağlar. Sen ona yazabilmek için onun da seni eklemesi ya da herkesten mesaj kabul etmesi gerekir.',
  'push.newMessage': 'Yeni mesaj',
  'requests.title': 'Mesaj istekleri',
  'requests.note': 'Eklemediğin kişilerden gelen mesajlar burada bekler. Sen kabul edene kadar mesajlarını okuduğunu bilmezler ve seni arayamazlar.',
  'requests.incomingTitle': '{name} sana mesaj göndermek istiyor',
  'requests.incomingNote': 'Kabul edersen normal sohbet olur. Silersen sana bir daha bu sohbetten yazamaz; sana haber verilmez.',
  'requests.accept': 'Kabul et',
  'requests.delete': 'Sil',
  'requests.block': 'Engelle',
  'requests.blockConfirm': '{name} engellensin mi? Sana yazamaz ve seni arayamaz.',
  'requests.outgoingNote': 'Mesaj isteği olarak gidiyor: {name} kabul edene kadar {left} mesaj daha gönderebilirsin ve görüldü bilgisi çıkmaz.',
  'requests.waiting': 'Mesaj isteğin gönderildi. {name} kabul edince sohbete devam edebilirsin.',
  'requests.hubTitle': 'İstekler',
  'requests.hubNote': 'Eklemediğin kişilerden gelen mesajlar ve seni kişilerine ekleyenler burada bekler. Yeni bir istek geldiğinde haber verilir; ne seçersen seç karşı tarafa söylenmez.',
  'requests.messagesHeading': 'Mesaj istekleri',
  'requests.addedHeading': 'Seni ekleyenler',
  'requests.addedNote': 'Bu kişiler seni kişilerine ekledi. Sen de eklersen birbirinizin durumlarını görürsünüz. Yoksayarsan listeden kalkar; ekleyen kişiye bir şey söylenmez.',
  'requests.addedYou': 'seni ekledi',
  'requests.addBack': 'Ekle',
  'requests.ignore': 'Yoksay',
  'requests.report': 'Bildir',
  'requests.more': '{name} için diğer seçenekler',
  'requests.empty': 'Bekleyen istek yok. Biri sana mesaj isteği gönderdiğinde ya da seni kişilerine eklediğinde burada görünür ve sana haber verilir.',
  'requests.senderSees': 'Sen kabul edene kadar {name} mesajlarını okuduğunu görmez, seni arayamaz ve en fazla {max} mesaj gönderebilir.',
  'requests.rowMessages': { one: '{count} mesaj isteği', other: '{count} mesaj isteği' },
  'requests.rowPeople': { one: '{count} kişi seni ekledi', other: '{count} kişi seni ekledi' },
  'requests.wallPointer': { one: '{count} kişi seni ekledi', other: '{count} kişi seni ekledi' },
  'requests.wallPointerHint': 'Mesajlar › İstekler’de ekleyebilir ya da yoksayabilirsin',
  'push.messageRequestBody': '{name} sana mesaj göndermek istiyor',
  'push.messageRequest': 'Mesaj isteği',
  'push.contactAdded': 'Yeni kişi isteği',
  'push.contactAddedBody': '{name} seni kişilerine ekledi. Mesajlar › İstekler’den ekleyebilir ya da yoksayabilirsin.',
  'notify.inviteTitle': 'Bildirimleri aç',
  'notify.inviteBody': 'Uygulama arka plandayken ya da kapalıyken de mesaj ve aramalardan haberin olsun.',
  'notify.enable': 'Aç',
  'notify.deniedHelp': 'Tarayıcı bildirimleri engelledi. Adres çubuğundaki kilit simgesinden bu site için bildirimlere izin ver.',
  'notify.tapToAnswer': 'Cevaplamak için dokun',
  'twofa.title': 'İki adımlı doğrulama',
  'twofa.intro': 'Parolan çalınsa bile hesabın korunsun: girişte doğrulayıcı uygulamandaki 6 haneli kod da istenir.',
  'twofa.onSince': 'Açık · {date} tarihinden beri',
  'twofa.on': 'Açık',
  'twofa.off': 'Kapalı',
  'twofa.setUp': 'İki adımlı doğrulamayı aç',
  'twofa.password': 'Parolan',
  'twofa.continue': 'Devam',
  'twofa.scanHint': 'Google Authenticator, Microsoft Authenticator, 1Password ya da Aegis gibi bir doğrulayıcı uygulamayla bu kodu okut.',
  'twofa.qrLabel': 'Doğrulayıcı uygulama için QR kod',
  'twofa.manual': 'Okutamıyorsan bu anahtarı uygulamaya elle yaz:',
  'twofa.firstCode': 'Uygulamadaki 6 haneli kod',
  'twofa.turnOn': 'Doğrula ve aç',
  'twofa.codesTitle': 'Yedek kodların',
  'twofa.codesHint': 'Telefonunu kaybedersen bu kodlarla giriş yapabilirsin; her biri bir kez çalışır. Güvenli bir yere kaydet (parola yöneticisi ya da kâğıt). Bu kodlar bir daha gösterilmez.',
  'twofa.copy': 'Kopyala',
  'twofa.copied': 'Kopyalandı',
  'twofa.download': 'İndir',
  'twofa.savedThem': 'Kaydettim',
  'twofa.codesLeft': { one: '{count} yedek kodun kaldı.', other: '{count} yedek kodun kaldı.' },
  'twofa.newCodes': 'Yeni yedek kodlar',
  'twofa.codePrompt': 'Doğrulayıcı uygulamandaki kodu (ya da bir yedek kodu) yaz:',
  'twofa.turnOff': 'Kapat',
  'twofa.codeOrBackup': 'Uygulamadaki kod ya da bir yedek kod',
  'twofa.codesFileTitle': 'DijitalApp yedek kodları (her biri bir kez kullanılır)',
  'twofa.loginTitle': 'İki adımlı doğrulama',
  'twofa.loginHint': 'Doğrulayıcı uygulamandaki 6 haneli kodu gir.',
  'twofa.code': 'Kod',
  'twofa.backupHint': 'Telefonun yanında değilse yedek kodlarından birini yazabilirsin.',
  'twofa.verify': 'Doğrula ve giriş yap',
  'notify.title.unread': { one: '{count} yeni mesaj', other: '{count} yeni mesaj' },
  'notify.title.missed': { one: '{count} cevapsız arama', other: '{count} cevapsız arama' },
  'notify.title.newFrom': '{name}: yeni mesaj',
  'notify.title.missedFrom': 'Cevapsız arama: {name}',
  'push.newMessageHidden': 'Yeni bir mesajın var',
  'push.reminderHidden': 'Yaklaşan bir etkinliğin var',
  'push.reminderStarts': '{when} başlıyor',
  'push.reminderNow': 'Şimdi başlıyor',
  'push.reminderAllDay': '{day} · tüm gün',
  'notifications.title': 'Bildirimler',
  'notifications.body': 'Uygulama kapalıyken yeni mesajlardan haberdar ol.',
  'notifications.enable': 'Bu cihazda bildirimleri aç',
  'notifications.disable': 'Bu cihazda kapat',
  'notifications.enabled': 'Bu cihazda bildirimler açık.',
  'notifications.denied': 'Tarayıcı bildirim iznini engelledi. İzni tarayıcının site ayarlarından açabilirsin.',
  'notifications.unsupported': 'Bu tarayıcı web bildirimlerini desteklemiyor.',
  'notifications.test': 'Test bildirimi gönder',
  'notifications.testSent': 'Gönderildi. Birkaç saniye içinde bu cihazda bir bildirim görmelisin; uygulamayı kapatıp da deneyebilirsin.',
  'notifications.testNone': 'Bu cihaz bildirime kayıtlı görünmüyor. Bildirimleri kapatıp yeniden aç.',
  'notifications.testShown': 'Bildirim bu cihaza ulaştı ve gösterildi.',
  'notifications.testShownWindows': 'Ekranda görmediysen Windows gizliyor: Ayarlar › Sistem › Bildirimler’de bildirimleri ve listede tarayıcını (Chrome ya da Edge) aç, “Rahatsız etme”yi kapat. Tarayıcıda da siteye bildirim izni açık olmalı.',
  'notifications.testShownApple': 'Ekranda görmediysen cihaz gizliyor: Ayarlar › Bildirimler’de DijitalApp’i aç (iPhone’da bildirimler yalnızca ana ekrana eklenen uygulamaya gelir) ve Odak’ı kapat.',
  'notifications.testShownMac': 'Ekranda görmediysen macOS gizliyor (Odak’tan ayrı bir ayar): Sistem Ayarları › Bildirimler’de listede Google Chrome’u (Safari ya da uygulama olarak eklediysen “DijitalApp”) bul, “Bildirimlere izin ver”i aç ve uyarı stilini “Afişler” ya da “Uyarılar” yap. Sağ üstteki saate tıklayıp Bildirim Merkezi’ne bak: bildirim orada duruyorsa stil “Hiçbiri” seçilidir.',
  'notifications.testShownPhone': 'Ekranda görmediysen telefon gizliyor: Ayarlar › Uygulamalar › tarayıcın (ya da DijitalApp) › Bildirimler’i aç ve Rahatsız Etme’yi kapat.',
  'notifications.testLost': 'Bildirim servise gönderildi ama bu cihaza ulaşmadı. Bildirimleri kapatıp yeniden aç; olmazsa tarayıcıyı tamamen kapatıp açıp tekrar dene.',
  'notifications.iosInstall': 'iPhone ve iPad’de bildirimler yalnızca ana ekrana eklenen uygulamaya gelir: Safari’de Paylaş düğmesine dokun, “Ana Ekrana Ekle”yi seç, sonra uygulamayı ana ekrandan açıp bildirimleri buradan aç.',
  'notifications.backgroundHint': 'Uygulama kapalıyken ya da arka plandayken de mesaj ve aramalar bildirim olarak gelir.',
  'push.testTitle': 'Bildirimler çalışıyor',
  'push.testBody': 'Mesajlar ve aramalar uygulama kapalıyken de böyle görünecek.',
  'notifications.unavailable': 'Bildirimler şu an kullanılamıyor.',
  'notifications.preview': 'Bildirimde göster',
  'notifications.preview.full': 'Gönderen ve mesaj',
  'notifications.preview.sender': 'Yalnız gönderen',
  'notifications.preview.hidden': 'Hiçbir ayrıntı',
  'notifications.previewHint': 'Mesaj metni bildirim servisine şifreli iletilir ama kilit ekranında görünebilir.',
  'notifications.interactions.title': 'Etkileşimler',
  'notifications.interactions.body': 'Mesajlarına ve durumlarına gelen tepkilerden, bahsedilmelerden ve grup aramalarından haberdar ol. Sessize aldığın sohbetler ve Rahatsız Etme bunları da susturur.',
  'notifications.interactions.reactions': 'Tepkiler',
  'notifications.interactions.reactionsHint': 'Biri mesajına tepki verdiğinde (beğeni dahil)',
  'notifications.interactions.storyLikes': 'Durum beğenileri ve tepkileri',
  'notifications.interactions.storyLikesHint': 'Biri durumunu beğendiğinde; art arda gelenler tek bildirimde toplanır',
  'notifications.interactions.storyReshares': 'Durum paylaşımları',
  'notifications.interactions.storyResharesHint': 'Biri durumunu kendi durumunda paylaştığında',
  'notifications.interactions.mentions': 'Bahsedilmeler',
  'notifications.interactions.mentionsHint': 'Bir grupta @ ile senden bahsedildiğinde, sohbet sessizde olsa bile',
  'notifications.interactions.groupCalls': 'Grup aramaları',
  'notifications.interactions.groupCallsHint': 'Gruplarında arama başladığında ve katılmadığın grup aramalarında',
  'mute.label': 'Sessize al',
  'mute.1h': '1 saat',
  'mute.8h': '8 saat',
  'mute.1w': '1 hafta',
  'mute.forever': 'Her zaman',
  'mute.off': 'Sessizi kaldır',
  'mute.active': 'Sessizde',
  'report.message': 'Bildir',
  'report.user': 'Kullanıcıyı bildir',
  'report.title': 'Bildir',
  'report.reason': 'Neden bildiriyorsun?',
  'report.reason.spam': 'Spam veya istenmeyen mesaj',
  'report.reason.harassment': 'Taciz veya zorbalık',
  'report.reason.hate': 'Nefret söylemi',
  'report.reason.sexual_content': 'Cinsel içerik',
  'report.reason.child_safety': 'Bir çocuğun güvenliği risk altında',
  'report.reason.self_harm': 'Kendine zarar verme',
  'report.reason.violence': 'Şiddet veya tehdit',
  'report.reason.impersonation': 'Başkasının kimliğine bürünme',
  'report.reason.scam': 'Dolandırıcılık',
  'report.reason.other': 'Diğer',
  'report.details': 'Eklemek istediğin bilgi (isteğe bağlı)',
  'report.includeRecent': { one: 'Son {count} mesajı kanıt olarak ekle', other: 'Son {count} mesajı kanıt olarak ekle' },
  'report.evidenceNote': 'Yalnızca bildirdiğin mesaj ve eklemeyi seçtiğin mesajlar inceleme ekibiyle paylaşılır.',
  'report.alsoBlock': 'Bu kişiyi engelle',
  'report.submit': 'Bildirimi gönder',
  'report.sent': 'Teşekkürler. Bildirimin alındı ve incelenecek.',
  'report.emergency': 'Biri şu an tehlikedeyse hemen 112 Acil Çağrı Merkezi’ni ara.',
  'common.close': 'Kapat',
  'common.scrollPrev': 'Önceki',
  'common.scrollNext': 'Sonraki',
  'admin.nav': 'Yönetim',
  'admin.title': 'Yönetim',
  'admin.passkeyRequired': 'Yönetici işlemleri yalnız passkey ile açılmış ve 12 saatten yeni bir oturumda çalışır. Çıkış yapıp “Passkey ile giriş yap” ile tekrar gir.',
  'admin.roles': 'Rollerin: {roles}',
  'admin.tab.users': 'Kullanıcılar',
  'admin.tab.reports': 'Şikâyetler',
  'admin.tab.invites': 'Davetler',
  'admin.search': 'Kullanıcı adı, e-posta veya kimlik',
  'invite.title': 'Arkadaşlarını {brand}\'e davet et',
  'invite.desc': 'Kişisel bağlantını paylaş; katılanlar otomatik olarak kişilerine eklenir ve hemen yazışabilirsiniz.',
  'invite.notAllowed': 'Davet bağlantısı, e-postası doğrulanmış yetişkin hesaplar içindir.',
  'invite.create': 'Davet bağlantımı oluştur',
  'invite.link': 'Davet bağlantın',
  'invite.copy': 'Kopyala',
  'invite.copied': 'Kopyalandı',
  'invite.share': 'Paylaş',
  'invite.email': 'E-posta',
  'invite.qr': 'QR kod',
  'invite.qrLabel': 'Davet bağlantısının QR kodu',
  'invite.qrHint': 'Karşındaki kişi telefonunun kamerasıyla okutsun.',
  'invite.message': '{brand}\'e katıl, oradan yazışalım: {link}',
  'invite.shareText': '{brand}\'e katıl, oradan yazışalım.',
  'invite.mailSubject': '{brand} daveti',
  'invite.used': '{count} / {max} kullanım',
  'invite.renew': 'Yeni bağlantı oluştur',
  'invite.renewConfirm': 'Eski bağlantı çalışmayı bırakacak. Yeni bağlantı oluşturulsun mu?',
  'invite.joinedCount': { one: 'Davetinle 1 kişi katıldı', other: 'Davetinle {count} kişi katıldı' },
  'invite.joinedOn': '{date} tarihinde katıldı',
  'invite.invitedBy': '{name} seni davet etti. Kaydolunca kişilerinize eklenirsiniz.',
  'admin.invites.personal': '@{name} kişisel davet bağlantısı',
  'admin.invites.joinsTitle': 'Kim kimi davet etti',
  'admin.invites.joinsSearch': 'Davet eden ya da katılan kullanıcı adı',
  'admin.invites.joinsEmpty': 'Henüz davetle katılan yok.',
  'admin.invites.colInviter': 'Davet eden',
  'admin.invites.colJoined': 'Katılan',
  'admin.invites.colVia': 'Nasıl',
  'admin.invites.colWhen': 'Ne zaman',
  'admin.invites.viaLink': 'Kişisel bağlantı',
  'admin.invites.viaCode': 'Yönetici kodu',
  'admin.users.hint': 'Aramak için bir ad, e-posta ya da kimlik yaz; ya da doğrulanmamış hesapları listele.',
  'admin.verify.filter': 'Yalnızca e-postası doğrulanmamışlar',
  'admin.verify.badge': 'E-posta doğrulanmadı',
  'admin.verify.one': 'Doğrula',
  'admin.verify.resend': 'Doğrulama e-postası gönder',
  'admin.verify.selectAll': 'Tümünü seç',
  'admin.verify.selected': { one: 'Seçileni doğrula', other: 'Seçilen {count} hesabı doğrula' },
  'admin.verify.pick': '{name} hesabını seç',
  'admin.verify.confirmMany': '{count} hesabın e-posta adresi elle doğrulanmış sayılacak. Devam edilsin mi?',
  'admin.verify.done': { one: '1 hesap doğrulandı.', other: '{count} hesap doğrulandı.' },
  'admin.verify.resent': '{name} için doğrulama e-postası gönderildi.',
  'admin.state.active': 'Aktif',
  'admin.state.restricted': 'Kısıtlı',
  'admin.state.suspended': 'Askıda',
  'admin.suspend': 'Askıya al',
  'admin.unsuspend': 'Askıdan çıkar',
  'admin.suspendReason': 'Askıya alma nedeni (kayda geçer)',
  'admin.noResults': 'Sonuç yok.',
  'admin.people.filter.state': 'Hesap durumu',
  'admin.people.filter.all': 'Tümü',
  'admin.people.filter.active': 'Aktif',
  'admin.people.filter.suspended': 'Askıda',
  'admin.people.filter.unverified': 'Doğrulanmamış',
  'admin.people.filter.online': 'Çevrimiçi',
  'admin.people.filter.staff': 'Ekip',
  'admin.people.filter.plan': 'Plan',
  'admin.people.filter.anyPlan': 'Tüm planlar',
  'admin.people.sort': 'Sırala',
  'admin.people.sort.newest': 'Kayıt tarihi',
  'admin.people.sort.lastSeen': 'Durum (çevrimiçi önce)',
  'admin.people.sort.lastLogin': 'Son giriş',
  'admin.people.sort.active': 'Etkinlik (30 gün)',
  'admin.people.sort.name': 'Ad',
  'admin.people.sort.plan': 'Plan',
  'admin.people.sort.roles': 'Roller (ekip önce)',
  'admin.people.dir.asc': 'Artan sırada',
  'admin.people.dir.desc': 'Azalan sırada',
  'admin.people.dir.toggle': 'Sıralama yönünü değiştir',
  'admin.people.sortBy': '{column} sütununa göre sırala',
  'admin.people.sorting': 'Sıralanıyor…',
  'admin.people.col.person': 'Kişi',
  'admin.people.col.status': 'Durum',
  'admin.people.col.registered': 'Kayıt',
  'admin.people.col.lastLogin': 'Son giriş',
  'admin.people.col.plan': 'Plan',
  'admin.people.col.roles': 'Roller',
  'admin.people.col.activity': 'Etkinlik',
  'admin.people.online': 'Çevrimiçi',
  'admin.people.never': 'Hiç',
  'admin.people.neverSeen': 'Görülmedi',
  'admin.people.justNow': 'az önce',
  'admin.people.minutesAgo': { one: '{count} dk önce', other: '{count} dk önce' },
  'admin.people.hoursAgo': { one: '{count} sa önce', other: '{count} sa önce' },
  'admin.people.daysAgo': { one: '{count} gün önce', other: '{count} gün önce' },
  'admin.people.stat.messages': { one: 'Son 30 günde 1 mesaj', other: 'Son 30 günde {count} mesaj' },
  'admin.people.stat.audio': { one: '1 sesli arama', other: '{count} sesli arama' },
  'admin.people.stat.video': { one: '1 görüntülü arama', other: '{count} görüntülü arama' },
  'admin.people.stat.groups': { one: '1 grup', other: '{count} grup' },
  'admin.people.empty': 'Kimse bulunamadı',
  'admin.people.emptyFiltered': 'Bu arama ve filtrelere uyan kimse yok. Filtreleri gevşetmeyi dene.',
  'admin.people.clear': 'Filtreleri temizle',
  'admin.people.shown': { one: '1 kişi gösteriliyor', other: '{count} kişi gösteriliyor' },
  'admin.people.more': 'Daha fazla göster',
  'admin.people.open': '{name} ayrıntılarını aç',
  'admin.people.loading': 'Yükleniyor…',
  'admin.people.sections': 'Kişi bölümleri',
  'admin.people.tab.general': 'Genel',
  'admin.people.tab.sessions': 'Oturumlar ve cihazlar',
  'admin.people.tab.activity': 'Aktivite',
  'admin.people.tab.security': 'Güvenlik',
  'admin.people.kpi.messages': 'Mesaj (30 gün)',
  'admin.people.kpi.audio': 'Sesli arama',
  'admin.people.kpi.video': 'Görüntülü arama',
  'admin.people.kpi.missed': 'Cevapsız arama',
  'admin.people.kpi.devices': 'Açık cihaz',
  'admin.people.kpi.groups': 'Grup',
  'admin.people.field.email': 'E-posta',
  'admin.people.field.state': 'Hesap durumu',
  'admin.people.field.registered': 'Kayıt tarihi',
  'admin.people.field.lastLogin': 'Son giriş',
  'admin.people.field.lastSeen': 'Son görülme',
  'admin.people.field.ageBand': 'Yaş grubu',
  'admin.people.field.locale': 'Dil ve bölge',
  'admin.people.field.onboarding': 'İlk kurulum',
  'admin.people.field.about': 'Hakkında',
  'admin.people.field.id': 'Kimlik',
  'admin.people.verified': 'Doğrulandı',
  'admin.people.onboardingDone': 'Tamamlandı',
  'admin.people.onboardingPending': 'Tamamlanmadı',
  'admin.people.actions': 'İşlemler',
  'admin.people.family': 'Aile Merkezi',
  'admin.people.guardian': 'Veli',
  'admin.people.child': 'Çocuk',
  'admin.people.devicesEmpty': 'Bu kişinin kayıtlı cihazı yok.',
  'admin.people.device.lastActive': 'Son etkinlik: {when}',
  'admin.people.device.signedIn': 'giriş: {date}',
  'admin.people.device.network': 'ağ: {ip}',
  'admin.people.device.active': 'Oturum açık',
  'admin.people.device.signedOut': 'Oturum kapalı',
  'admin.people.method.password': 'Parola',
  'admin.people.method.passkey': 'Geçiş anahtarı',
  'admin.people.method.qr': 'QR ile',
  'admin.people.groups': 'Gruplar ve kanallar',
  'admin.people.groupsEmpty': 'Hiçbir grupta ya da kanalda değil.',
  'admin.people.members': { one: '1 üye', other: '{count} üye' },
  'admin.people.joined': 'katıldı: {date}',
  'admin.people.role.owner': 'Sahip',
  'admin.people.role.admin': 'Yönetici',
  'admin.people.role.moderator': 'Moderatör',
  'admin.people.role.member': 'Üye',
  'admin.people.securityEmpty': 'Kayıtlı güvenlik olayı yok.',
  'admin.people.securityHidden': 'Güvenlik olaylarını görme yetkin yok.',
  'admin.people.tab.invites': 'Davetler',
  'admin.people.invitedBy': 'Davet eden',
  'admin.people.invitedByNobody': 'Kayıtlı değil',
  'admin.people.via.personal_link': 'kişisel davet bağlantısıyla',
  'admin.people.via.admin_code': 'yönetici davet koduyla',
  'admin.people.invitees': 'Davet ettikleri',
  'admin.people.inviteesEmpty': 'Henüz kimseyi davet etmedi.',
  'admin.people.invite.total': 'Davet edilen',
  'admin.people.invite.totalHint': 'Davetiyle kayıt olan herkes (silinen hesaplar dahil)',
  'admin.people.invite.joined': 'Katılan',
  'admin.people.invite.joinedHint': 'Kaydını tamamlayan (e-postası doğrulanmış, hesabı duran)',
  'admin.people.invite.active': 'Son 30 günde aktif',
  'admin.people.deletedAccount': 'Silinmiş hesap',
  'admin.people.invitee.recent': 'Son 30 günde aktif',
  'admin.people.invitee.idle': '30 günden uzun süredir yok',
  'admin.people.invitee.never': 'Hiç giriş yapmadı',
  'admin.people.inviteesShown': { one: '{total} kişiden 1 kişi gösteriliyor', other: '{total} kişiden {count} kişi gösteriliyor' },
  'admin.reports.empty': 'Bekleyen rapor yok.',
  'admin.reports.priority': 'Öncelik {priority}',
  'admin.reports.evidence': 'Kanıt',
  'admin.reports.note': 'Karar notu (kayda geçer)',
  'admin.reports.action': 'İşlem yapıldı',
  'admin.reports.dismiss': 'Reddet',
  'admin.reports.filter': 'Rapor türü',
  'admin.reports.type.all': 'Tümü',
  'admin.reports.type.message': 'Mesaj',
  'admin.reports.type.user': 'Kişi',
  'admin.reports.type.story': 'Durum',
  'admin.reports.removeStory': 'Durumu kaldır',
  'admin.reports.removeStoryReason': 'Kaldırma gerekçesi (kayda geçer)',
  'admin.reports.storyRemoved': 'Durum kaldırıldı',
  'admin.reports.storyGone': 'Durum artık yok.',
  'admin.invites.create': 'Kod üret',
  'admin.invites.count': 'Adet',
  'admin.invites.note': 'Not',
  'admin.invites.newCodes': 'Yeni kodlar (yalnız şimdi gösterilir):',
  'admin.invites.used': '{used}/{max} kullanıldı',
  'admin.invites.revoke': 'İptal et',
  'admin.invites.revoked': 'İptal edildi',
  'conn.connected': 'Bağlı',
  'conn.reconnecting': 'Yeniden bağlanıyor…',
  'onboarding.title': 'DijitalApp’i nasıl kullanacaksın?',
  'onboarding.subtitle': 'Ana ekranını buna göre hazırlarız. İstediğin zaman değiştirebilirsin.',
  'onboarding.continue': 'Devam et',
  'onboarding.skip': 'Şimdilik atla',
  'onboarding.personaNote': 'Mod seçimi yalnızca görünümü değiştirir; yetki veya rol vermez.',
  'suggest.step': 'Adım {step}/{total}',
  'suggest.people.title': 'Tanıyabileceğin kişiler',
  'suggest.people.subtitle': 'Eklediğin kişilere hemen yazabilirsin. Kimse senin onayın olmadan bağlanmaz; istersen sonra kaldırırsın.',
  'suggest.channels.title': 'Takip edebileceğin kanallar',
  'suggest.channels.subtitle': 'Duyurular, haberler ve ilgi alanların: kanallar yalnızca okunur, takipçiler birbirini görmez.',
  'suggest.apps.title': 'İşine yarayabilecek uygulamalar',
  'suggest.apps.subtitle': 'Market’ten birkaç uygulama. Uygulamalarım’a eklenir; istediğin zaman kaldırabilirsin.',
  'suggest.add': 'Ekle',
  'suggest.added': 'Eklendi',
  'suggest.requested': 'Onay bekliyor',
  'suggest.addAll': 'Tümünü ekle',
  'suggest.follow': 'Takip et',
  'suggest.following': 'Takip ediliyor',
  'suggest.install': 'Yükle',
  'suggest.installed': 'Yüklendi',
  'suggest.skip': 'Atla',
  'suggest.next': 'Devam',
  'suggest.finish': 'Başla',
  'suggest.addedCount': { one: '{count} kişi eklendi', other: '{count} kişi eklendi' },
  'suggest.subscribers': { one: '{count} takipçi', other: '{count} takipçi' },
  'suggest.privacyNote': 'Yalnızca önerilmeye izin veren kişiler önerilir. Kendini Ayarlar › Gizlilik’ten gizleyebilirsin.',
  'suggest.reason.inviter_invited': '{name} tarafından davet edildi',
  'suggest.reason.inviter_contact': 'Seni davet eden {name} ile bağlantılı',
  'suggest.reason.mutual': { one: 'Ortak {count} kişi', other: 'Ortak {count} kişi' },
  'suggest.reason.curated': 'DijitalApp önerisi',
  'suggest.reason.popular': 'Popüler',
  'suggest.reason.inviter_channel': '{name} yönetiyor',
  'suggest.reason.inviter_app': 'Seni davet eden {name} kullanıyor',
  'suggest.reason.circle': { one: 'Çevrenden {count} kişi kullanıyor', other: 'Çevrenden {count} kişi kullanıyor' },
  'suggest.reason.featured': 'Öne çıkan',
  'suggest.reason.pick': 'DijitalApp önerisi',
  'suggest.later.title': 'Tanıyabileceğin kişiler',
  'suggest.later.hint': 'Birini ekleyince sohbet başlatabilirsin.',
  'suggest.later.dismiss': 'Gizle',
  'shell.activeSpace': 'Etkin alan',
  'shell.minorNotice': 'Hesabın yaşına uygun korumalı ayarlarla çalışıyor.',
  'shell.guardianPending': 'Bazı özellikler veli/vasi onayı tamamlanana kadar kapalı.',
  'module.disabled.title': 'Bu bölüm henüz açık değil',
  'module.disabled.body': '{module} geliştirme aşamasında ve şu an kapalı. Hazır olduğunda burada göreceksin.',
  'spaces.title': 'Alanlarım',
  'spaces.create': 'Yeni alan',
  'spaces.name': 'Alan adı',
  'spaces.type': 'Alan türü',
  'spaces.members': { one: '{count} üye', other: '{count} üye' },
  'spaces.type.personal': 'Kişisel',
  'spaces.type.family': 'Aile',
  'spaces.type.community': 'Topluluk',
  'spaces.type.school': 'Eğitim',
  'spaces.type.business': 'İş',
  'spaces.type.event': 'Etkinlik',
  'spaces.verificationRequired': 'Eğitim ve iş alanları kurum doğrulaması gerektirir.',
  'spaces.persona': 'Bu alandaki mod',
  'settings.title': 'Ayarlar',
  'settings.devices': 'Cihazlar',
  'settings.privacy': 'Gizlilik',
  'settings.appearance': 'Görünüm',
  'settings.theme.light': 'Açık',
  'settings.theme.dark': 'Koyu',
  'settings.theme.system': 'Sistem',
  'settings.language': 'Dil',
  'devices.current': 'Bu cihaz',
  'devices.lastActive': 'Son etkinlik: {date}',
  'devices.firstSeen': 'İlk giriş: {date}',
  'devices.signOut': 'Oturumu kapat',
  'devices.signOutOthers': 'Diğer tüm cihazlardan çıkış yap',
  'devices.count': { one: '{count} etkin cihaz', other: '{count} etkin cihaz' },
  'privacy.lockedByAge': 'Yaş politikası nedeniyle kilitli',
  'privacy.saved': 'Gizlilik ayarları kaydedildi',
  'privacy.profileDiscoverable': 'Profilim aramalarda bulunabilsin',
  'privacy.suggestMe': 'Beni önerilerde göster',
  'privacy.dmFromNonContacts': 'Kişilerim dışındakiler mesaj gönderebilsin',
  'privacy.messageRequests': 'Eklemediğim kişilerden mesaj isteği gelebilsin (Mesaj istekleri bölümünde bekler)',
  'privacy.lastSeen': 'Son görülme',
  'about.profileTitle': 'Profil',
  'about.name': 'Adın',
  'about.nameHint': 'Kişilerin seni bu adla görür.',
  'about.title': 'Hakkında',
  'about.placeholder': 'Örn. Müsait',
  'about.hint': 'Adının altında görünür',
  'about.presets': 'Hazır seçenekler',
  'about.clear': 'Hakkında\'yı temizle',
  'about.saved': 'Profil kaydedildi.',
  'about.p.available': 'Müsait',
  'about.p.busy': 'Meşgul',
  'about.p.school': 'Okuldayım',
  'about.p.meeting': 'Toplantıdayım',
  'about.p.gym': 'Spor salonundayım',
  'about.p.sleeping': 'Uyuyorum',
  'about.p.battery': 'Şarjım bitmek üzere',
  'about.p.urgent': 'Sadece acil aramalar',
  'privacy.profilePhoto': 'Profil fotoğrafı',
  'privacy.about': 'Hakkında',
  'chat.statusShortcut': 'Durum',
  'privacy.readReceipts': 'Okundu bilgisi',
  'privacy.phoneVisible': 'Telefon numaram görünsün',
  'privacy.emailDiscoverable': 'Rehberinde e-posta adresim olanlar beni bulabilsin',
  'import.title': 'Rehberden arkadaşlarını bul',
  'import.lead': 'Kişilerinden kimin burada olduğunu gör, olmayanları tek dokunuşla davet et.',
  'import.fromPhone': 'Telefon rehberinden seç',
  'import.fromFile': 'Rehber dosyası yükle (.vcf / .csv)',
  'import.privacy': 'Rehberin cihazından çıkmaz ve saklanmaz. E-posta adresleri tek yönlü şifreli özet olarak karşılaştırılır.',
  'import.howTo': 'Rehber dosyasını nasıl alırım?',
  'import.howIphone': 'iPhone: Kişiler › Listeler › Tüm Kişiler’e uzun bas › Dışa Aktar (.vcf).',
  'import.howAndroid': 'Android: Kişiler › Düzenle/Ayarlar › Kişileri dışa aktar (.vcf).',
  'import.howGoogle': 'Google Kişiler: contacts.google.com › Dışa aktar › Google CSV ya da vCard.',
  'import.working': 'Rehberin karşılaştırılıyor…',
  'import.tooBig': 'Dosya çok büyük (en fazla 5 MB).',
  'import.onApp': { one: '{brand}’te olan {count} kişi', other: '{brand}’te olan {count} kişi' },
  'import.noneOnApp': 'Rehberindekilerden henüz kimse burada değil (ya da bulunmayı kapatmışlar). Aşağıdan davet edebilirsin.',
  'import.addAll': { one: '{count} kişiyi ekle', other: 'Tümünü ekle ({count})' },
  'import.inYourBook': 'rehberinde: {name}',
  'import.toInvite': { one: 'Davet edebileceğin {count} kişi', other: 'Davet edebileceğin {count} kişi' },
  'import.search': 'Rehberde ara',
  'import.email': 'E-posta',
  'import.mailSubject': '{brand}’e gel, oradan yazışalım',
  'import.inviteNoLink': '{brand}’e katıl, oradan yazışalım: https://web.dijitalapp.com',
  'privacy.audience.everyone': 'Herkes',
  'privacy.audience.contacts': 'Kişilerim',
  'privacy.audience.nobody': 'Hiç kimse',
  'common.save': 'Kaydet',
  'common.cancel': 'Vazgeç',
  'common.retry': 'Tekrar dene',
  'common.on': 'Açık',
  'common.off': 'Kapalı',
  'conn.offline': 'Çevrimdışı',
  'conn.connecting': 'Bağlanıyor…',
  'error.AUTH_INVALID_CREDENTIALS': 'E-posta/kullanıcı adı veya parola hatalı.',
  'error.AUTH_SESSION_EXPIRED': 'Oturumunun süresi doldu. Lütfen tekrar giriş yap.',
  'error.AUTH_REQUIRED': 'Devam etmek için giriş yapmalısın.',
  'error.AUTH_ORIGIN_REJECTED': 'İstek güvenlik kontrolünden geçmedi. Sayfayı yenileyip tekrar dene.',
  'error.AGE_BELOW_MINIMUM': 'Üzgünüz, bulunduğun ülkede bu yaşta DijitalApp hesabı açılamıyor.',
  'error.EMAIL_TAKEN': 'Bu e-posta adresiyle zaten bir hesap var.',
  'error.USERNAME_TAKEN': 'Bu kullanıcı adı kullanılamıyor.',
  'error.USERNAME_RESERVED': 'Bu kullanıcı adı ayrılmış, başka bir ad seç.',
  'error.VALIDATION_FAILED': 'Girdiğin bilgileri kontrol et.',
  'error.RATE_LIMITED': 'Çok fazla deneme yaptın. Biraz bekleyip tekrar dene.',
  'error.FORBIDDEN': 'Bu işlem için yetkin yok.',
  'error.NOT_FOUND': 'Aradığın şey bulunamadı.',
  'error.POLICY_LOCKED': 'Bu ayar yaşına uygun güvenlik politikası nedeniyle değiştirilemez.',
  'error.SPACE_VERIFICATION_REQUIRED': 'Bu alan türü kurum doğrulaması gerektirir.',
  'error.TERMS_NOT_ACCEPTED': 'Devam etmek için koşulları kabul etmelisin.',
  'error.ENTITLEMENT_LIMIT': 'Planındaki sınıra ulaştın.',
  'error.EMAIL_TOKEN_INVALID': 'Bu bağlantı geçersiz, kullanılmış ya da süresi dolmuş. Yeni bir bağlantı iste.',
  'error.EMAIL_CODE_INVALID': 'Kod hatalı ya da süresi dolmuş. En son gelen e-postadaki kodu gir veya yeni kod iste.',
  'error.PASSKEY_FAILED': 'Passkey doğrulanamadı. Tekrar dene.',
  'error.EMAIL_NOT_VERIFIED': 'Bu işlem için önce e-posta adresini doğrula.',
  'error.MESSAGING_NOT_ALLOWED': 'Bu kişiye şu an mesaj gönderemezsin.',
  'error.MESSAGE_TOO_LARGE': 'Mesaj çok uzun.',
  'error.AUTH_TICKET_INVALID': 'Canlı bağlantı kurulamadı. Tekrar deneniyor.',
  'error.PROTOCOL_INVALID_FRAME': 'Sunucuyla iletişimde bir sorun oldu.',
  'error.REGISTRATION_CLOSED': 'Yeni kayıtlar şu an kapalı.',
  'error.INVITE_INVALID': 'Davet kodu geçersiz, kullanılmış ya da süresi dolmuş.',
  'error.ADMIN_PASSKEY_REQUIRED': 'Yönetici işlemleri için son 12 saat içinde passkey ile giriş yapmış olmalısın.',
  'error.MESSAGE_EDIT_EXPIRED': 'Bu mesaj için düzenleme veya silme süresi doldu.',
  'error.ATTACHMENT_REJECTED': 'Bu dosya türü desteklenmiyor ya da dosya bozuk.',
  'error.UPLOAD_OFFSET_MISMATCH': 'Yükleme kaldığı yerden devam ediyor.',
  'error.STORAGE_QUOTA_EXCEEDED': 'Depolama alanın doldu. Eski dosyaları silerek yer açabilirsin.',
  'push.photo': '📷 Fotoğraf',
  'push.voice': '🎤 Sesli mesaj',
  'push.sticker': '🎨 Çıkartma',
  'push.location': '📍 Konum',
  'push.contact': '👤 Kişi',
  'chat.play': 'Oynat',
  'chat.pause': 'Duraklat',
  'chat.voicePosition': 'Sesli mesajda konum',
  'chat.playbackSpeed': 'Oynatma hızı',
  'contactCard.menu': 'Kişi',
  'contactCard.pickTitle': 'Kişi paylaş',
  'contactCard.search': 'Kişilerinde ara',
  'contactCard.none': 'Paylaşılacak kişi bulunamadı.',
  'contactCard.send': 'Gönder',
  'contactCard.sendCount': { one: '{count} kişiyi gönder', other: '{count} kişiyi gönder' },
  'contactCard.message': 'Mesaj gönder',
  'contactCard.add': 'Kişilere ekle',
  'contactCard.added': 'Eklendi',
  'contactCard.you': 'Bu sensin',
  'contactCard.label': 'Kişi kartı',
  'emoji.title': 'Emoji',
  'emoji.open': 'Emoji ve çıkartmalar',
  'emoji.stickers': 'Çıkartmalar',
  'emoji.search': 'Emoji ara (ör. kalp, gülen, heart)',
  'emoji.skin': 'Ten rengi',
  'emoji.categories': 'Kategoriler',
  'emoji.recent': 'Son kullanılanlar',
  'emoji.none': 'Bu aramayla emoji bulunamadı.',
  'emoji.more': 'Başka bir emoji seç',
  'gif.search': 'GIF ara (ör. mutlu, tebrikler)',
  'gif.fromDevice': 'Cihazından GIF',
  'gif.searchOff': 'GIF araması şu an kapalı. Cihazındaki bir GIF\'i gönderebilirsin; sohbette hareketli oynar.',
  'gif.failed': 'GIF\'ler şu an yüklenemedi. Biraz sonra tekrar dene.',
  'gif.credit': 'Tenor ile',
  'location.menu': 'Konum',
  'location.title': 'Konum',
  'location.sendCurrent': 'Şu anki konumumu gönder',
  'location.sendCurrentHint': 'Bulunduğun noktayı bir kez paylaşır',
  'location.shareLive': 'Canlı konum paylaş',
  'location.shareLiveHint': 'Seçtiğin süre boyunca konumun bu sohbette güncellenir; istediğin an durdurabilirsin',
  'location.minutes': { one: '{count} dakika', other: '{count} dakika' },
  'location.accuracy': 'Yaklaşık {m} m hassasiyet',
  'location.denied': 'Konum izni verilmedi. Tarayıcının adres çubuğundaki kilit simgesinden bu site için konuma izin ver.',
  'location.unavailable': 'Konumun şu an alınamadı. Konum servislerinin açık olduğundan emin ol.',
  'location.privacyOff': 'Konum paylaşımı gizlilik ayarlarında kapalı. Açarsan konumunu yalnızca sen gönderdiğinde, gönderdiğin sohbette paylaşırsın.',
  'location.allow': 'Konum paylaşımını aç',
  'location.privacyNote': 'Şifreli sohbetlerde konum uçtan uca şifreli gider; harita görseli için dış sunuculara istek yapılmaz.',
  'location.liveBadge': 'CANLI',
  'location.liveTitle': 'Canlı konum',
  'location.liveEnded': 'Canlı konum sona erdi',
  'location.timeLeft': '{time} kaldı',
  'location.updated': 'Son güncelleme {time}',
  'location.openMap': 'Haritada aç',
  'location.directions': 'Yol tarifi',
  'location.stop': 'Paylaşımı durdur',
  'emoji.cat.smileys': 'Yüzler ve duygular',
  'emoji.cat.people': 'İnsanlar ve vücut',
  'emoji.cat.animals': 'Hayvanlar ve doğa',
  'emoji.cat.food': 'Yiyecek ve içecek',
  'emoji.cat.travel': 'Seyahat ve yerler',
  'emoji.cat.activities': 'Etkinlikler',
  'emoji.cat.objects': 'Nesneler',
  'emoji.cat.symbols': 'Semboller',
  'emoji.cat.flags': 'Bayraklar',
  'push.poll': '📊 Anket:',
  'push.mentioned': '@ Senden bahsetti ·',
  'push.file': '📎 Dosya',
  'push.video': '🎬 Video',
  'error.PIN_LIMIT': 'En fazla 3 mesaj sabitlenebilir. Önce birinin sabitlemesini kaldır.',
  'error.E2EE_SEND_FAILED': 'Mesaj bu cihazda şifrelenemedi. "Tekrar dene"ye bas; sürerse Ayarlar › Güvenlik\'ten bu cihazın şifrelemesini kontrol et.',
  'error.E2EE_SIGNING_KEY_MISSING': 'Kişileri doğrulamak için önce bu cihazı bağla: telefonundan onayla ya da yedek parolanı gir.',
  'error.E2EE_DEVICE_UNVERIFIED': 'Bu cihaz henüz doğrulanmadığı için şifreli mesaj gönderemiyor. "Bu cihazı doğrula"ya bas; bir dakikada biter.',
  'e2ee.verifyThisDeviceShort': 'Bu cihazı bağla',
  'e2ee.composerUnverified': 'Bu cihaz doğrulanmadı; bu şifreli sohbete yazmak için önce doğrula.',
  'e2ee.deviceFixIntro': 'Telefonundan onayla ya da yedek parolanı gir. İkisi de eski mesajlarını getirir ve kişilerin bu cihaza güvenir.',
  'error.CHAT_PIN_LIMIT': 'En fazla 5 sohbet sabitlenebilir. Önce birinin sabitlemesini kaldır.',
  'error.FOLDER_LIMIT': 'En fazla 10 klasör oluşturabilirsin.',
  'chat.reply': 'Yanıtla',
  'chat.copy': 'Kopyala',
  'chat.translate': 'Çevir',
  'chat.translation': 'Çeviri',
  'chat.translation.hide': 'Çeviriyi gizle',
  'chat.translation.working': 'Çevriliyor…',
  'chat.translation.same': 'Bu mesaj zaten senin dilinde.',
  'chat.translation.e2ee': 'Bu sohbet uçtan uca şifreli. Çevirmek için yalnızca bu mesajın metni şifrelemenin dışına çıkarak yapay zekâ sağlayıcısına gönderilir. Devam edilsin mi?',
  'chat.translation.consent': 'Çeviri için önce Yapay Zekâ sayfasından onay vermen gerekiyor.',
  'chat.moreActions': 'Diğer seçenekler',
  'chat.call.voice': 'Sesli arama',
  'chat.call.video': 'Görüntülü arama',
  'chat.call.missedVoice': 'Cevapsız sesli arama',
  'chat.call.missedVideo': 'Cevapsız görüntülü arama',
  'chat.call.seconds': '{seconds} sn',
  'chat.call.callBack': 'Geri ara',
  'chat.call.callBackVoice': 'Sesli geri ara',
  'chat.call.callBackVideo': 'Görüntülü geri ara',
  'chat.call.reason.hangup': 'Sona erdi',
  'chat.call.reason.rejected': 'Reddedildi',
  'chat.call.reason.missed': 'Cevaplanmadı',
  'chat.call.reason.busy': 'Meşgul',
  'chat.call.reason.cancelled': 'İptal edildi',
  'chat.call.reason.failed': 'Bağlanamadı',
  'chat.call.reason.disconnected': 'Bağlantı koptu',
  'chat.call.reason.moved': 'Diğer cihaza aktarıldı',
  'chat.call.reason.answered_elsewhere': 'Başka cihazda cevaplandı',
  'chat.call.reason.no_media': 'Ses ve görüntü bağlanamadı',
  'chat.call.live.active': 'Arama sürüyor',
  'chat.call.live.calling': 'Arıyor…',
  'chat.call.live.ringing': 'Çalıyor…',
  'chat.call.live.connecting': 'Bağlanıyor…',
  'chat.call.live.incomingVoice': 'Gelen sesli arama',
  'chat.call.live.incomingVideo': 'Gelen görüntülü arama',
  'chat.call.live.return': 'Görüşmeye dön',
  'chat.call.live.answer': 'Cevapla',
  'chat.call.group.started': 'Grup araması başladı',
  'chat.call.group.startedVideo': 'Grup görüntülü araması başladı',
  'chat.call.group.by': '{name} başlattı',
  'chat.call.group.you': 'Sen başlattın',
  'chat.replyingTo': '{name} kişisine yanıt',
  'chat.cancelReply': 'Yanıtlamaktan vazgeç',
  'chat.originalMessage': 'Önceki bir mesaj',
  'chat.forward': 'İlet',
  'chat.forwarded': 'İletildi',
  'chat.forwardTitle': 'Mesajı ilet',
  'chat.forwardHint': 'En fazla 5 sohbet seçebilirsin.',
  'chat.forwardSent': 'İletildi.',
  'chat.pin': 'Sabitle',
  'chat.unpin': 'Sabitlemeyi kaldır',
  'chat.pinned': 'Sabitlenmiş mesaj',
  'chat.react': 'Tepki ver',
  'chat.reactionsBy': '{emoji}: {names}',
  'chat.reactionsCount': 'Tepkiler: {breakdown}',
  'chat.reactionsMine': 'Tepkiler: {breakdown}. Senin tepkin: {emoji}',
  'chat.attachmentLabel': 'Ek',
  'error.AI_UNAVAILABLE': 'Yazım asistanı şu an kullanılamıyor.',
  'error.AI_BUDGET_EXCEEDED': 'Yapay zekâ özellikleri bu ay için ayrılan bütçeye ulaştı. Ay başında ya da bütçe artırılınca yeniden açılır.',
  'error.AI_CONSENT_REQUIRED': 'Yazım asistanını kullanmak için önce onay vermelisin.',
  'error.AI_QUOTA_EXCEEDED': 'Bugünkü yazım asistanı hakkın doldu. Yarın yeniden kullanabilirsin.',
  'error.AI_REFUSED': 'Yazım asistanı bu metni düzenlemedi.',
  'error.FEATURE_NOT_ENABLED': 'Bu özellik henüz açılmadı.',
  'tpl.title': 'Şablonlar',
  'tpl.open': 'Şablon ekle',
  'tpl.search': 'Şablonlarda ara',
  'tpl.empty': 'Şablon bulunamadı.',
  'tpl.mine': 'Benim',
  'tpl.category.general': 'Genel',
  'tpl.category.education': 'Eğitim',
  'tpl.category.work': 'İş',
  'tpl.category.social': 'Sosyal',
  'tpl.saveDraft': 'Taslağı şablon olarak kaydet',
  'tpl.namePrompt': 'Şablon adı',
  'tpl.delete': 'Sil',
  'tpl.hint': 'Köşeli parantezli yerleri ([tarih] gibi) göndermeden önce doldur.',
  'ai.open': 'Yazım asistanı',
  'ai.title': 'Yazım asistanı',
  'ai.action.fix': 'Yazımı düzelt',
  'ai.action.shorten': 'Kısalt',
  'ai.action.formal': 'Resmi yap',
  'ai.action.friendly': 'Samimi yap',
  'ai.action.translate_en': 'İngilizceye çevir',
  'ai.action.translate_tr': 'Türkçeye çevir',
  'ai.consentTitle': 'Yazım asistanı hakkında',
  'ai.consentBody': 'Asistanı kullandığında, yalnız o an yazdığın taslak metin yapay zekâ sağlayıcısına ({provider}) gönderilir; sohbet geçmişin gönderilmez. Bir mesajda "Çevir" dersen yalnız o mesajın metni gönderilir. E-posta, telefon, IBAN, TC kimlik ve kart numaraları göndermeden önce gizlenir ve sonuçta geri konur. DijitalApp metni saklamaz; yalnız kaç kez kullandığını sayar. Sağlayıcının veri kullanımı kendi ticari koşullarına tabidir. Önerileri sen onaylamadan hiçbir şey gönderilmez. Onayını Yapay Zekâ sayfasından istediğin zaman geri çekebilirsin.',
  'ai.consentAccept': 'Anladım, kullanmak istiyorum',
  'ai.consentWithdraw': 'Onayı geri çek',
  'ai.e2eeWarning': 'Bu sohbet uçtan uca şifreli. Asistanı kullanırsan bu taslak şifrelemenin dışına çıkıp sağlayıcıya gönderilir.',
  'ai.suggestion': 'Öneri',
  'ai.use': 'Taslağa uygula',
  'ai.redacted': '{count} kişisel bilgi sağlayıcıdan gizlendi.',
  'ai.missing': 'Gizlenen {count} bilgi öneride yer almıyor; metni kontrol et.',
  'ai.remaining': 'Bugün kalan: {count}',
  'ai.working': 'Hazırlanıyor…',
  'ai.notForAccount': 'Yazım asistanı 18 yaş altı hesaplarda kullanılamaz.',
  'ai.turnedOff': 'Yazım asistanı yönetim panelinden kapatılmış.',
  'ai.notConfigured': 'Yazım asistanı açık ama sunucuda yapay zekâ sağlayıcısı ayarlı değil (AI_PROVIDER=anthropic ve API anahtarı gerekli; ayardan sonra servis yeniden başlatılmalı).',
  'ai.writeFirst': 'Önce mesaj kutusuna bir taslak yaz; asistan onu düzeltir, kısaltır ya da tonunu değiştirir.',
  'imports.title': 'İçe aktarılan sohbetler',
  'imports.new': 'Sohbet içe aktar',
  'imports.lead': 'WhatsApp, Telegram ya da BiP’ten dışa aktardığın sohbetleri fotoğraf, video ve sesli mesajlarıyla birlikte buraya taşı. Arşivleri yalnızca sen görürsün.',
  'imports.empty': 'Henüz içe aktarılmış sohbet yok. Eski sohbetlerini kaybetmeden buraya taşıyabilirsin.',
  'imports.counts': '{messages} mesaj · {media} medya',
  'imports.pickLead': 'Uygulamadan dışa aktardığın sohbeti seç. Zip dosyasını olduğu gibi seçebilirsin.',
  'imports.pickFiles': 'Dosya seç',
  'imports.pickFolder': 'Klasör seç',
  'imports.pickFolderHint': 'Telegram dışa aktarma klasörü',
  'imports.reading': 'Dışa aktarma okunuyor…',
  'imports.howTo': 'Sohbet nasıl dışa aktarılır?',
  'imports.howWhatsApp': 'WhatsApp: sohbeti aç › ⋮ (iPhone’da kişi adına dokun) › Diğer › Sohbeti dışa aktar › “Medya dahil et” › dosyayı kaydet ya da kendine gönder.',
  'imports.howBip': 'BiP: sohbeti aç › ⋮ › Sohbeti dışa aktar (ya da Sohbeti e-postala) › oluşan .txt/.zip dosyasını seç.',
  'imports.howTelegram': 'Telegram: bilgisayarda Telegram Desktop › sohbet › ⋮ › Sohbet geçmişini dışa aktar › Biçim: JSON › oluşan klasörü “Klasör seç” ile seç.',
  'imports.privacy': 'Dosya bu cihazda okunur; sunucuya yalnızca mesajlar ve medya gider. Arşiv salt okunurdur ve sadece sana görünür; istediğin an silebilirsin.',
  'imports.errAccountExport': 'Bu, Telegram’ın tüm hesap dışa aktarması. Lütfen tek bir sohbeti dışa aktar (sohbet › ⋮ › Sohbet geçmişini dışa aktar, JSON).',
  'imports.errZip': 'Zip dosyası açılamadı ya da bozuk. Dışa aktarmayı yeniden oluşturmayı dene.',
  'imports.errNoChat': 'Seçtiklerinde sohbet dosyası bulunamadı (.txt ya da result.json).',
  'imports.errFormat': 'Bu dosyadaki sohbet biçimi tanınmadı. WhatsApp/BiP .txt ya da Telegram JSON dışa aktarması seçtiğinden emin ol.',
  'imports.statMessages': 'mesaj',
  'imports.statMedia': 'medya dosyası',
  'imports.statPeople': 'kişi',
  'imports.missingMedia': { one: '{count} medya dışa aktarmada yok; yerine dosya adı görünecek.', other: '{count} medya dışa aktarmada yok; yerine dosya adları görünecek.' },
  'imports.tooMany': 'Bir arşive en fazla {count} mesaj alınır; ilk {count} mesaj aktarılacak.',
  'imports.fieldTitle': 'Arşiv adı',
  'imports.fieldSource': 'Kaynak',
  'imports.sourceOther': 'Diğer',
  'imports.fieldMe': 'Sohbette sen kimsin?',
  'imports.meNone': 'Belirtme',
  'imports.meIs': 'Ben: {name}',
  'imports.withMedia': 'Fotoğraf, video ve sesleri de aktar ({size})',
  'imports.otherFile': 'Başka dosya',
  'imports.start': 'İçe aktar',
  'imports.phaseMedia': 'Medya yükleniyor',
  'imports.phaseMessages': 'Mesajlar aktarılıyor',
  'imports.phaseFinishing': 'Tamamlanıyor…',
  'imports.skipped': { one: '{count} dosya desteklenmediği için atlandı.', other: '{count} dosya desteklenmediği için atlandı.' },
  'imports.keepOpen': 'Bitene kadar bu pencereyi açık tut.',
  'imports.quotaFull': 'Depolama alanın doldu; kalan medya aktarılmadı, mesajlar yine de aktarılıyor.',
  'imports.readOnly': 'salt okunur arşiv',
  'imports.options': 'Arşiv seçenekleri',
  'imports.rename': 'Yeniden adlandır',
  'imports.delete': 'Arşivi sil',
  'imports.deleteConfirm': 'Bu arşiv ve içindeki tüm medya kalıcı olarak silinsin mi?',
  'imports.search': 'Arşivde ara',
  'imports.older': 'Daha eski mesajlar',
  'imports.newer': 'Daha yeni mesajlar',
  'imports.footer': 'İçe aktarılmış arşiv · {count} mesaj · yalnızca sen görüyorsun',
  'imports.ctaTitle': 'Eski sohbetlerini taşı',
  'imports.ctaBody': 'WhatsApp, Telegram ve BiP sohbetlerini medyasıyla içe aktar.',
  'video.play': '{site} videosunu oynat',
  'video.watchOn': '{site} üzerinde izle',
  'viewer.zoomIn': 'Yakınlaştır',
  'viewer.zoomOut': 'Uzaklaştır',
  'camera.title': 'Kamera',
  'camera.photo': 'Fotoğraf',
  'camera.video': 'Video',
  'camera.take': 'Fotoğraf çek',
  'camera.record': 'Kaydı başlat',
  'camera.stop': 'Kaydı durdur',
  'camera.flip': 'Kamerayı çevir',
  'camera.retake': 'Tekrar çek',
  'camera.denied': 'Kamera izni verilmedi. Tarayıcı ayarlarından izin verebilir ya da telefonun kamerasını kullanabilirsin.',
  'camera.unavailable': 'Kamera açılamadı. Başka bir uygulama kullanıyor olabilir.',
  'camera.broken': 'Kayıt sırasında görüntü durdu, bu video gönderilmedi. Yeniden kaydet ve kayıt bitene dek ekranda kal.',
  'camera.unsupported': 'Bu tarayıcı kamerayı doğrudan açamıyor.',
  'camera.nativePhoto': 'Cihaz kamerasıyla fotoğraf',
  'camera.nativeVideo': 'Cihaz kamerasıyla video',
  'call.swap': 'Görüntülerin yerini değiştir',
  'call.elsewhere': 'Görüşmen diğer cihazında sürüyor',
  'call.takeOver': 'Bu cihaza al',
  'push.groupCall': '{name} grup sesli görüşmesi başlattı',
  'push.groupVideoCall': '{name} grup görüntülü görüşmesi başlattı',
  'gcall.startVideo': 'Grup görüntülü görüşmesi başlat',
  'gcall.startVoice': 'Grup sesli görüşmesi başlat',
  'gcall.join': 'Katıl',
  'gcall.inCall': 'Görüşmedesin',
  'gcall.runningVideo': 'Grup görüntülü görüşmesi sürüyor',
  'gcall.runningVoice': 'Grup sesli görüşmesi sürüyor',
  'gcall.people': { one: '{count} kişi', other: '{count} kişi' },
  'gcall.full': 'Görüşme dolu (en fazla {count} kişi)',
  'gcall.ringing': '{name} · {group}',
  'gcall.tapToJoin': 'Katılmak için dokun',
  'gcall.ringVideo': '{name} grup görüntülü görüşmesi başlattı',
  'gcall.ringVoice': '{name} grup sesli görüşmesi başlattı',
  'gcall.you': 'Sen',
  'gcall.connecting': 'bağlanıyor…',
  'gcall.lost': 'bağlantı koptu',
  'gcall.joining': 'Katılınıyor…',
  'gcall.waiting': 'Diğerlerinin katılması bekleniyor…',
  'gcall.leave': 'Görüşmeden ayrıl',
  'gcall.errPermission': 'Mikrofon ya da kamera izni verilmedi.',
  'gcall.errFull': 'Görüşme dolu; en fazla {count} kişi katılabilir.',
  'gcall.errFailed': 'Görüşmeye katılınamadı. Bağlantını kontrol edip tekrar dene.',
  'chat.dropHere': 'Göndermek için buraya bırak',
  'chat.dropHint': 'Fotoğraf, video, belge… (bir seferde en fazla 10 dosya)',
  'chat.dropMax': 'Bir seferde en fazla {count} dosya gönderilir; ilk {count} tanesi gönderildi.',
  'admin.tab.staff': 'Ekip',
  'staff.addTitle': 'Ekibe kişi ekle',
  'staff.addLead': 'Kullanıcı adını yaz ve rolünü seç. Yalnızca e-postası doğrulanmış etkin hesaplar eklenebilir; yönetim paneline girmek için passkey gerekir.',
  'staff.username': 'Kullanıcı adı',
  'staff.usernamePlaceholder': '@kullaniciadi',
  'staff.roleLabel': 'Rol',
  'staff.add': 'Ekle',
  'staff.listTitle': { one: 'Ekip ({count} kişi)', other: 'Ekip ({count} kişi)' },
  'staff.revoke': 'Rolü kaldır',
  'staff.revokeConfirm': '{name} kişisinin "{role}" rolü kaldırılsın mı?',
  'staff.footer': 'Süper yönetici rolü güvenlik için yalnızca sunucudan verilir. Kendi rollerini buradan değiştiremezsin. Her değişiklik denetim kaydına yazılır.',
  'staff.role.super_admin': 'Süper yönetici',
  'staff.role.admin': 'Yönetici',
  'staff.role.moderator': 'Moderatör',
  'staff.role.support': 'Destek',
  'staff.role.security_admin': 'Güvenlik yöneticisi',
  'staff.role.finance': 'Finans',
  'staff.role.analyst': 'Analist',
  'staff.role.read_only': 'Salt okunur',
  'flags.targeting': 'Hedefleme ve kademeli yayın',
  'flags.rollout': 'Kademeli yayın: kişilerin %{percent}’i',
  'flags.rolloutHint': 'Her kişi hep aynı tarafta kalır; oranı artırdıkça daha çok kişi görür.',
  'flags.rolloutOff': 'Kademeli yayın için önce özelliği aç.',
  'flags.overrides': 'Özel durumlar',
  'flags.noOverrides': 'Özel durum yok; herkes için genel ayar geçerli.',
  'flags.scope.user': 'Kişi',
  'flags.scope.plan': 'Plan',
  'flags.scope.region': 'Bölge',
  'flags.scopeLabel': 'Kime',
  'flags.pickPlan': 'Plan seç',
  'flags.userPlaceholder': 'kullanıcı adı',
  'flags.regionPlaceholder': 'ülke kodu, örn. TR',
  'flags.value': 'Durum',
  'flags.on': 'Açık',
  'flags.off': 'Kapalı',
  'flags.add': 'Ekle',
  'flags.remove': 'Kaldır',
  'staff.roleHelp.super_admin': 'Her şey; ekip rollerini ve sistem ayarlarını yönetir.',
  'staff.roleHelp.admin': 'Kullanıcılar, şikâyetler, site, rozetler, formlar ve denetim kaydı; sistem ayarları hariç.',
  'staff.roleHelp.moderator': 'Şikâyetleri inceler ve kullanıcı bilgilerini görür.',
  'staff.roleHelp.support': 'Kullanıcıları ve e-posta adreslerini görür (destek talepleri için).',
  'staff.roleHelp.security_admin': 'Güvenlik kayıtlarını, oturumları ve güvenlik ayarlarını yönetir.',
  'staff.roleHelp.finance': 'Ödemeleri, planları ve faturalama raporlarını görür.',
  'staff.roleHelp.analyst': 'İstatistikleri ve raporları görür; bir şey değiştiremez.',
  'staff.roleHelp.read_only': 'Paneli yalnızca görüntüler; hiçbir şeyi değiştiremez.',
  'privacy.staffExempt': 'Ekip ayrıcalığı: son görülme bilgini, çevrimiçi durumunu ya da okundu bilgisini gizlesen de başkalarınınkini görmeye devam edersin. Kendi bilgisini gizleyen kişilerinkini ise kimse göremez.',
  'look.title': 'Sohbet görünümü',
  'look.lead': 'Renkleri, duvar kâğıdını, balonları ve yazıyı kendine göre ayarla. Değişiklikler anında görünür ve tüm cihazlarında aynı olur.',
  'look.reset': 'Varsayılana dön',
  'look.saveFailed': 'Kaydedilemedi; bağlantını kontrol et.',
  'look.accent': 'Uygulama rengi',
  'look.auto': 'Otomatik',
  'look.wallpaper': 'Duvar kâğıdı',
  'look.dim': 'Koyu temada karartma',
  'look.bubbleMine': 'Benim mesaj balonum',
  'look.bubbleTheirs': 'Karşı tarafın balonu',
  'look.shape': 'Balon köşeleri',
  'look.shape.sharp': 'Keskin',
  'look.shape.normal': 'Normal',
  'look.shape.round': 'Yuvarlak',
  'look.textSize': 'Yazı boyutu',
  'look.font': 'Yazı tipi',
  'look.font.system': 'Standart',
  'look.font.rounded': 'Yuvarlak',
  'look.font.serif': 'Tırnaklı',
  'look.font.mono': 'Eş aralıklı',
  'look.density': 'Mesaj aralığı',
  'look.density.compact': 'Sık',
  'look.density.comfortable': 'Normal',
  'look.density.roomy': 'Ferah',
  'look.bigEmoji': 'Sadece emoji olan mesajlar büyük görünsün',
  'look.lowContrast': 'Bu renkte yazı zor okunabilir; daha açık ya da daha koyu bir ton dene.',
  'look.menu': 'Sohbet görünümü',
  'look.chatTitle': '{name} · görünüm',
  'look.scope': 'Kimin için',
  'look.scopeGroup': 'Grup için (herkes)',
  'look.scopeMe': 'Yalnızca benim için',
  'look.groupLead': 'Grubun görünümü: duvar kâğıdı ve balon rengi bütün üyelerde böyle görünür. Herkes isterse kendine özel görünüm seçebilir.',
  'look.chatLeadGroup': 'Yöneticiler bu grup için bir görünüm seçti. Burada seçtiğin yalnızca sende geçerli olur.',
  'look.groupReset': 'Grup görünümünü kaldır',
  'look.useGroup': 'Grubun görünümüne dön',
  'group.logAction.group.look_updated': '{actor} grubun görünümünü değiştirdi',
  'look.chatLead': 'Bu sohbete özel duvar kâğıdı ve balon rengi. Sadece sen görürsün.',
  'look.sameAsMine': 'Genel ayarım',
  'look.useMine': 'Genel görünümüme dön',
  'look.preview.today': 'Bugün',
  'look.preview.theirs': 'Selam! Yeni görünüm nasıl olmuş? 👀',
  'look.preview.mine': 'Harika oldu, tam istediğim gibi!',
  'look.wall.dots': 'Noktalı',
  'look.wall.plain': 'Sade',
  'look.wall.doodle': 'Çizim',
  'look.wall.grid': 'Kareli',
  'look.wall.sunset': 'Gün batımı',
  'look.wall.ocean': 'Okyanus',
  'look.wall.forest': 'Orman',
  'look.wall.lavender': 'Lavanta',
  'look.wall.peach': 'Şeftali',
  'look.wall.night': 'Gece',
  'look.wall.color': 'Düz renk',
  'privacy.sponsoredMessages': 'Firmalardan sponsorlu mesajlar alabilirim (sohbet listemde ayrı işaretli görünür)',
  'ads.sponsored': 'Sponsorlu',
  'ads.sponsoredBy': '{advertiser} · sponsorlu',
  'ads.hide': 'Bu reklamı gizle',
  'ads.why': 'Bunu neden görüyorum?',
  'ads.whyBody': 'Bu, {advertiser} firmasının sponsorlu içeriği. Reklamlar DijitalApp’i ücretsiz tutmaya yardım eder.',
  'ads.whyUsed': 'Kullanılan: uygulama dilin, yetişkin olman ve reklamın gösterildiği yer.',
  'ads.whyNotUsed': 'Kullanılmayan: mesajların, sohbetlerin, kişilerin ve aramaların; bunlar reklam için asla okunmaz.',
  'ads.whyControls': 'Bir reklamı gizlersen o kampanyayı bir daha görmezsin. Sponsorlu mesajları Ayarlar › Gizlilik’ten açıp kapatabilirsin.',
  'admin.tab.ads': 'Reklamlar',
  'adsAdmin.moduleOff': 'Reklam modülü şu an kapalı: kampanyaları hazırlayabilirsin ama kimseye gösterilmez. Açmak için Yapılandırma › Özellikler’den "ads" anahtarını aç.',
  'adsAdmin.campaigns': 'Kampanyalar',
  'adsAdmin.reports': 'Raporlar',
  'adsAdmin.campaignCount': { one: '{count} kampanya', other: '{count} kampanya' },
  'adsAdmin.newCampaign': 'Yeni kampanya',
  'adsAdmin.editCampaign': 'Kampanyayı düzenle',
  'adsAdmin.none': 'Henüz kampanya yok.',
  'adsAdmin.noEnd': 'bitiş yok',
  'adsAdmin.status.live': 'Yayında',
  'adsAdmin.status.draft': 'Taslak',
  'adsAdmin.status.active': 'Planlandı',
  'adsAdmin.status.paused': 'Duraklatıldı',
  'adsAdmin.status.ended': 'Bitti',
  'adsAdmin.placement.chat_list': 'Sohbet listesi',
  'adsAdmin.placement.discover': 'Keşfet',
  'adsAdmin.placement.feed': 'Duvar',
  'adsAdmin.placement.stories': 'Hikâyeler',
  'adsAdmin.placement.message': 'Sponsorlu mesaj',
  'adsAdmin.allLanguages': 'Tüm diller',
  'adsAdmin.capShort': 'günde en fazla {count}/kişi',
  'adsAdmin.budgetShort': 'toplam {count} gösterim',
  'adsAdmin.impressions': 'Gösterim',
  'adsAdmin.reach': 'Tekil erişim',
  'adsAdmin.clicks': 'Tıklama',
  'adsAdmin.ctr': 'TO (tıklanma oranı)',
  'adsAdmin.hides': 'Gizleme',
  'adsAdmin.activate': 'Yayına al',
  'adsAdmin.pause': 'Duraklat',
  'adsAdmin.end': 'Bitir',
  'adsAdmin.edit': 'Düzenle',
  'adsAdmin.delete': 'Sil',
  'adsAdmin.deleteConfirm': '"{name}" kampanyası, reklamları ve istatistikleriyle birlikte silinsin mi?',
  'adsAdmin.deleteCreative': 'Bu reklam silinsin mi?',
  'adsAdmin.creatives': { one: '{count} reklam', other: '{count} reklam' },
  'adsAdmin.needCreative': 'Yayına almak için en az bir reklam ekle.',
  'adsAdmin.image': 'Görsel',
  'adsAdmin.addCreative': 'Reklam ekle',
  'adsAdmin.fTitle': 'Başlık (en fazla 80 karakter)',
  'adsAdmin.fBody': 'Metin (isteğe bağlı, en fazla 280 karakter)',
  'adsAdmin.fCta': 'Düğme yazısı (ör. İncele)',
  'adsAdmin.advertiser': 'Firma',
  'adsAdmin.pickAdvertiser': 'Firma seç',
  'adsAdmin.newAdvertiser': 'ya da yeni firma adı',
  'adsAdmin.addAdvertiser': 'Firma ekle',
  'adsAdmin.fName': 'Kampanya adı',
  'adsAdmin.placements': 'Nerede görünsün?',
  'adsAdmin.messageNote': 'Sponsorlu mesajlar yalnızca bunu Gizlilik ayarlarında açan yetişkinlere gider. Reklamlar 18 yaş altına hiçbir yerde gösterilmez.',
  'adsAdmin.starts': 'Başlangıç',
  'adsAdmin.ends': 'Bitiş (boş: süresiz)',
  'adsAdmin.languages': 'Dil',
  'adsAdmin.languagesHint': 'Hiçbiri seçilmezse tüm dillerde.',
  'adsAdmin.dailyCap': 'Kişi başı günlük gösterim',
  'adsAdmin.budget': 'Toplam gösterim bütçesi',
  'adsAdmin.unlimited': 'sınırsız',
  'adsAdmin.priority': 'Öncelik (1–100)',
  'adsAdmin.createDraft': 'Taslak olarak oluştur',
  'adsAdmin.from': 'Başlangıç',
  'adsAdmin.to': 'Bitiş',
  'adsAdmin.campaign': 'Kampanya',
  'adsAdmin.allCampaigns': 'Tüm kampanyalar',
  'adsAdmin.daily': 'Günlük gösterim ve tıklama',
  'adsAdmin.byPlacement': 'Yerleşime göre',
  'adsAdmin.byCampaign': 'Kampanyaya göre',
  'adsAdmin.noData': 'Bu aralıkta veri yok.',
  'adsAdmin.privacyNote': 'Raporlar yalnızca toplam sayıları gösterir; kimin neyi gördüğü paylaşılmaz. Gösterim, reklamın en az yarısı bir saniye ekranda kaldığında sayılır; aynı kişiye aynı yerde 30 dakika içinde tekrar sayılmaz.',
  'call.ringingOut': 'Çalıyor…',
  'call.add.title': 'Kişi ekle',
  'call.add.lead': 'En fazla {count} kişi seç. Görüşme, hepinizin olduğu yeni bir grupta grup görüşmesi olarak devam eder; eklediklerinin telefonu çalar.',
  'call.add.noContacts': 'Eklenecek kişin yok.',
  'call.add.go': { one: 'Ekle ve devam et', other: '{count} kişiyi ekle ve devam et' },
  'admin.tab.analytics': 'Analiz',
  'an.range': 'Tarih aralığı',
  'an.preset.today': 'Bugün',
  'an.preset.d7': '7 gün',
  'an.preset.d30': '30 gün',
  'an.preset.d90': '90 gün',
  'an.users': 'Kullanıcılar',
  'an.totalUsers': 'Toplam kullanıcı',
  'an.newUsers': 'Yeni kayıt',
  'an.activeUsers': 'Aktif kullanıcı',
  'an.activeToday': 'Bugün aktif',
  'an.onlineNow': 'Şu an çevrimiçi',
  'an.adultsMinors': 'Yetişkin / 18 yaş altı',
  'an.logins': 'Giriş sayısı',
  'an.messaging': 'Mesajlaşma',
  'an.messages': 'Mesaj',
  'an.perActive': 'Aktif kişi başı mesaj',
  'an.inDirect': 'Birebir sohbetlerde',
  'an.inGroups': 'Gruplarda',
  'an.inChannels': 'Kanallarda',
  'an.reactions': 'Tepki',
  'an.polls': 'Anket',
  'an.byType': 'Mesaj türleri',
  'an.type.text': 'Metin',
  'an.type.image': 'Fotoğraf',
  'an.type.video': 'Video',
  'an.type.voice': 'Sesli mesaj',
  'an.type.file': 'Dosya',
  'an.type.encrypted': 'Uçtan uca şifreli',
  'an.type.poll': 'Anket',
  'an.type.sticker': 'Çıkartma',
  'an.type.location': 'Konum',
  'an.type.contact': 'Kişi kartı',
  'an.type.event': 'Etkinlik',
  'an.encryptedNote': 'Uçtan uca şifreli sohbetlerde mesajın türü bile sunucuda görünmez; bunlar "Uçtan uca şifreli" olarak sayılır.',
  'an.media': 'Medya',
  'an.uploads': 'Yükleme',
  'an.photos': 'Fotoğraf',
  'an.videos': 'Video',
  'an.voiceNotes': 'Sesli mesaj',
  'an.files': 'Dosya',
  'an.encryptedMedia': 'Şifreli medya',
  'an.storage': 'Yüklenen boyut',
  'an.calls': 'Aramalar',
  'an.voiceCalls': 'Sesli arama',
  'an.videoCalls': 'Görüntülü arama',
  'an.answered': 'Cevaplanan',
  'an.missed': 'Cevapsız / reddedilen',
  'an.callMinutes': 'Toplam görüşme (dk)',
  'an.avgCall': 'Ortalama görüşme',
  'an.longestCall': 'En uzun görüşme',
  'an.groupCalls': 'Grup görüşmesi',
  'an.avgPeople': 'ort. {count} kişi',
  'an.min': 'dk',
  'an.hours': 'saat',
  'an.online': 'Çevrimiçi süre',
  'an.onlineHours': 'Toplam çevrimiçi (saat)',
  'an.onlinePerUser': 'Kişi başı ortalama',
  'an.sessionLength': 'Ortalama oturum',
  'an.social': 'Gruplar, kanallar ve paylaşımlar',
  'an.groupsCreated': 'Yeni grup',
  'an.channelsCreated': 'Yeni kanal',
  'an.communities': 'Topluluk (toplam)',
  'an.stories': 'Hikâye',
  'an.storyViews': '{count} görüntülenme',
  'an.imports': 'İçe aktarılan sohbet',
  'an.reports': 'Şikâyet',
  'an.daily': 'Günlük gidişat',
  'an.metric': 'Gösterilen değer',
  'an.metric.messages': 'Mesaj',
  'an.metric.activeUsers': 'Aktif kullanıcı',
  'an.metric.logins': 'Giriş',
  'an.metric.newUsers': 'Yeni kayıt',
  'an.metric.media': 'Medya',
  'an.metric.calls': 'Arama',
  'an.metric.callMinutes': 'Görüşme dakikası',
  'an.metric.onlineHours': 'Çevrimiçi saat',
  'an.byHour': 'Günün saatlerine göre mesaj yoğunluğu',
  'an.topGroups': 'En hareketli gruplar',
  'an.topChannels': 'En büyük kanallar',
  'an.members': { one: '{count} üye', other: '{count} üye' },
  'an.posts': { one: '{count} paylaşım', other: '{count} paylaşım' },
  'an.people': 'En aktif kişiler',
  'an.showPeople': 'Göster',
  'an.peopleNote': 'Kişi bazlı sıralamaları yalnızca süper yöneticiler görebilir ve her görüntüleme denetim kaydına yazılır.',
  'an.topOnline': 'En uzun çevrimiçi kalanlar',
  'an.topMessages': 'En çok mesaj gönderenler',
  'an.topCalls': 'En çok görüşenler',
  'an.callsCount': { one: '{count} görüşme', other: '{count} görüşme' },
  'an.privacy': 'Raporlar yalnızca sayıları ve süreleri gösterir; mesajların, aramaların ve dosyaların içeriği hiçbir zaman okunmaz. Çevrimiçi süre bu sürümden itibaren kaydedilir.',
  'send.title': '{name} kişisine gönder',
  'send.caption': 'Açıklama ekle…',
  'send.captionFirst': 'Açıklama ilk dosyanın altına yazılır.',
  'send.addMore': 'Dosya ekle',
  'send.remove': 'Bu dosyayı çıkar',
  'ai.unavailable': 'Yazım asistanı bu sunucuda henüz etkin değil.',
  'ai.pageIntro': 'Yazım asistanı mesaj taslaklarını düzeltir, kısaltır, tonunu değiştirir veya çevirir. Yalnız sen istediğinde ve yalnız taslağın gönderilir.',
  'ai.consentGiven': 'Onay verildi.',
  'ai.noConsent': 'Henüz onay vermedin.',
  'call.voice': 'Sesli ara',
  'call.video': 'Görüntülü ara',
  'call.incomingVoice': '{name} sesli arıyor…',
  'call.ringVoice': 'Sesli arama',
  'call.ringVideo': 'Görüntülü arama',
  'call.answerVoice': 'Sesli yanıtla',
  'call.answerVideo': 'Görüntülü yanıtla',
  'call.incomingVideo': '{name} görüntülü arıyor…',
  'call.calling': '{name} aranıyor…',
  'call.connecting': 'Bağlanıyor…',
  'call.accept': 'Cevapla',
  'call.acceptAudio': 'Sesli cevapla',
  'call.decline': 'Reddet',
  'call.hangup': 'Kapat',
  'call.effects.deviceBlur': 'Kameranın kendi bulanıklaştırması (daha az pil)',
  'call.bg.title': 'Arka plan',
  'call.bg.none': 'Yok',
  'call.bg.blur': 'Bulanık',
  'call.bg.blurStrong': 'Çok bulanık',
  'call.bg.office': 'Ofis',
  'call.bg.sunset': 'Gün batımı',
  'call.bg.ocean': 'Okyanus',
  'call.bg.forest': 'Orman',
  'call.bg.bokeh': 'Işıklar',
  'call.bg.studio': 'Stüdyo',
  'call.bg.custom': 'Kendi resmin',
  'call.bg.upload': 'Resim yükle',
  'call.bg.removeCustom': 'Resmi kaldır',
  'call.bg.loading': 'Kişi algılama hazırlanıyor… (ilk seferde birkaç saniye sürebilir)',
  'call.bg.failed': 'Arka plan uygulanamadı; bu cihaz kişi algılamayı çalıştıramadı. Görüntün değiştirilmeden gönderiliyor.',
  'call.bg.badImage': 'Bu dosya resim olarak açılamadı.',
  'call.bg.unsupported': 'Bu tarayıcı arka plan değiştirmeyi desteklemiyor.',
  'call.bg.privacy': 'Arka plan cihazında işlenir; görüntün ve yüklediğin resim hiçbir sunucuya gönderilmez.',
  'call.chat': 'Sohbete git (arama sürer)',
  'gcall.chatOpen': 'Sohbeti aç (görüşme yanda sürer)',
  'gcall.chatClose': 'Görüşmeyi büyüt',
  'call.minimize': 'Küçült',
  'call.expand': 'Büyüt',
  'call.miniLabel': '{name} ile arama',
  'call.pip': 'Resim içinde resim',
  'call.share.start': 'Ekranı paylaş',
  'call.share.stop': 'Paylaşımı durdur',
  'call.share.you': 'Ekranını paylaşıyorsun',
  'call.share.peer': '{name} ekranını paylaşıyor',
  'call.share.failed': 'Ekran paylaşılamadı. Tarayıcının ekran kaydı iznini kontrol et.',
  'call.fullscreen': 'Tam ekran',
  'call.peerMuted': '{name} mikrofonunu kapattı',
  'call.reconnecting': 'Bağlantı yeniden kuruluyor…',
  'call.tapForSound': 'Sesi duymak için dokun',
  'call.silent': 'Ses gelmiyor — düzeltmek için dokunun',
  'call.device.from.phone': 'Telefondan arıyor',
  'call.device.from.tablet': 'Tabletten arıyor',
  'call.device.from.desktop': 'Bilgisayardan arıyor',
  'call.device.on.phone': 'Telefonda',
  'call.device.on.tablet': 'Tablette',
  'call.device.on.desktop': 'Bilgisayarda',
  'call.device.kind.phone': 'Telefon',
  'call.device.kind.tablet': 'Tablet',
  'call.device.kind.desktop': 'Bilgisayar',
  'call.device.app.pwa': 'uygulama',
  'call.device.app.browser': 'tarayıcı',
  'call.peerCameraOff': '{name} kamerasını kapattı',
  'call.flip': 'Kamerayı çevir',
  'call.settings.title': 'Ses ve görüntü ayarları',
  'call.settings.mic': 'Mikrofon',
  'call.settings.camera': 'Kamera',
  'call.settings.speaker': 'Hoparlör',
  'call.settings.noiseSuppression': 'Gürültü bastırma',
  'call.settings.echoCancellation': 'Yankı engelleme',
  'call.settings.autoGainControl': 'Otomatik ses seviyesi',
  'call.settings.failed': 'Bu ayar uygulanamadı. Cihazın başka bir uygulamada açık olmadığından emin ol.',
  'call.effects.title': 'Efektler',
  'call.effects.none': 'Yok',
  'call.effects.warm': 'Sıcak',
  'call.effects.cool': 'Serin',
  'call.effects.mono': 'Siyah-beyaz',
  'call.effects.vintage': 'Nostalji',
  'call.effects.vivid': 'Canlı',
  'call.effects.soft': 'Yumuşak',
  'call.effects.party': 'Parti',
  'call.effects.unsupported': 'Bu tarayıcı görüntü efektlerini desteklemiyor.',
  'call.mute': 'Sesi kapat',
  'call.unmute': 'Sesi aç',
  'call.cameraOff': 'Kamerayı kapat',
  'call.cameraOn': 'Kamerayı aç',
  'call.ended.hangup': 'Arama sona erdi.',
  'call.ended.rejected': 'Arama reddedildi.',
  'call.ended.missed': 'Cevap verilmedi.',
  'call.ended.busy': 'Kişi şu an başka bir aramada.',
  'call.ended.cancelled': 'Arama iptal edildi.',
  'call.ended.failed': 'Bağlantı kurulamadı.',
  'call.ended.disconnected': 'Bağlantı koptu.',
  'call.ended.moved': 'Görüşme diğer cihazına aktarıldı.',
  'call.ended.answered_elsewhere': 'Başka bir cihazında cevaplandı.',
  'call.ended.no_media': 'Arama cevaplandı ama ses ve görüntü bağlantısı kurulamadı. Bulunduğun ağ (okul, iş, otel Wi-Fi\'ı) arama trafiğini engelliyor olabilir; mobil veriyle ya da başka bir ağla tekrar dene.',
  'adminOps.calls.title': 'Arama bağlantısı',
  'adminOps.calls.intro': 'Son {days} günün aramaları: cihazların bildirdiğine göre ses/görüntü bağlantısı kurulabildi mi. Adres bilgisi tutulmaz, yalnız sayılar.',
  'adminOps.calls.counts': '{total} arama · {answered} cevaplandı · {connected} bağlandı · {failed} bağlanamadı · {missed} cevapsız',
  'adminOps.calls.failures': 'Bağlanamama nedenleri',
  'adminOps.calls.reason.timeout': 'Zaman aşımı (30 sn içinde medya akmadı)',
  'adminOps.calls.reason.ice_failed': 'Bağlantı denemeleri başarısız',
  'adminOps.calls.reason.no_relay': 'TURN sunucusuna ulaşılamadı / kimlik reddedildi',
  'adminOps.calls.relayVia': 'Röleye ulaşma yolu',
  'adminOps.calls.noRelay': 'Röle alamayan cihaz raporu: {count}',
  'adminOps.calls.turn': 'TURN: {urls}',
  'adminOps.calls.turnMissing': 'TURN yapılandırılmamış: aramalar yalnız doğrudan bağlantıyla kurulabilir.',
  'adminOps.calls.relayOnly': 'Yalnız röle (IP gizliliği): açık',
  'adminOps.calls.test': 'Bu cihazdan arama altyapısını test et',
  'adminOps.calls.testing': 'Test ediliyor…',
  'adminOps.calls.testOk': '✅ {url} — röle alındı ({ms} ms)',
  'adminOps.calls.testFail': '❌ {url} — röle alınamadı ({ms} ms)',
  'adminOps.calls.stunOk': '✅ STUN: dış adres bulundu',
  'adminOps.calls.stunFail': '⚠️ STUN: dış adres bulunamadı (UDP engelli olabilir)',
  'adminOps.calls.quality': '{reports} arama özeti: {noAudio} tanesinde ses gelmeyen bir süre oldu (%{noAudioPct}), {relay} tanesi röle üzerinden geçti (%{relayPct}), {restarted} tanesinde bağlantı yeniden kuruldu.',
  'adminOps.calls.qualityRtt': 'Ortanca gecikme (gidiş-dönüş): {ms} ms',
  'adminOps.calls.qualityPaths': 'Ses yolu',
  'adminOps.calls.qualityDevices': 'Cihaza göre (özet · sessiz)',
  'adminOps.calls.qualityNone': 'Henüz cihazlardan arama kalitesi özeti gelmedi.',
  'adminOps.calls.testNote': 'Hiçbir röle alınamıyorsa TURN sunucusu kapalı, gizli anahtar uyuşmuyor ya da bu ağ engelliyor demektir. Yalnız TCP çalışıyorsa bu ağ UDP\'yi engelliyor; aramalar TCP üzerinden yine bağlanır.',
  'call.permissionDenied': 'Mikrofon/kamera izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'call.encryptedNote': 'Şifreli bağlantı (DTLS-SRTP). Medya sunucu üzerinden aktarılır; karşı taraf IP adresini görmez.',
  'call.history': 'Aramalar',
  'call.noHistory': 'Henüz arama yok.',
  'call.incoming': 'Gelen',
  'call.outgoing': 'Giden',
  'call.missedLabel': 'Cevapsız',
  'call.duration': '{minutes} dk {seconds} sn',
  'call.log.incomingVoice': 'Gelen sesli arama',
  'call.log.incomingVideo': 'Gelen görüntülü arama',
  'call.log.outgoingVoice': 'Giden sesli arama',
  'call.log.outgoingVideo': 'Giden görüntülü arama',
  'call.log.filter': 'Aramaları göster',
  'call.log.all': 'Tümü',
  'call.log.missed': 'Cevapsız',
  'call.log.new': 'Yeni',
  'call.log.count': { one: '{count} arama', other: '{count} arama' },
  'call.log.noMissed': 'Cevapsız araman yok.',
  'call.log.openChat': '{name} ile sohbeti aç',
  'call.unsupported': 'Bu tarayıcı aramaları desteklemiyor.',
  'push.call': '📞 Gelen arama',
  'call.ended.permission': 'Mikrofon/kamera izni verilmedi.',
  'call.ended.unsupported': 'Bu tarayıcı aramaları desteklemiyor.',
  'call.ended.not_allowed': 'Bu kişiyi arayamazsın (engel veya mesaj ayarları).',
  'push.videoCall': '🎥 Gelen görüntülü arama',
  'push.missedCall': '📞 Cevapsız arama',
  'push.missedVideoCall': '🎥 Cevapsız görüntülü arama',
  'push.reacted': '{name} mesajına {emoji} tepkisini verdi',
  'push.reactedHidden': '{name} mesajına tepki verdi',
  'push.reactedMany': { one: '{name} ve {count} kişi mesajına tepki verdi', other: '{name} ve {count} kişi mesajına tepki verdi' },
  'push.storyTitle': 'Durumun',
  'push.storyLiked': '{name} durumunu beğendi',
  'push.storyLikedMany': { one: '{name} ve {count} kişi durumunu beğendi', other: '{name} ve {count} kişi durumunu beğendi' },
  'push.storyReshared': '{name} durumunu paylaştı',
  'push.storyResharedMany': { one: '{name} ve {count} kişi durumunu paylaştı', other: '{name} ve {count} kişi durumunu paylaştı' },
  'push.activityHidden': 'Yeni bir bildirimin var',
  'push.missedGroupCall': '📞 Cevapsız grup araması · {name}',
  'push.missedGroupVideoCall': '🎥 Cevapsız grup görüntülü araması · {name}',
  'error.E2EE_IDENTITY_CHANGED': 'Doğruladığın biri şifreleme kimliğini değiştirdi. Göndermeden önce onu yeniden doğrula veya değişikliği kabul et (sohbet başlığındaki uyarı).',
  'e2ee.fileFailed': '🔒 Dosya bu cihazda açılamadı (anahtar yok ya da dosya değiştirilmiş).',
  'e2ee.startFailed': 'Şifreleme bu cihazda başlatılamadı',
  'e2ee.startSlow': 'Şifreleme bu cihazda hâlâ hazırlanıyor',
  'e2ee.startHint': 'şifreli mesajlar açılana kadar kilitli görünür.',
  'e2ee.tryAgain': 'Tekrar dene',
  'e2ee.reload': 'Yenile',
  'e2ee.contactVsDeviceOk': 'Bu cihazın doğrulandı ✓. Buradaki doğrulama ise {name} kişisinin kimliği içindir; isteğe bağlıdır, mesajlar zaten uçtan uca şifreli.',
  'e2ee.contactVsDevice': 'Buradaki doğrulama {name} kişisinin kimliği içindir; kendi cihazlarını doğrulamak ayrı bir adımdır. Mesajlar her durumda uçtan uca şifreli.',
  'e2ee.unverifiedSender': 'Gönderen cihaz doğrulanamadı (yedekten geri yüklendi).',
  'e2ee.trust.verified': 'Doğrulandı',
  'e2ee.trust.unverified': 'Şifreli · kişi henüz doğrulanmadı',
  'e2ee.trust.changed': 'Kimlik değişti',
  'e2ee.verifyTitle': '{name} kişisini doğrula',
  'e2ee.verifyIntro': 'Doğrulama, mesajlarının gerçekten {name} kişisinin cihazlarına gittiğinden emin olmanı sağlar. Yüz yüze veya bir görüntülü aramada yapın.',
  'e2ee.verifyEmoji': 'Emoji ile doğrula',
  'e2ee.verifyEmojiHint': 'İkinizin de DijitalApp açık olmalı. Karşı taraf isteği kabul edince iki ekranda emojiler görünür.',
  'e2ee.safetyCode': 'Güvenlik kodu ile doğrula',
  'e2ee.theirCode': '{name} kişisinin kodu',
  'e2ee.yourCode': 'Senin kodun',
  'e2ee.codeHint': 'Karşı taraf, kendi Ayarlar → Uçtan uca şifreleme ekranındaki "Senin kodun" ile buradaki "{name} kişisinin kodu"nu karşılaştırsın. Tamamen aynıysa doğrula.',
  'e2ee.codesMatch': 'Kodlar eşleşiyor, doğrula',
  'e2ee.noIdentity': 'Bu kişi henüz şifrelemeyi kurmamış.',
  'e2ee.requestIncoming': '{name} seninle doğrulama yapmak istiyor.',
  'e2ee.requestIncomingSelf': 'Diğer cihazın bu cihazla doğrulama yapmak istiyor.',
  'e2ee.accept': 'Kabul et',
  'e2ee.decline': 'Reddet',
  'e2ee.waitingAccept': 'Karşı tarafın isteği kabul etmesi bekleniyor…',
  'e2ee.emojiHint': 'İki ekranda da aynı emojiler aynı sırayla görünüyor mu?',
  'e2ee.match': 'Evet, eşleşiyor',
  'e2ee.noMatch': 'Hayır, eşleşmiyor',
  'e2ee.waitingOther': 'Karşı tarafın onayı bekleniyor…',
  'e2ee.done': 'Doğrulama tamamlandı ✓',
  'e2ee.cancelled': 'Doğrulama iptal edildi.',
  'e2ee.changedTitle': '{name} güvenlik kimliğini değiştirdi',
  'e2ee.changedBody': 'Yeni bir cihaz kurmuş ya da şifreleme kimliğini sıfırlamış olabilir; bu durumda mesajlar başka birine gidebilir. Emin olmak için yeniden doğrula. Doğrulamadan kabul edersen mesajlar yeni kimliğe gider.',
  'e2ee.acceptChange': 'Doğrulamadan kabul et',
  'e2ee.reverify': 'Yeniden doğrula',
  'e2ee.deviceUnverifiedTitle': 'Bu cihazı bağla',
  'e2ee.verifyThisDevice': 'Bu cihazı bağla',
  'e2ee.enterRecovery': 'Kurtarma anahtarı',
  'e2ee.restore': 'Geçmişi geri yükle',
  'e2ee.restored': '{count} sohbet anahtarı geri yüklendi.',
  'e2ee.wrongRecovery': 'Kurtarma anahtarı bu yedekle eşleşmiyor.',
  'e2ee.settingsTitle': 'Uçtan uca şifreleme',
  'e2ee.thisDevice': 'Bu cihaz',
  'e2ee.loading': 'Şifreleme hazırlanıyor…',
  'error.E2EE_REQUIRED': 'Bu sohbet uçtan uca şifreli; mesaj şifrelenmeden gönderilemez.',
  'error.E2EE_UNAVAILABLE': 'Uçtan uca şifreleme için sohbetteki herkesin en az bir cihazında şifrelemenin kurulmuş olması gerekir (DijitalApp bir kez açılınca kurulur).',
  'error.E2EE_UNSUPPORTED': 'Bu özellik uçtan uca şifreli sohbetlerde henüz kullanılamıyor.',
  'push.encrypted': '🔒 Şifreli mesaj',
  'push.attachment': '📎 Ek',
  'push.viewOnce': '⏱ Tek seferlik medya',
  'push.chatUnread': { one: '{count} yeni mesaj', other: '{count} yeni mesaj' },
  'push.gif': 'GIF',
  'push.videoClip': '🎥 Video',
  'push.document': '📄 Dosya',
  'push.markRead': 'Okundu işaretle',
  'push.reply': 'Yanıtla',
  'push.replyPlaceholder': 'Mesaj yaz…',
  'push.replyFailed': 'Yanıt gönderilemedi. Uygulamayı açıp tekrar dene.',
  'notifications.sounds.title': 'Sesler ve titreşim',
  'notifications.sounds.enabled': 'Uygulama sesleri',
  'notifications.sounds.volume': 'Ses düzeyi',
  'notifications.sounds.tone': 'Ses',
  'notifications.sounds.vibration': 'Titreşim',
  'notifications.sounds.preview': 'Dinle',
  'notifications.sounds.kind.message': 'Mesajlar',
  'notifications.sounds.kind.group': 'Grup mesajları',
  'notifications.sounds.kind.call': 'Sesli aramalar',
  'notifications.sounds.kind.video': 'Görüntülü aramalar',
  'notifications.sounds.kind.groupCall': 'Grup aramaları',
  'notifications.sounds.closedHint': "Uygulama kapalıyken telefonun bildirim sesi kullanılır. Titreşim seçimi Android'de ve bilgisayarda Chrome'da bildirimlere de uygulanır.",
  'notifications.tone.chime': 'Çan',
  'notifications.tone.pop': 'Pıt',
  'notifications.tone.ding': 'Zil',
  'notifications.tone.bubble': 'Baloncuk',
  'notifications.tone.marimba': 'Marimba',
  'notifications.tone.none': 'Sessiz',
  'notifications.ring.classic': 'Klasik',
  'notifications.ring.pulse': 'Nabız',
  'notifications.ring.marimba': 'Marimba',
  'notifications.ring.digital': 'Dijital',
  'notifications.ring.soft': 'Yumuşak',
  'notifications.ring.none': 'Sessiz (yalnız titreşim)',
  'notifications.vibration.default': 'Varsayılan',
  'notifications.vibration.short': 'Kısa',
  'notifications.vibration.long': 'Uzun',
  'notifications.vibration.heartbeat': 'Kalp atışı',
  'notifications.vibration.none': 'Kapalı',
  'e2ee.label': 'Uçtan uca şifreli',
  'e2ee.enable': 'Uçtan uca şifrelemeyi aç',
  'e2ee.enableConfirm': 'Bu sohbette uçtan uca şifreleme açılacak; geri alınamaz. Mesajlar, dosyalar, tepkiler ve düzenlemeler şifreli olur. Bağlantı önizlemesi ve sunucuda arama şifreli sohbette çalışmaz; yeni bir cihaz eski mesajları telefonundan onaylanınca ya da yedek parolanla açar. Devam edilsin mi?',
  'e2ee.notice': 'Mesajlar, dosyalar ve tepkiler uçtan uca şifreli: içeriği DijitalApp sunucusu dahil kimse göremez; sunucu yalnızca kimin kime ne zaman yazdığını bilir. Kişiyi güvenlik kodu ya da QR ile doğrulayabilirsin.',
  'e2ee.qr.choose': 'Nasıl doğrulamak istersin? İki cihaz yan yana olsun.',
  'e2ee.qr.show': 'QR kodumu göster',
  'e2ee.qr.scan': 'QR kodunu okut',
  'e2ee.qr.emoji': 'Emoji ile karşılaştır',
  'e2ee.qr.emojiInstead': 'Emoji ile karşılaştır',
  'e2ee.qr.showHint': 'Diğer cihazda "QR kodunu okut"u seç ve bu kodu kamerayla okut.',
  'e2ee.qr.codeLabel': 'Doğrulama QR kodu',
  'e2ee.qr.scanHint': 'Diğer cihazın ekranındaki QR kodunu çerçeveye getir.',
  'e2ee.qr.cameraProblem': 'Kamera açılamadı. Kamera izni verip yeniden dene ya da emoji ile karşılaştır.',
  'e2ee.qr.scannedQuestion': 'Diğer cihaz kodunu okudu. O cihazda onay işareti (✓) görünüyor mu?',
  'e2ee.qr.scannedYes': 'Evet, doğrula',
  'e2ee.qr.scannedNo': 'Hayır',
  'e2ee.qr.waiting': 'Kod okundu ve eşleşti. Diğer cihazda onay bekleniyor…',
  'e2ee.qr.failed': 'Bu adım tamamlanamadı. Emoji ile karşılaştırmayı deneyebilirsin.',
  'e2ee.qr.badCode': 'Bu QR kodu bu doğrulamaya ait değil ya da eşleşmedi. Doğru cihazın kodunu okuttuğundan emin ol.',
  'e2ee.editTextOnly': 'Şifreli dosyalar düzenlenemez; yalnızca metin mesajları düzenlenebilir.',
  'e2ee.cannotDecrypt': '🔒 Bu mesaj bu cihazda çözülemiyor (cihaz mesajdan sonra eklenmiş olabilir).',
  'e2ee.decrypting': '🔒 Çözülüyor…',
  'e2ee.waitingKey': '⏳ Mesaj bekleniyor…',
  'e2ee.waitingKeyInfo': 'Bu mesajın anahtarı bu cihaza henüz ulaşmadı. Uygulama onu gönderenin cihazından ve senin diğer cihazlarından kendiliğinden istiyor; çoğu zaman birkaç saniyede açılır.',
  'e2ee.keyNotFound': '🔒 Bu mesaj bu cihazda açılamadı: anahtarı gelmedi. Gönderenin telefonu çevrimiçi olunca yeniden isteyebilirsin.',
  'e2ee.requestAgain': 'Yeniden iste',
  'e2ee.encryptedBadge': 'Şifreli',
  'e2ee.notReady': 'Şifreleme bu cihazda hazırlanıyor; birkaç saniye sonra yeniden dene.',
  'e2ee.unsupportedBrowser': 'Bu tarayıcı uçtan uca şifrelemeyi desteklemiyor.',
  'chat.star': 'Yıldızla',
  'chat.unstar': 'Yıldızı kaldır',
  'chat.starred': 'Yıldızlı mesajlar',
  'chat.noStarred': 'Henüz yıldızlı mesaj yok. Bir mesajı yıldızlamak için mesaj seçeneklerinden "Yıldızla"yı seç.',
  'chat.openInChat': 'Sohbette göster',
  'remind.menu': 'Bana hatırlat',
  'remind.change': 'Hatırlatmayı değiştir',
  'remind.remove': 'Hatırlatmayı kaldır',
  'remind.title': 'Ne zaman hatırlatılsın?',
  'remind.done': 'Hatırlatıcı kuruldu: {when}',
  'remind.list': 'Hatırlatıcılar',
  'remind.none': 'Bekleyen hatırlatıcın yok. Bir mesajın seçeneklerinden "Bana hatırlat"ı seç.',
  'remind.at': 'Hatırlatma: {when}',
  'chat.info': 'Bilgi',
  'chat.infoTitle': 'Mesaj bilgisi',
  'chat.readBy': 'Okudu',
  'chat.deliveredTo': 'İletildi',
  'chat.pendingTo': 'Henüz iletilmedi',
  'chat.readsHidden': 'Okundu bilgisini kapattığın için kimin okuduğu gösterilmiyor.',
  'chat.previewLoading': 'Bağlantı önizlemesi hazırlanıyor…',
  'chat.removePreview': 'Önizlemeyi kaldır',
  'error.ATTACHMENT_MALWARE': 'Bu dosyada zararlı yazılım bulundu; gönderilmedi.',
  'error.ATTACHMENT_SCAN_UNAVAILABLE': 'Dosya güvenlik taraması şu an yapılamıyor. Biraz sonra yeniden dene.',
  'chat.attach': 'Dosya ekle',
  'chat.record': 'Sesli mesaj kaydet',
  'chat.stopRecording': 'Kaydı bitir ve gönder',
  'chat.cancelRecording': 'Kaydı iptal et',
  'chat.pauseRecording': 'Kaydı duraklat',
  'chat.resumeRecording': 'Kayda devam et',
  'chat.previewRecording': 'Durdur ve dinle',
  'chat.sendRecording': 'Sesli mesajı gönder',
  'chat.discardRecording': 'Kaydı sil',
  'chat.recording': 'Kaydediliyor… {seconds} sn',
  'chat.uploading': 'Yükleniyor…',
  'send.quality': 'Fotoğraf kalitesi',
  'send.quality.standard': 'Standart',
  'send.quality.hd': 'HD',
  'send.quality.original': 'Orijinal',
  'send.quality.originalHint': 'Orijinal: fotoğraf olduğu gibi, dosya olarak gider; konum gibi fotoğraf bilgileri de içinde kalır.',
  'chat.uploadingFile': '{name} gönderiliyor · %{percent}',
  'chat.compressingVideo': 'Video hazırlanıyor %{percent}',
  'chat.videoCompressFailedLarge': 'Videoyu sıkıştırma başarısız oldu ve orijinali {limit} MB sınırını aşıyor, bu yüzden gönderilemedi. Daha kısa bir bölüm seçip yeniden dene.',
  'chat.videoProcessing': 'Video hazırlanıyor…',
  'chat.videoBuffering': 'Yükleniyor…',
  'chat.download': 'İndir',
  'chat.micDenied': 'Mikrofon izni verilmedi. Tarayıcı ayarlarından izin verebilirsin.',
  'chat.voiceMessage': 'Sesli mesaj',
  'chat.tooLarge': 'Dosya çok büyük (en fazla {mb} MB).',
  'chat.searchMessages': 'Mesajlar',
  'chat.searchEncrypted': 'Şifreli sohbetlerde aranıyor…',
  'chat.searchOlder': 'Daha eski mesajlarda ara',
  'group.new': 'Yeni grup',
  'group.title': 'Grup adı',
  'group.description': 'Açıklama',
  'group.pickMembers': 'Kişilerinden üye seç (sonra da ekleyebilirsin):',
  'group.addHint': 'Bir kişi ancak gizlilik ayarı izin veriyorsa eklenir (varsayılan: yalnız onu ekleyen kişileri).',
  'group.create': 'Grubu oluştur',
  'group.info': 'Grup bilgisi',
  'group.memberCount': { one: '{count} üye', other: '{count} üye' },
  'group.ban': 'Çıkar ve yasakla',
  'group.banConfirm': '{name} gruptan çıkarılıp yasaklansın mı? Bağlantıyla ya da istekle geri dönemez; yalnızca bir yönetici yasağı kaldırabilir.',
  'group.banned': '{name} yasaklandı.',
  'group.unban': 'Yasağı kaldır',
  'group.unbanned': '{name} için yasak kaldırıldı.',
  'group.bans': 'Yasaklananlar',
  'group.bansEmpty': 'Yasaklanan kimse yok.',
  'group.bansHint': 'Yasağı kaldırılan kişi bağlantıyla geri gelmek isterse yine bir yöneticinin onayını bekler.',
  'group.logAction.group.member.banned': '{actor}, {target} kişisini çıkarıp yasakladı',
  'group.logAction.group.member.unbanned': '{actor}, {target} için yasağı kaldırdı',
  'group.logAction.group.avatar_updated': '{actor} grup fotoğrafını değiştirdi',
  'group.logAction.group.avatar_removed': '{actor} grup fotoğrafını kaldırdı',
  'group.channelInfo': 'Kanal bilgisi',
  'group.subscriberCount': { one: '{count} takipçi', other: '{count} takipçi' },
  'group.editInfo': 'Adı ve açıklamayı düzenle',
  'group.leaveChannel': 'Kanaldan ayrıl',
  'group.removeConfirm': '{name} gruptan çıkarılsın mı?',
  'group.roleSaved': 'Yetki güncellendi.',
  'group.addCount': { one: '{count} kişiyi ekle', other: '{count} kişiyi ekle' },
  'group.roleOf': '{name} için yetki',
  'group.rolesHintOwner': 'Yönetici: ayarları, bağlantıları ve üyeleri yönetir. Moderatör: mesajları siler, üyeleri susturur. Sahip olarak her yetkiyi verebilirsin.',
  'group.rolesHintAdmin': 'Yönetici olarak üyeleri moderatör yapabilir ya da bu yetkiyi geri alabilirsin; yöneticileri yalnızca sahip değiştirir.',
  'group.photoChange': 'Grup fotoğrafını değiştir',
  'group.photoRemove': 'Fotoğrafı kaldır',
  'group.photoSaved': 'Grup fotoğrafı güncellendi.',
  'group.photoRemoved': 'Grup fotoğrafı kaldırıldı.',
  'group.someoneTyping': 'Biri yazıyor…',
  'group.onlyAdmins': 'Yalnız yöneticiler mesaj gönderebilsin (duyuru modu)',
  'group.role.member': 'Üye',
  'group.role.owner': 'Sahip',
  'group.role.admin': 'Yönetici',
  'group.makeAdmin': 'Yönetici yap',
  'group.makeMember': 'Yöneticilikten al',
  'thread.title': 'Konu başlığı',
  'thread.comments': 'Yorumlar',
  'thread.replyCount': { one: '{count} yanıt', other: '{count} yanıt' },
  'thread.commentCount': { one: '{count} yorum', other: '{count} yorum' },
  'thread.addComment': 'Yorum yap',
  'thread.replyIn': 'Konu başlığında yanıtla',
  'thread.replyPlaceholder': 'Konu başlığına yanıt yaz',
  'thread.commentPlaceholder': 'Yorum yaz',
  'thread.commentsOff': 'Bu kanalda yorumlar kapalı.',
  'thread.cannotWrite': 'Bu sohbete şu an yazamazsın.',
  'thread.sending': 'gönderiliyor…',
  'thread.failed': 'gönderilemedi',
  'thread.commentsSwitch': 'Takipçiler gönderilere yorum yapabilsin',
  'channel.reactions': 'Tepkiler',
  'channel.reactions.all': 'Her emoji',
  'channel.reactions.basic': 'Yalnızca temel emojiler',
  'channel.reactions.off': 'Kapalı',
  'channel.reactionsHint.all': 'Takipçiler gönderilere istedikleri emojiyle tepki verebilir. Kimin tepki verdiği görünmez; herkes yalnızca her emojinin sayısını görür.',
  'channel.reactionsHint.basic': 'Takipçiler yalnızca {emoji} ile tepki verebilir. Kimin tepki verdiği görünmez, yalnızca sayılar görünür.',
  'channel.reactionsHint.off': 'Takipçiler tepki veremez; gönderilerdeki tepkiler de gizlenir.',
  'notify.title': 'Bildirimler',
  'notify.all': 'Tüm mesajlar',
  'notify.mentions': 'Yalnız bahsedilince ve yanıtlarda',
  'notify.none': 'Hiçbiri',
  'group.silencedNote': 'Yöneticiler seni {until} tarihine kadar susturdu; mesajları okuyabilirsin.',
  'group.searchMembers': 'Üyelerde ara',
  'group.noMemberMatch': 'Eşleşen üye yok.',
  'group.subscribersPrivate': 'Takipçilerin kimliği gizlidir: listeyi yalnız kanalın yöneticileri görür.',
  'group.moreMembers': { one: '{count} kişi daha göster', other: '{count} kişi daha göster' },
  'group.memberActions': '{name} için seçenekler',
  'group.silence': 'Sustur',
  'group.unsilence': 'Susturmayı kaldır',
  'group.silenced': 'Susturuldu',
  'group.silenceFor.60': '1 saat',
  'group.silenceFor.480': '8 saat',
  'group.silenceFor.1440': '1 gün',
  'group.silenceFor.10080': '1 hafta',
  'group.log': 'Grup kaydı',
  'group.logEmpty': 'Henüz kayıt yok.',
  'group.logSomeone': 'Biri',
  'group.logAction.group.created': '{actor} grubu oluşturdu',
  'group.logAction.group.updated': '{actor} grup ayarlarını değiştirdi',
  'group.logAction.group.members.added': '{actor}, {target} kişisini ekledi',
  'group.logAction.group.member.removed': '{actor}, {target} kişisini çıkardı',
  'group.logAction.group.left': '{target} gruptan ayrıldı',
  'group.logAction.group.member.role': '{actor}, {target} kişisini {detail} yaptı',
  'group.logAction.group.member.silenced': '{actor}, {target} kişisini {detail} susturdu',
  'group.logAction.group.member.unsilenced': '{actor}, {target} kişisinin susturmasını kaldırdı',
  'group.logAction.group.joined.link': '{target} davet bağlantısıyla katıldı',
  'group.logAction.group.join.requested': '{target} katılmak istedi',
  'group.logAction.group.join.approved': '{actor} bir katılma isteğini onayladı',
  'group.logAction.group.join.rejected': '{actor} bir katılma isteğini reddetti',
  'group.logAction.group.link.created': '{actor} davet bağlantısı oluşturdu',
  'group.logAction.group.link.revoked': '{actor} davet bağlantısını iptal etti',
  'group.logAction.group.call_link.created': '{actor} görüşme bağlantısı oluşturdu',
  'group.logAction.group.call_link.revoked': '{actor} görüşme bağlantısını iptal etti',
  'group.role.moderator': 'Moderatör',
  'group.makeModerator': 'Moderatör yap',
  'group.removeModerator': 'Moderatörlükten al',
  'group.permissions': 'İzinler',
  'group.permSendMedia': 'Üyeler fotoğraf, video, ses ve dosya gönderebilir',
  'group.permAddMembers': 'Üyeler gruba kişi ekleyebilir',
  'group.permEditInfo': 'Üyeler grup adını ve açıklamasını değiştirebilir',
  'group.slowMode': 'Yavaş mod',
  'group.slowModeHint': 'Üyeler iki mesajı arasında bu kadar bekler; sahip, yöneticiler ve moderatörler beklemez.',
  'group.slowOff': 'Kapalı',
  'group.slowWait': 'Yavaş mod: {seconds} sn sonra yazabilirsin',
  'group.mediaNotAllowed': 'Bu grupta yalnız yöneticiler medya gönderebilir',
  'group.seconds': { one: '{count} saniye', other: '{count} saniye' },
  'group.minutes': { one: '{count} dakika', other: '{count} dakika' },
  'group.hours': { one: '{count} saat', other: '{count} saat' },
  'error.SLOW_MODE': 'Yavaş mod açık: biraz bekleyip tekrar dene.',
  'chatLock.title': 'Kilitli sohbetler',
  'chatLock.settingsHint': 'Seçtiğin sohbetler ana listeden çıkar ve yalnızca gizli kodunla ya da passkey (parmak izi, yüz, cihaz PIN’i) ile açılır. Bildirimlerinde de kimin ne yazdığı görünmez.',
  'chatLock.createCode': 'Gizli kod oluştur',
  'chatLock.changeCode': 'Gizli kodu değiştir',
  'chatLock.codeHint': 'En az 4 karakter: rakam, kelime ya da emoji olabilir. Bu kodu unutursan kilitli sohbetleri passkey ile açabilirsin.',
  'chatLock.currentCode': 'Şu anki gizli kod',
  'chatLock.newCode': 'Yeni gizli kod',
  'chatLock.repeatCode': 'Gizli kodu tekrar yaz',
  'chatLock.mismatch': 'İki kod aynı değil.',
  'chatLock.code': 'Gizli kod',
  'chatLock.unlock': 'Kilidi aç',
  'chatLock.unlockTitle': 'Kilitli sohbetleri aç',
  'chatLock.unlockHint': 'Gizli kodunu gir ya da bu cihazdaki passkey ile doğrula.',
  'chatLock.usePasskey': 'Parmak izi, yüz ya da cihaz PIN’i',
  'chatLock.noPasskey': 'Bu hesapta passkey yok. Gizli kodunu kullan ya da Güvenlik ayarlarından passkey ekle.',
  'chatLock.lockedTitle': 'Bu sohbet kilitli',
  'chatLock.lockedBody': 'Mesajları görmek için kilidi aç.',
  'chatLock.lockChat': 'Sohbeti kilitle',
  'chatLock.unlockChat': 'Kilitten çıkar',
  'chatLock.lockedNote': 'Sohbet kilitlendi. Artık “Kilitli sohbetler”de.',
  'chatLock.unlockedNote': 'Sohbet kilitten çıkarıldı.',
  'chatLock.lockNow': 'Şimdi kilitle',
  'chatLock.listNote': 'Bu sohbetler yalnızca kilit açıkken görünür. Uygulamadan bir dakikadan uzun ayrılınca yeniden kilitlenir.',
  'chatLock.lockedChats': 'Kilitli sohbet',
  'chatLock.count': '{count} sohbet',
  'chatLock.thisDevice': 'Bu cihaz',
  'chatLock.isUnlocked': 'Kilidi açık',
  'chatLock.isLocked': 'Kilitli',
  'chatLock.hide': '“Kilitli sohbetler”i listede gizle',
  'chatLock.hideHint': 'Gizliyken görmek için sohbet aramasına gizli kodunu yazıp Enter’a bas.',
  'chatLock.remove': 'Kilitli sohbetleri kapat',
  'chatLock.removeConfirm': 'Tüm sohbetlerin kilidi kaldırılacak ve gizli kod silinecek. Devam edilsin mi?',
  'error.CHAT_LOCKED': 'Bu sohbet kilitli. Açmak için gizli kodunu gir ya da passkey kullan.',
  'error.CHAT_LOCK_WRONG_CODE': 'Gizli kod yanlış.',
  'error.CHAT_LOCK_NO_CODE': 'Önce kilitli sohbetler için bir gizli kod belirle.',
  'group.remove': 'Çıkar',
  'group.messageMember': 'Mesaj gönder',
  'group.addContact': 'Kişilere ekle',
  'group.contactAdded': '{name} kişilerine eklendi.',
  'chat.copied': 'Kopyalandı',
  'chat.copyFailed': 'Kopyalanamadı. Mesaja uzun basıp metni seçmeyi dene.',
  'chat.replyPrivately': 'Özelden yanıtla',
  'chat.replyPrivatelyQuote': '↩ {group} grubundaki mesajın: “{text}”',
  'chat.readMore': 'Devamını oku',
  'admin.tab.releases': 'Sürüm notları',
  // ---- Notification Center (Panel › Bildirimler) ----
  'admin.tab.notifications': 'Bildirimler',
  'adminUi.desc.notifications': 'Sistem bildirimleri, duyurular ve teslim raporları.',
  'notifications.system.title': 'Sistem duyuruları',
  'notifications.system.label': 'DijitalApp duyuruları, haberler ve güncellemeler',
  'notifications.system.hint': 'Hesabınla ilgili kritik güvenlik uyarıları kapalıyken de gelir.',
  'nc.title': 'Bildirim merkezi',
  'nc.new': 'Yeni bildirim',
  'nc.newTitle': 'Yeni bildirim',
  'nc.editTitle': 'Bildirimi düzenle',
  'nc.backToList': 'Tüm bildirimler',
  'nc.search': 'Başlıkta ara',
  'nc.empty': 'Henüz bildirim yok',
  'nc.emptyText': 'Herkese ya da seçtiğin bir kitleye duyuru, haber veya önemli güncelleme gönder.',
  'nc.emptyFiltered': 'Bu filtreye uyan bildirim yok',
  'nc.col.notification': 'Bildirim',
  'nc.col.status': 'Durum',
  'nc.col.when': 'Zaman',
  'nc.col.audience': 'Hedef kitle',
  'nc.col.targeted': 'Hedeflenen',
  'nc.col.delivered': 'Teslim',
  'nc.col.opened': 'Açılma',
  'nc.status.all': 'Tümü',
  'nc.status.draft': 'Taslak',
  'nc.status.scheduled': 'Planlandı',
  'nc.status.sending': 'Gönderiliyor',
  'nc.status.sent': 'Gönderildi',
  'nc.status.cancelled': 'İptal edildi',
  'nc.kind.announcement': 'Duyuru',
  'nc.kind.news': 'Haber',
  'nc.kind.update': 'Önemli güncelleme',
  'nc.kind.promo': 'Kampanya',
  'nc.kind.security': 'Kritik güvenlik',
  'nc.kindLabel': 'Tür',
  'nc.kindHelp.announcement': 'Genel bir duyuru. “Sistem duyuruları”nı kapatanlara gitmez.',
  'nc.kindHelp.news': 'Haber ve yenilikler. “Sistem duyuruları”nı kapatanlara gitmez.',
  'nc.kindHelp.update': 'Uygulamayla ilgili önemli bir değişiklik. Tercihe uyar.',
  'nc.kindHelp.promo': 'Pazarlama içeriği: 18 yaş altına asla gönderilmez, tercihe uyar.',
  'nc.kindHelp.security': 'Yalnızca hesap güvenliği için: tercihi kapatanlara da gider ve ayrıca kayda geçer.',
  'nc.stat.sent': 'Gönderilen',
  'nc.stat.scheduled': { one: "{count} planlı", other: "{count} planlı" },
  'nc.stat.reached': 'Ulaşılan kişi',
  'nc.stat.deliveryRate': 'Teslim oranı',
  'nc.stat.ofPushes': { one: "{count} bildirim içinde", other: "{count} bildirim içinde" },
  'nc.stat.openRate': 'Açılma oranı',
  'nc.stat.ofReached': { one: "{count} ulaşılan kişide", other: "{count} ulaşılan kişide" },
  'nc.sec.content': 'İçerik',
  'nc.sec.audience': 'Hedef kitle',
  'nc.sec.audienceHelp': 'Seçtiğin her filtre kitleyi daraltır; bir filtredeki seçenekler “ya da” ile birleşir. Hiçbiri seçili değilse herkes.',
  'nc.sec.when': 'Zamanlama',
  'nc.f.kind': 'Tür',
  'nc.f.language': 'Dil',
  'nc.f.title': 'Başlık',
  'nc.f.titlePh': 'Örn. Yeni sürüm hazır',
  'nc.f.body': 'Metin',
  'nc.f.bodyPh': 'Kısa ve net bir cümle…',
  'nc.f.titleEn': 'İngilizce başlık',
  'nc.f.bodyEn': 'İngilizce metin',
  'nc.f.enHelp': 'Boş bırakılırsa İngilizce kullananlar Türkçesini görür.',
  'nc.f.link': 'Bağlantı',
  'nc.f.linkHelp': 'Uygulama içi bir sayfa (/market) ya da https adresi. Boşsa uygulama açılır.',
  'nc.f.image': 'Görsel',
  'nc.f.imageHelp': 'Büyük görsel (https). Android ve masaüstünde görünür; iPhone küçük gösterir.',
  'nc.f.inApp': 'Uygulama içinde duyuru kartı da göster',
  'nc.f.inAppHelp': 'Keşfet’te ve sohbetlerin üstünde, yalnızca bu kitleye.',
  'nc.f.inAppDays': 'Kart ne kadar kalsın',
  'nc.f.at': 'Gönderim zamanı',
  'nc.f.atHelp': 'Senin saatine göre. En fazla 90 gün sonrası.',
  'nc.days': { one: "{count} gün", other: "{count} gün" },
  'nc.aud.roles': 'Ekip üyeleri',
  'nc.aud.plans': 'Plan',
  'nc.aud.platforms': 'Platform',
  'nc.aud.deviceKinds': 'Cihaz',
  'nc.aud.apps': 'Uygulama / tarayıcı',
  'nc.aud.locales': 'Dil',
  'nc.aud.countries': 'Ülke',
  'nc.aud.ageGroups': 'Yaş grubu',
  'nc.aud.active': 'Son kullanım',
  'nc.aud.anyTime': 'Fark etmez',
  'nc.aud.activeIn': { one: "Son {count} günde aktif", other: "Son {count} günde aktif" },
  'nc.aud.users': 'Belirli kişiler',
  'nc.aud.findUser': 'Kullanıcı adı ya da ad ara',
  'nc.aud.pasteIds': 'Kullanıcı kimlikleri (virgülle)',
  'nc.aud.remove': 'Çıkar',
  'nc.aud.specific': { one: "{count} kişi", other: "{count} kişi" },
  'nc.aud.everyone': 'Herkes',
  'nc.aud.clear': 'Filtreleri temizle',
  'nc.role.staff': 'Tüm ekip',
  'nc.role.super_admin': 'Süper yönetici',
  'nc.role.admin': 'Yönetici',
  'nc.role.moderator': 'Moderatör',
  'nc.role.support': 'Destek',
  'nc.role.security_admin': 'Güvenlik',
  'nc.role.finance': 'Finans',
  'nc.role.analyst': 'Analist',
  'nc.role.read_only': 'Salt okunur',
  'nc.plan.free': 'Ücretsiz',
  'nc.plan.plus': 'Plus',
  'nc.plan.business': 'İşletme',
  'nc.plan.premium': 'Premium',
  'nc.os.ios': 'iOS',
  'nc.os.android': 'Android',
  'nc.os.windows': 'Windows',
  'nc.os.macos': 'macOS',
  'nc.os.linux': 'Linux',
  'nc.os.chromeos': 'ChromeOS',
  'nc.os.other': 'Diğer',
  'nc.device.phone': 'Telefon',
  'nc.device.tablet': 'Tablet',
  'nc.device.desktop': 'Bilgisayar',
  'nc.device.unknown': 'Bilinmiyor',
  'nc.app.pwa': 'Yüklü uygulama',
  'nc.app.browser': 'Tarayıcı',
  'nc.app.unknown': 'Bilinmiyor',
  'nc.age.minor': '18 yaş altı',
  'nc.age.18-24': '18–24',
  'nc.age.25-34': '25–34',
  'nc.age.35-44': '35–44',
  'nc.age.45-54': '45–54',
  'nc.age.55+': '55+',
  'nc.people': { one: "{count} kişi", other: "{count} kişi" },
  'nc.withPush': { one: "{count} kişiye bildirim ulaşabilir", other: "{count} kişiye bildirim ulaşabilir" },
  'nc.optedOut': { one: "{count} kişi kapatmış", other: "{count} kişi kapatmış" },
  'nc.countError': 'Sayılamadı',
  'nc.sample': 'Örnek alıcılar',
  'nc.minorsNote': 'Kampanyalar 18 yaş altındakilere hiçbir zaman gönderilmez; bu kişiler kitleden otomatik çıkarılır.',
  'nc.securityNote': 'Kritik güvenlik bildirimi “Sistem duyuruları”nı kapatanlara da gider. Yalnızca hesap güvenliği için kullan.',
  'nc.whenNow': 'Hemen gönder',
  'nc.whenLater': 'İleri tarihe planla',
  'nc.saveDraft': 'Taslağı kaydet',
  'nc.testToMe': 'Bana test gönder',
  'nc.sendNow': 'Gönder',
  'nc.schedule': 'Planla',
  'nc.delete': 'Sil',
  'nc.saved': 'Taslak kaydedildi',
  'nc.testSent': 'Test {devices} cihazından {sent} tanesine ulaştı',
  'nc.testNoDevice': 'Bildirim açık bir cihazın yok: Ayarlar › Bildirimler’den aç',
  'nc.confirmSendTitle': 'Şimdi gönderilsin mi?',
  'nc.confirmSendBody': { one: "Bildirim {count} kişiye hemen gönderilecek. Gönderim başladıktan sonra geri alınamaz.", other: "Bildirim {count} kişiye hemen gönderilecek. Gönderim başladıktan sonra geri alınamaz." },
  'nc.confirmSecurityBody': { one: "Kritik güvenlik bildirimi {count} kişiye, tercihlerine bakılmadan gönderilecek. Bu işlem kayda geçer.", other: "Kritik güvenlik bildirimi {count} kişiye, tercihlerine bakılmadan gönderilecek. Bu işlem kayda geçer." },
  'nc.confirmScheduleTitle': 'Planlansın mı?',
  'nc.confirmScheduleBody': { one: "{at} tarihinde yaklaşık {count} kişiye gönderilecek (kitle o an yeniden hesaplanır).", other: "{at} tarihinde yaklaşık {count} kişiye gönderilecek (kitle o an yeniden hesaplanır)." },
  'nc.sentToast': 'Gönderim başladı',
  'nc.scheduledToast': 'Bildirim planlandı',
  'nc.deleteTitle': 'Taslak silinsin mi?',
  'nc.deleteBody': 'Taslak kalıcı olarak silinir.',
  'nc.previewTitle': 'Önizleme',
  'nc.preview.date': 'Pazartesi, 2 Kasım',
  'nc.preview.now': 'şimdi',
  'nc.preview.opens': 'Dokununca açılır: {link}',
  'nc.preview.opensApp': 'Dokununca uygulama açılır.',
  'nc.preview.card': 'Uygulama içi kart',
  'nc.edit': 'Düzenle',
  'nc.unschedule': 'Taslağa al',
  'nc.unscheduledToast': 'Taslağa alındı',
  'nc.cancel': 'Gönderimi iptal et',
  'nc.cancelTitle': 'Gönderim iptal edilsin mi?',
  'nc.cancelBody': 'Henüz ulaşılmamış kişilere gönderilmez ve uygulama içi kart kaldırılır. Gönderilmiş olanlar geri alınamaz.',
  'nc.cancelledToast': 'Gönderim iptal edildi',
  'nc.exportSummary': 'Özet CSV',
  'nc.exportRecipients': 'Alıcılar CSV',
  'nc.scheduledFor': '{at} tarihinde gönderilecek.',
  'nc.sendingNote': 'Gönderiliyor: {total} kişiden {done} tanesi işlendi.',
  'nc.report': 'Rapor',
  'nc.m.targeted': 'Hedeflenen',
  'nc.m.targetedHint': { one: "{count} cihaza bildirim", other: "{count} cihaza bildirim" },
  'nc.m.delivered': 'Teslim edildi',
  'nc.m.deliveredHint': '{of} bildirimden {n}',
  'nc.m.opened': 'Açıldı',
  'nc.m.openedHint': 'Ulaşılan {of} kişiden {n}',
  'nc.m.read': 'Okundu',
  'nc.m.readHint': '{of} kişiden {n}',
  'nc.m.failed': 'Başarısız',
  'nc.m.skippedHint': 'Cihazı yok: {none} · kapatmış: {off}',
  'nc.overTime': 'Zaman içinde',
  'nc.byHour': 'Saatlik',
  'nc.byDay': 'Günlük',
  'nc.metric': 'Ölçü',
  'nc.chartTotal': { one: "Toplam {count}", other: "Toplam {count}" },
  'nc.chartAria': '{metric}: zaman içinde, toplam {count}',
  'nc.asTable': 'Tablo',
  'nc.asChart': 'Grafik',
  'nc.noData': 'Henüz veri yok',
  'nc.b.kind': 'Cihaz türü',
  'nc.b.os': 'İşletim sistemi',
  'nc.b.app': 'Uygulama / tarayıcı',
  'nc.b.locale': 'Dil',
  'nc.b.pushes': 'Bildirim',
  'nc.b.people': 'Kişi',
  'nc.b.delivered': 'Teslim',
  'nc.b.reached': 'Ulaşan',
  'nc.b.opened': 'Açılma',
  'nc.facts': 'Ayrıntılar',
  'nc.createdBy': 'Hazırlayan',
  'nc.createdAt': 'Oluşturulma',
  'nc.startedAt': 'Gönderim başlangıcı',
  'nc.sentAt': 'Tamamlanma',
  'nc.no': 'Hayır',
  'nc.peopleLocked': 'Kişi bazında ayrıntılar (kim, hangi cihazda, ne zaman açtı) yalnızca “notifications.people” yetkisi olan ekip üyelerine görünür; her bakış kayda geçer.',
  'nc.recipients': 'Alıcılar',
  'nc.recipientsHelp': { one: "{count} kişi · bu listeye her bakış kayda geçer", other: "{count} kişi · bu listeye her bakış kayda geçer" },
  'nc.noRecipients': 'Bu filtrede alıcı yok',
  'nc.r.person': 'Kişi',
  'nc.r.devices': 'Cihazlar',
  'nc.r.search': 'Kişi ara',
  'nc.r.waiting': 'Sırada',
  'nc.rf.all': 'Tümü',
  'nc.rf.delivered': 'Teslim edildi',
  'nc.rf.failed': 'Başarısız',
  'nc.rf.clicked': 'Açtı',
  'nc.rf.read': 'Okudu',
  'nc.rf.unread': 'Okumadı',
  'nc.rf.skipped': 'Atlandı',
  'nc.skip.no_device': 'Cihazı yok',
  'nc.skip.opted_out': 'Kapatmış',
  'nc.skip.push_off': 'Bildirim kapalı',
  'nc.skip.cancelled': 'İptal',
  'nc.err.too_small': 'Gerekli',
  'nc.err.too_big': 'Çok uzun ya da çok büyük',
  'nc.err.invalid_format': 'Geçersiz biçim',
  'nc.err.invalid_value': 'Geçersiz seçim',
  'nc.err.invalid_type': 'Geçersiz değer',
  'nc.err.invalid_state': 'Bu durumda değiştirilemez',
  'nc.err.minor_marketing': 'Kampanyalar 18 yaş altına gönderilemez',
  // ---- end Notification Center ----
  'releases.title': 'Sürüm notları',
  'releases.hint': 'Her sürümün tarihi ve getirdikleri. Herkese açık notlar Yenilikler sayfasında ve DijitalApp kanalında görünür; iç notlar ve gizlenen maddeler yalnızca ekipte kalır.',
  'releases.current': 'Yayındaki sürüm',
  'releases.new': 'Yeni sürüm',
  'releases.edit': 'v{version} düzenle',
  'releases.versions': 'sürüm',
  'releases.search': 'Sürümlerde ara',
  'releases.filter': 'Türe göre süz',
  'releases.all': 'Tümü',
  'releases.kind.feature': 'Yenilik',
  'releases.kind.improvement': 'İyileştirme',
  'releases.kind.fix': 'Hata düzeltme',
  'releases.kind.security': 'Güvenlik',
  'releases.kind.performance': 'Performans',
  'releases.kind.known_issue': 'Bilinen sorun',
  'releases.kindLabel': 'Tür',
  'releases.entryText': 'Madde',
  'releases.draft': 'Taslak',
  'releases.published': 'Yayında',
  'releases.live': 'Güncel',
  'releases.empty': 'Henüz sürüm notu yok.',
  'releases.noMatch': 'Aramaya uyan sürüm yok.',
  'releases.deleteConfirm': 'v{version} sürüm notu silinsin mi?',
  'releases.version': 'Sürüm numarası',
  'releases.date': 'Yayın tarihi',
  'releases.status': 'Durum',
  'releases.commit': 'Commit (isteğe bağlı)',
  'releases.headline': 'Başlık',
  'releases.summary': 'Kısa özet',
  'releases.entries': { one: '{count} madde', other: '{count} madde' },
  'releases.addEntry': 'Madde ekle',
  'releases.bulk': 'Toplu ekle',
  'releases.bulkHint': 'Her satır bir madde. Başına + yenilik, * iyileştirme, - düzeltme, # güvenlik, ~ performans, ! bilinen sorun.',
  'releases.bulkAdd': 'Satırları ekle',
  'releases.settings.title': 'Yayın ayarları',
  'releases.settings.desc': 'Sürüm notlarından kullanıcıların ne göreceği. İç notlar ve gizlenen maddeler hiçbir yerde kullanıcılara görünmez.',
  'releases.settings.page': 'Yenilikler sayfası',
  'releases.settings.pageHelp': 'Açıkken herkes Yenilikler’i menüden ve aramadan açar. Kapalıyken menülerde görünmez, sayfa “yakında” der.',
  'releases.settings.channel': 'Kanalda paylaş',
  'releases.settings.channelHelp': 'Herkese açık her yeni sürüm DijitalApp kanalında bir Yenilikler gönderisi olur. Resmî kanallar’daki “Yenilikler gönderileri” ile aynı ayar.',
  'releases.settings.default': 'Yeni notlar',
  'releases.settings.defaultHelp': 'Yeni bir sürüm notu yazılırken önce seçili olan görünürlük.',
  'releases.visibility': 'Görünürlük',
  'releases.visibility.public': 'Herkese açık (Yenilikler + kanal)',
  'releases.visibility.team': 'Yalnızca ekip (iç not)',
  'releases.visibility.publicShort': 'Herkese açık',
  'releases.visibility.teamShort': 'Yalnızca ekip',
  'releases.visibility.publicHelp': 'Yenilikler sayfasında ve DijitalApp kanalında görünür; gizlediğin maddeler hariç.',
  'releases.visibility.teamHelp': 'Yalnızca panelde kalır: Yenilikler’de, aramada ve kanalda hiç görünmez.',
  'releases.internal': 'İç not',
  'releases.hiddenCount': { one: '{count} gizli madde', other: '{count} gizli madde' },
  'releases.hideEntry': 'Kullanıcılara gösterme',
  'releases.showEntry': 'Kullanıcılara göster',
  'releases.audience': 'Kimin için',
  'releases.audience.none': 'Etiketsiz',
  'releases.audience.team': 'Ekip',
  'releases.audience.admins': 'Yönetici',
  'releases.hiddenTag': 'Gizli',
  'releases.preview': 'Kullanıcılar böyle görecek',
  'releases.previewTab': 'Önizleme',
  'releases.editTab': 'Düzenle',
  'releases.previewDraft': 'Taslak: yayımlanınca Yenilikler’de böyle görünecek.',
  'releases.previewTeam': 'İç not: kullanıcılar bu sürüm notunu hiç görmez.',
  'releases.previewHidden': { one: '{count} madde kullanıcılara gösterilmiyor.', other: '{count} madde kullanıcılara gösterilmiyor.' },
  'releases.previewPageOff': 'Yenilikler sayfası şu an kapalı; açıldığında böyle görünecek.',
  'releases.previewEmpty': 'Kullanıcılara gösterilecek madde yok; yalnızca başlık ve özet görünür.',
  'releases.makeTeam': 'Yalnızca ekibe al',
  'releases.makePublic': 'Herkese aç',
  'releases.makeTeamConfirm': 'v{version} iç not olsun mu? Yenilikler sayfasından kalkar, kanaldaki gönderisi de kaldırılır.',
  'releases.makePublicConfirm': 'v{version} herkese açılsın mı? Yenilikler sayfasında görünür; kanalda paylaşım açıksa ve daha önce paylaşılmadıysa kanalda da paylaşılır.',
  'releases.channel.posted': 'Kanalda',
  'releases.channel.stale': 'Kanaldaki gönderi eski',
  'releases.channel.sync': 'Kanaldaki paylaşımı güncelle',
  'releases.channel.staleHint': 'Kanaldaki gönderi bu notun eski hâlini gösteriyor (örneğin sonradan gizlenen bir madde). Birkaç dakika içinde kendiliğinden güncellenir; hemen de güncelleyebilirsin.',
  'releases.channel.internalHint': 'Bu iç not kanalda paylaşılmış; gönderi kanaldan kaldırılacak.',
  'releases.channel.willRemove': 'Kaydedince bu sürümün DijitalApp kanalındaki gönderisi kaldırılır.',
  'releases.channel.synced': 'Kanaldaki paylaşım güncel.',
  'album.label': { one: '1 fotoğraf', other: '{count} fotoğraf' },
  'viewer.previous': 'Önceki fotoğraf',
  'viewer.next': 'Sonraki fotoğraf',
  'story.like': 'Beğen',
  'story.unlike': 'Beğenmekten vazgeç',
  'story.liked': 'Beğendi',
  'story.reshare': 'Durumuma ekle',
  'story.reshared': 'Durumuna eklendi.',
  'story.from': '{name} adlı kişinin durumundan',
  'privacy.storyReshare': 'Durumlarımı görenler kendi durumlarında paylaşabilsin (adım belirtilerek)',
  'call.settings.volume': 'Karşı tarafın ses düzeyi',
  'gcall.soundFor': '{name}: ses ayarları',
  'gcall.volume': 'Ses düzeyi',
  'gcall.muteForMe': 'Yalnız bende sessize al',
  'gcall.unmuteForMe': 'Sesini aç',
  'gcall.soundHint': 'Bu ayar yalnızca senin duyduğunu değiştirir; diğerleri onu duymaya devam eder.',
  'contacts.findLabel': 'Kişilerinde ara ya da kullanıcı adıyla yeni kişi bul',
  'contacts.findPlaceholder': 'İsim ya da @kullanıcıadı',
  'contacts.looking': 'Aranıyor…',
  'contacts.notFound': '@{name} bulunamadı. Kullanıcı adını doğru yazdığından emin ol; bazı kişiler aramalarda görünmemeyi seçer.',
  'contacts.noMatch': 'Kişilerinde bu isimde biri yok.',
  'contacts.emptyHint': 'Henüz kişin yok. Yukarıya bir kullanıcı adı yaz, bulunca tek dokunuşla ekle ya da hemen mesaj gönder.',
  'contacts.messageTo': '{name} ile sohbet et',
  'contacts.blockName': '{name} engelle',
  'contacts.unblockName': '{name} engelini kaldır',
  'settings.section.family': 'Aile',
  'settings.section.family.desc': 'Aile Merkezi: çocuğunun kimlerle konuşabileceğine birlikte karar verin',
  'error.FAMILY_APPROVAL_PENDING': 'Velinin onayına gönderildi. Onaylayınca kişilerine eklenecek.',
  'family.off': 'Aile Merkezi şu an kapalı.',
  'family.introTitle': 'Aile Merkezi',
  'family.introText': 'Çocuğunun DijitalApp’i güvenle kullanması için onunla birlikte kurulur. Çocuğun Ayarlar › Aile bölümünden sana bir davet gönderir; kendi hesabınla bağlandığında şunlar olur:',
  'family.point.approve': 'Çocuğunun eklemek istediği her kişi önce senin onayına gelir; onaylarsın, reddedersin ya da spam diye şikâyet edersin.',
  'family.point.only': 'Kişi listesinde olmayan kimse çocuğuna yazamaz, onu arayamaz; çocuğun da yalnızca onlara yazabilir.',
  'family.point.alerts': 'Çocuğunun sohbetinde kaygı verici bir mesaj olursa kimin gönderdiğini ve ne tür olduğunu öğrenirsin.',
  'family.point.private': 'Mesajlarının içeriğini göremezsin. Bu, çocuğunun mahremiyeti ve sana olan güveni için böyle tasarlandı.',
  'family.mineTitle': 'Velilerim',
  'family.mineSupervised': 'Kişilerini velilerinle birlikte yönetiyorsunuz: eklemek istediğin kişiler onların onayına gider ve listende olmayan kimse sana yazamaz.',
  'family.mineNotYet': 'Velini Aile Merkezi’ne davet edebilirsin. Bağlandığında eklemek istediğin kişileri o onaylar; listende olmayan kimse sana yazamaz.',
  'family.guardian': 'veli',
  'family.childPrivacy': 'Velilerin mesajlarını okuyamaz; yalnızca kimlerle konuşabileceğine karar verir.',
  'family.guardianPrivacy': 'Mesajları göremezsin; kimlerle konuşabileceğine sen karar verirsin.',
  'family.waitingTitle': 'Onay bekleyenler',
  'family.waiting': 'Velinin onayını bekliyor',
  'family.inviteLabel': 'Velinin e-posta adresi',
  'family.inviteHint': 'Veline bir bağlantı gider; kendi DijitalApp hesabıyla bağlanır. Bağlantı 7 gün geçerlidir.',
  'family.invitedTo': '{email} adresine davet gönderildi. Yeniden gönderebilir ya da başka bir adres yazabilirsin.',
  'family.invite': 'Davet gönder',
  'family.invited': 'Davet gönderildi. Velin e-postasındaki bağlantıyla bağlanabilir.',
  'family.inviteOwn': 'Kendi e-posta adresini yazdın; velinin adresini yazmalısın.',
  'family.age': '{age} yaşında',
  'family.requestsTitle': 'Kişi istekleri',
  'family.noRequests': 'Şu an onay bekleyen bir istek yok.',
  'family.approve': 'Onayla',
  'family.decline': 'Reddet',
  'family.report': 'Spam diye şikâyet et',
  'family.reportConfirm': '{name} spam olarak şikâyet edilsin mi? İstek reddedilir ve ekibimiz inceler.',
  'family.done.approve': '{name} kişilere eklendi.',
  'family.done.decline': '{name} reddedildi.',
  'family.done.report': '{name} şikâyet edildi ve istek reddedildi.',
  'family.alertsTitle': 'Güvenlik uyarıları',
  'family.alertFrom': '{name} kaygı verici bir mesaj gönderdi',
  'family.alertUnknown': 'Kaygı verici bir mesaj geldi',
  'family.alertsHint': 'Mesajın kendisi sana gösterilmez. Çocuğunla sakin bir şekilde konuş; gerekirse kişiyi listeden çıkarabilir ya da şikâyet edebilirsin.',
  'family.kind.photos': 'fotoğraf ya da kamera isteği',
  'family.kind.secret': 'sır saklama isteği',
  'family.kind.meet': 'buluşma isteği',
  'family.kind.elsewhere': 'başka uygulamaya çekme',
  'family.kind.personal': 'adres ya da okul sorma',
  'family.kind.gifts': 'hediye ya da para teklifi',
  'family.contactsTitle': { one: 'Kişileri (1)', other: 'Kişileri ({count})' },
  'family.remove': '{name} kişilerden çıkar',
  'family.removeConfirm': '{name} çocuğunun kişilerinden çıkarılsın mı? Artık birbirlerine yazamazlar.',
  'family.addLabel': 'Kişi ekle',
  'family.addPlaceholder': 'Kullanıcı adı (ör. @ayse)',
  'family.add': 'Ekle',
  'family.added': 'Kişi eklendi.',
  'family.recentTitle': 'Son kararlar',
  'family.status.pending': 'Bekliyor',
  'family.status.approved': 'Onaylandı',
  'family.status.declined': 'Reddedildi',
  'family.status.reported': 'Şikâyet edildi',
  'family.status.expired': 'Süresi doldu',
  'family.unlink': 'Veli bağlantımı kaldır',
  'family.unlinkConfirm': '{name} ile veli bağlantın kaldırılsın mı? Başka velisi yoksa kişilerini artık sen yönetmezsin.',
  'family.linkTitle': 'Aile Merkezi’ne bağlan',
  'family.linkText': '{name} (@{username}, {age} yaşında) seni velisi olarak Aile Merkezi’ne davet ediyor.',
  'family.linkButton': '{name} için veli olarak bağlan',
  'family.linkInvalid': 'Bu bağlantı geçersiz ya da süresi dolmuş. Çocuğundan yeni bir davet göndermesini isteyebilirsin.',
  'family.linkAdultOnly': 'Veli olarak bağlanmak için e-postası doğrulanmış bir yetişkin hesabıyla giriş yapmalısın.',
  'family.open': 'Aile Merkezi’ni aç',
  'family.afterConsentTitle': 'Aile Merkezi ile bir adım daha',
  'family.afterConsentText': 'Kendi DijitalApp hesabınla bağlanırsan {child} adlı çocuğunun kimlerle konuşabileceğine sen karar verirsin. Mesajlarını göremezsin.',
  'family.afterConsentButton': 'Hesabımla bağlan',
  'family.sentForApproval': 'Velinin onayına gönderildi. Onaylayınca kişilerine eklenecek.',
  'familyAdmin.title': 'Aile Merkezi',
  'familyAdmin.on': 'Açık',
  'familyAdmin.off': 'Kapalı',
  'familyAdmin.hint': 'Veliler kendi hesaplarıyla çocuklarına bağlanır; çocuğun kişilerini onlar onaylar ve yalnızca kişiler yazabilir. Rapor yalnızca sayılardır; kimsenin mesajı görünmez.',
  'familyAdmin.enabled': 'Aile Merkezi açık (kapatılırsa veliye bağlı çocuklar için de eski çocuk kuralları geçerli olur)',
  'familyAdmin.safetyAlerts': 'Güvenlik kartı çıkınca veliye haber ver (kim ve ne tür; mesaj metni asla)',
  'familyAdmin.requestDays': 'Cevaplanmayan istekler şu süre sonra kapansın:',
  'familyAdmin.offConfirm': 'Aile Merkezi kapatılırsa veliler çocuklarının kişilerini yönetemez. Emin misin?',
  'familyAdmin.stat.children': 'veliye bağlı çocuk',
  'familyAdmin.stat.guardians': 'veli',
  'familyAdmin.stat.unsupervised': 'velisi bağlanmamış çocuk',
  'familyAdmin.stat.pending': 'bekleyen istek',
  'familyAdmin.stat.approved': 'onay (30 gün)',
  'familyAdmin.stat.declined': 'ret (30 gün)',
  'familyAdmin.stat.reported': 'şikâyet (30 gün)',
  'familyAdmin.stat.alerts': 'güvenlik uyarısı (30 gün)',
  'familyAdmin.kinds': 'Uyarı türleri (30 gün):',
  'safetyNudge.label': 'Güvenlik uyarısı',
  'safetyNudge.title': 'Bir saniye, kendine iyi bak',
  'safetyNudge.kind.photos': 'Bu mesajda senden fotoğraf, video ya da kamera isteniyor. Kimseye kendi fotoğrafını göndermek zorunda değilsin; hele de rahatsız edici bir şey isteniyorsa hiç göndermemelisin.',
  'safetyNudge.kind.secret': 'Bu mesajda bir şeyin sır kalması ya da ailenden saklanması isteniyor. Seni seven insanlar senden ailenden sır saklamanı istemez.',
  'safetyNudge.kind.meet': 'Bu mesajda buluşma ya da yalnız gelme isteniyor. İnternette tanıdığın biriyle, güvendiğin bir yetişkin bilmeden asla buluşma.',
  'safetyNudge.kind.elsewhere': 'Bu mesajda başka bir uygulamaya geçmen ya da numaranı vermen isteniyor. Bu, korumaların olmadığı bir yere taşımanın yolu olabilir.',
  'safetyNudge.kind.personal': 'Bu mesajda adresin, okulun ya da nerede yaşadığın soruluyor. Bunlar sadece gerçek hayatta tanıdığın ve güvendiğin kişilerle paylaşılır.',
  'safetyNudge.kind.gifts': 'Bu mesajda sana hediye, para ya da oyun parası teklif ediliyor. Karşılığında bir şey istenebilir; dikkatli ol.',
  'safetyNudge.notYourFault': 'Sen hiçbir şeyi yanlış yapmadın. Bu seni rahatsız ettiyse güvendiğin bir yetişkine göster.',
  'safetyNudge.helpAdult': 'Annene, babana, öğretmenine ya da güvendiğin başka bir yetişkine bu mesajı göster.',
  'safetyNudge.help183': 'ALO 183 Sosyal Destek Hattı (ücretsiz, 7/24)',
  'safetyNudge.help112': 'Acil bir durumdaysan 112',
  'safetyNudge.report': 'Bildir',
  'safetyNudge.block': 'Engelle',
  'safetyNudge.help': 'Yardım al',
  'safetyNudge.fine': 'Sorun yok',
  'safetyNudge.blocked': '{name} engellendi. Artık sana yazamaz ve seni arayamaz.',
  'terms.updatedTitle': 'Kullanım koşullarımız güncellendi',
  'terms.updatedOn': '{date} tarihinde güncellendi. Devam etmeden önce değişikliklere göz atıp onaylamanı rica ediyoruz.',
  'terms.updatedText': 'Devam etmeden önce değişikliklere göz atıp onaylamanı rica ediyoruz.',
  'terms.whatChanged': 'Neler değişti',
  'terms.accept': 'Okudum, kabul ediyorum',
  'terms.notNow': 'Şimdi değil, çıkış yap',
  'terms.deleteHint': 'Kabul etmek istemezsen giriş yapıp Ayarlar › Hesap bölümünden verilerini indirebilir ya da hesabını silebilirsin.',
  'termsAdmin.title': 'Koşul sürümleri ve yeniden onay',
  'termsAdmin.hint': 'Kullanım Koşulları ya da Gizlilik Bildirimi önemli ölçüde değiştiğinde yeni bir sürüm yayınla: herkes uygulamayı bir sonraki açışında neyin değiştiğini görür ve yeniden onaylar. Onaylar sürümüyle birlikte saklanır.',
  'termsAdmin.current': 'Geçerli sürüm',
  'termsAdmin.acceptedOf': '{accepted} / {users} kişi onayladı',
  'termsAdmin.summaryTr': 'Neler değişti (Türkçe)',
  'termsAdmin.summaryEn': 'Neler değişti (İngilizce, isteğe bağlı)',
  'termsAdmin.summaryPlaceholder': 'Örneğin: Saklama süreleri bölümü eklendi; çocuk hesaplarında veli onayı kuralları netleştirildi.',
  'termsAdmin.publish': 'Yeni sürümü yayınla',
  'termsAdmin.confirm': 'Yeni sürüm yayınlanınca herkesten yeniden onay istenecek. Sayfa metinlerini önce kaydettiğinden emin misin?',
  'termsAdmin.published': '{version} sürümü yayınlandı.',
  'termsAdmin.acceptedCount': { one: '1 kişi onayladı', other: '{count} kişi onayladı' },
  'retention.title': 'Saklama süreleri',
  'retention.hint': 'Bu kayıtlar süresi dolunca kendiliğinden silinir (her 6 saatte bir). Mesajlar, dosyalar ve hesaplar kendi kurallarıyla silinir. Süreler Gizlilik Bildirimi’ndekilerle aynı olmalı; değiştirmek için en üst yetki gerekir.',
  'retention.cat.sessions': 'Kapanmış oturumlar',
  'retention.cat.securityEvents': 'Güvenlik kayıtları',
  'retention.cat.auditLogs': 'Yönetim işlem kayıtları',
  'retention.cat.onlineHistory': 'Çevrimiçi olma geçmişi',
  'retention.cat.emailCodes': 'Kullanılmış e-posta kodları',
  'retention.cat.resolvedReports': 'Sonuçlanmış şikâyetler',
  'retention.cat.siteLeads': 'İşlenmiş site formları',
  'retention.cat.adEvents': 'Reklam gösterim kayıtları',
  'retention.cat.autoReplyLog': 'Otomatik yanıt kayıtları',
  'retention.cat.announcementViews': 'Duyuru görülme kayıtları',
  'retention.cat.deliveredEvents': 'İletilmiş sistem olayları',
  'retention.why.sessions': 'Çıkış yapılmış ya da süresi dolmuş girişler; cihaz listesinde görünmez.',
  'retention.why.securityEvents': 'Giriş, şifre ve cihaz olayları. 5651 sayılı Kanun’daki trafik kaydı süresi göz önünde tutulur (en az 1 yıl).',
  'retention.why.auditLogs': 'Panelde yapılan işlemler. Değiştirilemez; yalnızca bu temizlik 1 yıldan eskileri silebilir.',
  'retention.why.onlineHistory': 'Ne zaman çevrimiçi olunduğu; istatistikler için.',
  'retention.why.emailCodes': 'Doğrulama ve şifre sıfırlama kodları, kullanıldıktan ya da süresi dolduktan sonra.',
  'retention.why.resolvedReports': 'Kapatılmış şikâyetler ve kanıtları; açık olanlar silinmez.',
  'retention.why.siteLeads': 'dijitalapp.com formlarından gelen, işlenmiş ya da spam işaretlenmiş mesajlar.',
  'retention.why.adEvents': 'Reklam gösterim ve tıklama kayıtları.',
  'retention.why.autoReplyLog': 'İşletme otomatik yanıtlarının kime ne zaman gittiği.',
  'retention.why.announcementViews': 'Duyuruların kimlerce görüldüğü.',
  'retention.why.deliveredEvents': 'Teslim edilmiş iç olaylar.',
  'retention.lastRun': 'Son temizlik {when}: {count} kayıt silindi',
  'retention.notRun': 'Henüz temizlik yapılmadı',
  'retention.daysFor': '{name} için gün',
  'retention.range': '{min}–{max} gün',
  'retention.runNow': 'Şimdi temizle',
  'retention.ran': { one: 'Temizlik bitti: 1 kayıt silindi.', other: 'Temizlik bitti: {count} kayıt silindi.' },
  'retention.saved': 'Saklama süreleri kaydedildi.',
  'retention.publicTitle': 'Verilerin ne kadar saklanır',
  'retention.publicHint': 'Aşağıdaki kayıtlar bu sürelerin sonunda kendiliğinden silinir. Mesajların ve dosyaların sen ya da sohbet silinene kadar durur; hesabını silersen 30 gün sonra kalıcı olarak silinir.',
  'retention.days': { one: '1 gün', other: '{count} gün' },
  'group.skippedTitle': 'Bazı kişiler eklenemedi',
  'group.skippedHint': 'Gizlilik ayarları buna izin vermiyor. Onlara kişiye özel bir davet bağlantısı gönder; katılıp katılmamak onların kararı olsun.',
  'group.sendInvite': 'Davet gönder',
  'group.sendInviteAll': { one: 'Davet gönder', other: 'Hepsine davet gönder ({count})' },
  'group.inviteSending': 'Gönderiliyor…',
  'group.inviteSent': 'Davet gönderildi',
  'group.inviteNotPossible': 'Bu kişiye davet gönderilemiyor.',
  'group.copyInvite': 'Bağlantıyı kopyala',
  'group.inviteMessage': '"{group}" grubuna seni davet ediyorum. Katılmak için dokun: {link}\n(Bu bağlantı yalnızca senin için; 3 gün geçerli.)',
  'group.made': '"{title}" hazır',
  'group.goTo': 'Gruba git',
  'help.title': 'Yardım merkezi',
  'help.intro': '{brand} hakkında aklına takılanların cevapları burada.',
  'help.search': 'Soru ara: parola, bildirim, grup…',
  'help.topics': 'Konular',
  'help.all': 'Tümü',
  'help.questions': 'Sık sorulan sorular',
  'help.none': 'Bu aramaya uyan soru bulunamadı. Aşağıdan bize yazabilirsin.',
  'help.stillNeed': 'Hâlâ yardıma mı ihtiyacın var?',
  'help.reportProblem': 'Sorun bildir',
  'help.reportProblemHint': 'Bir şey çalışmıyorsa anlat, ekip incelesin.',
  'help.sendIdea': 'Öneri gönder',
  'help.sendIdeaHint': 'Fikrini paylaş, birlikte geliştirelim.',
  'help.email': 'E-posta ile yaz',
  'help.phone': 'Bizi ara',
  'help.terms': 'Kullanım koşulları',
  'help.privacy': 'Gizlilik politikası',
  'help.myFeedback': 'Gönderdiklerim',
  'help.cat.start': 'Başlarken',
  'help.cat.account': 'Hesap',
  'help.cat.privacy': 'Gizlilik ve güvenlik',
  'help.cat.messages': 'Mesajlar',
  'help.cat.calls': 'Aramalar',
  'help.cat.groups': 'Gruplar ve kanallar',
  'help.cat.notifications': 'Bildirimler',
  'help.cat.market': 'Market',
  'help.cat.plans': 'Planlar',
  'admin.tab.help': 'Yardım merkezi',
  'helpAdmin.contact': 'Bize ulaşın bilgileri',
  'helpAdmin.contactHint': 'Yardım merkezinin altında gösterilir. Boş bırakılan bilgi görünmez.',
  'helpAdmin.hoursTr': 'Çalışma saatleri (Türkçe)',
  'helpAdmin.hoursEn': 'Çalışma saatleri (İngilizce)',
  'helpAdmin.address': 'Adres',
  'helpAdmin.faqs': { one: 'Sık sorulan sorular ({count})', other: 'Sık sorulan sorular ({count})' },
  'helpAdmin.up': 'Yukarı taşı',
  'helpAdmin.down': 'Aşağı taşı',
  'helpAdmin.published': 'Yayında',
  'helpAdmin.edit': 'Düzenle',
  'helpAdmin.delete': 'Sil',
  'helpAdmin.deleteConfirm': 'Bu soru silinsin mi?',
  'helpAdmin.add': 'Yeni soru',
  'helpAdmin.editing': 'Soruyu düzenle',
  'helpAdmin.category': 'Konu',
  'helpAdmin.qTr': 'Soru',
  'helpAdmin.aTr': 'Cevap',
  'helpAdmin.qEn': 'Soru (İngilizce)',
  'helpAdmin.aEn': 'Cevap (İngilizce)',
  'helpAdmin.addButton': 'Soruyu ekle',
  'helpAdmin.saved': 'Yardım merkezi kaydedildi.',
  'settings.section.link': 'Bağlantım',
  'settings.section.link.desc': 'Profil bağlantın, QR kodun ve web siten için sohbet düğmesi',
  'settings.section.help': 'Yardım',
  'settings.section.help.desc': 'Sık sorulan sorular, bize ulaşın, geri bildirim',
  'linkShare.title': 'Mesajlaşma bağlantın',
  'linkShare.intro': 'Bu bağlantıya tıklayan herkes seninle hemen sohbet başlatabilir. Kartvizitine, e-posta imzana, sosyal medyana ekle.',
  'linkShare.for': 'Kimin bağlantısı',
  'linkShare.me': 'Ben',
  'linkShare.message': 'Hazır mesaj (isteğe bağlı)',
  'linkShare.messageExample': 'Merhaba, bilgi almak istiyorum.',
  'linkShare.share': 'Bağlantıyı paylaş',
  'linkShare.qr': 'QR kod',
  'linkShare.qrHint': 'Telefon kamerasıyla okutulunca sohbet açılır. Vitrine, menüye, broşüre koyabilirsin.',
  'linkShare.qrDownload': 'QR kodu indir (PNG)',
  'linkShare.buttonTitle': 'Web siten için sohbet düğmesi',
  'linkShare.buttonIntro': 'Ziyaretçilerin tek tıkla sana yazsın. Düğmeyi tasarla, kodu kopyala, sitene yapıştır.',
  'linkShare.label': 'Düğme metni',
  'linkShare.defaultLabel': 'Bize yazın',
  'linkShare.color': 'Renk',
  'linkShare.custom': 'Özel renk',
  'linkShare.shape': 'Şekil',
  'linkShare.shape.pill': 'Yazılı düğme',
  'linkShare.shape.round': 'Yuvarlak simge',
  'linkShare.place': 'Yer',
  'linkShare.place.inline': 'Sayfanın içinde',
  'linkShare.place.float': 'Sağ altta sabit',
  'linkShare.preview': 'Önizleme',
  'linkShare.code': 'Sitene eklenecek kod',
  'linkShare.copyCode': 'Kodu kopyala',
  'linkShare.codeHint': 'Kodu sitenin HTML\'inde düğmenin görünmesini istediğin yere (sabit düğme için </body> etiketinden hemen önce) yapıştır. Ek dosya ya da komut dosyası gerekmez.',
  'handle.title': 'Kısa bağlantı',
  'handle.titleChannel': 'Kanal bağlantısı',
  'handle.hint': 'Grubun herkese açık adı. Bağlantıya sahip herkes grubu görür ve katılabilir.',
  'handle.hintChannel': 'Kanalın herkese açık adı. Bağlantıya sahip herkes kanalı takip edebilir; kanal herkese açık olur.',
  'handle.label': 'Kısa ad',
  'handle.placeholder': 'grupadi',
  'handle.set': 'Bağlantıyı oluştur',
  'handle.change': 'Değiştir',
  'handle.remove': 'Kaldır',
  'handle.copy': 'Bağlantıyı kopyala',
  'handle.share': 'Paylaş',
  'handle.copied': 'Bağlantı kopyalandı.',
  'handle.saved': 'Kısa bağlantı kaydedildi.',
  'handle.removed': 'Kısa bağlantı kaldırıldı.',
  'handle.rule': '4–32 karakter: küçük harf, rakam, "_" ve "."; harf ya da rakamla başlayıp biter.',
  'linkPage.missing': 'Bu bağlantı bir hesaba, gruba ya da kanala ait değil ya da sahibi profilini gizlemiş.',
  'linkPage.home': 'Ana sayfaya git',
  'linkPage.kind.user': 'Kişi',
  'linkPage.kind.group': 'Grup',
  'linkPage.kind.channel': 'Kanal',
  'linkPage.members': { one: '{count} üye', other: '{count} üye' },
  'linkPage.subscribers': { one: '{count} takipçi', other: '{count} takipçi' },
  'linkPage.draft': 'Gönderilecek mesaj',
  'linkPage.signedOut': 'Mesajlaşmak için {brand} hesabınla giriş yap.',
  'linkPage.signIn': 'Giriş yap ve devam et',
  'linkPage.register': '{brand} hesabı oluştur',
  'linkPage.mine': 'Bu senin bağlantın: paylaş',
  'linkPage.message': 'Mesaj gönder',
  'linkPage.openGroup': 'Gruba git',
  'linkPage.openChannel': 'Kanala git',
  'linkPage.join': 'Gruba katıl',
  'linkPage.subscribe': 'Kanalı takip et',
  'linkPage.foot': '{brand} ile güvenli ve ücretsiz mesajlaşma.',
  'slash.b.task': 'Görev oluştur: /gorev ve yapılacak iş',
  'slash.b.contact': 'Kişi kartı paylaş',
  'slash.b.search': 'Sohbette ara',
  'slash.b.mute': 'Sohbeti sessize al ya da aç',
  'slash.b.date': 'Bugünün tarihini yaz',
  'slash.b.link': 'Profil bağlantını paylaş',
  'slash.muted': 'Sohbet 8 saatliğine sessize alındı.',
  'slash.unmuted': 'Sohbetin sesi açıldı.',
  'promo.short': 'Tanıt',
  'promo.title': '{name} uygulamasını tanıt',
  'promo.kind': 'Duyuru türü',
  'promo.kindIntro': 'Uygulamayı tanıt',
  'promo.kindNews': 'v{version} yeniliklerini duyur',
  'promo.kindNewsNone': 'Henüz sürüm notu yok',
  'promo.introTitle': 'Yeni: {name}',
  'promo.newsTitle': '{name} güncellendi: v{version}',
  'promo.cta': 'Uygulamayı gör',
  'promo.ctaNews': 'Yenilikleri gör',
  'promo.titleTr': 'Başlık',
  'promo.bodyTr': 'Metin',
  'promo.english': 'İngilizce metin (isteğe bağlı)',
  'promo.titleEn': 'Başlık (İngilizce)',
  'promo.bodyEn': 'Metin (İngilizce)',
  'promo.button': 'Düğme',
  'promo.days': 'Ne kadar sürsün',
  'promo.forDays': { one: '{count} gün', other: '{count} gün' },
  'promo.pin': 'Sohbetlerin üstünde de göster',
  'promo.send': 'Şimdi yayınla',
  'promo.hint': 'Hemen herkese gösterilir: Keşfet\'te ilk durum ve (seçtiysen) sohbet listesinin üstünde kart. Görenler ve 7 gün içinde uygulamayı ekleyenler bu tanıtıma sayılır.',
  'promo.done': '{name} tanıtımı yayında.',
  'promo.history': 'Uygulama tanıtımları',
  'promo.historyHint': 'Her tanıtımın kaç kişiye ulaştığı, kaç kişinin düğmeye bastığı ve uygulamayı eklediği. Satıra dokununca kişiler isim isim görünür.',
  'promo.count': 'Tanıtım',
  'promo.viewers': 'Gören',
  'promo.clickers': 'Tıklayan',
  'promo.installs': 'Ekleyen',
  'promo.none': 'Henüz tanıtım yapılmadı. Bir uygulamanın yanındaki "Tanıt" ile başla.',
  'promo.live': 'Yayında',
  'promo.ended': 'Bitti',
  'promo.stop': 'Durdur',
  'announceAdmin.kpiInstalls': 'Uygulamayı ekleyen',
  'announceAdmin.filter.installed': 'Ekleyenler',
  'announceAdmin.tagInstalled': 'Ekledi',
  'slashAdmin.title': 'Sohbet kısayolları ( / )',
  'slashAdmin.hint': 'Yazma kutusuna "/" yazınca açılan menü. Yerleşik komutları açıp kapat, herkesin kullanabileceği hazır metin kısayolları ekle (örneğin /adres, /iban, /mesai).',
  'slashAdmin.enabled': 'Kısayol menüsü açık',
  'slashAdmin.builtins': 'Yerleşik komutlar',
  'slashAdmin.custom': 'Hazır metin kısayolları',
  'slashAdmin.none': 'Henüz hazır kısayol yok.',
  'slashAdmin.on': '/{command} açık',
  'slashAdmin.edit': '/{command} düzenle',
  'slashAdmin.delete': '/{command} sil',
  'slashAdmin.deleteConfirm': '/{command} silinsin mi?',
  'slashAdmin.add': 'Yeni kısayol',
  'slashAdmin.editing': '/{command} düzenleniyor',
  'slashAdmin.command': 'Komut',
  'slashAdmin.descriptionTr': 'Açıklama (Türkçe)',
  'slashAdmin.descriptionEn': 'Açıklama (İngilizce)',
  'slashAdmin.descriptionExample': 'Şirket adresimiz',
  'slashAdmin.text': 'Yazılacak metin',
  'slashAdmin.textExample': 'Adresimiz: … Haritada: https://…',
  'slashAdmin.addButton': 'Kısayolu ekle',
  'slashAdmin.saved': 'Kısayollar kaydedildi; herkeste hemen geçerli.',
  'slash.title': 'Kısayollar',
  'slash.mine': 'Benim',
  'slash.panel': 'Hazır',
  'slash.b.poll': 'Anket oluştur',
  'slash.b.event': 'Etkinlik oluştur',
  'slash.b.location': 'Konumunu paylaş',
  'slash.b.template': 'Şablon ekle',
  'slash.b.ai': 'Yazım asistanı',
  'slash.b.code': 'Kod bloğu ekle',
  'code.label': 'Kod',
  'code.copy': 'Kopyala',
  'code.copied': 'Kopyalandı',
  'pick.menu': 'Seç',
  'pick.one': '{time} mesajını seç',
  'pick.count': { one: '{count} mesaj seçildi', other: '{count} mesaj seçildi' },
  'pick.cancel': 'Seçimi bırak',
  'pick.star': 'Yıldızla',
  'pick.copy': 'Kopyala',
  'pick.delete': 'Benden sil',
  'pick.deleteConfirm': { one: '{count} mesaj senden silinsin mi?', other: '{count} mesaj senden silinsin mi?' },
  'pick.deleted': { one: '{count} mesaj silindi.', other: '{count} mesaj silindi.' },
  'pick.copied': { one: '{count} mesaj kopyalandı.', other: '{count} mesaj kopyalandı.' },
  'pick.starred': { one: '{count} mesaj yıldızlandı.', other: '{count} mesaj yıldızlandı.' },
  'pick.unstarred': { one: '{count} mesajın yıldızı kaldırıldı.', other: '{count} mesajın yıldızı kaldırıldı.' },
  'forward.titleMany': '{count} mesajı ilet',
  'forward.search': 'Sohbet ya da kişi ara',
  'forward.remove': '{name} seçimini kaldır',
  'forward.none': 'Sohbet bulunamadı.',
  'forward.group': 'Grup',
  'forward.channel': 'Kanal',
  'forward.note': 'Not ekle (isteğe bağlı)',
  'forward.doneMany': { one: '{messages} mesaj 1 sohbete iletildi.', other: '{messages} mesaj {count} sohbete iletildi.' },
  'forward.partial': { one: '1 sohbete iletilemedi.', other: '{count} sohbete iletilemedi.' },
  'forward.retry': { one: 'Tekrar dene (1 sohbet)', other: 'Tekrar dene ({count} sohbet)' },
  'forward.sending': 'Gönderiliyor…',
  'forward.progress': 'Gönderiliyor… %{percent}',
  'forward.sent': 'Gönderildi',
  'forward.queued': 'Bağlantı gelince gönderilecek',
  'forward.unknownChat': 'Sohbet',
  'forward.why.forbidden': 'Bu sohbete bunu gönderemezsin',
  'forward.why.notAllowed': 'Bu kişiye şu an mesaj gönderemezsin',
  'forward.why.request': 'Mesaj isteğin henüz kabul edilmedi',
  'forward.why.tooLarge': 'Gönderilemeyecek kadar uzun',
  'forward.why.storage': 'Depolama alanın dolu',
  'forward.why.file': 'Bu dosya gönderilemiyor',
  'forward.why.slow': 'Çok hızlı oldu; biraz bekleyip tekrar dene',
  'forward.why.offline': 'Bağlantı yok',
  'forward.why.keys': 'Bu sohbetin şifrelemesi henüz hazır değil',
  'forward.why.unverified': 'Önce bu cihazı doğrula (Ayarlar › Güvenlik)',
  'forward.why.identity': 'Birinin güvenlik kodu değişti; sohbete bak',
  'forward.why.unreadable': 'Bu cihaz asıl mesajı okuyamıyor',
  'forward.why.notForwardable': 'Bu tür bir mesaj iletilemez',
  'forward.why.feature': 'Bu özellik şu an kapalı',
  'forward.why.gone': 'Artık erişilemiyor',
  'forward.why.locked': 'Bu sohbet kilitli',
  'forward.why.unknown': 'Bir sorun oldu; tekrar dene',
  'forward.send': { one: '1 sohbete ilet', other: '{count} sohbete ilet' },
  'forward.done': { one: '1 sohbete iletildi.', other: '{count} sohbete iletildi.' },
  'religiousAdmin.zakat': 'Zekât, fitre ve fidye',
  'religiousAdmin.zakatHint': 'Diyanet\'in her yıl açıkladığı tutarlar Zekât uygulamasında gösterilir. Boş bırakılan tutar "henüz açıklanmadı" sayılır; kullanıcı kendi tutarını yazabilir.',
  'religiousAdmin.zakatYear': 'Yıl',
  'religiousAdmin.zakatNisab': 'Nisap (gram altın)',
  'religiousAdmin.zakatFitre': 'Fitre, kişi başı (TL)',
  'religiousAdmin.zakatFidye': 'Fidye, günlük (TL)',
  'religiousAdmin.zakatGold': 'Gram altın fiyatı (TL)',
  'taskFrom.menu': 'Göreve çevir',
  'taskFrom.title': 'Göreve çevir',
  'taskFrom.what': 'Yapılacak iş',
  'taskFrom.whose': 'Kimin görevi',
  'taskFrom.mine': 'Kendime',
  'taskFrom.group': '{name} grubuna',
  'taskFrom.assignee': 'Kim yapacak',
  'taskFrom.nobody': 'Atanmasın',
  'taskFrom.pick': 'Tarih seç',
  'taskFrom.save': 'Görevi oluştur',
  'taskFrom.notes': 'Sohbetten: {chat}',
  'taskFrom.done': 'Görev oluşturuldu; Görevler\'de ve Planlayıcı\'da.',
  'taskFrom.doneGroup': 'Görev grubun görev listesine eklendi.',
  'member.open': '{name} profilini aç',
  'member.copy': 'Kullanıcı adını kopyala',
  'member.copied': 'Kullanıcı adı kopyalandı.',
  'member.inContacts': 'Kişilerinde',
  'member.noAbout': 'Hakkında bilgisi yok ya da yalnızca kişilerine açık.',
  'member.card': 'Kişi bilgisi',
  'group.addMembers': 'Üye ekle',
  'group.add': 'Ekle',
  'group.leave': 'Gruptan ayrıl',
  'group.leaveConfirm': 'Bu gruptan ayrılmak istiyor musun?',
  'group.delete': 'Grubu sil',
  'group.deleteChannel': 'Kanalı sil',
  'group.deleteConfirm': 'Grup herkes için silinsin mi? Üyeler gruptan çıkarılır ve sohbet listelerinden kaldırılır.',
  'group.deleteChannelConfirm': 'Kanal herkes için silinsin mi? Takipçiler kanaldan çıkarılır ve sohbet listelerinden kaldırılır.',
  'group.deleteStaffHint': 'Platform yetkilisi olarak siliyorsun; işlem denetim kaydına yazılır.',
  'error.SPACE_LINK_INVALID': 'Bu davet bağlantısı geçersiz ya da süresi dolmuş.',
  'error.GROUP_LINK_INVALID': 'Bu grup bağlantısı geçersiz, iptal edilmiş ya da süresi dolmuş.',
  'error.GROUP_FULL': 'Grup üye sınırına ulaştı.',
  'group.inviteLink': 'Davet bağlantısı',
  'group.linkHint': 'Bağlantıya sahip herkes gruba katılabilir veya katılma isteği gönderebilir. Yalnız güvendiğin kişilerle paylaş.',
  'group.noLink': 'Etkin bağlantı yok.',
  'group.createLink': 'Bağlantı oluştur',
  'group.resetLink': 'Yeni bağlantı oluştur (eskisi geçersiz olur)',
  'group.revokeLink': 'Bağlantıyı iptal et',
  'group.requireApproval': 'Katılmak için yönetici onayı gereksin',
  'group.linkExpiry': 'Geçerlilik',
  'group.expiry.never': 'İptal edilene kadar',
  'group.expiry.24': '1 gün',
  'group.expiry.168': '1 hafta',
  'group.expiry.720': '30 gün',
  'group.linkActive': 'Etkin bağlantı: {date} tarihinde oluşturuldu · {uses} kullanım',
  'group.linkExpires': 'Bitiş: {date}',
  'group.linkOnce': 'Bağlantı yalnız şimdi gösterilir; güvenlik için saklanmaz. Kaybedersen yenisini oluştur.',
  'group.copyLink': 'Kopyala',
  'group.linkCopied': 'Kopyalandı',
  'group.joinRequests': 'Katılma istekleri',
  'group.noRequests': 'Bekleyen istek yok.',
  'group.approve': 'Onayla',
  'group.reject': 'Reddet',
  'group.previouslyRemoved': 'daha önce çıkarıldı',
  'group.pendingBadge': '{count} istek',
  'join.title': 'Gruba katıl',
  'join.join': 'Katıl',
  'join.request': 'Katılma isteği gönder',
  'join.requested': 'İsteğin gönderildi. Bir yönetici onayladığında grup sohbetlerinde görünecek.',
  'join.approvalNote': 'Bu gruba katılmak için yönetici onayı gerekiyor.',
  'join.open': 'Sohbeti aç',
  'join.missingToken': 'Bağlantıda davet bilgisi yok.',
  'join.privacyNote': 'Katıldığında grup üyeleri adını ve kullanıcı adını görebilir.',
  'privacy.groupAdd': 'Beni gruplara kim ekleyebilir',
  'chat.online': 'çevrimiçi',
  'chat.lastSeen': 'son görülme: {date}',
  'chat.edit': 'Düzenle',
  'chat.edited': 'düzenlendi',
  'chat.editing': 'Mesajı düzenliyorsun',
  'chat.save': 'Kaydet',
  'chat.deleteForMe': 'Benden sil',
  'chat.delete': 'Sil',
  'chat.deleteTitle': 'Mesaj silinsin mi?',
  'chat.deleteBodyEveryone': 'Herkesten silersen mesaj sohbetteki herkes için kaldırılır; yerinde "Bu mesaj silindi" yazar.',
  'chat.deleteBodyMe': 'Mesaj yalnızca senin cihazlarından kaldırılır; diğerleri görmeye devam eder.',
  'chat.deleteForEveryone': 'Herkesten sil',
  'chat.deleted': 'Bu mesaj silindi',
  'chat.messageActions': 'Mesaj seçenekleri',
  'auth.inviteCode': 'Davet kodu',
  'auth.inviteHint': 'DijitalApp şu an davetle açılan kapalı beta aşamasında.',
  'auth.registrationClosed': 'Yeni kayıtlar şu an kapalı. Hesabın varsa giriş yapabilirsin.',
  'error.NETWORK': 'Sunucuya ulaşılamıyor. Bağlantını kontrol et.',
  'error.UNKNOWN': 'Beklenmeyen bir sorun oluştu. Tekrar dene.',
  'channel.title': 'Kanallar',
  'story.title': 'Durum',
  'story.mine': 'Durumum',
  'story.add': 'Durum ekle',
  'story.watchMine': 'Durumumu izle',
  'story.watch': '{name} kişisinin durumunu izle',
  'story.of': '{name} durumu',
  'story.noneYet': 'Kişilerinden yeni durum yok. 24 saat görünen ilk durumunu sen paylaş.',
  'story.justNow': 'şimdi',
  'story.minutesAgo': { one: '{count} dk önce', other: '{count} dk önce' },
  'story.hoursAgo': { one: '{count} sa önce', other: '{count} sa önce' },
  'story.play': 'Oynat',
  'story.pause': 'Duraklat',
  'story.more': 'Diğer seçenekler',
  'story.photo': 'Durum fotoğrafı',
  'story.viewers': 'Görüntüleyenler',
  'story.noViewers': 'Henüz kimse görmedi.',
  'story.viewCount': { one: '{count} görüntüleme', other: '{count} görüntüleme' },
  'story.delete': 'Durumu sil',
  'story.deleteConfirm': 'Bu durum herkes için silinsin mi?',
  'story.openChat': 'Sohbete git',
  'story.report': 'Durumu şikâyet et',
  'story.reportNote': 'Şikâyet edilen durum, inceleme bitene kadar moderatörler için saklanır. Paylaşan kişiye kimin şikâyet ettiği söylenmez.',
  'story.reply': '{name} kişisine yanıt yaz…',
  'story.replyPrefix': '↩️ Durumuna yanıt: “{quote}”',
  'story.replyQuotePhoto': '📷 Fotoğraf',
  'story.replySent': 'Yanıtın sohbetinize gönderildi.',
  'story.new': 'Yeni durum',
  'story.kind': 'Durum türü',
  'story.kindText': 'Yazı',
  'story.kindPhoto': 'Fotoğraf / video',
  'story.textLabel': 'Durum metni',
  'story.textPlaceholder': 'Bir şeyler yaz…',
  'story.background': 'Arka plan',
  'story.bg.ocean': 'Okyanus',
  'story.bg.sunset': 'Gün batımı',
  'story.bg.forest': 'Orman',
  'story.bg.berry': 'Böğürtlen',
  'story.bg.night': 'Gece',
  'story.bg.sand': 'Kum',
  'story.bg.coral': 'Mercan',
  'story.bg.slate': 'Arduvaz',
  'story.changePhoto': 'Fotoğrafı değiştir',
  'story.caption': 'Açıklama (isteğe bağlı)',
  'story.expiresNote': '24 saat sonra kendiliğinden silinir.',
  'story.photoOnly': 'Lütfen bir fotoğraf seç.',
  'story.photoTooLarge': 'Fotoğraf en fazla 15 MB olabilir.',
  'story.audience': 'Kimler görebilir?',
  'story.audience.contacts': 'Kişilerim',
  'story.audience.contacts.hint': 'birbirinizi eklediğiniz herkes',
  'story.audience.except': 'Kişilerim, şunlar hariç…',
  'story.audience.except.hint': 'seçtiklerin göremez',
  'story.audience.only': 'Yalnızca şunlar…',
  'story.audience.only.hint': 'sadece seçtiklerin görür',
  'story.searchContacts': 'Kişilerde ara',
  'story.noContacts': 'Henüz kişin yok.',
  'story.exceptCount': { one: '{count} kişi göremeyecek', other: '{count} kişi göremeyecek' },
  'story.onlyCount': { one: '{count} kişi görecek', other: '{count} kişi görecek' },
  'story.pickSomeone': 'En az bir kişi seç.',
  'story.mutualNote': 'Durumunu yalnızca birbirinizi kişi olarak eklediğiniz kişiler görür; engellediklerin asla göremez.',
  'story.posting': 'Paylaşılıyor…',
  'story.share': 'Paylaş',
  'wall.page': 'Duvar',
  'wall.intro': 'Kişilerinin durumları ve takip ettiğin kanalların son paylaşımları.',
  'wall.statusTitle': 'Durum güncellemeleri',
  'wall.statusEmpty': 'Şu an görünen bir durum yok. Bir fotoğraf ya da yazı paylaş; 24 saat kişilerine görünür.',
  'wall.new': 'Yeni',
  'wall.title': 'Kanallardan son paylaşımlar',
  'wall.emptyTitle': 'Duvarın henüz boş',
  'wall.empty': 'Kanalları takip ettikçe son paylaşımlar burada akış olarak görünür.',
  'wall.openChannel': 'Kanala git',
  'wall.openPost': '{channel} kanalındaki paylaşımı aç',
  'whatsNew.title': 'Yenilikler',
  'whatsNew.intro': 'DijitalApp’e gelen yenilikler, iyileştirmeler ve düzeltmeler. En yeni sürüm en üstte.',
  'whatsNew.empty': 'Henüz yayımlanmış bir sürüm notu yok.',
  'whatsNew.latest': 'En yeni',
  'whatsNew.versionAria': 'Sürüm {version}, {date}',
  'whatsNew.soon': 'Yenilikler çok yakında burada',
  'whatsNew.soonBody': 'DijitalApp’e gelen yenilikleri yakında bu sayfadan takip edebileceksin.',
  'wall.more': 'Daha eski paylaşımlar',
  'wall.off': 'Bu bölüm şu an kapalı.',
  'wall.followed': 'Takip ettiğin kanallar',
  'wall.seeAll': { one: 'Tümü ({count})', other: 'Tümü ({count})' },
  'wall.findChannels': 'Kanal bul',
  'wall.browseAll': 'Tümüne göz at',
  'wall.follow': 'Takip et',
  'wall.followNamed': '{name} kanalını takip et',
  'channel.intro': 'Kanallar birden çoğa yayındır: yalnız yöneticiler yazar, takipçiler okur ve birbirini göremez.',
  'channel.mine': 'Kanallarım',
  'channel.none': 'Henüz bir kanalı takip etmiyorsun.',
  'channel.directory': 'Herkese açık kanallar',
  'channel.search': 'Kanal ara',
  'channel.noResults': 'Kanal bulunamadı.',
  'channel.subscribe': 'Takip et',
  'channel.subscribers': { one: '{count} takipçi', other: '{count} takipçi' },
  'channel.privacyNote': 'Takip ettiğinde kanal yöneticileri seni takipçi listesinde görebilir; diğer takipçiler göremez.',
  'channel.adultsOnly': 'Herkese açık kanal dizini yalnız yetişkin hesaplar için. Özel kanallara davet bağlantısıyla katılabilirsin.',
  'channel.create': 'Kanal oluştur',
  'channel.name': 'Kanal adı',
  'channel.public': 'Herkese açık (dizinde görünsün)',
  'channel.publicNote': 'Herkese açık kanallar dizinde listelenir; yetişkin hesaplar bulup takip edebilir.',
  'channel.privateNote': 'Özel kanala yalnız davet bağlantısıyla katılınır (kanal bilgisinden bağlantı oluştur).',
  'channel.subscriberNote': 'Bu bir kanal: yalnız yöneticiler mesaj gönderebilir.',
  'discover.sections': 'Keşfet bölümleri',
  'discover.tab.browse': 'Kanal bul',
  'channel.subscribersShort': { one: '{n} takipçi', other: '{n} takipçi' },
  'channel.featured': 'Öne çıkanlar',
  'channel.results': 'Sonuçlar',
  'channel.allChannels': 'Tüm kanallar',
  'channel.filter': 'Kanalları süz',
  'channel.filter.all': 'Tümü',
  'channel.filter.notJoined': 'Takip etmediklerim',
  'channel.filter.joined': 'Takip ettiklerim',
  'channel.filter.unread': 'Okunmamış',
  'channel.filter.managing': 'Yönettiklerim',
  'channel.filterEmpty': 'Bu süzgece uyan kanal yok.',
  'channel.showAll': 'Tümünü göster',
  'channel.resultCount': { one: '{count} kanal', other: '{count} kanal' },
  'channel.noResultsHint': 'Başka bir kelime dene ya da yazımı kontrol et.',
  'channel.clearSearch': 'Aramayı temizle',
  'channel.loadError': 'Kanallar yüklenemedi. Bağlantını kontrol edip tekrar dene.',
  'channel.subscribed': 'Takip ediliyor',
  'channel.open': 'Aç',
  'channel.openNamed': '{name} kanalını aç',
  'channel.subscribeNamed': '{name} kanalını takip et',
  'channel.mineEmptyTitle': 'Henüz kanalın yok',
  'channel.noPosts': 'Henüz paylaşım yok',
  'channel.mute': 'Sessize al',
  'channel.unmute': 'Sesi aç',
  'channel.createIntro': 'Bir adla başla; fotoğraf, bağlantı ve yöneticileri sonra kanal bilgisinden ekleyebilirsin.',
  'channel.step.info': 'Kanal bilgileri',
  'channel.step.visibility': 'Kimler bulabilir?',
  'channel.preview': 'Önizleme',
  'channel.previewHint': 'Kanalın dizinde ve takipçilerine böyle görünecek.',
  'channel.nameRequired': 'Kanala bir ad ver.',
  'channel.namePlaceholder': 'Örn. Okul duyuruları',
  'channel.descPlaceholder': 'Kanal ne hakkında? Takipçilere kısaca anlat.',
  'channel.optional': 'isteğe bağlı',
  'channel.privateTitle': 'Özel',
  'channel.publicTitle': 'Herkese açık',
  'channel.createAdultsOnly': 'Kanal oluşturmak yalnız yetişkin hesaplar için. Özel kanallara davet bağlantısıyla katılabilirsin.',
  'community.title': 'Topluluk',
  'community.manage': 'Topluluk yönetimi',
  'community.announcements': 'Duyurular',
  'community.announcementsAdmin': 'Tüm üyelere duyuru gönder',
  'community.announcementsMember': 'Yöneticilerin duyuruları',
  'community.groups': 'Gruplar',
  'community.noGroups': 'Henüz grup yok.',
  'community.closed': 'kapalı',
  'community.newGroup': 'Yeni grup adı',
  'community.openGroup': 'Açık grup (topluluk üyeleri kendileri katılabilir)',
  'community.invite': 'Davet bağlantısı',
  'community.inviteNote': 'Bağlantıya sahip yetişkinler topluluğa katılır ve duyuruları takip eder.',
  'community.inviteFamilyNote': 'Bağlantıyı yalnız aile üyelerinle paylaş: aile alanlarına reşit olmayanlar da katılabilir.',
  'community.createLink': 'Yeni bağlantı oluştur (eskisi geçersiz olur)',
  'community.leave': 'Topluluktan ayrıl',
  'community.leaveConfirm': 'Topluluktan ayrılırsan duyuru kanalından ve topluluk gruplarından da çıkarsın. Devam edilsin mi?',
  'community.joinTitle': 'Topluluğa katıl',
  'community.open': 'Topluluğu aç',
  'community.joinPrivacyNote': 'Katıldığında topluluk yöneticileri adını görebilir; grupların üyeleri sen katıldığında görür.',
  'nav.calendar': 'Takvim',
  'planner.title': 'Takvim ve görevler',
  'planner.calendar': 'Takvim',
  'planner.tasks': 'Görevler',
  'planner.personal': 'Kişisel',
  'planner.prevMonth': 'Önceki ay',
  'planner.nextMonth': 'Sonraki ay',
  'planner.today': 'Bugün',
  'planner.noEvents': 'Bu ay etkinlik yok.',
  'planner.allDay': 'Tüm gün',
  'planner.cancelled': 'İptal edildi',
  'planner.responseCounts': '{going} katılıyor · {maybe} belki · {declined} katılmıyor',
  'planner.yourResponse': 'Yanıtın',
  'planner.response.going': 'Katılıyorum',
  'planner.response.maybe': 'Belki',
  'planner.response.declined': 'Katılmıyorum',
  'planner.cancel': 'İptal et',
  'planner.delete': 'Sil',
  'planner.cancelConfirm': 'Etkinlik herkes için iptal edilsin mi?',
  'planner.deleteConfirm': 'Etkinlik silinsin mi?',
  'planner.newEvent': 'Yeni etkinlik',
  'planner.eventTitle': 'Etkinlik adı',
  'planner.where': 'Nerede görünsün',
  'planner.date': 'Tarih',
  'planner.start': 'Başlangıç',
  'planner.end': 'Bitiş',
  'planner.location': 'Yer',
  'planner.description': 'Açıklama',
  'planner.scopeNote': 'Kişisel öğeleri yalnız sen görürsün; alan ve grup öğelerini o alanın/grubun üyeleri görür. Uçtan uca şifreli gruplarda takvim kullanılamaz.',
  'planner.addEvent': 'Etkinlik ekle',
  'planner.myTasks': 'Bana ait görevler',
  'planner.show': 'Göster',
  'planner.showDone': 'Tamamlananları göster',
  'planner.noTasks': 'Görev yok.',
  'planner.assignedTo': 'Atanan: {name}',
  'planner.due': 'Son: {date}',
  'planner.deleteTaskConfirm': 'Görev silinsin mi?',
  'planner.newTask': 'Yeni görev',
  'planner.taskTitle': 'Görev',
  'planner.assignee': 'Atanan kişi',
  'planner.unassigned': 'Atanmamış',
  'planner.dueDate': 'Son tarih',
  'planner.addTask': 'Görev ekle',
  'planner.edit': 'Düzenle',
  'planner.endBeforeStart': 'Bitiş saati başlangıçtan sonra olmalı.',
  'planner.repeating': 'Tekrarlanan etkinlik',
  'planner.modified': 'bu tarih için değiştirildi',
  'planner.ics.download': 'Takvime ekle (.ics)',
  'planner.repeat.label': 'Tekrar',
  'planner.repeat.none': 'Tekrarlanmaz',
  'planner.repeat.every': 'Sıklık',
  'planner.repeat.unit.daily': { one: 'günde bir', other: 'günde bir' },
  'planner.repeat.unit.weekly': { one: 'haftada bir', other: 'haftada bir' },
  'planner.repeat.unit.monthly': { one: 'ayda bir', other: 'ayda bir' },
  'planner.repeat.unit.yearly': { one: 'yılda bir', other: 'yılda bir' },
  'planner.repeat.weekdays': 'Tekrar günleri',
  'planner.repeat.ends': 'Bitiş',
  'planner.repeat.never': 'Hiç bitmesin',
  'planner.repeat.until': 'Şu tarihte',
  'planner.repeat.after': 'Şu kadar tekrardan sonra',
  'planner.repeat.times': 'kez',
  'planner.repeat.untilBeforeStart': 'Tekrarın bitiş tarihi etkinlik tarihinden önce olamaz.',
  'planner.rec.daily': { one: 'Her gün', other: '{count} günde bir' },
  'planner.rec.weekly': { one: 'Her hafta', other: '{count} haftada bir' },
  'planner.rec.monthly': { one: 'Her ay', other: '{count} ayda bir' },
  'planner.rec.yearly': { one: 'Her yıl', other: '{count} yılda bir' },
  'planner.rec.until': '{date} tarihine kadar',
  'planner.rec.count': { one: '1 kez', other: '{count} kez' },
  'planner.reminders.label': 'Hatırlatıcılar',
  'planner.reminders.none': 'Hatırlatıcı yok',
  'planner.reminders.add': 'Hatırlatıcı ekle',
  'planner.reminders.remove': '{label} hatırlatıcısını kaldır',
  'planner.reminders.pushOff': 'Hatırlatıcılar bildirim olarak gelir; bu cihazda bildirimler kapalı.',
  'planner.reminders.enable': 'Bildirimleri aç',
  'planner.reminders.denied': 'Bu tarayıcı bildirimleri engelliyor; hatırlatıcılar için site ayarlarından izin ver.',
  'planner.reminders.unavailable': 'Bildirimler şu anda kullanılamıyor; hatırlatıcılar gönderilemez.',
  'planner.rem.atStart': 'Başladığında',
  'planner.rem.minutes': { one: '1 dakika önce', other: '{count} dakika önce' },
  'planner.rem.hours': { one: '1 saat önce', other: '{count} saat önce' },
  'planner.rem.days': { one: '1 gün önce', other: '{count} gün önce' },
  'planner.rem.weeks': { one: '1 hafta önce', other: '{count} hafta önce' },
  'planner.rem.sameDay': 'Aynı gün {time}',
  'planner.rem.daysBefore': { one: '1 gün önce {time}', other: '{count} gün önce {time}' },
  'planner.series.editTitle': 'Tekrarlanan etkinliği düzenle',
  'planner.series.deleteTitle': 'Tekrarlanan etkinliği sil',
  'planner.series.cancelTitle': 'Tekrarlanan etkinliği iptal et',
  'planner.series.one': 'Yalnızca bu etkinlik',
  'planner.series.following': 'Bu ve sonraki etkinlikler',
  'planner.series.all': 'Tüm etkinlikler',
  'planner.series.oneDisabled': 'Tekrar kuralı ya da “tüm gün” değişince tek bir etkinlik seçilemez.',
  'planner.feed.button': 'Takvim aboneliği',
  'planner.feed.title': 'Başka takvimlerde gör',
  'planner.feed.desc': 'Google Takvim, Apple Takvim veya Outlook bu özel adrese abone olur ve etkinliklerini yaklaşık saatte bir günceller. Adresi bilen herkes takvimini görebilir; kimseyle paylaşma.',
  'planner.feed.create': 'Özel adres oluştur',
  'planner.feed.address': 'Abonelik adresi',
  'planner.feed.onceNote': 'Bu adres güvenlik için yalnızca şimdi gösterilir. Kopyala ve takvim uygulamana ekle.',
  'planner.feed.copy': 'Kopyala',
  'planner.feed.copied': 'Kopyalandı',
  'planner.feed.openApps': 'Apple Takvim / Outlook’ta aç',
  'planner.feed.google': 'Google Takvim: Diğer takvimler → “URL ile” → adresi yapıştır.',
  'planner.feed.active': 'Abonelik açık ({date} tarihinde oluşturuldu).',
  'planner.feed.lastUsed': 'Son okunma: {date}',
  'planner.feed.neverUsed': 'Henüz hiçbir takvim uygulaması okumadı.',
  'planner.feed.rotate': 'Yeni adres oluştur',
  'planner.feed.rotateConfirm': 'Eski adres hemen çalışmayı bırakır. Yeni adres oluşturulsun mu?',
  'planner.feed.remove': 'Aboneliği kapat',
  'planner.feed.removeConfirm': 'Abonelik kapatılsın mı? Takvim uygulamaların artık güncellenmez.',
  'nav.learn': 'Eğitim',
  'error.EDU_INVITE_INVALID': 'Bu okul daveti geçersiz, kullanılmış ya da süresi dolmuş.',
  'learn.title': 'Eğitim',
  'learn.classes': 'Sınıflarım',
  'learn.teachers': 'Öğretmen: {names}',
  'learn.studentCount': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'learn.role.teacher': 'Öğretmen',
  'learn.role.student': 'Öğrenci',
  'learn.role.guardian': 'Veli',
  'learn.childTitle': '{name} — ödev durumu',
  'learn.noClasses': 'sınıf yok',
  'learn.noAssignments': 'Ödev yok.',
  'learn.feedbackLine': 'Öğretmen: {text}',
  'learn.late': 'Geç',
  'learn.status.not_submitted': 'Teslim edilmedi',
  'learn.status.missing': 'Eksik',
  'learn.status.submitted': 'Teslim edildi',
  'learn.status.returned': 'Değerlendirildi',
  'learn.guardianNote': 'Veli olarak ödev durumunu, notu ve öğretmen geri bildirimini görürsün; çocuğunun cevaplarını ve mesajlarını görmezsin.',
  'learn.myGuardians': 'Velilerim',
  'learn.myGuardiansNote': 'Bu kişiler okulun onayıyla velin olarak bağlandı ve ödev durumunu, notunu görebilir; cevaplarını ve mesajlarını göremez.',
  'learn.empty': 'Öğretmeninden sınıf bağlantısı iste ya da okul davetini aç.',
  'learn.request.title': 'Okulunu ekle',
  'learn.request.note': 'Okul alanlarını yalnız DijitalApp ekibi açar: başvurunu inceler ve kurum bilgisini doğrular. Onaydan sonra okul yöneticisi sen olursun.',
  'learn.request.movedToEdu': 'Okul ve kurslar artık Okul modülünde açılıyor: kurumunu orada kurarsın, sınıflar, duyurular, ödevler ve veliler aynı yerde. Ekip kurumunu orada doğrular. Daha önce açılmış okul alanları burada çalışmaya devam eder.',
  'learn.request.openEdu': 'Okul modülünde kurum aç',
  'learn.request.schoolName': 'Okul adı',
  'learn.request.city': 'Şehir',
  'learn.request.message': 'Not (görevin, iletişim)',
  'learn.request.submit': 'Başvur',
  'learn.request.pending': 'İnceleniyor',
  'learn.request.approved': 'Onaylandı',
  'learn.request.rejected': 'Reddedildi',
  'learn.link': 'Davet bağlantısı',
  'learn.verified': 'Doğrulanmış okul',
  'learn.people': 'Okul kişileri',
  'learn.inviteTeacher': 'Öğretmen daveti oluştur',
  'learn.pickStudent': 'Öğrenci seç',
  'learn.inviteGuardian': 'Veli daveti oluştur',
  'learn.teacherLinkNote': 'Tek kullanımlık, 7 gün geçerli; yalnız yetişkin hesaplar kullanabilir. Öğretmene doğrudan ilet.',
  'learn.guardianLinkNote': 'Tek kullanımlık, 7 gün geçerli; yalnız seçtiğin öğrencinin velisine (yetişkin) doğrudan ilet.',
  'learn.className': 'Sınıf adı',
  'learn.subject': 'Ders',
  'learn.createClass': 'Sınıf oluştur',
  'learn.back': 'Geri',
  'learn.studentsTitle': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'learn.noStudents': 'Henüz öğrenci yok.',
  'learn.classLink': 'Sınıf bağlantısı oluştur',
  'learn.classLinkNote': 'Bağlantıyı yalnız öğrencilerinle paylaş (1 hafta geçerli). Reşit olmayanlar yalnız veli onayı verilmiş hesapla katılabilir.',
  'learn.newAssignment': 'Yeni ödev',
  'learn.assignmentTitle': 'Başlık',
  'learn.instructions': 'Yönerge',
  'learn.assign': 'Ödev ver',
  'learn.assignments': 'Ödevler',
  'learn.leaveClass': 'Sınıftan ayrıl',
  'learn.leaveConfirm': 'Sınıftan ayrılmak istiyor musun?',
  'learn.yourAnswer': 'Cevabın',
  'learn.submitNote': 'Öğretmen değerlendirene kadar düzenleyebilirsin. Yalnız öğretmenin görür.',
  'learn.submit': 'Teslim et',
  'learn.resubmit': 'Güncelle',
  'learn.counts': '{submitted}/{students} teslim · {returned} değerlendirildi',
  'learn.submissions': 'Teslimler',
  'learn.deleteAssignmentConfirm': 'Ödev silinsin mi?',
  'learn.feedback': 'Geri bildirim',
  'learn.grade': 'Not',
  'learn.return': 'Değerlendir',
  'learn.updateReturn': 'Güncelle',
  'learn.join.title': 'Okul daveti',
  'learn.join.teacher': '{school} okuluna öğretmen olarak katılıyorsun.',
  'learn.join.guardian': '{school} okulunda {name} adlı öğrencinin velisi olarak bağlanıyorsun.',
  'learn.join.class': '{school} — {className} sınıfına öğrenci olarak katılıyorsun.',
  'learn.join.teacherNote': 'Öğretmenler sınıf açar, ödev verir ve öğrencilerinin teslimlerini görür.',
  'learn.join.guardianNote': 'Çocuğunun ödev durumunu, notunu ve öğretmen geri bildirimini görürsün; cevaplarını ve mesajlarını görmezsin. Çocuğun seni velisi olarak görür.',
  'learn.join.classNote': 'Öğretmenlerinin adını ve kendi teslimlerini görürsün; sınıf arkadaşların seni bir sınıf listesinde görmez.',
  'learn.join.accept': 'Kabul et',
  'admin.tab.schools': 'Okullar',
  'admin.schools.note': 'Eğitim/Öğrenme bölümündeki eski okul alanları için. Onay, başvurana doğrulanmış bir okul alanı açar ve onu okul yöneticisi yapar. Kurumu bant dışında (resmî yazı, kurum e-postası, telefon) doğrulamadan onaylama.',
  'admin.schools.none': 'Bekleyen eski başvuru yok.',
  'admin.schools.legacyTitle': 'Eski okul alanı başvuruları',
  'adminEdu.queueMoved': 'Kurum doğrulama kuyruğu, paketler ve destek isteği Okullar sekmesinde.',
  'adminEdu.queueMovedLink': 'Okullar’a git',
  'admin.schools.reviewNote': 'İnceleme notu (başvurana gösterilir)',
  'admin.schools.approve': 'Onayla',
  'admin.schools.reject': 'Reddet',
  'admin.schools.approveConfirm': 'Kurum doğrulandı mı? Onay, doğrulanmış bir okul alanı oluşturur.',
  'quiz.title': 'Quizler',
  'quiz.new': 'Yeni quiz',
  'quiz.none': 'Henüz quiz yok.',
  'quiz.state.draft': 'Taslak',
  'quiz.state.published': 'Yayında',
  'quiz.state.closed': 'Kapandı',
  'quiz.meta': '{questions} soru · {points} puan',
  'quiz.minutes': { one: '{count} dk', other: '{count} dk' },
  'quiz.stats': '{submitted}/{students} tamamladı · ort. {average}',
  'quiz.edit': 'Düzenle',
  'quiz.publish': 'Yayınla',
  'quiz.publishConfirm': 'Yayınlanan quizin soruları ve cevap anahtarı artık değiştirilemez. Yayınlansın mı?',
  'quiz.results': 'Sonuçlar',
  'quiz.close': 'Kapat',
  'quiz.deleteConfirm': 'Quiz silinsin mi?',
  'quiz.byQuestion': 'Soru bazında',
  'quiz.correctRate': '%{rate} doğru',
  'quiz.cancel': 'Vazgeç',
  'quiz.timeLimit': 'Süre (dk)',
  'quiz.showAnswers': 'Doğru cevaplar',
  'quiz.policy.after_submit': 'Teslimden hemen sonra gösterilsin',
  'quiz.policy.after_close': 'Quiz kapanınca gösterilsin',
  'quiz.policy.never': 'Gösterilmesin (yalnız puan)',
  'quiz.question': 'Soru {n}',
  'quiz.prompt': 'Soru metni',
  'quiz.option': 'Seçenek {n}',
  'quiz.markCorrect': 'Seçenek {n} doğru cevap',
  'quiz.removeOption': 'Seçenek {n}i kaldır',
  'quiz.addOption': 'Seçenek ekle',
  'quiz.points': 'Puan',
  'quiz.removeQuestion': 'Soruyu kaldır',
  'quiz.correctHint': 'Her sorunun doğru cevabını soldaki düğmeyle işaretle. Cevap anahtarı sunucuda tutulur; öğrenciler seçtiğin zamana kadar göremez.',
  'quiz.addQuestion': 'Soru ekle',
  'quiz.saveDraft': 'Taslağı kaydet',
  'quiz.status.not_started': 'Başlanmadı',
  'quiz.status.in_progress': 'Devam ediyor',
  'quiz.status.submitted': 'Tamamlandı',
  'quiz.status.missing': 'Kaçırıldı',
  'quiz.start': 'Başla',
  'quiz.startConfirm': 'Süre başladığında durmaz: {count} dakikan olacak. Başlansın mı?',
  'quiz.resume': 'Devam et',
  'quiz.view': 'Sonucu gör',
  'quiz.score': 'Puan: {score}/{max}',
  'quiz.answersLater': 'Doğru cevaplar öğretmenin seçtiği zamanda gösterilecek.',
  'quiz.pointsShort': { one: '{count} puan', other: '{count} puan' },
  'quiz.submit': 'Teslim et',
  'quiz.blankConfirm': '{count} soru boş. Yine de teslim edilsin mi?',
  'quiz.oneAttempt': 'Tek hakkın var; teslimden sonra değiştiremezsin. Süre bitince cevapların otomatik teslim edilir.',
  'study.title': 'Çalışma planım',
  'study.prevWeek': 'Önceki hafta',
  'study.nextWeek': 'Sonraki hafta',
  'study.progress': '{done}/{planned} dk çalışıldı · {blocksDone}/{blocksTotal} blok',
  'study.weekProgress': 'Haftalık ilerleme',
  'study.due': 'Bu hafta yapılacaklar',
  'study.planned': 'Planlandı',
  'study.auto': 'Haftayı planla',
  'study.autoCreated': { one: '{count} blok eklendi.', other: '{count} blok eklendi.' },
  'study.autoNothing': 'Eklenecek yeni bir şey yok.',
  'study.autoNote': 'Ödev ve quizler için son tarihten bir gün önceye, hedeflerin için haftanın kalan günlerine çalışma blokları önerilir. Geçmiş günlere blok konmaz; tekrar basınca aynı şeyler eklenmez.',
  'study.goals': 'Hedeflerim',
  'study.goalLine': 'bu hafta {done}/{target} dk',
  'study.goalNoTarget': 'bu hafta {done} dk',
  'study.goalDone': 'Tamamlandı',
  'study.newGoal': 'Yeni hedef',
  'study.goalTitle': 'Hedef',
  'study.weeklyMinutes': 'Haftalık dk',
  'study.addGoal': 'Hedef ekle',
  'study.minutes': { one: '{count} dk', other: '{count} dk' },
  'study.kind.custom': 'Serbest',
  'study.kind.homework': 'Ödev',
  'study.kind.quiz': 'Quiz',
  'study.kind.goal': 'Hedef',
  'study.removeBlock': '{title} bloğunu kaldır',
  'study.day': 'Gün',
  'study.blockTitle': 'Ne çalışacaksın',
  'study.minutesLabel': 'Dk',
  'study.forGoal': 'Hedef',
  'study.addBlock': 'Ekle',
  'study.share': 'İlerlememi velilerimle paylaş',
  'study.privacy': 'Planın yalnız sana aittir; öğretmenler görmez. Paylaşırsan velilerin yalnız haftalık toplamları ve hedef yüzdelerini görür, blok başlıklarını görmez.',
  'study.notShared': 'Çalışma planı paylaşılmıyor (paylaşmak çocuğunun kararıdır).',
  'tutor.title': 'AI öğretmen',
  'tutor.intro': 'Konuyu anlaman için ipuçları verir, soru sorar, kavramı açıklar. Ödevini senin yerine yapmaz.',
  'tutor.consent.hints': 'Cevabı hazır vermez; ipucu ve sorularla seni yönlendirir. Yanılabilir; önemli konuları öğretmenine danış.',
  'tutor.consent.redaction': 'Yazdıkların bir yapay zekâ hizmetine gönderilir; telefon, e-posta, kimlik numarası gibi kişisel bilgiler gönderilmeden önce gizlenir.',
  'tutor.consent.retention': 'Konuşmaların 30 gün saklanır, sonra silinir; istediğin zaman kendin silebilirsin.',
  'tutor.consent.visibility': 'Konuşmalarını yalnız sen görürsün. Öğretmenin ve velin yalnız kaç mesaj yazıldığını görür.',
  'tutor.consent.guardian': '18 yaşından küçük olduğun için velinin de onay vermesi gerekir.',
  'tutor.consent.accept': 'Anladım, kullanmak istiyorum',
  'tutor.consent.withdraw': 'AI öğretmen iznimi geri al',
  'tutor.reason.account': 'Hesabın şu an AI öğretmeni kullanamıyor (e-posta doğrulaması veya veli onaylı kayıt gerekli).',
  'tutor.reason.guardian_approval_required': 'Velinin AI öğretmen için onay vermesi bekleniyor. Velin Eğitim sayfasından onaylayabilir.',
  'tutor.reason.quiz_in_progress': 'Bu sınıfta süren bir quizin var; quiz bitene kadar AI öğretmen kapalı.',
  'tutor.reason.quota': 'Bugünkü AI öğretmen hakkın doldu; yarın yeniden kullanabilirsin.',
  'tutor.newSession': 'Yeni konuşma başlat',
  'tutor.remaining': { one: 'Bugün {count} mesaj hakkın kaldı.', other: 'Bugün {count} mesaj hakkın kaldı.' },
  'tutor.safety': 'Önemli',
  'tutor.thinking': 'AI öğretmen düşünüyor…',
  'tutor.redacted': { one: '{count} kişisel bilgi gönderilmeden önce gizlendi.', other: '{count} kişisel bilgi gönderilmeden önce gizlendi.' },
  'tutor.ask': 'Neyi anlamadın? Ne denedin?',
  'tutor.turnsLeft': { one: 'Bu konuşmada {count} mesaj kaldı', other: 'Bu konuşmada {count} mesaj kaldı' },
  'tutor.send': 'Gönder',
  'tutor.teacher.enable': 'Bu sınıfta AI öğretmeni aç',
  'tutor.teacher.note': 'Öğrenciler ipucu ve açıklama alır, hazır cevap almaz; quiz sırasında kapalıdır. 18 yaşından küçükler için veli onayı da gerekir. Konuşmaları siz göremezsiniz, yalnız kullanım sayılarını görürsünüz.',
  'tutor.teacher.usage': 'Bu hafta {students} öğrenci, {messages} mesaj',
  'tutor.guardian.approve': 'Çocuğumun AI öğretmeni kullanmasına izin veriyorum',
  'tutor.guardian.note': 'Öğretmeni sınıfta açtıysa ve çocuğun da kabul ettiyse kullanılabilir. İpucu verir, ödevi yapmaz; kişisel bilgiler gizlenir; konuşmalar 30 gün sonra silinir. Konuşmaların içeriğini göremezsiniz, yalnız haftalık mesaj sayısını görürsünüz.',
  'tutor.guardian.usage': { one: 'Bu hafta {count} mesaj', other: 'Bu hafta {count} mesaj' },
  'admin.tab.system': 'Sistem sağlığı',
  'admin.tab.config': 'Ayarlar',
  'admin.tab.audit': 'Denetim kaydı',
  'admin.tab.security': 'Güvenlik olayları',
  'admin.tab.ai': 'AI kullanımı',
  'admin.tab.mail': 'E-posta',
  'mailAdmin.title': 'E-posta görünümü',
  'mailAdmin.intro': 'Uygulamanın gönderdiği tüm e-postaların ortak görünümü. Gönderim ayarı (SMTP) sunucudaki ortam dosyasında durur: {transport}.',
  'mailAdmin.accent': 'Vurgu rengi (başlık ve düğme)',
  'mailAdmin.logo': 'Logo adresi (https, PNG/SVG, yaklaşık 36 px yükseklik)',
  'mailAdmin.headline': 'Başlık altı satırı',
  'mailAdmin.footer': 'Alt bilgi (boş bırakılırsa standart metin)',
  'mailAdmin.templates': 'E-posta metinleri',
  'mailAdmin.templatesIntro': 'Her e-posta türünün konusu, metni ve düğme yazısı. Boş bırakılan diller için standart metin gider. Süslü parantez içindeki alanlar gönderilirken doldurulur.',
  'mailAdmin.subject': 'Konu',
  'mailAdmin.body': 'Metin',
  'mailAdmin.cta': 'Düğme yazısı',
  'mailAdmin.placeholders': 'Kullanılabilir alanlar: {list}',
  'mailAdmin.custom': 'Özel metin',
  'mailAdmin.default': 'Standart metin',
  'mailAdmin.reset': 'Standarda dön',
  'mailAdmin.preview': 'Önizle',
  'mailAdmin.sendTest': 'Kendime test gönder',
  'mailAdmin.sent': '{to} adresine gönderildi.',
  'mailAdmin.sendFailed': 'Gönderilemedi: {error}',
  'mailAdmin.kind.verify': 'E-posta doğrulama',
  'mailAdmin.kind.reset': 'Parola sıfırlama',
  'mailAdmin.kind.passwordChanged': 'Parola değişti',
  'mailAdmin.kind.newDevice': 'Yeni cihaz girişi',
  'mailAdmin.kind.newLead': 'Site formu (yeni talep)',
  'mailAdmin.kind.test': 'Test e-postası',
  'mailAdmin.kind.guardian': 'Veli onayı isteği',
  'mailAdmin.kind.guardianGranted': 'Veli onayı verildi',
  'mailAdmin.kind.guardianDenied': 'Veli onayı verilmedi',
  'mailAdmin.kind.familyLink': 'Aile Merkezi daveti',
  'mailAdmin.kind.accountDeletion': 'Hesap silme isteği',
  'mailAdmin.kind.appealAccepted': 'İtiraz kabul',
  'mailAdmin.kind.appealRejected': 'İtiraz ret',
  'mailAdmin.kind.opsAlert': 'Sistem uyarısı',
  'adminOps.reasonPrompt': 'Bu değişikliğin nedeni (denetim kaydına yazılır):',
  'adminOps.reasonShort': 'Lütfen en az 5 karakterlik bir neden yaz.',
  'adminOps.config.note': 'Değişiklikler hemen etkinleşir ve nedenleriyle birlikte denetim kaydına yazılır. Yalnız süper yöneticiler değiştirebilir.',
  'adminOps.settings': 'Genel ayarlar',
  'adminOps.registrationMode': 'Kayıt modu',
  'adminOps.registration.open': 'Açık (herkes kayıt olabilir)',
  'adminOps.registration.invite': 'Davetle (davet kodu gerekir)',
  'adminOps.registration.closed': 'Kapalı',
  'adminOps.source.console': 'panelden ayarlandı',
  'adminOps.source.env': 'sunucu varsayılanı (.env)',
  'adminOps.range': 'aralık {min}–{max} · varsayılan {def}',
  'adminOps.save': 'Kaydet',
  'adminOps.flags': 'Özellikler (feature flag)',
  'adminOps.flagsNote': 'Bir özelliği kapatmak onu herkes için kapatır. Çocuk güvenliği tabanı bayrak değildir; hiçbir bayrak onu gevşetemez.',
  'adminOps.overrides': { one: '{count} istisna', other: '{count} istisna' },
  'adminOps.plan': 'Plan hakları',
  'adminOps.secretsTitle': 'Gizli anahtarlar neden burada değil?',
  'adminOps.secretsNote': 'Veritabanı şifresi, e-posta (SMTP), Web Push özel anahtarı, TURN sırrı, AI API anahtarı ve yedekleme bilgileri yalnız sunucudaki, yalnız yöneticinin okuyabildiği /etc/dijitalapp/*.env dosyalarında durur. Panelden yönetilselerdi ele geçirilen tek bir admin oturumu bütün sırları sızdırabilir ya da yedekleri başka yere yönlendirebilirdi.',
  'adminOps.search': 'Ara',
  'adminOps.more': 'Daha eski kayıtlar',
  'adminOps.empty': 'Kayıt yok.',
  'adminOps.refresh': 'Yenile',
  'adminOps.mail.test': 'Test e-postası gönder',
  'adminOps.mail.accepted': '{relay} kabul etti → {to}. Gelen kutunu ve spam klasörünü kontrol et.',
  'adminOps.mail.localRelay': 'Bu sunucudaki yerel aktarıcı ({relay}) kabul etti; ama gerçekten teslim edildiği doğrulanamıyor (bu sunucudan giden posta portları kapalı). SMTP_URL bir dış sağlayıcıyı (ör. Resend) göstermeli.',
  'adminOps.mail.failed': 'Gönderilemedi ({error}). Sunucudaki SMTP ayarını kontrol et.',
  'adminOps.audit.action': 'İşlem (önek)',
  'adminOps.audit.actor': 'Kim (kullanıcı adı)',
  'adminOps.audit.resourceType': 'Kaynak türü',
  'adminOps.audit.before': 'Önce',
  'adminOps.audit.after': 'Sonra',
  'adminOps.security.summary': 'Son 7 gün',
  'adminOps.security.counts': '24 sa: {d1} · 7 gün: {d7}',
  'adminOps.ai.period': 'Dönem',
  'adminOps.ai.days': { one: '{count} gün', other: '{count} gün' },
  'adminOps.ai.provider': 'Sağlayıcı',
  'adminOps.ai.off': 'Kapalı (ANTHROPIC_API_KEY yok)',
  'adminOps.ai.safety': 'AI öğretmen güvenlik yanıtı: {count} (içerik saklanmaz)',
  'adminOps.ai.line': '{requests} istek · {ok} başarılı · {refused} reddedildi · {errors} hata · {users} kişi · {tokens} token · ort. {latency} ms',
  'adminOps.ai.daily': 'Günlük istek',
  'adminOps.ai.topUsers': 'En çok kullananlar',
  'adminOps.ai.privacy': 'Yalnız sayılar tutulur; hiçbir AI isteğinin metni saklanmaz.',
  'adminOps.state.ok': 'çalışıyor',
  'adminOps.state.degraded': 'kısıtlı',
  'adminOps.state.fail': 'hata',
  'adminOps.state.off': 'kapalı',
  'adminOps.system.release': 'Sürüm: {release} · Node {node}',
  'adminOps.system.process': 'Çalışma süresi: {uptime} dk · bellek {memory} MB',
  'adminOps.system.migrations': 'Veritabanı geçişleri: {count} · son: {latest}',
  'adminOps.system.outbox': 'Bekleyen olay: {pending} · en eskisi {oldest} sn',
  'adminOps.system.db': 'Veritabanı boyutu: {size} MB',
  'adminOps.system.counts': 'Kullanıcı: {users} · son 24 sa yeni: {newUsers} · mesaj: {messages} · bu sunucudaki canlı bağlantı: {sockets}',
  'adminOps.system.note': 'Yedekleme ve dış izleme sunucudaki zamanlayıcılarla çalışır; durumları bu sürümde panelde gösterilmiyor.',
  'adminOps.budget.title': 'Aylık yapay zekâ bütçesi',
  'adminOps.budget.intro': 'Tüm yapay zekâ özellikleri (yazım yardımı, çeviri, öğretmen, işletme asistanı, Özel Bölge incelemesi) birlikte sayılır. Harcama, bu ay kaydedilen token sayısı × girdiğin fiyatlardır.',
  'adminOps.budget.spent': '{month}: {spent} harcandı',
  'adminOps.budget.of': ' / {limit}',
  'adminOps.budget.noLimit': 'Sınır yok',
  'adminOps.budget.limit': 'Aylık sınır (USD, boş: sınırsız)',
  'adminOps.budget.alert': 'Uyarı e-postası (%)',
  'adminOps.budget.reached': 'Sınıra ulaşıldı: yapay zekâ özellikleri bu ay kapalı.',
  'adminOps.budget.model': 'Model',
  'adminOps.budget.tokens': 'Token (girdi / çıktı)',
  'adminOps.budget.priceIn': 'Girdi $/1M',
  'adminOps.budget.priceOut': 'Çıktı $/1M',
  'adminOps.budget.cost': 'Bu ay',
  'adminOps.budget.unpriced': 'Fiyat girilmemiş: bu modelin harcaması sıfır sayılıyor.',
  'adminOps.budget.priceHint': 'Fiyatları sağlayıcının güncel fiyat sayfasından gir (milyon token başına USD).',
  'adminOps.budget.noModels': 'Bu ay kayıtlı yapay zekâ kullanımı yok ve açık bir sağlayıcı yok.',
  'adminOps.budget.readOnly': 'Bütçeyi yalnız süper yöneticiler değiştirebilir.',
  'adminOps.live.title': 'Canlı rakamlar (bu sunucu)',
  'adminOps.live.last5m': 'Son 5 dk: {requests} istek · {errors} hata (5xx) · p50 {p50} ms · p95 {p95} ms',
  'adminOps.live.requests': 'Dakikada istek (son 60 dk)',
  'adminOps.live.p95': 'Dakikalık p95 yanıt süresi, ms (son 60 dk)',
  'adminOps.live.minute': '{time}: {value}',
  'adminOps.live.peak': 'en yüksek {value}',
  'adminOps.live.loop': 'Zamanlayıcı gecikmesi: p50 {p50} ms · p99 {p99} ms · en çok {max} ms',
  'adminOps.live.pool': 'Veritabanı bağlantıları: {busy} meşgul · {idle} boşta · {waiting} bekleyen',
  'adminOps.live.routes': 'En yoğun uç noktalar',
  'adminOps.live.route': 'Uç nokta',
  'adminOps.live.count': 'İstek',
  'adminOps.live.errors': 'Hata',
  'adminOps.live.jobs': 'Arka plan iş hataları',
  'adminOps.live.noJobs': 'Arka plan işlerinde hata yok.',
  'adminOps.live.alerts': 'Son uyarılar',
  'adminOps.live.noAlerts': 'Uyarı yok.',
  'adminOps.live.limits': 'Uyarı sınırları: hata oranı > %{errorRate}, p95 > {p95} ms, zamanlayıcı p99 > {loop} ms, bekleyen sorgu > {db}, kuyruk > {outbox} dk. Uyarılar süper yönetici ve yöneticilere e-postayla gider (aynı tür en çok saatte bir).',
  'adminOps.live.prometheusOn': 'Prometheus: /metrics açık (METRICS_TOKEN ile).',
  'adminOps.live.prometheusOff': 'Prometheus: /metrics kapalı. Açmak için sunucuda METRICS_TOKEN tanımla.',
  'adminOps.live.alert.errors': 'Sunucu hataları',
  'adminOps.live.alert.latency': 'Yavaş yanıt',
  'adminOps.live.alert.eventLoop': 'Zamanlayıcı gecikmesi',
  'adminOps.live.alert.dbPool': 'Veritabanı havuzu',
  'adminOps.live.alert.outbox': 'Olay kuyruğu',
  'adminOps.live.alert.aiBudget': 'Yapay zekâ bütçesi',
  'settings.section.account': 'Hesap',
  'settings.section.account.desc': 'Profilin ve oturumun',
  'settings.section.appearance': 'Görünüm',
  'settings.section.appearance.desc': 'Tema ve dil',
  'settings.section.privacy': 'Gizlilik',
  'settings.section.privacy.desc': 'Seni kim görebilir, kim yazabilir',
  'settings.section.notifications': 'Bildirimler',
  'settings.section.notifications.desc': 'Anlık bildirimler ve önizleme',
  'settings.section.security': 'Güvenlik',
  'settings.section.security.desc': 'İki adımlı doğrulama, passkey ve uçtan uca şifreleme',
  'settings.section.devices': 'Cihazlar',
  'settings.section.devices.desc': 'Oturum açık cihazların',
  'settings.section.bots': 'Botlar',
  'settings.section.bots.desc': 'Kendi botlarını yap ve yönet',
  'common.copy': 'Kopyala',
  'common.copied': 'Kopyalandı',
  'bots.moduleOff': 'Botlar şu an kapalı; yönetici açınca kullanılabilir.',
  'bots.adultsOnly': 'Bot yalnızca yetişkin hesaplarıyla yapılabilir.',
  'bots.empty': 'Henüz botun yok.',
  'bots.new': 'Yeni bot',
  'bots.name': 'Görünen ad',
  'bots.username': 'Kullanıcı adı',
  'bots.usernameHint': 'Küçük harf, rakam ve alt çizgi; "bot" ile bitmeli (ör. havadurumubot).',
  'bots.description': 'Açıklama',
  'bots.create': 'Botu oluştur',
  'bots.secrets.title': 'Bot anahtarların',
  'bots.secrets.body': 'Bunlar yalnızca şimdi gösterilir. Güvenli bir yere kaydet; kaybedersen "Anahtarı yenile" ile yenisini alırsın.',
  'bots.token': 'Bot API anahtarı',
  'bots.webhookSecret': 'Webhook imza anahtarı',
  'bots.secrets.done': 'Kaydettim',
  'bots.on': 'Açık',
  'bots.off': 'Kapalı',
  'bots.tokenPrefix': 'Anahtar: {prefix}…',
  'bots.lastDelivery': 'son webhook: {status} ({date})',
  'bots.webhook': 'Webhook adresi (https)',
  'bots.webhookHint': 'Boş bırakırsan olayları /bot/v1/updates ile sorgulayarak alırsın.',
  'bots.commands': 'Komutlar',
  'bots.commandsHint': 'Her satıra bir komut: /komut Açıklama. Sohbette kullanıcılara gösterilir.',
  'bots.renew': 'Anahtarı yenile',
  'bots.renewConfirm': 'Eski anahtar hemen geçersiz olur. Devam edilsin mi?',
  'bots.delete': 'Sil',
  'bots.deleteConfirm': '{name} silinsin mi? Bot hesabı kapanır; gönderdiği mesajlar sohbetlerde kalır.',
  'bots.api.title': 'Bot API nasıl kullanılır?',
  'bots.api.intro': 'Bot, kendi anahtarıyla konuşur; oturum ya da parola kullanmaz. Yalnızca içinde olduğu sohbetleri görür ve oraya yazar. Birisi bota yazınca ya da botu bir gruba ekleyince olay alırsın.',
  'bots.api.webhook': 'Webhook (ayarlıysa) — 2xx dönmezsen tekrar denenir:',
  'bots.api.notes': 'Mesajlar en fazla 4096 karakter. Düğmeler: en fazla 10 satır × 4 düğme; "data" ile geri çağrı, "url" ile bağlantı. Uçtan uca şifreli sohbetleri botlar okuyamaz.',
  'bots.commandsFor': '{name} komutları',
  'bots.callbackSent': 'Gönderildi',
  'settings.theme': 'Tema',
  'settings.account.details': 'Hesap bilgileri',
  'settings.account.badges': 'Rozetlerin',
  'settings.account.badgesHint': 'Adının yanında herkesin gördüğü işaretler. Üzerine gelen ya da profiline bakan kişi ne anlama geldiğini de görür.',
  'settings.account.badgesEmpty': 'Henüz rozetin yok',
  'settings.account.badgesEmptyHint': 'Rozetleri DijitalApp ekibi verir: doğrulanmış hesap, kurum, okul ya da topluluk görevi gibi. Bir rozet verildiğinde burada hemen görünür.',
  'settings.account.emailVerifiedChip': 'E-posta doğrulandı',
  'settings.account.emailUnverifiedChip': 'E-posta doğrulanmadı',
  'settings.account.memberSince': '{date} tarihinden beri üye',
  'settings.account.email': 'E-posta',
  'settings.account.verified': 'Doğrulandı',
  'settings.account.unverified': 'Doğrulanmadı',
  'settings.account.type': 'Hesap türü',
  'settings.account.adult': 'Yetişkin',
  'settings.account.minor': '18 yaş altı (korumalı)',
  'settings.account.since': 'Üyelik tarihi',
  'settings.account.session': 'Oturum',
  'settings.account.sessionHint': 'Bu cihazdan çıkış yapar. Diğer cihazlarını Cihazlar bölümünden yönetebilirsin.',
  'e2ee.deviceUnverifiedShort': 'şifreli sohbetlerini ve eski mesajlarını burada görmek için',
  'e2ee.fix': 'Bağla',
  'e2ee.later': 'Daha sonra',
  'e2ee.openSecurity': 'Güvenlik ayarları',
  'chat.splashTitle': '{brand} Web',
  'chat.splashFoot': 'Bağlantın her zaman şifreli. Dilediğin sohbette uçtan uca şifrelemeyi açabilirsin.',
  'chat.newDesc': 'Bir kişiyi kullanıcı adıyla ekle ya da yeni bir grup kur.',
  'e2ee.fix.waiting': 'Telefonunda onay bekleniyor…',
  'e2ee.fix.recoveryTitle': 'Eski kurtarma anahtarı',
  'e2ee.fix.haveRecovery': 'Eskiden kaydettiğim bir kurtarma anahtarım var',
  'adminOps.flag.messaging': 'Mesajlaşma',
  'adminOps.flag.messaging.desc': 'Birebir ve grup sohbetleri',
  'adminOps.flag.voice_messages': 'Sesli mesajlar',
  'adminOps.flag.voice_messages.desc': 'Sohbetlerde ses kaydı gönderme',
  'adminOps.flag.groups': 'Gruplar',
  'adminOps.flag.groups.desc': 'Grup sohbetleri ve davet bağlantıları',
  'adminOps.flag.communities': 'Topluluklar',
  'adminOps.flag.communities.desc': 'Topluluk ve aile alanları, duyuru kanalı',
  'adminOps.flag.channels': 'Kanallar',
  'adminOps.flag.channels.desc': 'Birden çoğa yayın ve kanal dizini',
  'adminOps.flag.stories': 'Durum',
  'adminOps.flag.stories.desc': 'Kişilerle 24 saatlik durum paylaşımı ve Duvar',
  'adminOps.flag.voice_calls': 'Sesli aramalar',
  'adminOps.flag.voice_calls.desc': 'Birebir sesli arama',
  'adminOps.flag.video_calls': 'Görüntülü aramalar',
  'adminOps.flag.video_calls.desc': 'Birebir görüntülü arama',
  'adminOps.flag.screen_share': 'Ekran paylaşımı',
  'adminOps.flag.screen_share.desc': 'Birebir aramalarda ekran, pencere veya sekme paylaşımı (masaüstü)',
  'adminOps.flag.bots': 'Botlar',
  'adminOps.flag.bots.desc': 'Bot hesapları ve Bot API (Ayarlar › Botlar; webhook veya sorgulama ile olaylar, düğmeli mesajlar, komutlar)',
  'adminOps.flag.business': 'İşletme hesapları',
  'adminOps.flag.business.desc': 'İşletme asistanı ve Business uygulamaları (otomatik yanıt, randevu, katalog)',
  'adminOps.flag.translation': 'Çeviri',
  'adminOps.flag.translation.desc': 'Gelen mesajı çevirme (mesaj menüsünde “Çevir”; her çeviri ücretli bir yapay zekâ isteğidir, AI anahtarı ve yazım asistanı bayrağı gerekir)',
  'adminOps.flag.ai': 'AI yazım asistanı',
  'adminOps.flag.ai.desc': 'Taslak düzeltme, kısaltma, çeviri',
  'adminOps.flag.payments': 'Ödemeler',
  'adminOps.flag.payments.desc': 'Market’te Pro uygulama ve Plus/Business plan satın alma; sağlayıcı (iyzico / PayTR) Ödemeler sekmesinden seçilir',
  'adminOps.flag.location': 'Konum paylaşımı',
  'adminOps.flag.location.desc': 'Konum ve canlı konum paylaşımı; çocuklar için her zaman kapalı',
  'adminOps.flag.public_discovery': 'Herkese açık keşif',
  'adminOps.flag.public_discovery.desc': 'Profillerin aramada bulunması; çocuklar için her zaman kapalı',
  'adminOps.flag.learning_hub': 'Eğitim',
  'adminOps.flag.learning_hub.desc': 'Okullar, sınıflar, ödev, quiz, çalışma planı',
  'adminOps.flag.events': 'Etkinlik alanları',
  'adminOps.flag.events.desc': 'Etkinlik türünde alan açabilme',
  'adminOps.flag.calendar': 'Takvim',
  'adminOps.flag.calendar.desc': 'Kişisel, alan ve grup etkinlikleri',
  'adminOps.flag.tasks': 'Görevler',
  'adminOps.flag.tasks.desc': 'Kişisel, alan ve grup görevleri',
  'adminOps.flag.ai_tutor': 'AI öğretmen',
  'adminOps.flag.ai_tutor.desc': 'Sınıflarda pedagojik AI yardımı',
  'adminOps.flag.passkey_login': 'Passkey ile giriş',
  'adminOps.flag.passkey_login.desc': 'Şifresiz, cihaz kilidiyle giriş',
  'adminOps.flag.push_notifications': 'Anlık bildirimler',
  'adminOps.flag.push_notifications.desc': 'Tarayıcı ve telefon bildirimleri',
  'adminOps.rc.maxMessageLength': 'En uzun mesaj',
  'adminOps.rc.maxMessageLength.unit': 'karakter',
  'adminOps.rc.maxUploadSizeMb': 'En büyük dosya',
  'adminOps.rc.maxUploadSizeMb.unit': 'MB',
  'adminOps.rc.typingTimeoutMs': '"Yazıyor…" süresi',
  'adminOps.rc.typingTimeoutMs.unit': 'milisaniye',
  'adminOps.rc.presenceTimeoutMs': 'Çevrimiçi sayılma süresi',
  'adminOps.rc.presenceTimeoutMs.unit': 'milisaniye',
  'adminOps.rc.storyDurationHours': 'Durum süresi',
  'adminOps.rc.storyDurationHours.unit': 'saat',
  'adminOps.ent.limit.ai_requests_daily': 'Günlük AI yazım asistanı hakkı',
  'adminOps.ent.limit.ai_requests_daily.unit': 'istek',
  'adminOps.ent.limit.ai_tutor_daily': 'Günlük AI öğretmen hakkı',
  'adminOps.ent.limit.ai_tutor_daily.unit': 'mesaj',
  'adminOps.ent.limit.channel_subscribers': 'Kanal başına takipçi',
  'adminOps.ent.limit.channel_subscribers.unit': 'kişi',
  'adminOps.ent.limit.community_groups': 'Topluluk başına grup',
  'adminOps.ent.limit.community_groups.unit': 'grup',
  'adminOps.ent.limit.devices': 'Cihaz sayısı',
  'adminOps.ent.limit.devices.unit': 'cihaz',
  'adminOps.ent.limit.group_members': 'Grup başına üye',
  'adminOps.ent.limit.group_members.unit': 'kişi',
  'adminOps.ent.limit.open_tasks_per_scope': 'Açık görev (alan/grup başına)',
  'adminOps.ent.limit.open_tasks_per_scope.unit': 'görev',
  'adminOps.ent.limit.spaces_owned': 'Sahip olunabilecek alan',
  'adminOps.ent.limit.spaces_owned.unit': 'alan',
  'adminOps.ent.limit.storage_mb': 'Depolama alanı',
  'adminOps.ent.limit.storage_mb.unit': 'MB',
  'adminOps.check.postgres': 'Veritabanı',
  'adminOps.check.redis': 'Önbellek (Redis)',
  'adminOps.check.clamav': 'Virüs taraması',
  'adminOps.check.ai': 'AI sağlayıcısı',
  'adminOps.check.push': 'Anlık bildirim',
  'adminOps.check.turn': 'Arama sunucusu (TURN)',
  'adminOps.check.mail': 'E-posta gönderimi',
  'adminOps.check.outbox': 'Olay kuyruğu',
  'adminOps.aiAction.fix': 'Yazım düzeltme',
  'adminOps.aiAction.shorten': 'Kısaltma',
  'adminOps.aiAction.formal': 'Resmîleştirme',
  'adminOps.aiAction.friendly': 'Samimileştirme',
  'adminOps.aiAction.translate_en': 'İngilizceye çeviri',
  'adminOps.aiAction.translate_tr': 'Türkçeye çeviri',
  'adminOps.aiAction.tutor': 'AI öğretmen',
  'adminOps.secKind.login.failed': 'Başarısız giriş',
  'adminOps.secKind.login.rate_limited': 'Çok fazla giriş denemesi',
  'adminOps.secKind.passkey.login_failed': 'Başarısız passkey girişi',
  'adminOps.secKind.password.reset_requested': 'Şifre sıfırlama istendi',
  'adminOps.secKind.password.reset_completed': 'Şifre sıfırlandı',
  'adminOps.secKind.privacy.floor_violation': 'Çocuk koruma kuralı denemesi',
  'adminOps.secKind.tutor.safety_reply': 'AI öğretmen güvenlik yanıtı',
  'adminOps.secKind.username.changed': 'Kullanıcı adı değişti',
  'role.platform.super_admin': 'Süper yönetici',
  'role.platform.admin': 'Yönetici',
  'role.platform.moderator': 'Moderatör',
  'role.platform.support': 'Destek',
  'spaces.role.owner': 'Sahip',
  'spaces.role.admin': 'Yönetici',
  'spaces.role.member': 'Üye',
  'spaces.role.guest': 'Misafir',
  'adminOps.registrationModeHint': 'Yeni kullanıcıların nasıl kayıt olabileceği',
  'adminOps.remoteTitle': 'Uygulama sınırları',
  'error.USERNAME_CHANGE_TOO_SOON': 'Kullanıcı adını 30 günde bir değiştirebilirsin.',
  'settings.account.username': 'Kullanıcı adı',
  'settings.account.changeUsername': 'Kullanıcı adını değiştir',
  'settings.avatar.upload': 'Profil fotoğrafı yükle',
  'settings.avatar.change': 'Profil fotoğrafını değiştir',
  'settings.avatar.remove': 'Fotoğrafı kaldır',
  'settings.account.newUsername': 'Yeni kullanıcı adı',
  'settings.account.usernameRules': '3–30 karakter; küçük harf, rakam, "_" ve "." kullanılabilir. Ayda bir kez (30 günde bir) değiştirebilirsin; eski adın 30 gün boyunca başkasına verilmez.',
  'settings.account.passwordToConfirm': 'Onaylamak için şifren',
  'settings.account.usernameSaved': 'Kullanıcı adın güncellendi.',
  'settings.account.usernameNextChange': 'Bir sonraki değişiklik: {date}',
  'planner.calendarDesc': 'Kişisel, alan ve grup etkinliklerin',
  'planner.tasksDesc': 'Sana ait ve atanan görevler',
  'learn.nav.home': 'Genel bakış',
  'learn.nav.homeDesc': 'Sınıfların, okulların ve çocukların',
  'learn.nav.planDesc': 'Hedefler ve haftalık çalışma planı',
  'learn.nav.schoolDesc': 'Okulunu doğrulanmış olarak ekle',
  'learn.emptyTitle': 'Henüz bir sınıfın yok',
  'spaces.createDesc': 'Ailen ya da topluluğun için ortak bir alan kur.',
  'spaces.cannotCreate': 'Bu hesap yeni alan oluşturamaz.',
  'spaces.typeDesc.personal': 'Yalnız sana ait',
  'spaces.typeDesc.family': 'Ailen için: çocuklar da katılabilir',
  'spaces.typeDesc.community': 'Mahalle, dernek, kulüp: duyurular ve gruplar',
  'spaces.typeDesc.school': 'Okullar personel onayıyla açılır',
  'spaces.typeDesc.business': 'Kurum doğrulaması gerekir',
  'spaces.typeDesc.event': 'Bir etkinlik için geçici alan',
  'call.historyDesc': 'Gelen, giden ve cevapsız aramaların',
  'call.howTo': 'Bir sohbeti açıp üstteki telefon ya da kamera düğmesiyle arama başlatabilirsin.',
  'auth.hero.title': 'Aileniz, okulunuz ve topluluğunuz için güvenli mesajlaşma',
  'auth.hero.p1': 'Sohbetler, gruplar ve sesli/görüntülü aramalar',
  'auth.hero.p2': 'Aile ve topluluk alanları, kanallar',
  'auth.hero.p3': 'Okul, ödev, quiz ve çalışma planı',
  'auth.login.subtitle': 'Tekrar hoş geldin! Hesabına giriş yap.',
  'auth.register.subtitle': 'Birkaç adımda ücretsiz hesabını oluştur.',
  'date.placeholder': 'gg.aa.yyyy',
  'date.open': 'Takvimi aç',
  'date.tomorrow': 'Yarın',
  'date.nextWeek': 'Gelecek hafta',
  'date.prevMonth': 'Önceki ay',
  'date.nextMonth': 'Sonraki ay',
  'date.clear': 'Tarihi temizle',
  'time.placeholder': 'ss:dd',
  'admin.tab.usernames': 'Kullanıcı adları',
  'error.USERNAME_NOT_ALLOWED': 'Bu kullanıcı adı uygunsuz ifadeler içerdiği için kullanılamaz.',
  'settings.account.usernameRulesStaff': '3–30 karakter; küçük harf, rakam, "_" ve "." kullanılabilir. Yönetici olarak istediğin kadar değiştirebilir, ayrılmış adları (ör. destek, resmi) kullanabilirsin.',
  'settings.account.usernameAvailable': '@{name} kullanılabilir',
  'settings.account.usernameReason.invalid': '3–30 karakter; yalnız küçük harf, rakam, "_" ve "."',
  'settings.account.usernameReason.same': 'Bu zaten senin kullanıcı adın.',
  'settings.account.usernameReason.taken': 'Bu kullanıcı adı alınmış.',
  'settings.account.usernameReason.reserved': 'Bu ad platform veya resmi kurumlar için ayrılmış.',
  'settings.account.usernameReason.blocked': 'Bu ad uygunsuz ifadeler içerdiği için kullanılamaz.',
  'adminOps.uname.intro': 'Kayıt olurken ve kullanıcı adı değiştirirken uygulanır. "Ayrılmış" adları yalnız yöneticiler alabilir; "Yasaklı" adları kimse alamaz. Benzer yazımlar da yakalanır (a.d.m.i.n, 4ll4h, s1kt1r).',
  'adminOps.uname.testTitle': 'Bir adı dene',
  'adminOps.uname.testPlaceholder': 'ör. destek_ekibi',
  'adminOps.uname.test': 'Dene',
  'adminOps.uname.invalid': 'Biçim geçersiz: 3–30 karakter; küçük harf, rakam, "_" ve "."',
  'adminOps.uname.allowed': '@{name} normal kullanıcılar için uygun.',
  'adminOps.uname.refused.reserved': 'Ayrılmış: "{term}" kuralına takılıyor ({source}). Yalnız yöneticiler alabilir.',
  'adminOps.uname.refused.blocked': 'Yasaklı: "{term}" kuralına takılıyor ({source}). Kimse alamaz.',
  'adminOps.uname.sourceBuiltin': 'yerleşik liste',
  'adminOps.uname.sourceCustom': 'senin listen',
  'adminOps.uname.addTitle': 'Kural ekle',
  'adminOps.uname.term': 'İfade',
  'adminOps.uname.match': 'Eşleşme',
  'adminOps.uname.kind': 'Tür',
  'adminOps.uname.note': 'Not (isteğe bağlı)',
  'adminOps.uname.add': 'Ekle',
  'adminOps.uname.match.whole': 'Adın tamamı',
  'adminOps.uname.match.word': 'Kelime olarak',
  'adminOps.uname.match.contains': 'İçinde geçerse',
  'adminOps.uname.matchHint.whole': 'Yalnız adın kendisi bu ifade ise: "iletisim" engellenir, "iletisim_ali" serbest.',
  'adminOps.uname.matchHint.word': 'Ad bu ifade ise ya da "_" "." ile ayrılmış bir parçası bu ise: "admin_ali" engellenir, "badminton" serbest.',
  'adminOps.uname.matchHint.contains': 'İfade adın herhangi bir yerinde geçerse. Yalnız uzun, başka anlamı olmayan ifadeler için kullan; kısa ifadeler gerçek isimleri de engelleyebilir.',
  'adminOps.uname.kind.reserved': 'Ayrılmış (yalnız yöneticiler)',
  'adminOps.uname.kind.blocked': 'Yasaklı (kimse alamaz)',
  'adminOps.uname.customTitle': 'Senin eklediklerin ({count})',
  'adminOps.uname.none': 'Henüz kural eklemedin.',
  'adminOps.uname.remove': 'Kaldır',
  'adminOps.uname.builtinTitle': 'Yerleşik listeler',
  'adminOps.uname.builtinHint': 'Uygulamayla birlikte gelir ve her zaman uygulanır; buradan kaldırılamaz. Eksik gördüğün ifadeleri yukarıdan ekleyebilirsin.',
  'install.button': 'Uygulamayı yükle',
  'settings.themeToggle': 'Açık / koyu tema',
  'install.addToHome': 'Ana ekrana ekle',
  'install.title': 'DijitalApp uygulaması',
  'install.why': 'Ana ekranından tek dokunuşla aç, kendi penceresinde çalışsın ve bildirimleri alsın. Mağaza gerekmez, yer kaplamaz.',
  'install.installed': 'DijitalApp bu cihazda uygulama olarak yüklü.',
  'install.ios1': 'Safari’de alttaki Paylaş simgesine (kare ve yukarı ok) dokun.',
  'install.ios2': '“Ana Ekrana Ekle”yi seç.',
  'install.ios3': 'Sağ üstteki “Ekle”ye dokun.',
  'install.other': 'Tarayıcının menüsünden “Uygulamayı yükle” ya da “Ana ekrana ekle” seçeneğini kullanabilirsin.',
  'admin.tab.site': 'Web sitesi',
  'error.QR_LOGIN_EXPIRED': 'Bu QR kodunun süresi dolmuş ya da kullanılmış.',
  'error.SITE_CHANGED': 'Bu içerik siz düzenlerken başka biri tarafından kaydedildi. Sayfayı yenileyip tekrar deneyin.',
  'error.MESSAGE_REQUEST_PENDING': 'Mesaj isteğin bekliyor. Karşı taraf kabul edene kadar daha fazla mesaj gönderemezsin.',
  'error.VOICE_UNAVAILABLE': 'Seslendirme şu an yapılamıyor. Panelde seslendirmenin açık, bir sesin seçili ve sunucuda ElevenLabs anahtarının olduğunu kontrol et.',
  'error.VOICE_LIMIT': 'Bu ayın seslendirme sınırı doldu. Sınırı panelden artırabilirsin.',
  'error.VOICE_BUSY': 'Bu hutbe zaten seslendiriliyor; bir iki dakika içinde hazır olur.',
  'error.SOURCE_UNAVAILABLE': 'Kaynak siteye şu an ulaşılamadı ya da sayfa beklenen biçimde değil. Biraz sonra tekrar dene.',
  'adminOps.site.language': 'Dil',
  'adminOps.site.version': 'Sürüm {version} · {by} · {date}',
  'adminOps.site.defaults': 'Varsayılan içerik yayında (henüz düzenlenmedi)',
  'adminOps.site.open': 'Siteyi aç',
  'adminOps.site.undo': 'Değişiklikleri geri al',
  'adminOps.site.save': 'Kaydet ve yayınla',
  'adminOps.site.saved': 'Kaydedildi ve yayına alındı.',
  'adminOps.site.restored': 'Seçilen sürüm geri yüklendi ve yayına alındı.',
  'adminOps.site.discard': 'Kaydedilmemiş değişiklikler var. Yine de dil değiştirilsin mi?',
  'adminOps.site.sections': 'Bölümler',
  'adminOps.site.resetSection': 'Bu bölümü varsayılana döndür',
  'adminOps.site.history': 'Sürüm geçmişi',
  'adminOps.site.noHistory': 'Henüz kayıt yok.',
  'adminOps.site.restore': 'Bu sürüme dön',
  'adminOps.site.add': 'Ekle',
  'adminOps.site.remove': 'Kaldır',
  'adminOps.site.up': 'Yukarı taşı',
  'adminOps.site.down': 'Aşağı taşı',
  'adminOps.site.section.general': 'Genel',
  'adminOps.site.section.hero': 'Giriş',
  'adminOps.site.section.product': 'Ürün',
  'adminOps.site.section.security': 'Güvenlik',
  'adminOps.site.section.business': 'Business ve Asistan',
  'adminOps.site.section.plus': 'Plus',
  'adminOps.site.section.plans': 'Paketler',
  'adminOps.site.section.apps': 'Uygulamalar',
  'adminOps.site.section.faq': 'Sorular',
  'adminOps.site.section.final': 'Kapanış ve alt bilgi',
  'adminOps.site.section.forms': 'Formlar',
  'siteField.forms': 'Formlar (Haberdar ol / Bize yazın)',
  'siteField.notifyEmail': 'Yeni kayıtları şu adrese e-postayla bildir (boş: bildirme)',
  'siteField.interest': 'Haberdar ol formu',
  'siteField.contact': 'Bize yazın formu',
  'siteField.topics': 'İlgi seçenekleri',
  'siteField.button': 'Düğme yazısı',
  'siteField.success': 'Gönderildi mesajı',
  'siteField.fields': 'Alan adları',
  'siteField.email': 'E-posta',
  'siteField.phone': 'Telefon',
  'siteField.message': 'Mesaj',
  'siteField.topic': 'İlgi',
  'siteField.optional': '“İsteğe bağlı” yazısı',
  'siteField.consent': 'Onay kutusu metni (KVKK)',
  'siteField.privacyUrl': 'Aydınlatma metni bağlantısı',
  'siteField.error': 'Hata mesajı',
  'siteField.tooFast': 'Çok fazla deneme mesajı',
  'admin.tab.leads': 'Form kayıtları',
  'leads.all': 'Tümü',
  'leads.kind.interest': 'Haberdar ol',
  'leads.kind.contact': 'Bize yazın',
  'leads.status.all': 'Her durum',
  'leads.status.new': 'Yeni',
  'leads.status.handled': 'Yanıtlandı',
  'leads.status.spam': 'Spam',
  'leads.search': 'Ad, e-posta, telefon ya da mesajda ara',
  'leads.export': 'CSV indir',
  'leads.empty': 'Bu filtreye uyan kayıt yok.',
  'leads.markHandled': 'Yanıtlandı',
  'leads.markNew': 'Yeniye al',
  'leads.markSpam': 'Spam',
  'leads.delete': 'Sil',
  'leads.deleteConfirm': 'Bu kayıt kalıcı olarak silinsin mi? Kişisel veri içerir; geri alınamaz.',
  'leads.note': 'İç not',
  'leads.notePlaceholder': 'Ekip için not (ziyaretçi görmez)',
  'leads.saveNote': 'Notu kaydet',
  'leads.handledBy': '{who} · {date}',
  'leads.reply': 'E-postayla yanıtla',
  'leads.call': 'Ara',
  'leads.more': 'Daha fazla göster',
  'leads.hint': 'Formları açıp kapatmak, metinlerini ve bildirim adresini değiştirmek için: Web sitesi › Formlar.',
  'leads.openSettings': 'Form ayarları',
  'admin.tab.badges': 'Rozetler',
  'admin.tab.statuses': 'Durumlar',
  'admin.tab.legal': 'Yasal sayfalar',
  'legalAdmin.title': 'Yasal ve yardım sayfaları',
  'legalAdmin.hint': 'dijitalapp.com/kosullar, /gizlilik ve /yardim (İngilizceleri /en/ altında). Metinler senin sorumluluğunda: örnek taslağı yükleyip [köşeli parantezli] yerleri doldur ve hukuk danışmanına gözden geçirt. Metin yazılana kadar sayfa “hazırlanıyor” der, hata vermez.',
  'legalAdmin.page.kosullar': 'Kullanım Koşulları',
  'legalAdmin.page.gizlilik': 'Gizlilik',
  'legalAdmin.page.yardim': 'Yardım',
  'legalAdmin.language': 'Dil',
  'legalAdmin.open': 'Sayfayı aç',
  'legalAdmin.loadDraft': 'Örnek taslağı yükle',
  'legalAdmin.draftConfirm': 'Yazılı metnin yerine örnek taslak gelsin mi? (Kaydetmeden önce geri alabilirsin.)',
  'legalAdmin.pageTitle': 'Başlık',
  'legalAdmin.body': 'Metin',
  'legalAdmin.format': 'Paragrafların arasında boş satır bırak. “## ” başlık, “- ” madde yapar; **kalın** yazılabilir; e-posta ve https adresleri bağlantı olur.',
  'legalAdmin.formatEn': 'İngilizce metin boşsa İngilizce sayfada Türkçe metin gösterilir.',
  'legalAdmin.saved': 'Sayfa kaydedildi; sitede hemen görünür.',
  'legalAdmin.updated': 'Son kayıt: {when}',
  'legalAdmin.empty': 'Henüz yazılmadı: sayfa “hazırlanıyor” der.',
  'religious.title': 'Önemli Gün ve Geceler',
  'religious.off': 'Bu bölüm şu an kapalı.',
  'religious.nextDay': 'Sıradaki mübarek gün',
  'religious.today': 'Bugün',
  'religious.tomorrow': 'Yarın',
  'religious.daysLeft': { one: '{count} gün kaldı', other: '{count} gün kaldı' },
  'religious.passed': 'Geçti',
  'religious.thisFriday': 'Bu haftanın Cuma hutbesi',
  'religious.sermon': 'Cuma Hutbesi',
  'religious.read': 'Oku',
  'religious.listen': 'Dinle',
  'religious.shareStatus': 'Durumumda paylaş',
  'religious.shareBody': '📖 Bu haftanın hutbesi\n{topic}',
  'religious.shareCta': 'Hutbeyi oku',
  'religious.shareNote': 'Eklemek istediğin bir söz (isteğe bağlı)',
  'religious.shareNotePlaceholder': 'Örneğin: Herkesin okumasını tavsiye ederim.',
  'religious.shareHint': 'Durumun 24 saat boyunca kişilerinde görünür; “Hutbeyi oku” düğmesi hutbeyi açar.',
  'religious.shareNow': 'Paylaş',
  'religious.shared': 'Durumunda paylaşıldı. Kişilerin 24 saat boyunca görebilir.',
  'religious.nowPlaying': 'Çalan hutbe',
  'religious.toPlayer': 'Oynatıcıya dön',
  'religious.listenWith': 'Ne ile dinlensin',
  'religious.voiceDijitalApp': 'Seslendirme',
  'religious.voiceRecording': 'Hutbe kaydı',
  'religious.voiceHint': 'DijitalApp seslendirmesi · okunan paragraf işaretlenir, bir paragrafa dokunursan oradan devam eder.',
  'religious.recordingHint': 'Hutbenin kaynaktaki ses kaydı.',
  'religious.upcoming': 'Yaklaşan gün ve geceler',
  'religious.archive': 'Geçmiş hutbeler',
  'religious.showArchive': 'Geçmiş hutbeleri göster',
  'religious.more': 'Daha fazla',
  'religious.hasAudio': 'Sesli hutbe var',
  'religious.credit': 'İçerikler {name} işbirliğiyle sunulmaktadır ·',
  'religious.tools': 'Okuma araçları',
  'religious.pause': 'Duraklat',
  'religious.textSize': 'Yazı boyutu',
  'religious.smaller': 'Yazıyı küçült',
  'religious.larger': 'Yazıyı büyüt',
  'religious.sourceLine': 'Bu hutbe kaynağında da okunabilir:',
  'religious.openAtSource': 'Kaynakta aç',
  'religious.addToCalendar': 'Takvimime ekle',
  'religious.type.kandil': 'Kandil',
  'religious.type.bayram': 'Bayram',
  'religious.type.onemli-gun': 'Önemli gün',
  'admin.tab.religious': 'Önemli Günler',
  'religiousAdmin.title': 'Önemli Gün ve Geceler',
  'religiousAdmin.hint': 'Cuma hutbeleri ve dini günler takvimi ortağın sitesinden kendiliğinden gelir; burada açıp kapatır, otomatik duyuruların saatini ve metnini seçersin.',
  'religiousAdmin.open': 'Bölümü aç',
  'religiousAdmin.enabled': 'Bölüm açık (Market uygulaması, sayfalar ve otomatik duyurular)',
  'religiousAdmin.sourceName': 'Kaynağın adı',
  'religiousAdmin.sourceUrl': 'Kaynak adresi (https)',
  'religiousAdmin.syncSermons': 'Cuma hutbelerini getir (perşembe ve cuma her yarım saatte, diğer günler 6 saatte bir)',
  'religiousAdmin.syncDays': 'Dini günler takvimini getir (günde bir)',
  'religiousAdmin.friday': 'Cuma sabahı hutbe duyurusu',
  'religiousAdmin.fridayHint': 'Cuma günü bu saatte haftanın hutbesi “DijitalApp” duyurusu olarak herkese gider; düğmesi hutbeyi uygulama içinde açar. Hutbe henüz gelmediyse geldiği an gönderilir.',
  'religiousAdmin.daysAnn': 'Kandil ve bayram sabahı duyurusu',
  'religiousAdmin.daysHint': 'Seçili türlerdeki günlerin sabahında bu saatte duyuru gider ({name} günün adıyla değişir).',
  'religiousAdmin.time': 'Saat (Türkiye)',
  'religiousAdmin.background': 'Arka plan',
  'religiousAdmin.annTitle': 'Duyuru başlığı',
  'religiousAdmin.ctaLabel': 'Düğme yazısı',
  'religiousAdmin.titleKandil': 'Kandil başlığı',
  'religiousAdmin.titleBayram': 'Bayram başlığı',
  'religiousAdmin.titleOther': 'Diğer günlerin başlığı',
  'religiousAdmin.saved': 'Kaydedildi.',
  'religiousAdmin.sync': 'Kaynaktan getirme',
  'religiousAdmin.syncState': 'Hutbeler en son: {sermons} · Takvim en son: {days}',
  'religiousAdmin.never': 'henüz değil',
  'religiousAdmin.syncFailed': 'Son getirme başarısız oldu: {message}',
  'religiousAdmin.synced': 'Kaynaktan getirildi.',
  'religiousAdmin.syncSermonsNow': 'Hutbeleri şimdi getir',
  'religiousAdmin.syncDaysNow': 'Takvimi şimdi getir',
  'religiousAdmin.sermons': 'Hutbeler',
  'religiousAdmin.noSermons': 'Henüz hutbe yok; “Hutbeleri şimdi getir”e bas.',
  'religiousAdmin.readers': { one: '{count} kişi okudu', other: '{count} kişi okudu' },
  'religiousAdmin.listeners': { one: '{count} kişi dinledi', other: '{count} kişi dinledi' },
  'religiousAdmin.withAudio': 'Sesli',
  'religiousAdmin.reportHint': 'Okuyan ve dinleyen sayılarına dokununca kimler olduğunu görürsün. Cuma ve kandil duyurularını kimlerin gördüğü:',
  'religiousAdmin.reportAnnouncements': 'Duyurular sekmesi',
  'religiousAdmin.nobodyYet': 'Henüz kimse yok.',
  'religiousAdmin.previewFriday': 'Cuma duyurusu',
  'religiousAdmin.previewDay': 'Kandil / bayram duyurusu',
  'religiousAdmin.previewFridayBody': 'Bu haftanın hutbesi: {topic}',
  'religiousAdmin.previewSampleTopic': 'Birlik ve Beraberlik',
  'religiousAdmin.previewSampleDay': 'Miraç Kandili',
  'religiousAdmin.previewFridayWhen': 'Her cuma {time}’da (Türkiye saati) yayınlanır, gün sonunda kendiliğinden kalkar.',
  'religiousAdmin.previewDayWhen': 'Kandil ve bayram günlerinin sabahı {time}’da yayınlanır, gün sonunda kendiliğinden kalkar.',
  'religiousAdmin.previewOff': 'Bu duyuru şu an kapalı; açmak için yukarıdaki kutuyu işaretleyip kaydet.',
  'religiousAdmin.whereChats': 'Sohbetler listesinin en üstünde, kişi açıp görene kadar DijitalApp duyurusu olarak durur.',
  'religiousAdmin.whereWall': 'Keşfet › Duvar’da durumların başında DijitalApp halkası olarak görünür.',
  'religiousAdmin.whereOpen': 'Dokununca bu önizlemedeki gibi tam ekran açılır; herkes görür, Market’ten eklemiş olmak gerekmez.',
  'religiousAdmin.whereButtonFriday': 'Düğme hutbenin okuma sayfasını açar.',
  'religiousAdmin.whereButtonDay': 'Düğme o günün sayfasını açar.',
  'religiousAdmin.previewHint': 'Yaklaşan içerikle örnek',
  'religiousAdmin.withVoice': 'Seslendirildi',
  'religiousAdmin.voiceWorking': 'Seslendiriliyor…',
  'religiousAdmin.voiceFailed': 'Seslendirilemedi',
  'religiousAdmin.voiceNow': 'Seslendir',
  'religiousAdmin.voiceAgain': 'Yeniden seslendir',
  'religiousAdmin.voiceChars': '{chars} karakter',
  'religiousAdmin.voiceConfirm': '“{topic}” ElevenLabs ile seslendirilsin mi? Yaklaşık {chars} karakter kullanılır (ücretli).',
  'religiousAdmin.voiceAgainConfirm': '“{topic}” yeniden seslendirilsin mi? Önceki seslendirmenin yerine geçer ve yaklaşık {chars} karakter daha kullanılır (ücretli).',
  'religiousAdmin.voiceStarted': 'Seslendirme başladı; bir iki dakika içinde hazır olur. Bu liste kendiliğinden güncellenir.',
  'religiousAdmin.refresh': 'Yeniden çek',
  'religiousAdmin.refreshing': 'Çekiliyor…',
  'religiousAdmin.refreshHint': 'Sadece bu hutbeyi kaynaktan yeniden getirir: sonradan eklenen ses kaydını ve metindeki düzeltmeleri alır.',
  'religiousAdmin.refreshed.added': 'Hutbe yeniden getirildi; ses kaydı eklendi.',
  'religiousAdmin.refreshed.kept': 'Hutbe yeniden getirildi; ses kaydı zaten vardı.',
  'religiousAdmin.refreshed.none': 'Hutbe yeniden getirildi; kaynakta henüz ses kaydı yok.',
  'religiousAdmin.refreshedText': 'Metin değişmiş; eski seslendirme kaldırıldı, istersen yeniden seslendirebilirsin.',
  'religiousAdmin.voice': 'Hutbeleri seslendir (ElevenLabs)',
  'religiousAdmin.voiceNoKey': 'Sunucuda ElevenLabs anahtarı yok. /etc/dijitalapp/api.env dosyasına ELEVENLABS_API_KEY eklenip API yeniden başlatılmalı.',
  'religiousAdmin.voiceHint': 'Cihazın kendi sesi yerine, seçtiğin doğal bir sesle okunur. Her hutbe bir kez seslendirilir ve saklanır; aylık sınırı aşmaz. Hutbenin kaynakta ses kaydı da varsa dinleyen ikisinden birini seçebilir.',
  'religiousAdmin.voiceAuto': 'Yeni gelen ve ses kaydı olmayan hutbeleri kendiliğinden seslendir',
  'religiousAdmin.voiceServerDefault': 'Sunucudaki varsayılan ses',
  'religiousAdmin.voiceNone': 'Henüz ses seçilmedi',
  'religiousAdmin.voiceLoad': 'Hesaptaki sesleri getir',
  'religiousAdmin.voiceEmpty': 'Hesapta ses yok. ElevenLabs’te Ses Kitaplığı’ndan Türkçe bir erkek sesi ekleyip tekrar getir.',
  'religiousAdmin.voiceChoose': 'Ses seç',
  'religiousAdmin.voiceMale': 'Erkek',
  'religiousAdmin.voiceFemale': 'Kadın',
  'religiousAdmin.voiceSample': '{name} örneğini dinle',
  'religiousAdmin.voiceId': 'Ses kimliği (Voice ID)',
  'religiousAdmin.voiceModel': 'Model',
  'religiousAdmin.voiceLimit': 'Aylık karakter sınırı',
  'religiousAdmin.voiceUsed': 'Bu ay kullanılan',
  'religiousAdmin.voiceUsedOf': '{used} / {limit} karakter',
  'religiousAdmin.hidden': 'Gizli',
  'religiousAdmin.view': 'Gör',
  'religiousAdmin.show': 'Göster',
  'religiousAdmin.hide': 'Gizle',
  'religiousAdmin.days': 'Dini günler takvimi',
  'religiousAdmin.addDay': 'Gün ekle',
  'religiousAdmin.dayName': 'Adı',
  'religiousAdmin.dayType': 'Türü',
  'religiousAdmin.dayDate': 'Tarihi',
  'religiousAdmin.dayHijri': 'Hicri tarih',
  'religiousAdmin.dayDescription': 'Açıklama (isteğe bağlı)',
  'religiousAdmin.dayActive': 'Görünsün',
  'religiousAdmin.imported': 'Kaynaktan',
  'religiousAdmin.manual': 'Elle',
  'religiousAdmin.announced': 'Duyuruldu',
  'religiousAdmin.deleteDay': 'Günü sil',
  'religiousAdmin.deleteConfirm': '“{name}” silinsin mi? Kaynaktan gelen bir günse yalnızca gizlenir.',
  'market.app.religious-days.name': 'Önemli Gün ve Geceler',
  'market.app.religious-days.desc': 'Haftanın Cuma hutbesini oku ya da dinle; kandil ve bayramlara kalan günleri gör. İslamiyet.gen.tr işbirliğiyle.',
  'announce.title': 'Duyuru',
  'announce.kind': 'Resmî duyuru',
  'announce.verified': 'Onaylı hesap',
  'announce.watch': 'DijitalApp duyurularını izle',
  'announce.open': 'Gör',
  'announce.mute': 'Sesi kapat',
  'announce.unmute': 'Sesi aç',
  'announce.pause': 'Duraklat',
  'announce.play': 'Devam et',
  'announce.previous': 'Önceki',
  'announce.next': 'Sonraki',
  'announce.like': 'Beğen',
  'announce.unlike': 'Beğenmekten vazgeç',
  'announce.likeCount': { one: '{count} beğeni', other: '{count} beğeni' },
  'announce.reshare': 'Durumumda paylaş',
  'announce.reshared': 'Durumunda paylaşıldı.',
  'announce.reshareCount': { one: '{count} paylaşım', other: '{count} paylaşım' },
  'story.fromOfficial': '{name} duyurusu',
  'story.officialOpen': 'Duyuruyu aç',
  'story.officialGone': 'Bu duyuru artık yayında değil.',
  'admin.tab.announcements': 'Duyurular',
  'announceAdmin.title': 'Duyurular',
  'announceAdmin.hint': 'DijitalApp adıyla herkese duyuru: önemli gün ve geceler, bilgilendirmeler. Keşfet’te ilk durum olarak ve sohbetlerin üstünde kart olarak görünür; kimin gördüğünü, sonuna kadar izlediğini ve düğmeye bastığını buradan izlersin.',
  'announceAdmin.new': 'Yeni duyuru',
  'announceAdmin.empty': 'Henüz duyuru yok.',
  'announceAdmin.saved': 'Duyuru kaydedildi.',
  'announceAdmin.deleted': 'Duyuru silindi.',
  'announceAdmin.deleteConfirm': '“{title}” silinsin mi? İstatistikleri de silinir.',
  'announceAdmin.delete': 'Duyuruyu sil',
  'announceAdmin.titleTr': 'Başlık (Türkçe)',
  'announceAdmin.titleEn': 'Başlık (İngilizce, isteğe bağlı)',
  'announceAdmin.bodyTr': 'Metin (Türkçe)',
  'announceAdmin.bodyEn': 'Metin (İngilizce, isteğe bağlı)',
  'announceAdmin.background': 'Arka plan',
  'announceAdmin.bg.night': 'Gece',
  'announceAdmin.bg.crescent': 'Hilal',
  'announceAdmin.bg.flag': 'Bayrak',
  'announceAdmin.bg.sunrise': 'Gün doğumu',
  'announceAdmin.bg.ocean': 'Okyanus',
  'announceAdmin.bg.forest': 'Orman',
  'announceAdmin.bg.gold': 'Altın',
  'announceAdmin.bg.rose': 'Gül',
  'announceAdmin.bg.brand': 'DijitalApp',
  'announceAdmin.bg.color': 'Düz renk',
  'announceAdmin.image': 'Görsel',
  'announceAdmin.music': 'Müzik',
  'announceAdmin.upload': 'Yükle',
  'announceAdmin.replace': 'Değiştir',
  'announceAdmin.remove': 'Kaldır',
  'announceAdmin.saveFirst': 'Görsel ve müzik eklemek için önce kaydet.',
  'announceAdmin.musicHint': 'MP3, M4A ya da OGG, en fazla 10 MB. Duyuru açıkken döngüyle çalar; izleyen sesi kapatabilir. Kullanım hakkı sende olan müzikleri yükle.',
  'announceAdmin.audioTooBig': 'Müzik dosyası 10 MB’tan büyük olamaz.',
  'announceAdmin.ctaLabel': 'Düğme yazısı',
  'announceAdmin.ctaPlaceholder': 'Göz at',
  'announceAdmin.ctaUrl': 'Düğme bağlantısı',
  'announceAdmin.ctaUrlPlaceholder': 'https://… ya da /onemli-gunler',
  'announceAdmin.ctaUrlHint': 'Uygulama içi bir sayfa (/ ile başlar, ör. /onemli-gunler/hutbe/son) yerinde açılır; https ile başlayan adres yeni sekmede açılır.',
  'announceAdmin.startsAt': 'Başlangıç',
  'announceAdmin.endsAt': 'Bitiş (boş: kaldırana kadar)',
  'announceAdmin.duration': 'Ekranda kalma süresi: {seconds} sn',
  'announceAdmin.plan': 'Kimler görür',
  'announceAdmin.planEveryone': 'Herkes',
  'announceAdmin.pinToChats': 'Sohbetlerin üstünde kart olarak da göster',
  'announceAdmin.allowReactions': 'Beğenilebilsin',
  'announceAdmin.allowReshare': 'Kişiler kendi durumlarında paylaşabilsin',
  'announceAdmin.interactionsHint': 'Kapatınca yeni beğeni ya da paylaşım alınmaz; paylaşımı kapatmak, onu paylaşan durumları da kaldırır. Bir plana ya da bir gruba özel duyurular durumlarda paylaşılamaz.',
  'announceAdmin.kpiLikes': 'Beğeni',
  'announceAdmin.kpiReshares': 'Durumlarda paylaşım',
  'announceAdmin.interactions': 'Beğeni ve paylaşım',
  'announceAdmin.active': 'Yayında (başlangıç saatinde herkese görünür)',
  'announceAdmin.back': 'Listeye dön',
  'announceAdmin.preview': 'Önizleme',
  'announceAdmin.previewHint': 'Kişilerin göreceği hâli',
  'announceAdmin.phase.live': 'Yayında',
  'announceAdmin.phase.scheduled': 'Planlandı',
  'announceAdmin.phase.ended': 'Bitti',
  'announceAdmin.phase.draft': 'Taslak',
  'announceAdmin.stats': 'İstatistik',
  'announceAdmin.kpiViewers': 'kişi gördü',
  'announceAdmin.kpiCompleted': 'sonuna kadar izledi',
  'announceAdmin.kpiClickers': 'kişi düğmeye bastı ({clicks} tıklama)',
  'announceAdmin.whoSaw': 'Kimler gördü',
  'announceAdmin.filter.all': 'Görenler',
  'announceAdmin.filter.completed': 'Sonuna kadar izleyenler',
  'announceAdmin.filter.clicked': 'Düğmeye basanlar',
  'announceAdmin.nobody': 'Henüz kimse yok.',
  'announceAdmin.tagCompleted': 'Sonuna kadar',
  'announceAdmin.tagClicked': '{count} tıklama',
  'announceAdmin.more': 'Daha fazla göster',
  'statusAdmin.title': 'Durumlar',
  'statusAdmin.hint': 'Kişilerin seçtiği durumlar: adları, açıklamaları, ikon ve renkleri, ne işe yaradıkları ve kimlerin seçebileceği. Yerleşik dört durum silinemez; metinleri, ikonu ve rengi değiştirilebilir.',
  'statusAdmin.new': 'Yeni durum',
  'statusAdmin.newName': 'Yeni durum',
  'statusAdmin.descPlaceholder': 'Açıklama',
  'statusAdmin.saved': 'Durum kaydedildi.',
  'statusAdmin.deleted': 'Durum silindi; kullananlar otomatiğe döndü.',
  'statusAdmin.deleteConfirm': '“{name}” silinsin mi? Kullananlar otomatik duruma döner.',
  'statusAdmin.delete': 'Durumu sil',
  'statusAdmin.builtIn': 'Yerleşik',
  'statusAdmin.off': 'Kapalı',
  'statusAdmin.inUse': 'Şu an {count} kişi kullanıyor',
  'statusAdmin.chosenCount': 'Seçili {count} kişi',
  'statusAdmin.behavior': 'Ne yapar',
  'statusAdmin.behavior.dnd': 'Bildirimleri susturur',
  'statusAdmin.behavior.busy': 'Meşgul görünür',
  'statusAdmin.behavior.away': 'Uzakta görünür',
  'statusAdmin.behavior.invisible': 'Çevrimdışı görünür',
  'statusAdmin.behaviorHint.dnd': 'Mesaj bildirimleri ve sesleri susar, aramalar yine gelir; fotoğrafta kırmızı nokta.',
  'statusAdmin.behaviorHint.busy': 'Yalnızca görünür; fotoğrafta durumun renginde nokta.',
  'statusAdmin.behaviorHint.away': 'Yalnızca görünür; fotoğrafta durumun renginde nokta.',
  'statusAdmin.behaviorHint.invisible': 'Kişi başkalarına çevrimdışı görünür.',
  'statusAdmin.plan': 'Kimler seçebilir (plan)',
  'statusAdmin.planEveryone': 'Herkes',
  'statusAdmin.audience': 'Kimlere açık',
  'statusAdmin.audienceEveryone': 'Herkese',
  'statusAdmin.audienceChosen': 'Yalnızca seçtiğim kişilere',
  'statusAdmin.active': 'Açık (kişiler seçebilir)',
  'status.plan.plus': 'Plus',
  'status.plan.business': 'Business',
  'status.plan.premium': 'Premium',
  'badges.giveTitle': 'Rozet ver',
  'badges.who': 'Kime',
  'badges.whoPlaceholder': 'Ad soyad ya da kullanıcı adı yaz…',
  'badges.addMore': 'Başka kişi ekle…',
  'badges.removePerson': '{name} kişisini çıkar',
  'badges.alreadyHas': 'Bu rozet var',
  'badges.nobody': 'Bu isimde kimse bulunamadı.',
  'badges.which': 'Hangi rozet',
  'badges.giveMany': 'Rozeti {count} kişiye ver',
  'badges.grantedMany': 'Rozet {count} kişiye verildi.',
  'badges.renewNote': '{count} kişide bu rozet zaten var: süresi ve notu yenilenir.',
  'badges.user': 'Kullanıcı',
  'badges.type': 'Rozet',
  'badges.duration': 'Süre',
  'badges.duration.forever': 'Süresiz',
  'badges.duration.m1': '1 ay',
  'badges.duration.m3': '3 ay',
  'badges.duration.m6': '6 ay',
  'badges.duration.y1': '1 yıl',
  'badges.duration.custom': 'Tarih seç',
  'badges.until': 'Bitiş tarihi',
  'badges.note': 'İç not',
  'badges.notePlaceholder': 'Neden verildi, belge no… (kullanıcılar görmez)',
  'badges.give': 'Rozeti ver',
  'badges.granted': 'Rozet verildi; kişinin adının yanında hemen görünür.',
  'badges.typesTitle': 'Rozet türleri',
  'badges.typesHint': 'Her rengin tek bir anlamı olsun: mavi doğrulanmış kişi, altın kurum, yeşil okul, gri resmî hesap, mor içerik üreticisi, kırmızı DijitalApp ekibi. Sıra numarası küçük olan önce gösterilir.',
  'badges.newType': 'Yeni rozet türü',
  'badges.holders': { one: '{count} kişide', other: '{count} kişide' },
  'badges.order': 'Sıra {n}',
  'badges.orderLabel': 'Sıra',
  'badges.off': 'Kapalı',
  'badges.edit': 'Düzenle',
  'badges.remove': 'Sil',
  'badges.deleteConfirm': '“{name}” rozet türü silinsin mi?',
  'badges.deactivateConfirm': '“{name}” rozeti verilmiş kişiler var. Silinemez ama kapatılabilir; kapatılsın mı? (Geçmiş kayıtlar kalır.)',
  'badges.saved': 'Kaydedildi.',
  'badges.sampleName': 'Ayşe Demir',
  'badges.slug': 'Kısa ad (değiştirilemez)',
  'badges.nameTr': 'Ad (Türkçe)',
  'badges.nameEn': 'Ad (İngilizce)',
  'badges.descTr': 'Anlamı (Türkçe)',
  'badges.descEn': 'Anlamı (İngilizce)',
  'badges.orderHint': 'Birden fazla rozeti olan kişide en küçük sıradaki gösterilir.',
  'badges.color': 'Renk',
  'badges.customColor': 'Özel renk',
  'badges.icon': 'Simge',
  'badges.active': 'Açık (kapalı rozetler hiçbir yerde görünmez)',
  'badges.holdersTitle': 'Rozet sahipleri',
  'badges.allTypes': 'Tüm rozetler',
  'badges.search': 'Ad ya da @kullanıcı adı ara',
  'badges.showPast': 'Süresi dolan ve geri alınanları da göster',
  'badges.noHolders': 'Bu rozete sahip kimse yok.',
  'badges.state.forever': 'süresiz',
  'badges.state.until': '{date} tarihine kadar',
  'badges.state.expired': 'süresi {date} tarihinde doldu',
  'badges.state.revoked': '{date} tarihinde geri alındı',
  'badges.givenBy': 'veren {who}, {date}',
  'badges.changeDate': 'Süreyi değiştir',
  'badges.revoke': 'Geri al',
  'badges.revokeConfirm': '{name} kişisinin rozeti geri alınsın mı?',
  'badges.revoked': 'Rozet geri alındı.',
  'siteField.meta': 'Arama motoru bilgileri',
  'siteField.title': 'Başlık',
  'siteField.description': 'Açıklama',
  'siteField.labels': 'Etiketler',
  'siteField.comingSoon': 'Yakında etiketi',
  'siteField.available': 'Kullanılabilir etiketi',
  'siteField.signIn': 'Giriş düğmesi',
  'siteField.start': 'Kayıt düğmesi',
  'siteField.menu': 'Menü',
  'siteField.otherLanguage': 'Diğer dil bağlantısı',
  'siteField.skip': 'İçeriğe geç bağlantısı',
  'siteField.theme': 'Tema düğmesi',
  'siteField.toTop': 'Yukarı çık düğmesi',
  'siteField.home': 'Ana sayfa (mobil alt menü)',
  'siteField.nav': 'Üst menü',
  'siteField.product': 'Ürün',
  'siteField.security': 'Güvenlik',
  'siteField.business': 'Business',
  'siteField.plus': 'Plus',
  'siteField.apps': 'Uygulamalar',
  'siteField.faq': 'Sorular',
  'siteField.hero': 'Giriş bölümü',
  'siteField.eyebrow': 'Üst satır',
  'siteField.lead': 'Açıklama metni',
  'siteField.primary': 'Ana düğme',
  'siteField.secondary': 'İkinci düğme',
  'siteField.label': 'Yazı',
  'siteField.url': 'Bağlantı',
  'siteField.notes': 'Küçük notlar',
  'siteField.visible': 'Bu bölümü göster',
  'siteField.kicker': 'Üst başlık',
  'siteField.rows': 'Satırlar',
  'siteField.visual': 'Görsel',
  'siteField.visual.chat': 'Sohbet ekranı',
  'siteField.visual.spaces': 'Alan ekranı',
  'siteField.visual.learn': 'Eğitim ekranı',
  'siteField.visual.calendar': 'Takvim ekranı',
  'siteField.points': 'Maddeler',
  'siteField.body': 'Metin',
  'siteField.items': 'Öğeler',
  'siteField.assistant': 'DijitalApp Asistan',
  'siteField.demoQuestion': 'Örnek soru',
  'siteField.demoAnswer': 'Örnek yanıt',
  'siteField.demoSource': 'Örnek kaynak',
  'siteField.plans': 'Paketler',
  'siteField.name': 'Ad',
  'siteField.price': 'Fiyat',
  'siteField.note': 'Not',
  'siteField.status': 'Durum',
  'siteField.status.available': 'Kullanılabilir',
  'siteField.status.soon': 'Yakında',
  'siteField.features': 'Özellikler',
  'siteField.cta': 'Düğme',
  'siteField.kind': 'Tür',
  'siteField.kind.web': 'Web',
  'siteField.kind.pwa': 'Ana ekran uygulaması',
  'siteField.kind.ios': 'App Store',
  'siteField.kind.android': 'Google Play',
  'siteField.kind.huawei': 'AppGallery',
  'siteField.q': 'Soru',
  'siteField.a': 'Yanıt',
  'siteField.final': 'Kapanış',
  'siteField.footer': 'Alt bilgi',
  'siteField.tagline': 'Kısa tanım',
  'siteField.contactEmail': 'İletişim e-postası',
  'siteField.columns': 'Sütunlar',
  'siteField.links': 'Bağlantılar',
  'siteField.item': 'Madde',
  'qr.modes': 'Giriş yöntemi',
  'qr.withPassword': 'Şifreyle',
  'qr.withPhone': 'Telefonla (QR)',
  'qr.codeLabel': 'Giriş için QR kodu',
  'qr.step1': 'Telefonunda DijitalApp’i aç.',
  'qr.step2': 'Ayarlar → Cihazlar → “QR kodu okut”a dokun ya da telefon kamerasıyla bu kodu okut.',
  'qr.step3': 'Telefonda girişi onayla; bu bilgisayarda oturumun açılır.',
  'qr.desktopSafety': 'Kod iki dakika geçerlidir ve yalnız bir kez kullanılır. Ortak bir bilgisayardaysan işin bitince çıkış yap.',
  'qr.newCode': 'Yeni kod oluştur',
  'qr.declined': 'Giriş telefondan reddedildi.',
  'qr.paused': 'Kodun süresi doldu.',
  'qr.invalid': 'Bu bağlantı geçersiz.',
  'qr.expired': 'Bu kodun süresi dolmuş ya da kullanılmış. Bilgisayardaki yeni kodu okut.',
  'qr.askTitle': 'Bu bilgisayarda {brand}’e giriş yapılsın mı?',
  'qr.device': 'Cihaz',
  'qr.address': 'IP adresi',
  'qr.when': 'İstek saati',
  'qr.unknownDevice': 'Bilinmeyen tarayıcı',
  'qr.phoneSafety': 'Yalnız kendi önündeki bilgisayarda, web.dijitalapp.com adresinde gördüğün kodu onayla. Biri sana bir QR kodu gönderip okutmanı istediyse onaylama: o kişi hesabına girer.',
  'qr.approve': 'Girişi onayla',
  'qr.decline': 'Reddet',
  'qr.approvedTitle': 'Bilgisayarında oturum açıldı',
  'qr.approvedBody': 'Bu oturumu istediğin zaman Ayarlar → Cihazlar’dan kapatabilirsin.',
  'qr.seeDevices': 'Cihazları gör',
  'qr.declinedTitle': 'Giriş reddedildi',
  'qr.errorTitle': 'Kod kullanılamadı',
  'qr.scan': 'QR kodu okut',
  'qr.scanHint': 'Bilgisayardaki DijitalApp giriş ekranında görünen kodu çerçeveye getir.',
  'qr.noScanner': 'Bu tarayıcı uygulama içinden QR okuyamıyor. Telefonunun kamera uygulamasını açıp bilgisayardaki koda tut; açılan bağlantı seni buraya getirir.',
  'qr.cameraDenied': 'Kameraya izin verilmedi. Tarayıcı ayarlarından kamera iznini aç ya da telefonunun kamera uygulamasıyla okut.',
  'qr.linkTitle': 'Bilgisayarda oturum aç',
  'qr.linkBody': 'Bilgisayarında web.dijitalapp.com’u aç, “Telefonla (QR)” sekmesindeki kodu buradan okut.',
  'qr.openOnPhone': 'Telefonda devam et',
  'qr.openOnPhoneBody': 'Kodu telefonunun kamerasıyla okut; kayıt telefonda açılır.',
  'assistant.title': 'DijitalApp Asistan',
  'assistant.entryBody': 'Kurumunuzun belgeleriyle yanıt veren, kaynak gösteren ve bilmediğini ekibinize devreden asistan.',
  'assistant.manage': 'Asistanı yönet',
  'assistant.backToSpace': 'Alana dön',
  'assistant.notAllowed': 'Bu alanın asistanını yalnız sahipleri ve yöneticileri, Business özelliği açıkken yönetebilir.',
  'assistant.on': 'Açık',
  'assistant.off': 'Kapalı',
  'assistant.stat.status': 'Durum',
  'assistant.stat.sources': 'Bilgi kaynağı',
  'assistant.stat.questions': 'Soru',
  'assistant.stat.unanswered': 'Yanıtlanamayan',
  'assistant.tab.sources': 'Bilgi kaynakları',
  'assistant.tab.test': 'Dene',
  'assistant.tab.settings': 'Ayarlar',
  'assistant.tab.unanswered': 'Yanıtlanamayanlar',
  'assistant.gettingStarted': 'Başlamak için önce Ayarlar’ı kaydedin, sonra metin, SSS ya da web sayfası ekleyin ve Dene sekmesinden sorular sorun.',
  'assistant.setupTitle': 'Sunucu kurulumu tamamlanmadı',
  'assistant.noAi': 'Yanıt üretimi kapalı: sunucuya Anthropic API anahtarı eklenince asistan yanıt vermeye başlar. O zamana kadar Dene sekmesi hangi kaynakların kullanılacağını gösterir.',
  'assistant.noEmbeddings': 'Anlamsal arama kapalı: Voyage AI anahtarı eklenince kaynaklar anlamına göre de aranır. Şimdilik kelime araması kullanılıyor; eklenen her şey anahtar gelince kendiliğinden işlenir.',
  'assistant.addSource': 'Bilgi kaynağı ekle',
  'assistant.saveSettingsFirst': 'Kaynak eklemeden önce Ayarlar sekmesinde asistanı bir kez kaydedin.',
  'assistant.sourceKind': 'Kaynak türü',
  'assistant.kind.text': 'Metin',
  'assistant.kind.faq': 'SSS',
  'assistant.kind.url': 'Web sayfası',
  'assistant.kindHint.text': 'Yönerge, duyuru, fiyat listesi gibi metinleri yapıştırın. Uzun metinler parçalara ayrılır.',
  'assistant.kindHint.faq': 'Soru–yanıt çiftleri. Her çift ayrı aranır, en isabetli sonuçları verir.',
  'assistant.kindHint.url': 'Herkese açık bir sayfanın metni okunur. Sayfa değişirse “Yeniden işle” deyin.',
  'assistant.url': 'Sayfa adresi',
  'assistant.sourceTitle': 'Başlık',
  'assistant.content': 'Metin',
  'assistant.question': 'Soru',
  'assistant.answer': 'Yanıt',
  'assistant.addPair': 'Soru ekle',
  'assistant.removePair': 'Bu soruyu kaldır',
  'assistant.add': 'Ekle ve işle',
  'assistant.indexing': 'İşleniyor…',
  'assistant.sources': 'Kaynaklar ({count})',
  'assistant.noSources': 'Henüz bilgi kaynağı yok.',
  'assistant.chunks': '{count} parça',
  'assistant.embedded': '{count} vektör',
  'assistant.status.ready': 'Hazır',
  'assistant.status.failed': 'Hata',
  'assistant.status.queued': 'Sırada',
  'assistant.reindex': 'Yeniden işle',
  'assistant.delete': 'Sil',
  'assistant.testTitle': '{name} ile deneyin',
  'assistant.testHint': 'Ziyaretçilerin kullanacağı akışın aynısı: yalnız eklediğiniz kaynaklardan yanıt verir ve kaynağını gösterir.',
  'assistant.newChat': 'Yeni sohbet',
  'assistant.thinking': 'Yanıt hazırlanıyor…',
  'assistant.retrievalOnly': 'Yanıt üretimi henüz kapalı. Bu soru için kullanılacak kaynaklar:',
  'assistant.handedOver': 'Ekibe devredildi',
  'assistant.askLabel': 'Bir soru yazın',
  'assistant.send': 'Gönder',
  'assistant.basics': 'Temel bilgiler',
  'assistant.behaviour': 'Davranış',
  'assistant.field.enabled': 'Asistan açık',
  'assistant.field.name': 'Asistanın adı',
  'assistant.field.tone': 'Üslup',
  'assistant.field.welcome': 'Karşılama mesajı',
  'assistant.field.handoffMessage': 'Devir mesajı',
  'assistant.field.blockedTopics': 'Girmeyeceği konular',
  'assistant.field.instructions': 'Ek talimatlar',
  'assistant.fieldHint.name': 'Ziyaretçiler bu adı görür.',
  'assistant.fieldHint.welcome': 'Sohbet açılınca gösterilir.',
  'assistant.fieldHint.handoffMessage': 'Yanıt kaynaklarda yoksa gösterilir; boş bırakılırsa standart mesaj kullanılır.',
  'assistant.fieldHint.blockedTopics': 'Virgülle ayırın; ör. siyaset, sağlık tavsiyesi. Bu konularda kibarca bir çalışana yönlendirir.',
  'assistant.fieldHint.instructions': 'Kurumunuza özel kurallar (ör. “Fiyat sorulursa güncel liste için mağazaya yönlendir”). Güvenlik ve kaynak kurallarını değiştiremez.',
  'assistant.tone.friendly': 'Samimi',
  'assistant.tone.formal': 'Resmî',
  'assistant.tone.concise': 'Kısa ve net',
  'assistant.save': 'Kaydet',
  'assistant.saved': 'Kaydedildi.',
  'assistant.unansweredHint': 'Asistanın kaynaklarda bulamadığı sorular. Bunlara yanıt veren bir SSS ekleyerek bilgi tabanınızı tamamlayın.',
  'assistant.noUnanswered': 'Yanıtlanamayan soru yok.',
  'assistant.times': '{count} kez',
  'admin.tab.appearance': 'Site görünümü',
  'appearance.defaultsLive': 'Varsayılan görünüm yayında (henüz değiştirilmedi)',
  'appearance.saved': 'Kaydedildi ve dijitalapp.com’da yayına alındı.',
  'appearance.restored': 'Seçilen sürüm geri yüklendi ve yayına alındı.',
  'appearance.theme': 'Hazır tema',
  'appearance.preset.clean': 'A · Sade / Kurumsal',
  'appearance.preset.warm': 'B · Sıcak / Aile odaklı',
  'appearance.preset.bold': 'C · Cesur / Teknoloji',
  'appearance.presetDesc.clean': 'Lacivert yazı, tek mavi vurgu, bol beyaz alan.',
  'appearance.presetDesc.warm': 'Krem zemin, kiremit ve yeşil, tırnaklı başlıklar.',
  'appearance.presetDesc.bold': 'Dev başlıklar, kalın çerçeveler, fosforlu yeşil.',
  'appearance.colours': 'Renkler',
  'appearance.coloursHint': 'Değiştirmediğin renkler temanın kendi rengini kullanır; koyu temada vurgu renkleri otomatik açılır.',
  'appearance.colour.accent': 'Vurgu rengi',
  'appearance.colour.secondary': 'İkinci renk',
  'appearance.colour.background': 'Zemin',
  'appearance.colour.text': 'Yazı',
  'appearance.custom': 'özel',
  'appearance.fromTheme': 'temadan',
  'appearance.useTheme': 'Temanın rengi',
  'appearance.shape': 'Yazı ve köşeler',
  'appearance.headingFont': 'Başlık yazı tipi',
  'appearance.font.preset': 'Temanın',
  'appearance.font.serif': 'Tırnaklı',
  'appearance.font.sans': 'Sade',
  'appearance.font.heavy': 'Kalın',
  'appearance.radius': 'Köşe yuvarlaklığı',
  'appearance.radiusOpt.preset': 'Temanın',
  'appearance.radiusOpt.sharp': 'Keskin',
  'appearance.radiusOpt.soft': 'Yumuşak',
  'appearance.radiusOpt.round': 'Yuvarlak',
  'appearance.hero': 'Giriş düzeni',
  'appearance.heroVisual': 'Görsel',
  'appearance.visual.preset': 'Temanın',
  'appearance.visual.phone': 'Telefon',
  'appearance.visual.desktop': 'Bilgisayar ekranı',
  'appearance.heroAlign': 'Yerleşim',
  'appearance.align.preset': 'Temanın',
  'appearance.align.split': 'Yan yana',
  'appearance.align.center': 'Ortalı',
  'appearance.order': 'Bölüm sırası',
  'appearance.orderHint': 'Giriş bölümü en üstte, kapanış ve alt bilgi en altta kalır. Bir bölümü gizlemek için Web sitesi sekmesini kullan.',
  'appearance.preview': 'Canlı önizleme',
  'appearance.unsaved': 'Kaydedilmedi',
  'appearance.device': 'Cihaz',
  'appearance.deviceOpt.desktop': 'Masaüstü',
  'appearance.deviceOpt.tablet': 'Tablet',
  'appearance.deviceOpt.phone': 'Telefon',
  'appearance.previewHint': 'Önizleme yalnız sana görünür; “Kaydet ve yayınla” deyince dijitalapp.com güncellenir.',
  // Market apps outside the Market: the Uygulamalar tab, the home screen (/apps) and the dock.
  'nav.apps': 'Uygulamalar',
  'nav.appUpdates': { one: '{count} güncelleme', other: '{count} güncelleme' },
  'nav.spacesDesc': 'Aile, okul, topluluk ve iş alanların',
  'apps.title': 'Uygulamalar',
  'apps.subtitle': 'Market’ten eklediğin uygulamalar, tek dokunuş uzağında.',
  'apps.search': 'Uygulamalarında ara',
  'apps.results': 'Arama sonuçları',
  'apps.pinned': 'Sabitlenenler',
  'apps.mostUsed': 'En çok kullandıkların',
  'apps.others': 'Diğer uygulamaların',
  'apps.all': 'Tüm uygulamaların',
  'apps.noResults': '“{query}” ile eşleşen bir uygulaman yok.',
  'apps.empty.title': 'Henüz uygulama eklemedin',
  'apps.empty.body': 'Pusula, hava durumu, radyo, oyunlar ve daha fazlası Market’te seni bekliyor.',
  'apps.goMarket': 'Market’e git',
  'apps.goMarketDesc': 'Yeni uygulamalar keşfet, sevdiklerini ekle.',
  'apps.updatesWaiting': { one: 'Bir uygulamanın yeni sürümü çıktı', other: '{count} uygulamanın yeni sürümü çıktı' },
  'apps.updates': { one: 'Güncellemeler ({count})', other: 'Güncellemeler ({count})' },
  'apps.withUpdate': '{name}, yeni sürüm var',
  'apps.hint': 'Seçenekler için bir simgeye basılı tut ya da sağ tıkla.',
  'apps.menu.label': '{name} seçenekleri',
  'apps.menu.open': 'Aç',
  'apps.menu.pin': 'Sabitle',
  'apps.menu.unpin': 'Sabitlemeyi kaldır',
  'apps.menu.addDock': 'Rafa ekle',
  'apps.menu.removeDock': 'Raftan çıkar',
  'apps.menu.page': 'Uygulama sayfası',
  'apps.menu.uninstall': 'Kaldır',
  'apps.uninstallConfirm': '{name} kaldırılsın mı? İstediğin zaman Market’ten yeniden ekleyebilirsin.',
  'dock.label': 'Uygulama rafı',
  'dock.allApps': 'Tüm uygulamalar',
  'dock.isOpen': 'açık',
  'dock.position': 'Konum',
  'dock.position.bottom': 'Alt',
  'dock.position.left': 'Sol',
  'dock.position.right': 'Sağ',
  'dock.options': 'Raf seçenekleri',
  'dock.autoHide': 'Otomatik gizle',
  'dock.close': 'Rafı kapat',
  'dock.closedNote': 'Raf kapatıldı. Ayarlar › Görünüm’den yeniden açabilirsin.',
  'dock.undo': 'Geri al',
  'dock.keysHint': 'Ok tuşlarıyla gez, Enter ile aç. Alt ve ok tuşlarıyla sırasını değiştir, Delete ile raftan çıkar.',
  'dock.dropRemove': 'Bırak, raftan çıksın',
  'dock.removed': '{name} raftan çıkarıldı',
  'dock.moved': '{name}, {position}/{count}. sırada',
  'dock.settings.title': 'Uygulama rafı',
  'dock.settings.desc': 'Uygulamaların Market’teki Uygulamalarım rafında, telefonda Uygulamalar sekmesinde. İstersen bilgisayar ve tablette ekranın kenarında da bir raf gösterebilirsin.',
  'dock.settings.enabled': 'Ekranın kenarında uygulama rafı göster',
  'dock.settings.autoHideDesc': 'Raf kenara çekilir; imleci o kenara götürünce geri gelir.',
  'dock.settings.apps': 'Raftaki uygulamalar',
  'dock.settings.auto': 'Otomatik seçiliyor: sabitlediklerin, yoksa en çok açtıkların.',
  'dock.settings.custom': { one: 'Rafta senin seçtiğin {count} uygulama var.', other: 'Rafta senin seçtiğin {count} uygulama var.' },
  'dock.settings.reset': 'Otomatik seçime dön',
  'dock.settings.manage': 'Uygulamalarımı düzenle',
  'dock.settings.hint': 'Sırayı rafta sürükleyerek değiştir, rafın dışına sürükleyip bırakınca çıkar. Sağ tık daha fazla seçenek açar.',
  'dock.minimize': 'Rafı küçült',
  'dock.restore': 'Rafı göster',
  'dock.controls': 'Raf düğmeleri',
  'dock.settings.notHere': 'Bu cihazda raf gösterilmiyor (platform ayarı). Seçimin diğer cihazlarında geçerli.',
  'dock.settings.max': 'Rafta en fazla {count} uygulama olabilir.',
  'adminDock.title': 'Uygulama rafı',
  'adminDock.desc': 'Ekranın kenarındaki raf ve Market’teki Uygulamalarım rafı: herkes için varsayılanlar, özellikler ve cihazlar. Kişiler yalnızca izin verdiklerini değiştirebilir.',
  'adminDock.preview': 'Önizleme',
  'adminDock.previewHint': 'İmleci simgelerin üzerinde gezdir, bir simgeye tıkla: raf seçtiğin ayarlarla, varsayılan konumunda çalışır.',
  'adminDock.save': 'Kaydet',
  'adminDock.saved': 'Uygulama rafı ayarları kaydedildi',
  'adminDock.confirmTitle': 'Raf ayarları kaydedilsin mi?',
  'adminDock.confirmBody': 'Değişiklik herkese hemen uygulanır. Kişilerin kendi seçimleri yalnızca izin verdiğin ölçüde geçerli kalır.',
  'adminDock.reset': 'Varsayılanlar',
  'adminDock.resetTitle': 'Varsayılanlara dönülsün mü?',
  'adminDock.resetBody': 'Tüm raf ayarları ilk hâline döner; kaydetmeden önce önizlemede görebilirsin.',
  'adminDock.g.defaults': 'Varsayılanlar',
  'adminDock.g.defaultsHint': 'Henüz kendi seçimini yapmamış herkes için.',
  'adminDock.defaultEnabled': 'Raf varsayılan olarak açık',
  'adminDock.defaultEnabledHint': 'Kapalıyken herkes Ayarlar › Görünüm’den kendisi açabilir.',
  'adminDock.defaultPosition': 'Varsayılan konum',
  'adminDock.defaultAutoHide': 'Varsayılan olarak otomatik gizle',
  'adminDock.g.people': 'Kişilerin değiştirebilecekleri',
  'adminDock.g.peopleHint': 'Kapattığın ayar kişilerin ekranından kalkar; herkes için varsayılan geçerli olur.',
  'adminDock.userPosition': 'Konumu değiştirebilsinler',
  'adminDock.userPositionHint': 'Alt, sol ya da sağ.',
  'adminDock.userAutoHide': 'Otomatik gizlemeyi açabilsinler',
  'adminDock.userAutoHideHint': 'Raf kenara çekilir, imleç o kenara gelince geri döner.',
  'adminDock.g.features': 'Özellikler',
  'adminDock.magnify': 'Büyüteç',
  'adminDock.magnifyHint': 'İmlecin yakınındaki simgeler büyür, Mac’teki gibi.',
  'adminDock.maxScale': 'En büyük boyut',
  'adminDock.bounce': 'Açılış zıplaması',
  'adminDock.bounceHint': 'Uygulama açılırken simgesi zıplar.',
  'adminDock.reorder': 'Sürükleyerek sıralama',
  'adminDock.reorderHint': 'Rafta ve Market rafında simgeleri sürükleyip yer değiştirme.',
  'adminDock.dragRemove': 'Dışarı sürükleyerek çıkarma',
  'adminDock.dragRemoveHint': 'Raftan dışarı bırakılan simge raftan çıkar.',
  'adminDock.controls': 'Küçült ve kapat düğmeleri',
  'adminDock.controlsHint': 'Rafın ucunda iki küçük düğme: kenarda bir tutamağa küçült ya da rafı kapat.',
  'adminDock.maxApps': 'Raftaki en fazla uygulama',
  'adminDock.maxAppsHint': '{min}–{max} arası; Uygulamalar ve Market düğmeleri sayılmaz.',
  'adminDock.fewer': 'Azalt',
  'adminDock.more': 'Artır',
  'adminDock.g.devices': 'Kenar rafı hangi cihazlarda',
  'adminDock.g.devicesHint': 'Telefonlarda Uygulamalar sekmesi var; raf orada varsayılan olarak kapalı.',
  'adminDock.nowhere': 'Raf hiçbir cihazda görünmeyecek.',
  'adminDock.device.desktop': 'Bilgisayar',
  'adminDock.device.tablet': 'Tablet',
  'adminDock.device.phone': 'Telefon',
  'adminDock.on': 'Açık',
  'adminDock.off': 'Kapalı',
  'adminDock.g.shelf': 'Market rafı (Uygulamalarım)',
  'adminDock.g.shelfHint': 'Market’in üstünde uygulamaların raf gibi dizildiği bölüm; kapalıyken yerine ızgara görünür.',
  'adminDock.shelf': 'Market rafını göster',
  'adminDock.shelfMagnify': 'Market rafında büyüteç',
  'adminDock.sum.onByDefault': 'Varsayılan: açık',
  'adminDock.sum.offByDefault': 'Varsayılan: kapalı',
  'adminDock.sum.maxApps': 'En fazla {count} uygulama',
  'shelf.label': 'Uygulamalarım',
  'shelf.keysHint': 'Ok tuşlarıyla gez, Enter ile aç. Alt ve ok tuşlarıyla sırasını değiştir; ayraçtan öteye taşıyınca sabitlenir ya da sabitlemesi kalkar. Shift+F10 seçenekleri açar.',
  'shelf.hint': 'Sürükleyerek sırala; en başa, ayracın önüne taşıdığın uygulamalar sabitlenir. Sağ tık daha fazla seçenek açar.',
  'shelf.pinned': '{name} sabitlendi',
  'shelf.unpinned': '{name} artık sabit değil',
  'shelf.isPinned': 'sabit',
  'shelf.pinnedApart': 'Sabitlenenler ve diğerleri',
  'reinstall.title': 'Uygulamayı yenileyelim',
  'reinstall.body': 'Ekranın üstündeki bulanıklığı gidermek için DijitalApp’i ana ekrandan kaldırıp Safari’den yeniden ekle.',
  'reinstall.step1': 'Ana ekranda DijitalApp simgesine basılı tut',
  'reinstall.step1Sub': '“Uygulamayı Sil” ya da “Ana Ekrandan Kaldır”ı seç.',
  'reinstall.step2': 'Safari’de web.dijitalapp.com’u aç',
  'reinstall.step3': 'Paylaş › Ana Ekrana Ekle',
  'reinstall.note': 'Yeniden ekledikten sonra bir kez giriş yapman gerekir; eski şifreli mesajların için yedek parolan istenebilir. Sohbetlerin hesabında olduğu gibi kalır.',
  'reinstall.ok': 'Tamam',
  'reinstall.later': 'Daha sonra',
  // ---- admin panel design system (components/admin/ui.tsx) ----
  'adminUi.clearSearch': 'Aramayı temizle',
  'adminUi.rowActions': 'İşlemler',
  'adminUi.selectAll': 'Tümünü seç',
  'adminUi.more': 'Daha fazla göster',
  'adminUi.inMinutes': { one: '{count} dk sonra', other: '{count} dk sonra' },
  'adminUi.inHours': { one: '{count} sa sonra', other: '{count} sa sonra' },
  'adminUi.inDays': { one: '{count} gün sonra', other: '{count} gün sonra' },
  'adminUi.refresh': 'Yenile',
  'adminUi.all': 'Tümü',
  'adminUi.desc.system': 'Sunucu, veritabanı, e-posta ve aramaların anlık durumu.',
  'adminUi.desc.analytics': 'Büyüme, etkinlik ve kullanım eğilimleri.',
  'adminUi.desc.users': 'Hesapları bul, incele ve yönet.',
  'adminUi.desc.staff': 'Ekip rolleri ve her rolün yetkileri.',
  'adminUi.desc.reports': 'Gelen şikâyetleri incele, karar ver ve not düş.',
  'adminUi.desc.safety': 'Çocuk güvenliği incelemeleri ve aile ayarları.',
  'adminUi.desc.invites': 'Davet kodları, davetle katılanlar ve sohbet listesindeki davet şeridi.',
  'adminUi.desc.schools': 'Okul başvurularını onayla ya da reddet.',
  'adminUi.desc.usernames': 'Ayrılmış ve yasaklı kullanıcı adı kuralları.',
  'adminUi.desc.badges': 'Rozet türleri ve kişilere verilen rozetler.',
  'adminUi.desc.statuses': 'Kişilerin seçebileceği durumlar.',
  'adminUi.desc.announcements': 'Uygulama içi duyurular ve hedefleri.',
  'adminUi.desc.religious': 'Önemli gün ve gecelerin takvimi ve içerikleri.',
  'adminUi.desc.feedback': 'Kullanıcılardan gelen geri bildirimler.',
  'adminUi.desc.help': 'Yardım merkezi makaleleri ve kategorileri.',
  'adminUi.desc.ads': 'Reklam alanları, kampanyalar ve sonuçları.',
  'adminUi.desc.market': 'Market uygulamaları, incelemeler ve öne çıkanlar.',
  'adminUi.desc.payments': 'Ödemeler, iadeler ve sağlayıcı durumu.',
  'adminUi.desc.site': 'Tanıtım sitesinin bölümleri ve metinleri.',
  'adminUi.desc.legal': 'Kullanım koşulları, gizlilik ve diğer yasal metinler.',
  'adminUi.desc.mail': 'E-posta şablonları ve gönderim ayarları.',
  'adminUi.desc.leads': 'Web sitesindeki formlardan gelen kayıtlar.',
  'adminUi.desc.appearance': 'Sitenin renkleri, yazıları ve görünümü.',
  'adminUi.desc.config': 'Kayıt modu, uzaktan ayarlar, özellik bayrakları ve planlar.',
  'admin.tab.suggestions': 'Öneriler',
  'adminUi.desc.suggestions': 'Kayıttan sonra önerilen kişiler, kanallar ve uygulamalar: kaynaklar, sıra, yedekler ve sayılar.',
  'adminUi.desc.meydan': 'Sosyal akış: sayılar, görünümler, sıralama, sınırlar ve moderasyon.',
  'adminSuggest.general': 'Genel',
  'adminSuggest.generalDesc': 'Önerilerin nerede gösterileceği ve nasıl görüneceği.',
  'adminSuggest.onboarding': 'Kayıttan sonra öneri adımı',
  'adminSuggest.onboardingHint': 'Yeni hesaplar önce kişileri, sonra kanalları ve uygulamaları görür.',
  'adminSuggest.later': 'Sonra da göster',
  'adminSuggest.laterHint': 'Sohbet listesi boşken “Tanıyabileceğin kişiler” kartı.',
  'adminSuggest.showReasons': 'Neden önerildiğini göster',
  'adminSuggest.showReasonsHint': 'Her önerinin altında kısa bir satır (“Ortak 3 kişi”). Kapalıyken yalnızca ad görünür.',
  'adminSuggest.addAllMax': '“Tümünü ekle” sınırı',
  'adminSuggest.addAllMaxHint': 'Kişi listesi en çok bu kadarsa “Tümünü ekle” görünür (0: hiç).',
  'adminSuggest.section.people': 'Kişiler',
  'adminSuggest.section.channels': 'Kanallar',
  'adminSuggest.section.apps': 'Uygulamalar',
  'adminSuggest.sectionDesc.people': 'Önerilmeye izin veren yetişkinler; engellenenler, rehberdekiler ve reşit olmayanlar hiçbir kaynakta yer almaz.',
  'adminSuggest.sectionDesc.channels': 'Yalnızca herkese açık kanallar; reşit olmayanlara kanal önerilmez.',
  'adminSuggest.sectionDesc.apps': 'Kişinin şu an ekleyebileceği Market uygulamaları.',
  'adminSuggest.sectionOn': 'Bu bölüm açık',
  'adminSuggest.max': 'En çok',
  'adminSuggest.minFill': 'En az (yedeklerle tamamla)',
  'adminSuggest.minFillHint': 'Kaynaklar bu sayıdan az bulursa “yedek” işaretli kaynaklar sırayla tamamlar.',
  'adminSuggest.sources': 'Kaynaklar (yukarıdan aşağı çalışır)',
  'adminSuggest.enabled': 'Açık',
  'adminSuggest.fallback': 'Yedek',
  'adminSuggest.count': 'Adet',
  'adminSuggest.up': 'Yukarı taşı',
  'adminSuggest.down': 'Aşağı taşı',
  'adminSuggest.mutualOnly': 'Yalnızca karşılıklı eklenenler',
  'adminSuggest.min.mutuals': 'En az ortak kişi',
  'adminSuggest.min.peoplePopular': 'En az ekleyen kişi',
  'adminSuggest.min.channelsPopular': 'En az takipçi',
  'adminSuggest.min.circle': 'En az kişi (en az 3)',
  'adminSuggest.picked': 'Seçilenler',
  'adminSuggest.searchUser': 'Kişi ara (@kullanıcı veya ad)',
  'adminSuggest.searchChannel': 'Kanal ara',
  'adminSuggest.pickApp': 'Uygulama ekle',
  'adminSuggest.remove': 'Listeden çıkar',
  'adminSuggest.noneYet': 'Henüz seçilen yok.',
  'adminSuggest.blocked.minor': 'Reşit değil · gösterilmez',
  'adminSuggest.blocked.opted_out': 'Önerilmeyi kapatmış',
  'adminSuggest.blocked.unverified': 'E-posta doğrulanmamış',
  'adminSuggest.blocked.inactive': 'Hesap etkin değil',
  'adminSuggest.blocked.bot': 'Bot hesabı',
  'adminSuggest.blocked.unavailable': 'Herkese açık değil',
  'adminSuggest.save': 'Kaydet',
  'adminSuggest.saved': 'Öneri ayarları kaydedildi.',
  'adminSuggest.reset': 'Varsayılanlar',
  'adminSuggest.undo': 'Geri al',
  'adminSuggest.confirmTitle': 'Öneri ayarları kaydedilsin mi?',
  'adminSuggest.confirmBody': 'Yeni hesaplar ve öneri kartları bundan sonra bu ayarlarla hesaplanır. Değişiklik denetim kaydına yazılır.',
  'adminSuggest.resetTitle': 'Varsayılanlara dönülsün mü?',
  'adminSuggest.resetBody': 'Taslak varsayılan kaynaklara ve sayılara döner; seçilen listeler boşalır. Kaydetmeden uygulanmaz.',
  'adminSuggest.privacy': 'Gizlilik kuralları',
  'adminSuggest.privacyBody': 'Her kaynak aynı süzgeçten geçer: yalnızca “Beni önerilerde göster” açık, e-postası doğrulanmış, etkin yetişkinler; iki yönlü engeller ve zaten rehberde olanlar hariç. Davet edenin çevresi yalnızca o kişi de önerilere açıksa ve davet kişisel bağlantıyla yapıldıysa kullanılır. Eklemek her zaman normal istek akışıyla olur.',
  'adminSuggest.preview': 'Bir kişi için dene',
  'adminSuggest.previewDesc': 'Bu kişiye şu taslakla neler önerilirdi ve neden. Bakış denetim kaydına yazılır; kişiye bir şey gösterilmez.',
  'adminSuggest.previewUser': '@kullanıcı adı veya kimlik',
  'adminSuggest.previewRun': 'Dene',
  'adminSuggest.previewNeedsPermission': 'Kişi bazında deneme için “suggestions.people” yetkisi gerekir (süper yöneticiler).',
  'adminSuggest.inviter': 'Davet eden',
  'adminSuggest.inviterUsed': 'çevresi kullanılıyor',
  'adminSuggest.inviterNone': 'Davetle gelmemiş',
  'adminSuggest.why.admin_code': 'kapalı beta koduyla geldi',
  'adminSuggest.why.inactive': 'davet eden etkin değil',
  'adminSuggest.why.minor': 'davet eden reşit değil',
  'adminSuggest.why.opted_out': 'davet eden önerileri kapatmış',
  'adminSuggest.why.blocked': 'aralarında engel var',
  'adminSuggest.skip.off': 'Bölüm kapalı',
  'adminSuggest.skip.viewer_minor': 'Reşit olmayanlara kişi önerilmez',
  'adminSuggest.skip.channels_off': 'Kanallar kapalı',
  'adminSuggest.skip.viewer_not_allowed': 'Bu hesap herkese açık kanallara katılamaz',
  'adminSuggest.skip.no_inviter': 'davet eden yok',
  'adminSuggest.skip.inviter': 'davet edenin çevresi kullanılamıyor',
  'adminSuggest.result': 'Sonuç',
  'adminSuggest.nothing': 'Bu kişiye bu bölümde öneri çıkmazdı.',
  'adminSuggest.trace.fetched': 'bulunan',
  'adminSuggest.trace.picked': 'seçilen',
  'adminSuggest.trace.fallbackPicked': 'yedekten',
  'adminSuggest.trace.duplicates': 'tekrar',
  'adminSuggest.trace.notRun': 'çalışmadı',
  'adminSuggest.drop.self': 'kendisi',
  'adminSuggest.drop.inactive': 'etkin değil',
  'adminSuggest.drop.bot': 'bot',
  'adminSuggest.drop.unverified': 'doğrulanmamış',
  'adminSuggest.drop.minor': 'reşit değil',
  'adminSuggest.drop.blocked': 'engel',
  'adminSuggest.drop.contact': 'zaten rehberde',
  'adminSuggest.drop.opted_out': 'önerilmek istemiyor',
  'adminSuggest.drop.not_found': 'bulunamadı',
  'adminSuggest.drop.unavailable': 'uygun değil',
  'adminSuggest.drop.member': 'zaten takip ediyor',
  'adminSuggest.drop.banned': 'yasaklı',
  'adminSuggest.drop.installed': 'zaten yüklü',
  'adminSuggest.stats': 'Sayılar',
  'adminSuggest.statsDesc': 'Kaynak başına gösterilen, eklenen ve atlanan (kişi bazında değil).',
  'adminSuggest.statsDays': { one: 'Son {count} gün', other: 'Son {count} gün' },
  'adminSuggest.col.section': 'Bölüm',
  'adminSuggest.col.source': 'Kaynak',
  'adminSuggest.col.shown': 'Gösterilen',
  'adminSuggest.col.added': 'Eklenen',
  'adminSuggest.col.skipped': 'Atlanan',
  'adminSuggest.col.rate': 'Ekleme oranı',
  'adminSuggest.statsEmpty': 'Bu dönemde gösterilen öneri yok.',
  'adminSuggest.total': 'Toplam',
  'adminSuggest.src.people.inviter_invitees': 'Davet edenin davet ettikleri',
  'adminSuggest.srcHint.people.inviter_invitees': 'Aynı kişinin davetiyle katılan diğerlerinden rastgele.',
  'adminSuggest.src.people.inviter_contacts': 'Davet edenin rehberi',
  'adminSuggest.srcHint.people.inviter_contacts': 'Davet edenin eklediği kişilerden rastgele.',
  'adminSuggest.src.people.mutuals': 'Ortak kişiler',
  'adminSuggest.srcHint.people.mutuals': 'Kişilerinin rehberinde olanlar, ortak sayısına göre.',
  'adminSuggest.src.people.curated': 'Ekip seçimi',
  'adminSuggest.srcHint.people.curated': 'Ekibin seçtiği kişilerden rastgele.',
  'adminSuggest.src.people.popular': 'Popüler kişiler',
  'adminSuggest.srcHint.people.popular': 'Çok kişinin eklediği, önerilmeye açık hesaplar.',
  'adminSuggest.src.channels.curated': 'Ekip seçimi',
  'adminSuggest.srcHint.channels.curated': 'Ekibin seçtiği herkese açık kanallar.',
  'adminSuggest.src.channels.inviter_channels': 'Davet edenin kanalları',
  'adminSuggest.srcHint.channels.inviter_channels': 'Davet edenin yönettiği herkese açık kanallar (takip ettikleri değil).',
  'adminSuggest.src.channels.popular': 'Popüler kanallar',
  'adminSuggest.srcHint.channels.popular': 'En çok takipçisi olan herkese açık kanallar.',
  'adminSuggest.src.apps.curated': 'Ekip seçimi',
  'adminSuggest.srcHint.apps.curated': 'Ekibin seçtiği uygulamalar.',
  'adminSuggest.src.apps.inviter_apps': 'Davet edenin uygulamaları',
  'adminSuggest.srcHint.apps.inviter_apps': 'Davet edenin eklediği uygulamalar.',
  'adminSuggest.src.apps.circle_popular': 'Çevrende popüler',
  'adminSuggest.srcHint.apps.circle_popular': 'Kişilerinin ve davet edenin rehberinde en az N kişinin kullandığı (yalnızca sayı).',
  'adminSuggest.src.apps.popular': 'En çok yüklenenler',
  'adminSuggest.srcHint.apps.popular': 'Herkesin en çok eklediği uygulamalar.',
  'adminSuggest.src.apps.featured': 'Öne çıkanlar',
  'adminSuggest.srcHint.apps.featured': 'Market’te öne çıkan uygulamalardan rastgele.',
  'adminSuggest.src.apps.random': 'Rastgele',
  'adminSuggest.srcHint.apps.random': 'Eklenebilecek uygulamalardan rastgele.',
  'adminUi.desc.audit': 'Paneldeki her değişikliğin kaydı.',
  'adminUi.desc.security': 'Oturum, giriş ve güvenlikle ilgili olaylar.',
  'adminUi.desc.ai': 'Yapay zekâ istekleri, bütçe ve sağlayıcılar.',
  'adminUi.desc.releases': 'Sürüm notları ve yenilikler.',
  'admin.invites.createTitle': 'Davet oluştur',
  'admin.invites.createHint': 'Kodlar yalnız bir kez, oluşturulduktan hemen sonra gösterilir; sunucu yalnızca özetlerini saklar.',
  'admin.invites.createCount': { one: '{count} kod oluştur', other: '{count} kod oluştur' },
  'admin.invites.countHelp': 'Tek seferde en fazla 50.',
  'admin.invites.maxUses': 'Kod başına kullanım',
  'admin.invites.maxUsesHelp': 'Bir kodla kaç kişi katılabilir (1–1000).',
  'admin.invites.days': 'Geçerlilik süresi',
  'admin.invites.daysHelp': 'Gün olarak, en fazla 365. Süresiz kod verilemez.',
  'admin.invites.dayCount': { one: '{count} gün', other: '{count} gün' },
  'admin.invites.customDays': 'Özel',
  'admin.invites.noteHelp': 'Kimin ya da hangi etkinlik için olduğunu hatırlatır; yalnız ekip görür.',
  'admin.invites.notePlaceholder': 'Örn. tanıtım günü',
  'admin.invites.summary': 'Özet',
  'admin.invites.summaryText': '{count} kod · her biri {uses} kişilik · {days} gün geçerli',
  'admin.invites.newTitle': { one: '{count} yeni kod hazır', other: '{count} yeni kod hazır' },
  'admin.invites.copyAll': 'Tümünü kopyala',
  'admin.invites.copyCode': 'Kodu kopyala',
  'admin.invites.copyLink': 'Bağlantıyı kopyala',
  'admin.invites.share': 'Paylaş',
  'admin.invites.createdToast': { one: '{count} davet kodu oluşturuldu', other: '{count} davet kodu oluşturuldu' },
  'admin.invites.revokeTitle': 'Davet iptal edilsin mi?',
  'admin.invites.revokeBody': 'Bu kodla ya da bağlantıyla artık kimse katılamaz. Daha önce katılanlar etkilenmez.',
  'admin.invites.revokedToast': 'Davet iptal edildi',
  'admin.invites.statsLabel': 'Davet özeti',
  'admin.invites.statActive': 'Etkin davet',
  'admin.invites.statActiveHint': { one: 'toplam {count} davetten', other: 'toplam {count} davetten' },
  'admin.invites.statUses': 'Kullanım',
  'admin.invites.statUsesHint': 'tüm kodlarda',
  'admin.invites.statJoins': 'Davetle katılan',
  'admin.invites.statJoinsHint': 'kod ya da kişisel bağlantıyla',
  'admin.invites.statClosed': 'Kapanan',
  'admin.invites.statClosedHint': 'dolan, süresi biten ya da iptal',
  'admin.invites.codesTitle': 'Davet kodları',
  'admin.invites.codesHint': 'Ekibin ürettiği kodlar ve kişilerin kişisel davet bağlantıları.',
  'admin.invites.search': 'Not ya da oluşturan ara',
  'admin.invites.filter': 'Duruma göre süz',
  'admin.invites.filter.all': 'Tümü',
  'admin.invites.filter.active': 'Etkin',
  'admin.invites.filter.used': 'Doldu',
  'admin.invites.filter.expired': 'Süresi doldu',
  'admin.invites.filter.revoked': 'İptal',
  'admin.invites.filter.personal': 'Kişisel bağlantılar',
  'admin.invites.sort': 'Sırala',
  'admin.invites.sort.newest': 'En yeni',
  'admin.invites.sort.oldest': 'En eski',
  'admin.invites.sort.mostUsed': 'En çok kullanılan',
  'admin.invites.sort.expiring': 'Süresi en yakın',
  'admin.invites.colInvite': 'Davet',
  'admin.invites.colUses': 'Kullanım',
  'admin.invites.colBy': 'Oluşturan',
  'admin.invites.colCreated': 'Oluşturma',
  'admin.invites.colExpires': 'Bitiş',
  'admin.invites.colStatus': 'Durum',
  'admin.invites.noNote': 'Notsuz kod',
  'admin.invites.noExpiry': 'Süresiz',
  'admin.invites.status.active': 'Etkin',
  'admin.invites.status.used': 'Doldu',
  'admin.invites.status.expired': 'Süresi doldu',
  'admin.invites.status.revoked': 'İptal',
  'admin.invites.emptyTitle': 'Henüz davet kodu yok',
  'admin.invites.emptyText': 'Kapalı kayıt dönemlerinde ya da etkinliklerde dağıtmak için kod oluşturun.',
  'admin.invites.noMatch': 'Eşleşen sonuç yok',
  'admin.invites.noMatchText': 'Aramayı ya da süzgeci değiştirin.',
  'admin.invites.showing': '{shown} / {total} gösteriliyor',
  'admin.invites.joinsHint': 'Kimin kimi, hangi yolla ve ne zaman davet ettiği.',
  'admin.invites.joinsEmptyText': 'Biri davet koduyla ya da kişisel bağlantıyla katıldığında burada görünür.',
  'admin.invites.unknownInviter': 'Bilinmeyen davet eden',
  'admin.invites.barOn': 'Açık',
  'admin.invites.barOff': 'Kapalı',
  'adminUi.a.sys.checks': 'Servis durumu',
  'adminUi.a.sys.checksHint': 'Uygulamanın dayandığı her parçanın anlık sağlığı.',
  'adminUi.a.sys.allOk': 'Tümü çalışıyor',
  'adminUi.a.sys.issues': { one: '{count} sorun', other: '{count} sorun' },
  'adminUi.a.sys.users': 'Kullanıcı',
  'adminUi.a.sys.usersHint': 'son 24 sa: +{count}',
  'adminUi.a.sys.messages': 'Mesaj (24 sa)',
  'adminUi.a.sys.sockets': 'Canlı bağlantı',
  'adminUi.a.sys.socketsHint': 'bu sunucuda',
  'adminUi.a.sys.db': 'Veritabanı',
  'adminUi.a.sys.dbHint': { one: '{count} geçiş', other: '{count} geçiş' },
  'adminUi.a.sys.outbox': 'Bekleyen olay',
  'adminUi.a.sys.outboxHint': 'en eskisi {seconds} sn',
  'adminUi.a.sys.uptime': 'Çalışma süresi',
  'adminUi.a.sys.uptimeHint': 'bellek {memory} MB',
  'adminUi.a.sys.server': 'Sunucu',
  'adminUi.a.sys.serverHint': 'Sürüm, çalışma ortamı ve veritabanı.',
  'adminUi.a.sys.release': 'Sürüm',
  'adminUi.a.sys.runtime': 'Çalışma ortamı',
  'adminUi.a.sys.migrations': 'Veritabanı geçişleri',
  'adminUi.a.sys.latest': 'Son geçiş',
  'adminUi.a.sys.dbSize': 'Veritabanı boyutu',
  'adminUi.a.sys.memory': 'Bellek',
  'adminUi.a.minutes': '{count} dk',
  'adminUi.a.calls.hint': 'Aramaların ses ve görüntüsünün ulaşıp ulaşmadığı, aktarıcı testi.',
  'adminUi.a.live.hint': 'Son 60 dakikanın istekleri, gecikmeleri ve uyarıları.',
  'adminUi.a.live.requests': 'İstek (5 dk)',
  'adminUi.a.live.errors': 'Hata (5xx, 5 dk)',
  'adminUi.a.live.latency': 'p95 yanıt',
  'adminUi.a.live.latencyHint': 'p50 {p50} ms',
  'adminUi.a.live.loop': 'Zamanlayıcı gecikmesi p99',
  'adminUi.a.live.loopHint': 'p50 {p50} · en çok {max} ms',
  'adminUi.a.live.pool': 'DB bağlantısı',
  'adminUi.a.live.poolHint': '{idle} boşta · {waiting} bekleyen',
  'adminUi.a.budget.spent': 'Bu ay harcanan',
  'adminUi.a.cfg.flagsOn': '{on} / {total} açık',
  'adminUi.a.cfg.planHint': 'Bu plandaki kişilerin hakları ve sınırları.',
  'adminUi.a.cfg.remoteHint': 'Uygulamanın sayısal sınırları; sunucu aralık dışını reddeder.',
  'adminUi.a.cfg.settingsHint': 'Kayıt ve erişimle ilgili temel seçimler.',
  'adminUi.a.audit.title': 'Kayıtlar',
  'adminUi.a.audit.hint': 'Bir satırı açarak önce/sonra değerlerini görün.',
  'adminUi.a.audit.when': 'Zaman',
  'adminUi.a.audit.what': 'İşlem',
  'adminUi.a.audit.who': 'Kim',
  'adminUi.a.audit.resource': 'Kaynak',
  'adminUi.a.audit.detail': 'Kayıt ayrıntısı',
  'adminUi.a.audit.clear': 'Temizle',
  'adminUi.a.sec.kindsHint': 'Bir türe dokunarak olayları süzün.',
  'adminUi.a.sec.last24': '24 sa',
  'adminUi.a.sec.last7': '7 günde {count}',
  'adminUi.a.sec.events': 'Olaylar',
  'adminUi.a.sec.eventsHint': 'En yeni 100 olay.',
  'adminUi.a.sec.kind': 'Tür',
  'adminUi.a.sec.user': 'Kullanıcı',
  'adminUi.a.sec.ip': 'IP',
  'adminUi.a.sec.detail': 'Ayrıntı',
  'adminUi.a.sec.showAll': 'Tüm türler',
  'adminUi.a.ai.requests': 'İstek',
  'adminUi.a.ai.tokens': 'Token',
  'adminUi.a.ai.people': 'Kişi',
  'adminUi.a.ai.safetyLabel': 'Güvenlik yanıtı',
  'adminUi.a.ai.safetyHint': 'AI öğretmen; içerik saklanmaz',
  'adminUi.a.ai.providers': 'Sağlayıcılar',
  'adminUi.a.ai.providersHint': 'Metin ve ses için kullanılan servisler.',
  'adminUi.a.ai.byAction': 'İşleme göre',
  'adminUi.a.ai.action': 'İşlem',
  'adminUi.a.ai.ok': 'Başarılı',
  'adminUi.a.ai.refused': 'Reddedildi',
  'adminUi.a.ai.errors': 'Hata',
  'adminUi.a.ai.latency': 'Ort. süre',
  'adminUi.a.rel.versions': 'Sürüm',
  'adminUi.a.rel.current': 'Yayındaki sürüm',
  'adminUi.a.rel.none': 'Yok',
  'adminUi.b.staffPeople': 'Ekip üyesi',
  'adminUi.b.reportsEmptyText': 'Yeni bir şikâyet geldiğinde burada, önceliğine göre görünür.',
  'adminUi.b.schoolsEmptyText': 'Bir okul başvurusu geldiğinde burada incelemeye hazır olur.',
  'adminUi.b.helpEmpty': 'Bu kategoride soru yok',
  'adminUi.b.hidden': 'Gizli',
  'adminUi.c.giveHint': 'Kişileri seç, rozeti ve süresini belirle.',
  'adminUi.c.activeTypes': { one: '{count} tanesi açık', other: '{count} tanesi açık' },
  'adminUi.c.holdersHint': 'rozeti şu an taşıyan',
  'adminUi.c.holdersDesc': 'Kimde hangi rozet var, ne zamana kadar.',
  'adminUi.c.on': 'Açık',
  'adminUi.c.off': 'Kapalı',
  'adminUi.c.inUseNow': 'Şu an kullanılan',
  'adminUi.c.inUseHint': 'bu durumları seçmiş kişi',
  'adminUi.c.planOnly': 'Plana özel',
  'adminUi.c.planOnlyHint': 'belirli bir plan isteyen durumlar',
  'adminUi.c.totalAnn': { one: 'toplam {count} duyuru', other: 'toplam {count} duyuru' },
  'adminUi.c.allAnn': 'tüm duyurularda',
  'adminUi.c.byPhase': 'Duruma göre süz',
  'adminUi.c.annEmptyText': 'Bayramlar, önemli günler ve haberler için ilk duyurunuzu yazın.',
  'adminUi.c.readersTotal': { one: '{count} okuma', other: '{count} okuma' },
  'adminUi.c.syncOk': 'Güncel',
  'adminUi.c.syncFail': 'Hata',
  'adminUi.c.published': 'Yayında',
  'adminUi.c.emptyPage': 'Boş',
  'adminUi.c.section': 'Bölüm',
  'adminUi.c.source': 'Kaynak',
  'adminUi.e.leadWho': 'Gönderen',
  'adminUi.e.leadKind': 'Form',
  'adminUi.e.leadMessage': 'Mesaj',
  'adminUi.e.leadStatus': 'Durum',
  'adminUi.e.leadWhen': 'Tarih',
  'adminUi.e.leadEmail': 'E-posta',
  'adminUi.e.leadPhone': 'Telefon',
  'adminUi.e.leadLocale': 'Dil',
  'adminUi.e.leadsEmptyText': 'Süzgeci ya da aramayı değiştirin; yeni kayıtlar geldikçe burada görünür.',
  'adminUi.e.leadsShown': { one: '{count} kayıt gösteriliyor', other: '{count} kayıt gösteriliyor' },
  'adminUi.e.unsaved': 'Kaydedilmemiş değişiklik',
  'adminUi.e.current': 'Yayında',
  'adminUi.e.mailLook': 'Görünüm',
  'adminUi.e.mailKind': 'Şablon',
  // ---- end admin panel design system ----
  // ---- meydan ----
  'push.meydan.title': 'Meydan',
  'push.meydan.meydanLike': '{name} gönderini beğendi',
  'push.meydan.meydanLikeMany': { one: '{name} ve {count} kişi gönderini beğendi', other: '{name} ve {count} kişi gönderini beğendi' },
  'push.meydan.meydanComment': '{name} gönderine yorum yaptı',
  'push.meydan.meydanCommentMany': { one: '{name} ve {count} kişi gönderine yorum yaptı', other: '{name} ve {count} kişi gönderine yorum yaptı' },
  'push.meydan.meydanReply': '{name} yorumuna yanıt verdi',
  'push.meydan.meydanReplyMany': { one: '{name} ve {count} kişi yorumuna yanıt verdi', other: '{name} ve {count} kişi yorumuna yanıt verdi' },
  'push.meydan.meydanRepost': '{name} gönderini paylaştı',
  'push.meydan.meydanRepostMany': { one: '{name} ve {count} kişi gönderini paylaştı', other: '{name} ve {count} kişi gönderini paylaştı' },
  'push.meydan.meydanFollow': '{name} seni takip etmeye başladı',
  'push.meydan.meydanFollowMany': { one: '{name} ve {count} kişi seni takip etmeye başladı', other: '{name} ve {count} kişi seni takip etmeye başladı' },
  'push.meydan.meydanFollowRequest': '{name} seni takip etmek istiyor',
  'push.meydan.meydanFollowRequestMany': { one: '{name} ve {count} kişi seni takip etmek istiyor', other: '{name} ve {count} kişi seni takip etmek istiyor' },
  'push.meydan.meydanMention': '{name} senden bahsetti',
  'push.meydan.meydanMentionMany': { one: '{name} senden bahsetti', other: '{name} senden bahsetti' },
  'nav.meydan': 'Meydan',
  'admin.tab.meydan': 'Meydan',
  'views.title': 'Görünümü değiştir',
  'views.switch': 'Görünümü değiştir',
  'views.switchShort': 'Görünüm',
  'views.switchDesc': 'Meydan, Nabız, Vitrin ya da Akış',
  'views.intro': 'Aynı paylaşımlar, aynı arkadaşlar; yalnızca görünüş değişir. İstediğin an geri dönebilirsin.',
  'views.locked': 'Şu an herkes {name} görünümünü kullanıyor.',
  'views.preparing': 'Hazırlanıyor',
  'views.preparingBody': 'Bu görünüm üzerinde çalışıyoruz. Seçimin kaydedildi; hazır olduğunda burada açılacak. O zamana kadar başka bir görünümle devam edebilirsin.',
  'views.meydan.name': 'Meydan',
  'views.meydan.desc': 'Topluluk meydanı: paylaşımlar, gruplar ve etkinlikler bir arada.',
  'views.nabiz.name': 'Nabız',
  'views.nabiz.desc': 'Kısa ve hızlı: gündemi saniyesinde yakala.',
  'views.vitrin.name': 'Vitrin',
  'views.vitrin.desc': 'Fotoğraf ve video öncelikli, göz alıcı bir vitrin.',
  'views.akis.name': 'Akış',
  'views.akis.desc': 'Sade ve kronolojik: takip ettiklerin, sırasıyla.',
  'views.kesif.name': 'Keşif',
  'views.kesif.desc': 'Tam ekran kısa videolar: kaydır, izle, yeni şeyler bul.',
  'meydan.kesif.tabs': 'Keşif akışları',
  'meydan.kesif.tab.for_you': 'Senin için',
  'meydan.kesif.tab.following': 'Takip ettiklerin',
  'meydan.kesif.share': 'Video paylaş',
  'meydan.kesif.shareTitle': 'Yeni video',
  'meydan.kesif.empty.forYou': 'Henüz video yok',
  'meydan.kesif.empty.forYouBody': 'Kısa bir video paylaş; burada ilk görünen sen ol.',
  'meydan.kesif.empty.following': 'Takip ettiklerinden henüz video yok',
  'meydan.kesif.empty.followingBody': 'İnsanları takip et; paylaştıkları videolar burada akar. O zamana kadar Senin için sekmesine göz at.',
  'meydan.kesif.offline': 'Bağlantı yok. Yüklenmiş videolar oynamaya devam eder.',
  'meydan.kesif.end': 'Şimdilik hepsi bu. Yeni videolar geldikçe burada.',
  'meydan.kesif.keys': '↑ ↓ videolar arasında geç · Boşluk oynat / duraklat · M ses',
  'meydan.kesif.details': 'Video ayrıntıları ve yorumlar',
  'meydan.kesif.detailsEmpty': 'Ekrandaki videonun ayrıntıları ve yorumları burada görünür.',
  'meydan.kesif.likes': { one: '{shown} beğeni', other: '{shown} beğeni' },
  'meydan.kesif.comments': { one: '{shown} yorum', other: '{shown} yorum' },
  'meydan.kesif.profileOf': '{name} profili',
  'meydan.kesif.followName': '{name} kişisini takip et',
  'adminMeydan.safety.title': 'Medya güvenliği',
  'adminMeydan.safety.desc': 'Yüklenen fotoğraf ve videoların bu sunucuda nasıl işlendiği ve engellenen dosyalar.',
  'adminMeydan.safety.strip': 'Videolardan konum, cihaz ve tarih bilgisi siliniyor (MP4, MOV, WebM).',
  'adminMeydan.safety.duration': 'Video süresi dosyanın kendisinden okunuyor; uygulamanın bildirdiğine güvenilmiyor.',
  'adminMeydan.safety.postersClient': 'Kapak karesini uygulama videodan alıyor; sunucu onu fotoğraf olarak doğrulayıp yeniden kaydediyor.',
  'adminMeydan.safety.postersServer': 'Kapak karesi sunucuda videodan çıkarılıyor.',
  'adminMeydan.safety.transcodeOff': 'Sunucuda yeniden kodlama kapalı ya da ffmpeg bulunamadı (bkz. Medya hattı).',
  'adminMeydan.safety.transcodeOn': 'Videolar sunucuda yeniden kodlanıyor.',
  'adminMeydan.safety.malwareOn': 'Kötü amaçlı yazılım taraması açık.',
  'adminMeydan.safety.malwareOff': 'Kötü amaçlı yazılım taraması bu sunucuda kapalı.',
  'adminMeydan.safety.classifier': 'Görsel sınıflandırıcı: {name}',
  'adminMeydan.safety.classifierNone': 'Otomatik görsel sınıflandırıcı kapalı; yalnızca engellenen dosyalar listesi çalışıyor.',
  'adminMeydan.safety.ownerDecision': 'Otomatik görsel sınıflandırıcı kapalı. Medya hattı bölümünden açılabilir; açıkken herkese açık Meydan görselleri Anthropic\'e gönderilir.',
  'adminMeydan.safety.stats': 'Son 7 gün: {blocked} yükleme engellendi · {cleaned} videonun bilgileri temizlendi.',
  'adminMeydan.safety.list': 'Engellenen medya',
  'adminMeydan.safety.empty': 'Engellenen dosya yok. Bildirilen bir gönderinin fotoğrafını ya da videosunu "Engelle" ile ekleyebilirsin.',
  'adminMeydan.safety.block': 'Engelle',
  'adminMeydan.safety.blocked': 'Engellendi',
  'adminMeydan.safety.blockTitle': 'Bu dosya engellensin mi?',
  'adminMeydan.safety.blockBody': 'Aynı dosya ya da ona çok benzeyen bir fotoğraf (videoda kapak karesi) bir daha yüklenemez. Gönderiyi kaldırmak ayrı bir adımdır.',
  'adminMeydan.safety.remove': 'Listeden çıkar',
  'adminMeydan.safety.removeTitle': 'Engel kaldırılsın mı?',
  'adminMeydan.safety.removeBody': 'Bu dosya yeniden yüklenebilir hâle gelir.',
  'adminMeydan.safety.hits': { one: '{count} kez engelledi', other: '{count} kez engelledi' },
  'adminMeydan.safety.manual': 'Özet ile ekle',
  'adminMeydan.safety.kind': 'Tür',
  'adminMeydan.safety.kindPhoto': 'Fotoğraf',
  'adminMeydan.safety.kindVideo': 'Video',
  'adminMeydan.safety.hash': 'SHA-256 (64 hane) ya da benzerlik özeti (16 hane)',
  'adminMeydan.safety.hashHelp': 'SHA-256 dosyanın birebir aynısını, 16 haneli benzerlik özeti boyutu ya da kalitesi değişmiş aynı görseli yakalar.',
  'adminMeydan.safety.note': 'Not (isteğe bağlı)',
  'adminMeydan.safety.add': 'Engelle',
  'adminOps.check.ffmpeg': 'Video kodlama (ffmpeg)',
  'adminMeydan.pipe.title': 'Medya hattı',
  'adminMeydan.pipe.desc': 'Videoların sunucuda yeniden kodlanması ve görsel güvenlik sınıflandırıcısı: durum, kuyruk ve ayarlar.',
  'adminMeydan.pipe.ffmpegOk': 'ffmpeg {version} hazır (H.264 / AAC).',
  'adminMeydan.pipe.ffmpegMissing': 'ffmpeg bulunamadı: videolar yüklendiği gibi (temizlenmiş hâliyle) oynatılıyor.',
  'adminMeydan.pipe.ffmpegBroken': 'ffmpeg var ama kullanılamıyor: {detail}',
  'adminMeydan.pipe.transcodeDisabled': 'Yeniden kodlama ayarlardan kapatılmış.',
  'adminMeydan.pipe.queue': 'Kuyruk: {pending} bekliyor · {processing} işleniyor · {failed} başarısız · son 24 saatte {done} tamamlandı, {skipped} olduğu gibi bırakıldı',
  'adminMeydan.pipe.lastErrors': 'Son hatalar',
  'adminMeydan.pipe.attempts': { one: '{count} deneme', other: '{count} deneme' },
  'adminMeydan.pipe.retry': 'Yeniden dene',
  'adminMeydan.pipe.retryAll': 'Başarısızların hepsini yeniden dene',
  'adminMeydan.pipe.classifierOn': 'Sınıflandırıcı açık: {name} · {model}',
  'adminMeydan.pipe.classifierOff': 'Sınıflandırıcı kapalı: görseller hiçbir yere gönderilmiyor.',
  'adminMeydan.pipe.classifierUnavailable': 'Sunucuda yapay zekâ sağlayıcısı yapılandırılmamış; sınıflandırıcı çalışamaz.',
  'adminMeydan.pipe.today': 'Bugün: {calls} kontrol · {cached} önbellekten · {errors} hata · {denied} bütçe nedeniyle gönderilmedi · ortalama {ms} ms',
  'adminMeydan.pipe.open': 'İnceleme bekleyen görsel: {count}',
  'adminMeydan.pipe.escalated': 'Acil: {count} (reşit olmayan şüphesi)',
  'adminMeydan.pipe.privacy': 'Açıkken herkese açık Meydan fotoğrafları ve video kapakları güvenlik denetimi için Anthropic\'e (Claude) gönderilir; sohbet ve uçtan uca şifreli medya asla gönderilmez. Açmadan önce Gizlilik metnine bunu ekle.',
  'adminMeydan.pipe.readOnly': 'Ayarları değiştirmek için Meydan yönetimi yetkisi gerekir.',
  'adminMeydan.pipe.transcode': 'Yeniden kodlama',
  'adminMeydan.pipe.transcodeEnabled': 'Videoları sunucuda yeniden kodla',
  'adminMeydan.pipe.transcodeHelp': 'H.264 / AAC MP4, en çok 1080p, meta veri yok, dönüş düzeltilmiş. İş bitene dek video yüklendiği gibi oynar.',
  'adminMeydan.pipe.concurrency': 'Aynı anda kodlanan video',
  'adminMeydan.pipe.crf': 'Kalite (CRF)',
  'adminMeydan.pipe.crfHelp': 'Düşük sayı: daha iyi görüntü, daha büyük dosya. 23 önerilir.',
  'adminMeydan.pipe.maxrate': 'En yüksek bit hızı (kbit/sn)',
  'adminMeydan.pipe.preset': 'Hız ön ayarı',
  'adminMeydan.pipe.presetHelp': 'Daha yavaş ön ayar aynı kalitede daha küçük dosya verir ama işlemciyi uzun tutar.',
  'adminMeydan.pipe.timeout': 'Zaman aşımı (sn)',
  'adminMeydan.pipe.maxAttempts': 'Deneme sayısı',
  'adminMeydan.pipe.chatEnabled': 'Sohbet videolarını da yeniden kodla',
  'adminMeydan.pipe.chatHelp': 'Uçtan uca şifreli olmayan gruplar, kanallar ve topluluklardaki videolar sunucuda H.264 / AAC MP4 olur (kapak, süre, boyut dahil). İş bitene dek video gönderildiği gibi oynar; şifreli sohbetlerde video gönderen cihazda küçültülür.',
  'adminMeydan.pipe.chatResolution': 'Sohbet videosu en çok',
  'adminMeydan.pipe.chatQueue': 'Sohbet videoları: {pending} bekliyor · {processing} işleniyor · {failed} başarısız · son 24 saatte {done} tamamlandı, {skipped} olduğu gibi bırakıldı',
  'adminMeydan.pipe.chatDisabled': 'Sohbet videoları yeniden kodlanmıyor (gönderildiği gibi kalıyor).',
  'adminMeydan.pipe.classifier': 'Görsel sınıflandırıcı',
  'adminMeydan.pipe.classifierEnabled': 'Meydan görsellerini sınıflandır',
  'adminMeydan.pipe.classifierHelp': 'Yalnızca herkese açık Meydan fotoğrafları ve video kapakları (videoda üç kare ile birlikte tek görsel). Aynı görsel iki kez gönderilmez.',
  'adminMeydan.pipe.model': 'Model',
  'adminMeydan.pipe.modelHelp': 'Boş bırakılırsa sunucunun yapay zekâ modeli kullanılır. Yüksek hacim için claude-haiku-5-5 önerilir.',
  'adminMeydan.pipe.waitMs': 'Yayında bekleme (ms)',
  'adminMeydan.pipe.waitHelp': 'Kontrol sürüyorsa gönderi bu kadar bekler; sonra yayımlanır, sonuç gerektirirse gizlenir.',
  'adminMeydan.pipe.dailyCap': 'Günlük sınır (0: sınırsız)',
  'adminMeydan.pipe.perUserDaily': 'Kişi başına günlük',
  'adminMeydan.pipe.onUnavailable': 'Yanıt alınamazsa',
  'adminMeydan.pipe.allow': 'İzin ver ve kaydet',
  'adminMeydan.pipe.hold': 'İncelemeye al',
  'adminMeydan.pipe.minorFactor': '18 yaş altı katsayısı',
  'adminMeydan.pipe.minorFactorHelp': '18 yaşından küçüklerin görsellerinde eşikler bu sayıyla çarpılır (daha sıkı).',
  'adminMeydan.pipe.rules': 'Eşikler (0–1)',
  'adminMeydan.pipe.rulesHelp': 'Puan eşiğe ulaşınca: bulanık gösterilir, incelemeye alınır ya da engellenir. Boş: hiçbir zaman.',
  'adminMeydan.pipe.category': 'Kategori',
  'adminMeydan.pipe.level.sensitive': 'Bulanık',
  'adminMeydan.pipe.level.review': 'İnceleme',
  'adminMeydan.pipe.level.block': 'Engel',
  'adminMeydan.pipe.cat.sexual': 'Cinsellik / çıplaklık',
  'adminMeydan.pipe.cat.minors_sexual': 'Reşit olmayan + cinsellik (her zaman engel ve acil bildirim)',
  'adminMeydan.pipe.cat.violence': 'Şiddet / kan',
  'adminMeydan.pipe.cat.hate': 'Nefret sembolleri',
  'adminMeydan.pipe.cat.self_harm': 'Kendine zarar',
  'adminMeydan.pipe.cat.weapons': 'Silah',
  'adminMeydan.pipe.cat.drugs': 'Uyuşturucu',
  'adminMeydan.pipe.cat.spam_scam': 'Spam / dolandırıcılık yazısı',
  'adminMeydan.pipe.saveTitle': 'Medya hattı ayarları kaydedilsin mi?',
  'adminMeydan.pipe.saveBody': 'Değişiklik hemen geçerli olur ve denetim kaydına yazılır.',
  'adminMeydan.pipe.enableBody': 'Sınıflandırıcıyı açıyorsun: herkese açık Meydan görselleri bundan sonra Anthropic\'e gönderilecek. Gizlilik metninin bunu söylediğinden emin ol.',
  'adminMeydan.pipe.undo': 'Geri al',
  'adminMeydan.pipe.defaults': 'Varsayılanlar',
  'adminMeydan.review.title': 'Görsel incelemesi',
  'adminMeydan.review.desc': 'Sınıflandırıcının beklettiği ya da engellediği görseller. Karar verilene dek gönderi yalnızca sahibine görünür.',
  'adminMeydan.review.filter': 'Görsel incelemesi filtresi',
  'adminMeydan.review.filter.open': 'Bekleyen',
  'adminMeydan.review.filter.sensitive': 'Bulanık (7 gün)',
  'adminMeydan.review.filter.decided': 'Karar verilen',
  'adminMeydan.review.empty': 'İncelenecek görsel yok.',
  'adminMeydan.review.allow': 'İzin ver',
  'adminMeydan.review.sensitive': 'Bulanık göster',
  'adminMeydan.review.block': 'Engelle',
  'adminMeydan.review.blockTitle': 'Görsel engellensin mi?',
  'adminMeydan.review.blockBody': 'Gönderisi kaldırılır. İstersen dosya engel listesine de eklenir; bir daha yüklenemez.',
  'adminMeydan.review.blocklist': 'Engel listesine de ekle',
  'adminMeydan.review.escalated': 'Acil',
  'adminMeydan.review.minor': '18 yaş altı',
  'adminMeydan.review.refused': 'Model görseli değerlendirmeyi reddetti.',
  'adminMeydan.review.noPost': 'Henüz bir gönderide değil',
  'adminMeydan.review.post': 'Gönderi',
  'adminMeydan.review.by': 'Karar: @{user}',
  'adminMeydan.review.state.pending': 'Kontrol ediliyor',
  'adminMeydan.review.state.allow': 'İzin verildi',
  'adminMeydan.review.state.sensitive': 'Bulanık',
  'adminMeydan.review.state.review': 'İncelemede',
  'adminMeydan.review.state.block': 'Engellendi',
  'adminMeydan.review.state.error': 'Yanıt alınamadı',
  'adminMeydan.review.state.none': 'Kontrol edilmedi',
  'meydan.media.sensitive': 'Hassas içerik',
  'meydan.media.sensitiveHint': 'Bu görsel bazı kişileri rahatsız edebilir.',
  'meydan.media.show': 'Göster',
  'meydan.media.held': 'İnceleniyor: bu gönderiyi şimdilik yalnızca sen görüyorsun.',
  'meydan.akis.chrono': 'En yeniden eskiye · sıralama yok',
  'meydan.akis.tabs': 'Akış bölümleri',
  'meydan.akis.tab.following': 'Takip ettiklerin',
  'meydan.akis.tab.saved': 'Kaydedilenler',
  'meydan.akis.newPosts': 'Yeni gönderiler ({count})',
  'meydan.akis.emptyTitle': 'Akışın şimdilik sessiz',
  'meydan.akis.end': 'Hepsi bu kadar; en eskiye ulaştın.',
  'meydan.akis.share': 'Paylaş',
  'meydan.akis.liked': 'Beğendin',
  'meydan.akis.saved': 'Kaydedildi',
  'meydan.akis.copied': 'Bağlantı kopyalandı',
  'views.settingsTitle': 'Sosyal akış görünümü',
  'views.settingsBody': 'Meydan’ı nasıl görmek istediğini seç. Seçimin tüm cihazlarında aynı kalır.',
  'views.motionTitle': 'Hareket',
  'views.density': 'Yoğunluk',
  'views.density.comfortable': 'Ferah',
  'views.density.compact': 'Sıkı',
  'views.sort': 'Sıralama',
  'views.sort.ranked': 'Senin için',
  'views.sort.latest': 'En yeniler',
  'views.reduceMotion': 'Hareketi azalt',
  'views.reduceMotionHint': 'Geçişler ve animasyonlar kapanır; cihazının ayarı da her zaman geçerlidir.',
  'meydan.nav': 'Meydan bölümleri',
  'meydan.aside': 'Öneriler ve etkinlikler',
  'meydan.shortcuts': 'Kısayollar',
  'meydan.section.feed': 'Akışım',
  'meydan.section.communities': 'Topluluklar',
  'meydan.section.saved': 'Kaydedilenler',
  'meydan.section.trending': 'Gündem',
  'meydan.audience.public': 'Herkes',
  'meydan.audience.followers': 'Takipçiler',
  'meydan.audience.contacts': 'Yakın çevre',
  'meydan.audience.public.hint': 'DijitalApp’teki herkes görebilir',
  'meydan.audience.followers.hint': 'Takipçilerin ve yakın çevren görür',
  'meydan.audience.contacts.hint': 'Yalnızca birbirinizi eklediğiniz kişiler görür',
  'meydan.composer.label': 'Gönderi yaz',
  'meydan.composer.quoteLabel': 'Alıntıya bir şey ekle',
  'meydan.composer.placeholder': 'Ne düşünüyorsun, {name}?',
  'meydan.composer.quotePlaceholder': 'Bu gönderi hakkında ne söylemek istersin?',
  'meydan.composer.addMedia': 'Fotoğraf / video',
  'meydan.composer.media': 'Eklenen medya',
  'meydan.composer.audience': 'Kimler görsün?',
  'meydan.composer.send': 'Paylaş',
  'meydan.composer.sendQuote': 'Alıntıla',
  'meydan.composer.uploading': 'Yükleniyor',
  'meydan.composer.removeMedia': 'Kaldır',
  'meydan.composer.photoVideo': 'Fotoğraf/Video',
  'meydan.composer.dropHere': 'Bırak, gönderine eklensin',
  'meydan.composer.dropHint': 'Dosyaları buraya sürükleyip bırakabilir ya da yapıştırabilirsin',
  'meydan.composer.addMore': 'Ekle',
  'meydan.composer.arrange': 'Düzenle',
  'meydan.composer.describe': 'Açıklama ekle',
  'meydan.composer.arrangeTitle': 'Fotoğraf ve videoları düzenle',
  'meydan.composer.arrangeHint': 'Sırayı değiştirmek için sürükle ya da oklara dokun. Açıklama, ekran okuyucu kullananlara ne gördüğünü anlatır.',
  'meydan.composer.altLabel': 'Açıklama (alternatif metin)',
  'meydan.composer.altPhoto': 'Bu fotoğrafta ne var? Örn. Gün batımında Galata Kulesi',
  'meydan.composer.altVideo': 'Bu videoda neler oluyor?',
  'meydan.composer.moveEarlier': '{n}. öğeyi öne al',
  'meydan.composer.moveLater': '{n}. öğeyi arkaya al',
  'meydan.composer.done': 'Tamam',
  'meydan.composer.removeLink': 'Bağlantı önizlemesini kaldır',
  'meydan.composer.noMediaQuote': 'Alıntıya fotoğraf ya da video eklenemiyor.',
  'meydan.composer.noMediaPoll': 'Ankete fotoğraf ya da video eklenemiyor.',
  'meydan.composer.oneVideo': 'Bir gönderide tek bir video olabilir (fotoğrafla birlikte değil).',
  'meydan.composer.tooMany': { one: 'En fazla {count} fotoğraf ekleyebilirsin.', other: 'En fazla {count} fotoğraf ekleyebilirsin.' },
  'meydan.composer.videoTooLong': 'Video en fazla {seconds} saniye olabilir.',
  'meydan.composer.videoTooBig': 'Video en fazla {mb} MB olabilir.',
  'meydan.composer.publicOff': 'Herkese açık paylaşım gizlilik ayarlarında kapalı.',
  'meydan.composer.publicTurnOn': 'Aç',
  'meydan.composer.minorNote': 'Hesabın gizli: paylaşımlarını yalnızca yakın çevren ve onayladığın takipçilerin görür.',
  'meydan.composer.cannotPost': 'Paylaşım yapabilmek için e-postanı doğrulaman (ve gerekiyorsa veli onayının gelmesi) gerekiyor.',
  'meydan.composer.restricted': 'Hesabın Meydan’da kısıtlandı; şimdilik paylaşım ve etkileşim yapamazsın.',
  'meydan.edited': 'düzenlendi',
  'meydan.more': 'devamını gör',
  'meydan.less': 'daha az',
  'meydan.openPhoto': 'Fotoğrafı aç',
  'meydan.openPost': 'Gönderiyi aç',
  'meydan.video': 'Video',
  'meydan.mediaFailed': 'Yüklenemedi',
  'meydan.quoteGone': 'Bu gönderi artık görüntülenemiyor.',
  'meydan.actions': 'Gönderi işlemleri',
  'meydan.like': 'Beğen',
  'meydan.unlike': 'Beğenmekten vazgeç',
  'meydan.comment': 'Yorum yap',
  'meydan.repost': 'Yeniden paylaş',
  'meydan.undoRepost': 'Paylaşımı geri al',
  'meydan.quote': 'Alıntıla',
  'meydan.cannotShare': 'Yalnızca herkese açık gönderiler paylaşılabilir.',
  'meydan.share': 'Gönder',
  'meydan.shareToChat': 'Sohbete gönder',
  'meydan.shareElsewhere': 'Başka uygulamayla paylaş',
  'meydan.copyLink': 'Bağlantıyı kopyala',
  'meydan.save': 'Kaydet',
  'meydan.unsave': 'Kaydedilenlerden çıkar',
  'meydan.postMenu': 'Gönderi seçenekleri',
  'meydan.commentMenu': 'Yorum seçenekleri',
  'meydan.edit': 'Düzenle',
  'meydan.editUntil': '{time} saatine kadar düzenleyebilirsin.',
  'meydan.delete': 'Sil',
  'meydan.deleteTitle': 'Gönderi silinsin mi?',
  'meydan.deleteBody': 'Gönderin tüm görünümlerden ve akışlardan kalkar. Bu işlem geri alınamaz.',
  'meydan.notInterested': 'İlgimi çekmiyor',
  'meydan.muteUser': '{name} sessize al',
  'meydan.unmute': '{name} sesini aç',
  'meydan.report': 'Şikâyet et',
  'meydan.reportTitle': 'Gönderiyi şikâyet et',
  'meydan.reposted': '{name} paylaştı',
  'meydan.youReposted': 'Sen paylaştın',
  'meydan.loadMore': 'Daha fazla göster',
  'meydan.empty.title': 'Meydan’da henüz bir şey yok',
  'meydan.empty.forYou': 'İlk gönderini paylaş ya da birkaç kişiyi takip et; burası hemen dolmaya başlar.',
  'meydan.empty.following': 'Takip ettiklerin ve yakın çevren paylaştıkça burada en yeniden eskiye görünür.',
  'meydan.saved.empty': 'Kaydettiğin bir gönderi yok',
  'meydan.saved.emptyBody': 'Bir gönderideki yer imi düğmesine dokun; yalnızca sen görürsün.',
  'meydan.communities.title': 'Topluluklarım',
  'meydan.communities.empty': 'Takip ettiğin bir kanal yok',
  'meydan.communities.emptyBody': 'Kanal rehberinden ilgini çeken toplulukları bul; paylaşımları burada görünür.',
  'meydan.community': 'Topluluk',
  'meydan.online': 'Şu an çevrimiçi',
  'meydan.events': 'Yaklaşan etkinlikler',
  'meydan.seriesEvent': 'Seri etkinlik',
  'meydan.trending.title': 'Gündemde',
  'meydan.trending.circle': 'Yalnızca yakın çevrenin konuştukları gösterilir.',
  'meydan.trending.none': 'Şu an öne çıkan bir konu yok.',
  'meydan.trending.people': { one: '{count} kişi konuşuyor', other: '{count} kişi konuşuyor' },
  'meydan.trending.popular': 'Öne çıkan gönderiler',
  'meydan.trending.noPosts': 'Henüz öne çıkan gönderi yok',
  'meydan.tag.empty': '#{tag} etiketiyle henüz paylaşım yok',
  'meydan.post': 'Gönderi',
  'meydan.postGone': 'Bu gönderiyi göremiyorsun',
  'meydan.postGoneBody': 'Silinmiş, kaldırılmış ya da yalnızca belirli kişilerle paylaşılmış olabilir.',
  'meydan.chatCard.gone': 'Bu Meydan gönderisi sana açık değil',
  'meydan.comments.title': 'Yorumlar',
  'meydan.emoji': 'Emoji',
  'meydan.album': { one: '{count} fotoğraf', other: '{count} fotoğraf' },
  'meydan.comments.titleOf': '{name} gönderisine yorumlar',
  'meydan.vitrin.sections': 'Vitrin bölümleri',
  'meydan.vitrin.tab.home': 'Paylaşımlar',
  'meydan.vitrin.tab.explore': 'Keşfet',
  'meydan.vitrin.tab.reels': 'Kısa videolar',
  'meydan.vitrin.tab.saved': 'Kaydedilenler',
  'meydan.vitrin.new': 'Yeni paylaşım',
  'meydan.vitrin.newTitle': 'Fotoğraf, video ya da birkaç söz paylaş',
  'meydan.vitrin.myProfile': 'Profilim',
  'meydan.vitrin.likes': { one: '{count} beğenme', other: '{count} beğenme' },
  'meydan.vitrin.allComments': { one: 'Yorumu gör', other: '{count} yorumun tümünü gör' },
  'meydan.vitrin.liked': 'Beğendin',
  'meydan.vitrin.carousel': 'fotoğraf albümü',
  'meydan.vitrin.album': { one: '{count} fotoğraf', other: '{count} fotoğraf' },
  'meydan.vitrin.slide': 'fotoğraf',
  'meydan.vitrin.slideOf': '{index} / {count}',
  'meydan.vitrin.prev': 'Önceki fotoğraf',
  'meydan.vitrin.next': 'Sonraki fotoğraf',
  'meydan.vitrin.prevPost': 'Önceki gönderi',
  'meydan.vitrin.nextPost': 'Sonraki gönderi',
  'meydan.vitrin.play': 'Oynat',
  'meydan.vitrin.pause': 'Duraklat',
  'meydan.vitrin.mute': 'Sesi kapat',
  'meydan.vitrin.unmute': 'Sesi aç',
  'meydan.vitrin.reelOf': '{name} paylaştı',
  'meydan.vitrin.dataSaver': 'Veri tasarrufu açık: videolar sen dokununca oynar.',
  'meydan.vitrin.calmVideos': 'Hareketi azalt açık: videolar sen dokununca oynar.',
  'meydan.vitrin.tile.photo': 'Fotoğraf',
  'meydan.vitrin.tile.album': 'Albüm',
  'meydan.vitrin.tile.video': 'Video',
  'meydan.vitrin.tile.text': 'Yazı',
  'meydan.vitrin.savedPrivate': 'Kaydettiklerini yalnızca sen görürsün.',
  'meydan.vitrin.empty.home': 'Vitrin henüz boş',
  'meydan.vitrin.empty.homeBody': 'Bir fotoğraf ya da video paylaş, birkaç kişiyi takip et; vitrinin hemen renklenir.',
  'meydan.vitrin.empty.explore': 'Keşfedecek bir şey yok, şimdilik',
  'meydan.vitrin.empty.exploreBody': 'Görebildiğin kişiler fotoğraf ve video paylaştıkça burada bir galeri oluşur.',
  'meydan.vitrin.empty.reels': 'Henüz kısa video yok',
  'meydan.vitrin.empty.reelsBody': 'Bir video paylaşıldığında burada tam ekran izleyebilirsin.',
  'meydan.comments.placeholder': 'Bir yorum yaz…',
  'meydan.comments.replyTo': '{name} adlı kişiye yanıt ver…',
  'meydan.comments.send': 'Gönder',
  'meydan.comments.reply': 'Yanıtla',
  'meydan.comments.showReplies': { one: '{count} yanıtı gör', other: '{count} yanıtı gör' },
  'meydan.comments.hideReplies': { one: 'Yanıtları gizle', other: 'Yanıtları gizle' },
  'meydan.comments.empty': 'İlk yorumu sen yap.',
  'meydan.comments.more': 'Daha fazla yorum',
  'meydan.comments.seeMore': 'Daha fazla yorum gör',
  'meydan.comments.hide': 'Yorumları gizle',
  'meydan.comments.count': { one: '{count} yorum', other: '{count} yorum' },
  'meydan.comments.none': 'Henüz yorum yok.',
  'meydan.comments.closed': 'Bu gönderiye yorum yapılamıyor.',
  'meydan.comments.moreReplies': 'Daha fazla yanıt gör',
  'meydan.comments.repliesOf': '{name} yorumuna yanıtlar',
  'meydan.comments.answering': 'yanıtladığı kişi:',
  'meydan.comments.liked': 'Beğendin',
  'meydan.comments.likes': { one: '{count} beğeni', other: '{count} beğeni' },
  'meydan.comments.edit': 'Düzenle',
  'meydan.comments.editLabel': 'Yorumu düzenle',
  'meydan.comments.edited': 'Düzenlendi',
  'meydan.comments.escHint': 'Vazgeçmek için Esc.',
  'meydan.comments.deleteTitle': 'Yorum silinsin mi?',
  'meydan.comments.deleteBody': 'Yorum ve ona yazılan yanıtlar kaldırılır. Bu geri alınamaz.',
  'meydan.follow': 'Takip et',
  'meydan.followBack': 'Sen de takip et',
  'meydan.following': 'Takiptesin',
  'meydan.requested': 'İstek gönderildi',
  'meydan.followsYou': 'Seni takip ediyor',
  'meydan.closeCircle': 'Yakın çevren',
  'meydan.removeFollower': 'Takipçilerimden çıkar',
  'meydan.block': 'Engelle',
  'meydan.blocked': 'Engellendi. Artık birbirinizin paylaşımlarını görmeyeceksiniz.',
  'meydan.privateAccount': 'Gizli hesap',
  'meydan.requests.title': 'Takip istekleri',
  'meydan.requests.accept': 'Onayla',
  'meydan.requests.decline': 'Reddet',
  'meydan.profile.posts': 'gönderi',
  'meydan.profile.followers': 'takipçi',
  'meydan.profile.following': 'takip',
  'meydan.profile.tabs': 'Profil sekmeleri',
  'meydan.profile.tab.posts': 'Gönderiler',
  'meydan.profile.tab.replies': 'Yanıtlar',
  'meydan.profile.tab.media': 'Medya',
  'meydan.profile.tab.likes': 'Beğeniler',
  'meydan.profile.noPosts': 'Henüz gönderi yok',
  'meydan.profile.noReplies': 'Henüz yanıt yok',
  'meydan.profile.noMedia': 'Henüz fotoğraf ya da video yok',
  'meydan.profile.noLikes': 'Henüz beğeni yok',
  'meydan.profile.nobody': 'Burada henüz kimse yok.',
  'meydan.profile.replyOn': '{name} gönderisine yanıt',
  'meydan.profile.privateTitle': 'Bu hesap gizli',
  'meydan.profile.privateBody': 'Paylaşımlarını görmek için takip isteği gönder; onaylarsa görebilirsin.',
  'meydan.profile.settings': 'Gizlilik ayarları',
  'meydan.profile.menu': 'Profil seçenekleri',
  'meydan.nabiz.tabs': 'Akış',
  'meydan.nabiz.tab.forYou': 'Senin için',
  'meydan.nabiz.tab.following': 'Takip ettiklerin',
  'meydan.nabiz.newPosts': { one: '{count} yeni gönderi', other: '{count} yeni gönderi' },
  'meydan.nabiz.compose': 'Gönderi yaz',
  'meydan.nabiz.trends': 'Gündem',
  'meydan.nabiz.scope.circle': 'Yakın çevrende',
  'meydan.nabiz.scope.everyone': 'Herkes · son {hours} saat',
  'meydan.nabiz.trendPosts': { one: '{count} gönderi', other: '{count} gönderi' },
  'meydan.nabiz.trendPeople': { one: '{count} kişi', other: '{count} kişi' },
  'meydan.nabiz.tagStrip': 'Gündemdeki etiketler',
  'meydan.nabiz.openThread': 'Konuşmayı aç',
  'meydan.nabiz.backToFeed': 'Akışa dön',
  'meydan.nabiz.replies': 'Yanıtlar',
  'meydan.nabiz.stat.likes': { one: '{count} beğeni', other: '{count} beğeni' },
  'meydan.nabiz.stat.reposts': { one: '{count} yeniden paylaşım', other: '{count} yeniden paylaşım' },
  'meydan.nabiz.stat.quotes': { one: '{count} alıntı', other: '{count} alıntı' },
  'meydan.nabiz.stat.replies': { one: '{count} yanıt', other: '{count} yanıt' },
  'meydan.nabiz.reposted': '{name} yeniden paylaştı',
  'meydan.nabiz.youReposted': 'Yeniden paylaştın',
  'meydan.nabiz.mediaPost': 'Fotoğraf ya da video',
  'adminMeydan.stats': 'Meydan özeti',
  'adminMeydan.s.posts': 'Gönderi',
  'adminMeydan.s.today': { one: 'son 24 saatte {count}', other: 'son 24 saatte {count}' },
  'adminMeydan.s.comments': 'Yorum',
  'adminMeydan.s.authors': 'Son 7 günde paylaşan',
  'adminMeydan.s.reports': 'Açık şikâyet',
  'adminMeydan.s.removed': 'Kaldırılan',
  'adminMeydan.s.restricted': 'Kısıtlı hesap',
  'adminMeydan.system': 'Meydan sistemi',
  'adminMeydan.systemDesc': 'Sosyal akışın tamamı: gönderiler, takip, yorumlar ve dört görünüm.',
  'adminMeydan.on': 'Açık',
  'adminMeydan.off': 'Kapalı',
  'adminMeydan.offNote': 'Meydan şu an kapalı: kimse görmez, tüm uç noktalar FEATURE_NOT_ENABLED yanıtı verir. Gözden geçirdikten sonra buradan açabilirsin (ya da Yapılandırma › özellik bayrakları ile belirli kişilere).',
  'adminMeydan.systemSwitch': 'Meydan’ı herkes için aç',
  'adminMeydan.systemSwitchHelp': 'Kişi, plan ya da bölgeye özel bayrak ayarları ayrıca geçerli kalır.',
  'adminMeydan.enable': 'Aç',
  'adminMeydan.disable': 'Kapat',
  'adminMeydan.enableTitle': 'Meydan herkese açılsın mı?',
  'adminMeydan.enableBody': 'Gezinme menüsünde Meydan görünür ve herkes paylaşım yapmaya başlayabilir.',
  'adminMeydan.disableTitle': 'Meydan kapatılsın mı?',
  'adminMeydan.disableBody': 'Meydan menüden kalkar; gönderiler silinmez, yeniden açıldığında yerinde durur.',
  'adminMeydan.views': 'Görünümler',
  'adminMeydan.viewsDesc': 'Hangi görünümler sunulsun, yeni kullanıcılar hangisiyle başlasın.',
  'adminMeydan.defaultAlwaysOn': 'Varsayılan görünüm her zaman açıktır.',
  'adminMeydan.defaultView': 'Varsayılan görünüm',
  'adminMeydan.defaultViewHelp': 'Görünüm seçmemiş herkes bununla başlar.',
  'adminMeydan.allowSwitch': 'Kullanıcılar görünüm değiştirebilsin',
  'adminMeydan.allowSwitchHelp': 'Kapalıyken herkes varsayılan görünümü görür (seçimleri saklı kalır).',
  'adminMeydan.ranking': 'Sıralama ağırlıkları',
  'adminMeydan.rankingDesc': '“Senin için” akışının şeffaf puanı.',
  'adminMeydan.w.recency': 'Temel puan (tazelik)',
  'adminMeydan.w.follow': 'Takip / yakın çevre ağırlığı',
  'adminMeydan.w.engagement': 'Etkileşim ağırlığı',
  'adminMeydan.w.halfLife': 'Yarı ömür (saat)',
  'adminMeydan.w.window': 'Pencere (gün)',
  'adminMeydan.formula': 'Puan = (temel + takip × ilişki + etkileşim × ln(1 + beğeni + 2·yorum + 3·paylaşım)) × 0,5^(yaş ÷ yarı ömür)',
  'adminMeydan.trending': 'Gündem koruması',
  'adminMeydan.trendingDesc': 'Birkaç hesabın bir konuyu yapay olarak gündeme taşımasına karşı.',
  'adminMeydan.tr.window': 'Pencere (saat)',
  'adminMeydan.tr.authors': 'En az farklı kişi',
  'adminMeydan.tr.authorsHelp': 'Bir etiket ancak bu kadar farklı kişi kullanınca gündeme girer.',
  'adminMeydan.tr.age': 'Hesap en az kaç günlük olsun',
  'adminMeydan.tr.engagement': 'Öne çıkan gönderi için en az etkileşim',
  'adminMeydan.tr.max': 'Gösterilen etiket sayısı',
  'adminMeydan.limits': 'Paylaşım sınırları',
  'adminMeydan.limitsDesc': 'Yeni hesaplar için daha sıkı sınırlar spam’e karşı korur.',
  'adminMeydan.l.newDays': '“Yeni hesap” süresi (gün)',
  'adminMeydan.l.newPosts': 'Yeni hesap: günlük gönderi',
  'adminMeydan.l.posts': 'Günlük gönderi',
  'adminMeydan.l.comments': 'Saatlik yorum',
  'adminMeydan.l.follows': 'Günlük takip',
  'adminMeydan.media': 'Medya ve düzenleme',
  'adminMeydan.mediaDesc': 'Bir gönderideki fotoğraf sayısı, video sınırları ve düzenleme süresi.',
  'adminMeydan.m.max': 'En fazla fotoğraf',
  'adminMeydan.m.videoSeconds': 'Video süresi (saniye)',
  'adminMeydan.m.videoMb': 'Video boyutu (MB)',
  'adminMeydan.m.edit': 'Düzenleme süresi (dakika)',
  'adminMeydan.m.editHelp': '0: gönderiler düzenlenemez.',
  'adminMeydan.x.title': 'Gönderi ve yorum deneyimi',
  'adminMeydan.x.desc': 'Video bağlantıları, emoji ve yorumların akışta nasıl göründüğü.',
  'adminMeydan.x.embeds': 'Video bağlantılarını oynat',
  'adminMeydan.x.embedsHelp': 'Gönderi ve yorumlardaki video bağlantıları oynatılabilir karta dönüşür. Önce bizim sunucumuzdaki küçük resim görünür; site, kişi oynat dediğinde yüklenir.',
  'adminMeydan.x.providerHelp': 'Bu sitenin bağlantıları oynatılsın',
  'adminMeydan.x.emoticons': 'İfadeleri emojiye çevir',
  'adminMeydan.x.emoticonsHelp': ':) <3 gibi ifadeler yazarken emojiye döner. Herkes Meydan ayarlarından kendisi için kapatabilir.',
  'adminMeydan.x.nested': 'Yanıtlara yanıt (iki seviye)',
  'adminMeydan.x.nestedHelp': 'Bir yanıta verilen yanıt bir adım içeride görünür. Kapalıyken ipliğin tamamı tek seviyede durur.',
  'adminMeydan.x.preview': 'Kartta görünen yorum sayısı',
  'adminMeydan.x.previewHelp': 'Gerisi “Daha fazla yorum gör” ile açılır.',
  'adminMeydan.x.edit': 'Yorum düzenleme süresi (dakika)',
  'adminMeydan.x.editHelp': '0: yorumlar düzenlenemez.',
  'adminMeydan.revert': 'Değişiklikleri geri al',
  'adminMeydan.defaults': 'Varsayılanları yükle',
  'adminMeydan.saveTitle': 'Meydan ayarları kaydedilsin mi?',
  'adminMeydan.saveBody': 'Değişiklik herkes için hemen geçerli olur ve denetim kaydına yazılır.',
  'adminMeydan.readOnly': 'Ayarları görmek ve değiştirmek için meydan.manage yetkisi gerekir.',
  'adminMeydan.moderation': 'Moderasyon',
  'adminMeydan.moderationDesc': 'Şikâyet edilen ve kaldırılan gönderiler; kaldırmak açık şikâyetleri kapatır.',
  'adminMeydan.reported': 'Şikâyet edilenler',
  'adminMeydan.removed': 'Kaldırılanlar',
  'adminMeydan.noReports': 'Açık şikâyet yok',
  'adminMeydan.noRemoved': 'Kaldırılan gönderi yok',
  'adminMeydan.reports': { one: '{count} şikâyet', other: '{count} şikâyet' },
  'adminMeydan.deletedByAuthor': 'Sahibi sildi',
  'adminMeydan.mediaAlt': 'Gönderideki medya',
  'adminMeydan.reason': 'Gerekçe: {reason}',
  'adminMeydan.remove': 'Kaldır',
  'adminMeydan.restore': 'Geri getir',
  'adminMeydan.removeTitle': 'Gönderi kaldırılsın mı?',
  'adminMeydan.restoreTitle': 'Gönderi geri getirilsin mi?',
  'adminMeydan.restrictions': 'Kısıtlanan hesaplar',
  'adminMeydan.restrictionsDesc': 'Kısıtlanan hesap Meydan’da paylaşım ve etkileşim yapamaz, gönderileri başkalarına görünmez.',
  'adminMeydan.username': 'Kullanıcı adı',
  'adminMeydan.reasonLabel': 'Gerekçe (isteğe bağlı)',
  'adminMeydan.restrict': 'Kısıtla',
  'adminMeydan.noRestrictions': 'Kısıtlanan hesap yok',
  'adminMeydan.lift': 'Kısıtlamayı kaldır',
  'notifications.interactions.meydanLikes': 'Meydan beğenileri',
  'notifications.interactions.meydanLikesHint': 'Gönderilerin beğenildiğinde',
  'notifications.interactions.meydanComments': 'Meydan yorumları',
  'notifications.interactions.meydanCommentsHint': 'Gönderine yorum ya da yorumuna yanıt geldiğinde',
  'notifications.interactions.meydanReposts': 'Paylaşımlar ve alıntılar',
  'notifications.interactions.meydanRepostsHint': 'Gönderin yeniden paylaşıldığında ya da alıntılandığında',
  'notifications.interactions.meydanFollows': 'Yeni takipçiler',
  'notifications.interactions.meydanFollowsHint': 'Biri seni takip ettiğinde ya da takip isteği gönderdiğinde',
  'notifications.interactions.meydanMentions': 'Meydan’da bahsedilmeler',
  'notifications.interactions.meydanMentionsHint': 'Bir gönderi ya da yorumda @ ile anıldığında',
  'notifications.interactions.contactAdds': 'Seni ekleyenler',
  'notifications.interactions.contactAddsHint': 'Biri seni kişilerine eklediğinde (Mesajlar › İstekler)',
  'admin.reports.type.meydan_post': 'Meydan gönderisi',
  'admin.reports.type.meydan_comment': 'Meydan yorumu',
  // ---- end meydan ----
  // ---- Son Depremler (quake channel) ----
  'quakeCard.severity.light': 'Hafif',
  'quakeCard.severity.moderate': 'Orta',
  'quakeCard.severity.strong': 'Güçlü',
  'quakeCard.severity.major': 'Çok güçlü',
  'quakeCard.aria': '{magnitude} büyüklüğünde deprem, {place}, {severity}',
  'quakeCard.test': 'TEST · Gerçek bir deprem değil, kartın görünümünü denemek için gönderildi',
  'quakeCard.important': 'Önemli',
  'quakeCard.tz': 'TSİ',
  'quakeCard.mapLabel': 'Merkez üssü haritada: {place}',
  'quakeCard.depth': 'Derinlik',
  'quakeCard.km': '{km} km',
  'quakeCard.position': 'Konum',
  'quakeCard.area': 'Bölge',
  'quakeCard.source': 'Kaynak',
  'quakeCard.north': 'K',
  'quakeCard.south': 'G',
  'quakeCard.east': 'D',
  'quakeCard.west': 'B',
  'quakeCard.revisedMag': 'AFAD büyüklüğü {from} yerine {to} olarak güncelledi.',
  'quakeCard.revisedOther': 'AFAD konum ya da derinlik bilgisini güncelledi.',
  'quakeCard.openMap': 'Haritada aç',
  'quakeCard.openApp': 'Deprem uygulaması',
  'quakeCard.share': 'Kanalı paylaş',
  'quakeCard.copied': 'Bağlantı kopyalandı',
  'quakeCard.shareText': 'Son Depremler: Türkiye ve çevresindeki depremler AFAD verisiyle DijitalApp\'te.',
  'quakeCard.quakes': 'deprem',
  'quakeCard.summaryAftershocks': { one: 'Son 1 saatte {count} artçı deprem', other: 'Son 1 saatte {count} artçı deprem' },
  'quakeCard.summaryMore': { one: 'Son 1 saatte {count} deprem daha', other: 'Son 1 saatte {count} deprem daha' },
  'quakeCard.summaryHint': 'Kanalı doldurmamak için tek gönderide toplandı. En büyüğü M{magnitude}.',
  'quakeCard.andMore': { one: '… ve {count} deprem daha', other: '… ve {count} deprem daha' },
  'quakeCard.seeAll': { one: 'Tümünü gör ({count})', other: 'Tümünü gör ({count})' },
  'quakeCard.safety': 'Güvenlik bilgisi',
  'channel.verified': 'Doğrulanmış kanal',
  'channel.verifiedHint': 'Bu kanal DijitalApp tarafından doğrulandı.',
  'admin.tab.quakes': 'Deprem kanalı',
  'adminUi.desc.quakes': 'Son Depremler kanalı: otomatik paylaşım kuralları, güvenlik metinleri, deneme gönderisi ve kayıt.',
  'adminQuake.channel': 'Kanal',
  'adminQuake.channelDesc': 'Resmî DijitalApp hesabının sahibi olduğu, herkese açık ve doğrulanmış "Son Depremler" kanalı.',
  'adminQuake.warn.no_official_account': 'Resmî DijitalApp hesabı (@dijitalapp) bulunamadı. Kanal kendiliğinden oluşturulmaz; istersen aşağıdan bir sahip seçerek oluşturabilirsin. Hiçbir hesap otomatik açılmaz.',
  'adminQuake.warn.no_channel': 'Kanal henüz oluşturulmadı.',
  'adminQuake.warn.channel_deleted': 'Kanal silinmiş. Yeniden oluşturmak için bir sahip seç.',
  'adminQuake.warn.channels_off': 'Kanallar özelliği kapalı: kanal ne oluşturulur ne de paylaşım yapar.',
  'adminQuake.warn.owner_no_device': 'Kanal sahibinin hiç cihazı yok; paylaşım yapılabilmesi için sahibin en az bir kez giriş yapmış olması gerekir.',
  'adminQuake.create': 'Kanalı oluştur',
  'adminQuake.owner': 'Sahip',
  'adminQuake.ownerHelp': 'Kanalın sahibi olacak mevcut hesabın kullanıcı adı (varsayılan: resmî DijitalApp hesabı).',
  'adminQuake.createTitle': 'Kanal oluşturulsun mu?',
  'adminQuake.createBody': '"Son Depremler" kanalı @{username} sahipliğinde, herkese açık ve doğrulanmış olarak oluşturulacak.',
  'adminQuake.open': 'Kanalı aç',
  'adminQuake.followers': 'Takipçi',
  'adminQuake.postsToday': 'Gönderi (24 sa)',
  'adminQuake.editsToday': 'Düzeltme (24 sa)',
  'adminQuake.skipsToday': 'Atlanan (24 sa)',
  'adminQuake.sinceSafety': 'Son güvenlik metninden beri',
  'adminQuake.lastPosted': 'Son gönderi',
  'adminQuake.verified': 'Doğrulanmış',
  'adminQuake.link': 'Bağlantı',
  'adminQuake.admins': 'Kanal yöneticileri',
  'adminQuake.adminsHelp': 'Yöneticiler kanala elle gönderi yapabilir; resmî hesabın parolası paylaşılmaz.',
  'adminQuake.addAdmin': 'Yönetici ekle',
  'adminQuake.removeAdmin': 'Kaldır',
  'adminQuake.usernamePh': 'kullaniciadi',
  'adminQuake.noAdmins': 'Henüz başka yönetici yok.',
  'adminQuake.rules': 'Otomatik paylaşım',
  'adminQuake.rulesDesc': 'AFAD listesindeki hangi depremlerin paylaşılacağı.',
  'adminQuake.on': 'Açık',
  'adminQuake.off': 'Kapalı',
  'adminQuake.enabled': 'Otomatik paylaşım',
  'adminQuake.enabledHelp': 'Kapalıyken yalnızca yöneticilerin elle yaptığı gönderiler olur. Açıldığında yalnızca o andan sonraki depremler paylaşılır.',
  'adminQuake.minMagnitude': 'En küçük büyüklük',
  'adminQuake.minMagnitudeHelp': 'Varsayılan 3,5: merkeze yakın yerlerde hissedilir, normal bir günde birkaç gönderi eder.',
  'adminQuake.maxAge': 'En eski (dakika)',
  'adminQuake.maxAgeHelp': 'Bundan daha eski görülen deprem paylaşılmaz (geç gelen liste, yeniden başlatma).',
  'adminQuake.region': 'Bölge',
  'adminQuake.regionDesc': 'Enlem ve boylam sınırları (varsayılan: Türkiye ve çevresi) ve isteğe bağlı ülke listesi.',
  'adminQuake.minLat': 'Güney sınırı (enlem)',
  'adminQuake.maxLat': 'Kuzey sınırı (enlem)',
  'adminQuake.minLon': 'Batı sınırı (boylam)',
  'adminQuake.maxLon': 'Doğu sınırı (boylam)',
  'adminQuake.countries': 'Ülkeler',
  'adminQuake.countriesHelp': 'Virgülle ayır (ör. Türkiye, Yunanistan). Boş bırakırsan bölgedeki her deprem; ülkesi yazılmayan deprem Türkiye sayılır.',
  'adminQuake.burst': 'Yoğunluk ve gece',
  'adminQuake.burstDesc': 'Artçı fırtınasında kanalı boğmamak ve geceleri insanları gereksiz uyandırmamak için.',
  'adminQuake.maxPerHour': 'Saatte en fazla ayrı gönderi',
  'adminQuake.maxPerHourHelp': 'Fazlası tek bir "Son 1 saatte N artçı" gönderisinde toplanır; o gönderi yerinde güncellenir.',
  'adminQuake.bigMagnitude': 'Her zaman ayrı paylaşılan büyüklük',
  'adminQuake.bigMagnitudeHelp': 'Bu büyüklükten itibaren saatlik sınır ve gece sessizliği uygulanmaz.',
  'adminQuake.importantMagnitude': 'Önemli sayılan büyüklük',
  'adminQuake.importantHelp': 'Önemli gönderiler "yalnızca bahsedilmeler" seçen takipçilere de bildirim olarak gider; kanalı sessize alanlara ve bildirimi kapatanlara gitmez.',
  'adminQuake.quiet': 'Gece sessizliği',
  'adminQuake.quietHelp': 'Bu saatlerde (TSİ) büyük olmayan depremler bildirimsiz paylaşılır.',
  'adminQuake.quietStart': 'Başlangıç saati',
  'adminQuake.quietEnd': 'Bitiş saati',
  'adminQuake.psa': 'Güvenlik metinleri',
  'adminQuake.psaDesc': 'Her N deprem gönderisinden sonra sıradaki metin bildirimsiz paylaşılır. Metinler AFAD ve Türk Kızılay önerilerine dayanır; her biri kaynağını gösterir.',
  'adminQuake.psaEnabled': 'Güvenlik metinleri',
  'adminQuake.psaEvery': 'Kaç gönderide bir',
  'adminQuake.psaCount': '{active}/{total} metin yayında',
  'adminQuake.psaActive': 'Yayında',
  'adminQuake.psaTitleTr': 'Başlık (Türkçe)',
  'adminQuake.psaTitleEn': 'Başlık (İngilizce)',
  'adminQuake.psaBodyTr': 'Metin (Türkçe)',
  'adminQuake.psaBodyEn': 'Metin (İngilizce)',
  'adminQuake.psaSource': 'Kaynak',
  'adminQuake.psaSourceUrl': 'Kaynak bağlantısı (https)',
  'adminQuake.psaAdd': 'Metin ekle',
  'adminQuake.psaRemove': 'Sil',
  'adminQuake.psaUp': 'Yukarı taşı',
  'adminQuake.psaDown': 'Aşağı taşı',
  'adminQuake.psaNew': 'Yeni güvenlik metni',
  'adminQuake.save': 'Kaydet',
  'adminQuake.revert': 'Geri al',
  'adminQuake.defaults': 'Varsayılanlar',
  'adminQuake.saveTitle': 'Kurallar kaydedilsin mi?',
  'adminQuake.saveBody': 'Değişiklikler bir sonraki dakikadan itibaren uygulanır.',
  'adminQuake.test': 'Deneme gönderisi',
  'adminQuake.testDesc': 'Kartın görünümünü örnek bir depremle dene. Kart ve metin "TEST" diye işaretlenir.',
  'adminQuake.testSelf': 'Bana gönder (Kendime not)',
  'adminQuake.testChannel': 'Kanala gönder',
  'adminQuake.testChannelBody': 'Takipçiler TEST etiketli bir kart görecek; bildirim gitmez. Gönderilsin mi?',
  'adminQuake.testSent': 'Deneme gönderisi gönderildi.',
  'adminQuake.log': 'Kayıt',
  'adminQuake.logDesc': 'Ne paylaşıldı, ne düzeltildi, ne atlandı ve neden (30 gün saklanır).',
  'adminQuake.logAll': 'Tümü',
  'adminQuake.logEmpty': 'Henüz kayıt yok.',
  'adminQuake.action.posted': 'Paylaşıldı',
  'adminQuake.action.edited': 'Düzeltildi',
  'adminQuake.action.summarized': 'Özete eklendi',
  'adminQuake.action.skipped': 'Atlandı',
  'adminQuake.action.psa': 'Güvenlik metni',
  'adminQuake.action.test': 'Deneme',
  'adminQuake.action.created': 'Kanal oluşturuldu',
  'adminQuake.action.error': 'Sorun',
  'adminQuake.reason.region': 'Bölge dışında',
  'adminQuake.reason.country': 'Ülke listesinde değil',
  'adminQuake.reason.below_min': 'Eşiğin altında',
  'adminQuake.reason.too_old': 'Çok eski',
  'adminQuake.reason.deleted': 'Gönderi silinmiş',
  'adminQuake.reason.important': 'Önemli',
  'adminQuake.reason.silent': 'Bildirimsiz',
  'adminQuake.colAt': 'Zaman',
  'adminQuake.colAction': 'İşlem',
  'adminQuake.colQuake': 'Deprem',
  'adminQuake.colReason': 'Ayrıntı',
  'adminQuake.source': 'Veri kaynağı: AFAD Deprem Dairesi Başkanlığı (deprem.afad.gov.tr). Liste dakikada bir, Deprem uygulamasıyla aynı önbellekten okunur; AFAD büyüklüğü ya da konumu düzeltirse gönderi yerinde güncellenir. Erken uyarı sistemi değildir.',
  // ---- end Son Depremler ----
  // ---- info panel (contact, group and channel info beside the chat) ----
  'ip.readMore': 'Devamını oku',
  'ip.createdAt': 'Oluşturulma zamanı: {date}',
  'ip.channelSubtitle': { one: 'Kanal · {count} takipçi', other: 'Kanal · {count} takipçi' },
  'ip.groupSubtitle': { one: 'Grup · {count} üye', other: 'Grup · {count} üye' },
  'ip.following': 'Takip ediliyor',
  'ip.unfollowConfirm': '{title} kanalını takip etmeyi bırakmak istiyor musun?',
  'ip.copyLink': 'Bağlantıyı kopyala',
  'ip.linkCopied': 'Bağlantı kopyalandı',
  'ip.voice': 'Sesli',
  'ip.video': 'Görüntülü',
  'ip.add': 'Ekle',
  'ip.added': 'Üyeler eklendi',
  'ip.mute': 'Sessiz',
  'ip.muteOff': 'Bildirimler açık',
  'ip.lockHint': 'Yalnız kilidi açık cihazlarda görünür',
  'ip.privacy': 'Profil gizliliği',
  'ip.privacyHint': 'Fotoğrafını, son görülmeni ve hakkımda yazını kimlerin göreceğini seç',
  'ip.publicChannel': 'Herkese açık kanal',
  'ip.publicChannelHint': 'Kanallar dizininde görünür; herkes bulup takip edebilir. Takipçiler birbirini görmez.',
  'ip.privateChannel': 'Özel kanal',
  'ip.privateChannelHint': 'Dizinde görünmez; yalnız bağlantıyla ya da davetle takip edilir. Takipçiler birbirini görmez.',
  'ip.addDescription': 'Açıklama ekle',
  'ip.members': 'Üyeler',
  'ip.subscribers': 'Takipçiler',
  'ip.seeAll': 'Tümünü gör',
  'ip.seeAllCount': { one: '{count} kişi daha', other: '{count} kişi daha' },
  'ip.inviteLink': 'Davet bağlantısı',
  'ip.groupSettings': 'Grup ayarları',
  'ip.channelSettings': 'Kanal ayarları',
  'ip.settingsHint': 'İzinler, yavaş mod, bağlantılar, yasaklananlar',
  'ip.settingsHintModerator': 'Grup kayıtları',
  'ip.leaveGroup': 'Gruptan çık',
  'ip.leaveChannel': 'Kanaldan çık',
  'ip.reportGroup': 'Grubu şikâyet et',
  'ip.reportChannel': 'Kanalı şikâyet et',
  'ip.followerCount': { one: '{count} takipçi', other: '{count} takipçi' },
  'ip.followersPrivate': 'Takipçilerin kimliği gizlidir: listeyi yalnız kanalın yöneticileri görür.',
  // ---- end info panel ----
  // ---- official channels and channel links ----
  'admin.tab.official': 'Resmî kanallar',
  'adminUi.desc.official': 'DijitalApp ve Son Depremler kanalları: otomatik paylaşımlar, ipuçları, Market tanıtımları, sürüm duyuruları, kanal bağlantıları ve kayıt.',
  'officialCard.tipKicker': 'Biliyor muydunuz?',
  'officialCard.releaseKicker': 'Yenilikler',
  'officialCard.releaseAria': 'Yenilikler, sürüm {version}',
  'officialCard.spotlightKicker': 'Market’te öne çıkan',
  'officialCard.spotlightAria': 'Market’te öne çıkan uygulama: {name}',
  'officialCard.developer': 'Geliştirici',
  'officialCard.openApp': 'Uygulamayı aç',
  'officialCard.marketPage': 'Market sayfası',
  'officialCard.share': 'Kanalı paylaş',
  'officialCard.copied': 'Bağlantı kopyalandı',
  'officialCard.shareText': 'DijitalApp’in resmî kanalı: yenilikler, ipuçları ve öne çıkan uygulamalar.',
  'officialCard.test': 'TEST · Bu bir deneme gönderisidir, kartın görünümünü denemek için gönderildi',
  'officialCard.more': { one: '{count} yenilik daha', other: '{count} yenilik daha' },
  'officialCard.allNotes': 'Tüm sürüm notları',
  'officialCard.seeAll': 'Tümünü gör',
  'officialCard.fixes': { one: '{count} düzeltme', other: '{count} düzeltme' },
  'officialCard.kind.feature': 'Yeni',
  'officialCard.kind.improvement': 'İyileştirme',
  'officialCard.kind.fix': 'Düzeltme',
  'officialCard.kind.security': 'Güvenlik',
  'officialCard.kind.performance': 'Performans',
  'officialCard.kind.known_issue': 'Bilinen sorun',
  'officialCard.tier.free': 'Ücretsiz',
  'officialCard.tier.pro': 'Pro · tek seferlik',
  'officialCard.tier.plus': 'Plus ile',
  'officialCard.tier.business': 'Business ile',
  'channelLink.kind': 'Kanal',
  'channelLink.followers': { one: '{count} takipçi', other: '{count} takipçi' },
  'channelLink.more': 'Devamını oku',
  'channelLink.less': 'Daha az göster',
  'channelLink.created': '{date} tarihinde oluşturuldu',
  'channelLink.copy': 'Bağlantıyı kopyala',
  'channelLink.copied': 'Bağlantı kopyalandı',
  'channelLink.follow': 'Takip et',
  'channelLink.openInApp': 'Uygulamada aç',
  'channelLink.missingTitle': 'Kanal bulunamadı',
  'channelLink.missing': 'Bu bağlantıya ait bir kanal yok ya da kanal artık herkese açık değil.',
  'channelSlug.title': 'Kanal bağlantısı',
  'channelSlug.hint': 'Kanalın kendine ait bağlantısı. Bu bağlantıyla herkes kanalı bulup takip edebilir; bağlantısı olan kanal herkese açık olur.',
  'channelSlug.label': 'Kanal bağlantısı',
  'channelSlug.placeholder': 'kanal-adi',
  'channelSlug.set': 'Bağlantıyı kaydet',
  'channelSlug.change': 'Bağlantıyı değiştir',
  'channelSlug.remove': 'Bağlantıyı kaldır',
  'channelSlug.saved': 'Kanal bağlantısı kaydedildi.',
  'channelSlug.removed': 'Kanal bağlantısı kaldırıldı.',
  'channelSlug.copy': 'Bağlantıyı kopyala',
  'channelSlug.share': 'Paylaş',
  'channelSlug.copied': 'Bağlantı kopyalandı.',
  'channelSlug.rule': '3–32 karakter: küçük harf (a–z), rakam ve aralarda tek tire.',
  'channelSlug.available': 'Bu bağlantı kullanılabilir.',
  'channelSlug.reason.invalid': '3–32 karakter: küçük harf (a–z), rakam ve aralarda tek tire.',
  'channelSlug.reason.taken': 'Bu bağlantıyı başka bir kanal kullanıyor.',
  'channelSlug.reason.reserved': 'Bu ad resmî hesaplar ve kanallar için ayrılmış.',
  'channelSlug.reason.blocked': 'Bu ad kullanılamaz.',
  'channelSlug.useSuggestion': 'Önerilen: {slug}',
  'channelSlug.oldHandle': 'Kanalın eski @{handle} adı hâlâ bu bağlantıya yönlendiriyor.',
  'channelSlug.removeOldHandle': 'Eski adı bırak',
  'adminOfficial.section.dijitalapp': 'DijitalApp',
  'adminOfficial.section.quakes': 'Son Depremler',
  'adminOfficial.channel': 'DijitalApp kanalı',
  'adminOfficial.channelDesc': 'Resmî DijitalApp hesabının sahibi olduğu, herkese açık ve doğrulanmış "DijitalApp" kanalı. @dijitalapp kişinin adıdır; kanal kendi bağlantısıyla paylaşılır.',
  'adminOfficial.open': 'Kanalı aç',
  'adminOfficial.warn.no_official_account': 'Resmî DijitalApp hesabı (@dijitalapp) bulunamadı. Kanal kendiliğinden oluşturulmaz; istersen aşağıdan bir sahip seçerek oluşturabilirsin. Hiçbir hesap otomatik açılmaz.',
  'adminOfficial.warn.no_channel': 'Kanal henüz oluşturulmadı. Resmî hesap varsa sunucu ilk açılışta kendisi oluşturur.',
  'adminOfficial.warn.channel_deleted': 'Kanal silinmiş. Kendiliğinden geri gelmez; istersen aşağıdan yeniden oluşturabilirsin.',
  'adminOfficial.warn.channels_off': 'Kanallar özelliği kapalı: kanal gönderi paylaşmaz.',
  'adminOfficial.warn.owner_no_device': 'Kanalın sahibinin oturum açtığı bir cihaz yok; otomatik gönderiler bekliyor.',
  'adminOfficial.warn.no_slug': 'Kanalın bağlantısı yok (dijitalapp başka bir kanaldaysa). Aşağıdan bir bağlantı ver.',
  'adminOfficial.followers': 'Takipçi',
  'adminOfficial.postsToday': 'Bugünkü gönderi',
  'adminOfficial.sinceSpotlight': 'Uygulama tanıtımına kalan',
  'adminOfficial.owner': 'Sahip',
  'adminOfficial.ownerHelp': 'Kanalın sahibi olacak hesabın kullanıcı adı (varsayılan: resmî hesap).',
  'adminOfficial.created': 'Oluşturulma',
  'adminOfficial.lastPosted': 'Son otomatik gönderi',
  'adminOfficial.next': 'Sıradaki gönderi',
  'adminOfficial.now': 'Şu an',
  'adminOfficial.wait.ready': 'Sıradaki kontrolde paylaşabilir',
  'adminOfficial.wait.off': 'Otomatik paylaşım kapalı',
  'adminOfficial.wait.quiet_hours': 'Paylaşım saatleri dışında',
  'adminOfficial.wait.daily_limit': 'Bugünkü gönderi sınırı doldu',
  'adminOfficial.wait.gap': 'Son gönderiden bu yana yeterli süre geçmedi',
  'adminOfficial.kind.tip': 'İpucu',
  'adminOfficial.kind.release': 'Yenilikler',
  'adminOfficial.kind.spotlight': 'Uygulama tanıtımı',
  'adminOfficial.kindLabel': 'Gönderi türü',
  'adminOfficial.slug': 'Kanal bağlantısı',
  'adminOfficial.slugHelp': 'Resmî kanallara ayrılmış adlar (dijitalapp, sondepremler…) yalnızca buradan verilebilir.',
  'adminOfficial.slugSave': 'Bağlantıyı kaydet',
  'adminOfficial.slugSaved': 'Kanal bağlantısı kaydedildi.',
  'adminOfficial.admins': 'Kanal yöneticileri',
  'adminOfficial.adminsHelp': 'Resmî hesabın parolası olmadan kanala elle gönderi yazabilecek ekip üyeleri.',
  'adminOfficial.noAdmins': 'Henüz yönetici yok.',
  'adminOfficial.addAdmin': 'Yönetici ekle',
  'adminOfficial.removeAdmin': 'Yöneticilikten çıkar',
  'adminOfficial.usernamePh': '@kullaniciadi',
  'adminOfficial.create': 'Kanalı oluştur',
  'adminOfficial.createTitle': 'DijitalApp kanalını oluştur',
  'adminOfficial.createBody': '@{username} sahibi olarak herkese açık, doğrulanmış "DijitalApp" kanalı oluşturulacak ve otomatik paylaşım başlayacak.',
  'adminOfficial.rules': 'Paylaşım düzeni',
  'adminOfficial.rulesDesc': 'Gönderiler gün içinde sakin bir tempoda ve sessiz gider; gece hiç paylaşım yapılmaz.',
  'adminOfficial.on': 'Açık',
  'adminOfficial.off': 'Kapalı',
  'adminOfficial.enabled': 'Otomatik paylaşım',
  'adminOfficial.enabledHelp': 'Kapalıyken yalnızca ekip elle paylaşır.',
  'adminOfficial.postsPerDay': 'Günde en çok gönderi',
  'adminOfficial.startHour': 'Paylaşım başlangıç saati',
  'adminOfficial.endHour': 'Paylaşım bitiş saati',
  'adminOfficial.hoursHelp': 'Türkiye saatiyle; bitiş saati dahil değildir.',
  'adminOfficial.minGap': 'İki gönderi arası en az (saat)',
  'adminOfficial.minGapHelp': 'Takipçileri bunaltmamak için.',
  'adminOfficial.spotlights': 'Market tanıtımları',
  'adminOfficial.spotlightsDesc': 'Belirli aralıklarla bir Market uygulaması ikonu, kategorisi ve kısa tanıtımıyla paylaşılır.',
  'adminOfficial.spotlightsOn': 'Uygulama tanıtımları',
  'adminOfficial.spotlightEvery': 'Her kaç gönderide bir',
  'adminOfficial.spotlightEveryHelp': '3: iki gönderi, ardından bir uygulama.',
  'adminOfficial.noRepeat': 'Aynı uygulama tekrar için en az',
  'adminOfficial.noRepeatHelp': 'Bu kadar tanıtım geçmeden aynı uygulama yeniden gösterilmez.',
  'adminOfficial.freeOnly': 'Yalnızca herkese açık ücretsiz uygulamalar',
  'adminOfficial.freeOnlyHelp': 'Kapalıyken plan ya da satın alma gerektirenler de (ücretsizlerden sonra) tanıtılır.',
  'adminOfficial.appOrder': 'Uygulama sırası',
  'adminOfficial.tipOrder': 'İpucu sırası',
  'adminOfficial.order.sequential': 'Listedeki sırayla',
  'adminOfficial.order.shuffle': 'Karışık (her gün farklı)',
  'adminOfficial.releasesTitle': 'Sürüm duyuruları',
  'adminOfficial.releasesDesc': 'Sürüm notlarında yayımlanan her yeni sürüm bir "Yenilikler" gönderisi olur.',
  'adminOfficial.releasesOn': 'Yenilikler gönderileri',
  'adminOfficial.notifyReleases': 'Sürüm duyurularında bildirim gönder',
  'adminOfficial.notifyReleasesHelp': 'Diğer bütün gönderiler her zaman sessizdir.',
  'adminOfficial.tips': 'Biliyor muydunuz? ipuçları',
  'adminOfficial.tipsDesc': 'Gerçekten var olan özellikler hakkında kısa ipuçları. Gerektirdiği özellik kapalıysa ipucu paylaşılmaz.',
  'adminOfficial.tipCount': '{active} / {total} ipucu açık',
  'adminOfficial.tipActive': 'İpucu açık',
  'adminOfficial.tipNew': 'Yeni ipucu',
  'adminOfficial.tipAdd': 'İpucu ekle',
  'adminOfficial.tipRemove': 'İpucunu sil',
  'adminOfficial.tipIcon': 'Simge',
  'adminOfficial.tipAccent': 'Renk',
  'adminOfficial.tipTitleTr': 'Başlık (Türkçe)',
  'adminOfficial.tipBodyTr': 'Metin (Türkçe)',
  'adminOfficial.tipTitleEn': 'Başlık (İngilizce)',
  'adminOfficial.tipBodyEn': 'Metin (İngilizce)',
  'adminOfficial.tipBullets': 'Öne çıkanlar',
  'adminOfficial.tipBulletsHelp': 'En çok 4 satır; Türkçe, İngilizce ve simge.',
  'adminOfficial.addBullet': 'Satır ekle',
  'adminOfficial.remove': 'Sil',
  'adminOfficial.tipPath': 'Düğmenin açacağı sayfa',
  'adminOfficial.tipPathHelp': 'Uygulama içi yol, ör. /settings/privacy (boş: düğme yok).',
  'adminOfficial.tipFlag': 'Gerektirdiği özellik anahtarı',
  'adminOfficial.tipFlagHelp': 'Ör. chat_lock; bu özellik kapalıyken ipucu paylaşılmaz (boş: her zaman).',
  'adminOfficial.tipCtaTr': 'Düğme yazısı (Türkçe)',
  'adminOfficial.tipCtaEn': 'Düğme yazısı (İngilizce)',
  'adminOfficial.flagOff': 'özellik kapalı',
  'adminOfficial.up': 'Yukarı taşı',
  'adminOfficial.down': 'Aşağı taşı',
  'adminOfficial.accent.blue': 'Mavi',
  'adminOfficial.accent.violet': 'Mor',
  'adminOfficial.accent.green': 'Yeşil',
  'adminOfficial.accent.orange': 'Turuncu',
  'adminOfficial.accent.pink': 'Pembe',
  'adminOfficial.accent.teal': 'Camgöbeği',
  'adminOfficial.revert': 'Değişiklikleri geri al',
  'adminOfficial.defaults': 'Varsayılanlar',
  'adminOfficial.save': 'Kaydet',
  'adminOfficial.saveTitle': 'Paylaşım düzenini kaydet',
  'adminOfficial.saveBody': 'Yeni düzen bir sonraki kontrolden (en geç 5 dakika) itibaren geçerli olur.',
  'adminOfficial.test': 'Deneme gönderisi',
  'adminOfficial.testDesc': 'Bir kartı önce kendine (Kendime not) gönderip görünümünü dene; kanala gönderirsen TEST olarak işaretlenir ve sessiz gider. Denemeler sıralamayı etkilemez.',
  'adminOfficial.testSelf': 'Kendime gönder',
  'adminOfficial.testChannel': 'Kanala gönder (TEST)',
  'adminOfficial.testChannelBody': 'Kart, TEST işaretiyle ve bildirimsiz olarak kanalda bütün takipçilere görünecek.',
  'adminOfficial.testSent': 'Deneme gönderisi gönderildi.',
  'adminOfficial.postNow': 'Şimdi paylaş',
  'adminOfficial.postNowBody': '{what} şimdi kanalda paylaşılacak (saat ve günlük sınır bu gönderi için uygulanmaz).',
  'adminOfficial.posted': 'Paylaşıldı.',
  'adminOfficial.apps': 'Tanıtılabilecek uygulamalar',
  'adminOfficial.appsDesc': 'Market’te kapatılan uygulamalar hiç tanıtılmaz.',
  'adminOfficial.colApp': 'Uygulama',
  'adminOfficial.colState': 'Durum',
  'adminOfficial.colLast': 'Son tanıtım',
  'adminOfficial.usable': 'Sırada',
  'adminOfficial.appOff': 'Market’te kapalı',
  'adminOfficial.notFree': 'Ücretli',
  'adminOfficial.recent': 'Yakında tanıtıldı',
  'adminOfficial.releases': 'Sürümler',
  'adminOfficial.releasesListDesc': 'Yayımlanmış son sürüm notları.',
  'adminOfficial.noReleases': 'Yayımlanmış sürüm notu yok.',
  'adminOfficial.colVersion': 'Sürüm',
  'adminOfficial.releasePosted': 'Paylaşıldı',
  'adminOfficial.releaseWaiting': 'Paylaşılmadı',
  'adminOfficial.log': 'Kayıt',
  'adminOfficial.logDesc': 'Kanalın ne paylaştığı, neyi neden atladığı (son 60 gün).',
  'adminOfficial.logAll': 'Tümü',
  'adminOfficial.logEmpty': 'Henüz kayıt yok.',
  'adminOfficial.colAt': 'Zaman',
  'adminOfficial.colAction': 'İşlem',
  'adminOfficial.colWhat': 'Gönderi',
  'adminOfficial.colReason': 'Ayrıntı',
  'adminOfficial.action.posted': 'Paylaşıldı',
  'adminOfficial.action.skipped': 'Atlandı',
  'adminOfficial.action.test': 'Deneme',
  'adminOfficial.action.created': 'Oluşturuldu',
  'adminOfficial.action.slug': 'Bağlantı',
  'adminOfficial.action.error': 'Hata',
  'adminOfficial.action.removed': 'Kaldırıldı',
  'adminOfficial.releasesShared': 'Sürüm notları › Yayın ayarları’ndaki “Kanalda paylaş” ile aynı ayar. İç notlar ve gizli maddeler kanalda paylaşılmaz.',
  'adminOfficial.reason.auto': 'Otomatik',
  'adminOfficial.reason.manual': 'Elle (Şimdi paylaş)',
  'adminOfficial.reason.no_app': 'Uygulama sırası geldi ama uygun uygulama yoktu; yerine ipucu paylaşıldı',
  'adminOfficial.reason.no_content': 'Paylaşılacak ipucu ya da uygulama yok',
  'adminOfficial.reason.owner_no_device': 'Sahibin cihazı yok',
  'adminOfficial.reason.self': 'Kendime',
  'adminOfficial.reason.channel': 'Kanala',
  // ---- end official channels ----
  // ---- channels in Keşfet, channel invites ----
  'error.channelAdd': 'Kanallara kişi eklenemez; davet bağlantısını paylaşabilirsin.',
  'nav.unreadChannels': { one: '{count} kanalda yeni gönderi', other: '{count} kanalda yeni gönderi' },
  'settings.section.chats': 'Sohbetler',
  'settings.section.chats.desc': 'Sohbet listesi ve kanallar',
  'settings.chats.list': 'Sohbet listesi',
  'settings.chats.channels': 'Kanalları sohbet listesinde göster',
  'settings.chats.channelsHint': 'Kapalıyken takip ettiğin kanallar Keşfet’te durur; yeni gönderileri Keşfet simgesinde sayılır.',
  'channel.searchMine': 'Takip ettiğin kanallarda ara',
  'channel.searchMineEmpty': 'Bu adla takip ettiğin bir kanal yok.',
  'channelInvite.title': 'Davet et',
  'channelInvite.action': 'Davet et',
  'channelInvite.rowHint': 'Bağlantıyı sohbetlere gönder veya paylaş',
  'channelInvite.intro': 'Kanallara kimse eklenmez, herkes kendisi takip eder. Bağlantıyı gönder; isteyen tek dokunuşla takip etsin.',
  'channelInvite.private': 'Bu kanal gizli: takip edilebilmesi için bir davet bağlantısı oluştur.',
  'channelInvite.privateReplace': 'Yeni bir davet bağlantısı oluşturunca eskisi artık çalışmaz.',
  'channelInvite.makeLink': 'Davet bağlantısı oluştur',
  'channelInvite.adminsOnly': 'Bu gizli kanala yalnızca yöneticiler davet edebilir.',
  'channelInvite.send': 'Sohbetlere gönder',
  'channelInvite.sendHint': 'Sohbette kanalın kartı olarak görünür',
  'channelInvite.share': 'Paylaş',
  'adminOps.rc.channelsInChatList': 'Kanallar sohbet listesinde (varsayılan)',
  'adminOps.rc.channelsInChatList.unit': '0: yalnızca Keşfet’te, 1: sohbetlerde de',
  // ---- end channels in Keşfet ----
  // ---- Meydan: Bildirimler, sessize alınanlar, yorum denetimi ----
  'meydan.activity.title': 'Bildirimler',
  'meydan.activity.openUnread': { one: 'Bildirimler, {count} yeni', other: 'Bildirimler, {count} yeni' },
  'meydan.activity.markAll': 'Tümünü okundu işaretle',
  'meydan.activity.new': 'Yeni',
  'meydan.activity.filter.label': 'Bildirim türü',
  'meydan.activity.filter.all': 'Tümü',
  'meydan.activity.filter.likes': 'Beğeniler',
  'meydan.activity.filter.comments': 'Yorumlar',
  'meydan.activity.filter.reposts': 'Paylaşımlar',
  'meydan.activity.filter.follows': 'Takipler',
  'meydan.activity.filter.mentions': 'Bahsetmeler',
  'meydan.activity.bucket.new': 'Yeni',
  'meydan.activity.bucket.today': 'Bugün',
  'meydan.activity.bucket.week': 'Bu hafta',
  'meydan.activity.bucket.earlier': 'Daha önce',
  'meydan.activity.empty': 'Henüz bildirim yok',
  'meydan.activity.emptyBody': 'Biri gönderini beğendiğinde, yorum yaptığında, seni takip ettiğinde ya da senden bahsettiğinde burada görürsün.',
  'meydan.activity.emptyFiltered': 'Bu türde bildirim yok',
  'meydan.activity.emptyFilteredBody': 'Son {days} günde bu türde bir etkinlik olmadı.',
  'meydan.activity.toFeed': 'Akışa dön',
  'meydan.activity.showAll': 'Tümünü göster',
  'meydan.activity.more': 'Daha fazla göster',
  'meydan.activity.loading': 'Yükleniyor…',
  'meydan.activity.retention': 'Son {days} günün etkinliği gösterilir.',
  'meydan.activity.offline': 'Çevrimdışısın. Bağlantı gelince bildirimlerin yenilenir.',
  'meydan.activity.postGone': 'Bu gönderi artık yok',
  'meydan.activity.photo': 'Fotoğraf',
  'meydan.activity.video': 'Video',
  'meydan.activity.requests': 'Takip istekleri',
  'meydan.activity.requestsCount': { one: '{count} kişi seni takip etmek istiyor', other: '{count} kişi seni takip etmek istiyor' },
  'meydan.activity.requestsDone': 'Bekleyen istek kalmadı.',
  'meydan.activity.k.like': '{name} gönderini beğendi',
  'meydan.activity.k.likeTwo': '{name} ve {other} gönderini beğendi',
  'meydan.activity.k.likeMany': { one: '{name}, {other} ve {count} kişi daha gönderini beğendi', other: '{name}, {other} ve {count} kişi daha gönderini beğendi' },
  'meydan.activity.k.comment': '{name} gönderine yorum yaptı',
  'meydan.activity.k.commentTwo': '{name} ve {other} gönderine yorum yaptı',
  'meydan.activity.k.commentMany': { one: '{name}, {other} ve {count} kişi daha gönderine yorum yaptı', other: '{name}, {other} ve {count} kişi daha gönderine yorum yaptı' },
  'meydan.activity.k.reply': '{name} yorumuna yanıt verdi',
  'meydan.activity.k.replyTwo': '{name} ve {other} yorumuna yanıt verdi',
  'meydan.activity.k.replyMany': { one: '{name}, {other} ve {count} kişi daha yorumuna yanıt verdi', other: '{name}, {other} ve {count} kişi daha yorumuna yanıt verdi' },
  'meydan.activity.k.repost': '{name} gönderini yeniden paylaştı',
  'meydan.activity.k.repostTwo': '{name} ve {other} gönderini yeniden paylaştı',
  'meydan.activity.k.repostMany': { one: '{name}, {other} ve {count} kişi daha gönderini yeniden paylaştı', other: '{name}, {other} ve {count} kişi daha gönderini yeniden paylaştı' },
  'meydan.activity.k.quote': '{name} gönderini alıntıladı',
  'meydan.activity.k.follow': '{name} seni takip etmeye başladı',
  'meydan.activity.k.followTwo': '{name} ve {other} seni takip etmeye başladı',
  'meydan.activity.k.followMany': { one: '{name}, {other} ve {count} kişi daha seni takip etmeye başladı', other: '{name}, {other} ve {count} kişi daha seni takip etmeye başladı' },
  'meydan.activity.k.mention': '{name} bir gönderide senden bahsetti',
  'meydan.activity.k.mentionComment': '{name} bir yorumda senden bahsetti',
  'meydan.prefs.title': 'Meydan ayarları',
  'meydan.prefs.nav': 'Ayarlar',
  'meydan.prefs.open': 'Meydan ayarları',
  'meydan.prefs.manageMutes': 'Sessize alınanları yönet',
  'meydan.prefs.entry': 'Meydan',
  'meydan.prefs.entryDesc': 'Gizli hesap, sessize aldığın hesaplar ve kelimeler, ilgilenmediğin gönderiler.',
  'meydan.prefs.account': 'Hesabım',
  'meydan.prefs.writing': 'Yazarken',
  'meydan.prefs.writingDesc': 'Gönderi ve yorum yazarken sana eşlik eden küçük yardımlar.',
  'meydan.prefs.emoticons': 'İfadeleri emojiye çevir',
  'meydan.prefs.emoticonsHelp': ':) yazıp boşluk bırakınca 🙂 olur. Hemen ardından ⌫ ile eski hâline döner.',
  'meydan.prefs.emoticonsOff': 'Şu an DijitalApp genelinde kapalı.',
  'meydan.prefs.accountDesc': 'Meydan’da seni kimlerin göreceği.',
  'meydan.prefs.private': 'Gizli hesap',
  'meydan.prefs.privateHelp': 'Gönderilerini yalnız onayladığın takipçilerin ve yakın çevren görür; yeni takipler onayını bekler.',
  'meydan.prefs.likes': 'Beğenilerim profilimde görünsün',
  'meydan.prefs.likesHelp': 'Profilindeki “Beğeniler” sekmesi, gönderilerini görebilenlere açılır.',
  'meydan.prefs.lockedMinor': '18 yaşından küçük hesaplarda bu ayar kapalı kalır.',
  'meydan.prefs.pushLink': 'Meydan bildirim ayarları',
  'meydan.prefs.mutedAccounts': 'Sessize alınan hesaplar',
  'meydan.prefs.mutedAccountsDesc': 'Gönderileri akışlarında ve bildirimlerinde görünmez. Bundan haberleri olmaz.',
  'meydan.prefs.mutedAccountsEmpty': 'Sessize aldığın kimse yok.',
  'meydan.prefs.unmute': 'Sesini aç',
  'meydan.prefs.mutedWords': 'Sessize alınan kelimeler',
  'meydan.prefs.mutedWordsDesc': 'Bu kelimeleri ya da etiketleri içeren gönderiler akışlarında görünmez.',
  'meydan.prefs.mutedWordsEmpty': 'Sessize aldığın kelime yok.',
  'meydan.prefs.wordsCount': '{count}/{max}',
  'meydan.prefs.wordsFull': 'En fazla {max} kelime sessize alabilirsin. Yenisi için birini kaldır.',
  'meydan.prefs.wordLabel': 'Sessize alınacak kelime',
  'meydan.prefs.wordPlaceholder': 'Kelime ya da #etiket',
  'meydan.prefs.duration': 'Ne kadar süre',
  'meydan.prefs.d.24h': '24 saat',
  'meydan.prefs.d.7d': '7 gün',
  'meydan.prefs.d.30d': '30 gün',
  'meydan.prefs.d.forever': 'Süresiz',
  'meydan.prefs.add': 'Ekle',
  'meydan.prefs.whole': 'Yalnız tam kelime',
  'meydan.prefs.wholeHelp': '(“kar” yazarsan “kardeş” etkilenmez)',
  'meydan.prefs.tagWhole': 'Tam kelime',
  'meydan.prefs.tagAny': 'İçinde geçen',
  'meydan.prefs.until': '{date} tarihine kadar',
  'meydan.prefs.removeWord': '“{word}” kelimesini kaldır',
  'meydan.prefs.notInterested': 'İlgilenmediklerin',
  'meydan.prefs.notInterestedDesc': 'Akışından çıkardığın gönderiler. Geri alırsan yeniden görünebilirler.',
  'meydan.prefs.notInterestedEmpty': 'İlgilenmediğin olarak işaretlediğin gönderi yok.',
  'meydan.prefs.undo': 'Geri al',
  'adminMeydan.c.title': 'Yorum denetimi',
  'adminMeydan.c.desc': 'Şikâyet edilen ve kaldırılan yorumlar. Kaldırılan yorum yanıtlarıyla birlikte gizlenir; açık şikâyetler işlem yapıldı olarak kapanır.',
  'adminMeydan.c.reason': 'Gerekçe (isteğe bağlı, kaldırırken ve kısıtlarken kaydedilir)',
  'adminMeydan.c.noReports': 'Şikâyet edilen yorum yok',
  'adminMeydan.c.noRemoved': 'Kaldırılan yorum yok',
  'adminMeydan.c.reply': 'Yanıt',
  'adminMeydan.c.authorRestricted': 'Yazar kısıtlı',
  'adminMeydan.c.onPost': 'Gönderi: {text}',
  'adminMeydan.c.openPost': 'Gönderiyi aç',
  'adminMeydan.c.restrict': 'Yazarı kısıtla',
  'adminMeydan.c.restrictTitle': '{name} Meydan’dan kısıtlansın mı?',
  'adminMeydan.c.restrictBody': 'Paylaşım ve etkileşim yapamaz; gönderileri ve yorumları başkalarına görünmez. Kısıtlamayı Kısıtlanan hesaplar bölümünden kaldırabilirsin.',
  'adminMeydan.c.restrictedDone': 'Hesap kısıtlandı',
  'adminMeydan.c.remove': 'Yorumu kaldır',
  'adminMeydan.c.restore': 'Geri getir',
  'adminMeydan.c.removeTitle': 'Yorum kaldırılsın mı?',
  'adminMeydan.c.restoreTitle': 'Yorum geri getirilsin mi?',
  'adminMeydan.c.removed': 'Yorum kaldırıldı',
  'adminMeydan.c.restored': 'Yorum geri getirildi',
  'adminMeydan.a.title': 'Denetim kayıtları',
  'adminMeydan.a.desc': 'Meydan’daki son personel işlemleri: kaldırmalar, geri getirmeler, kısıtlamalar ve ayar değişiklikleri.',
  'adminMeydan.a.refresh': 'Yenile',
  'adminMeydan.a.empty': 'Henüz kayıt yok',
  'adminMeydan.a.postRemoved': 'Gönderi kaldırıldı',
  'adminMeydan.a.postRestored': 'Gönderi geri getirildi',
  'adminMeydan.a.commentRemoved': 'Yorum kaldırıldı',
  'adminMeydan.a.commentRestored': 'Yorum geri getirildi',
  'adminMeydan.a.restricted': 'Hesap kısıtlandı',
  'adminMeydan.a.unrestricted': 'Kısıtlama kaldırıldı',
  'adminMeydan.a.config': 'Ayarlar değişti',
  'adminMeydan.a.enabled': 'Meydan sistemi açıldı ya da kapandı',
  // ---- end Meydan: Bildirimler, sessize alınanlar, yorum denetimi ----
  // ---- Meydan içerik araçları (taslaklar, zamanlama, anket, etiket takibi, istatistikler, doğrulama) ----
  'meydanCreator.more': 'Diğer araçlar',
  'meydanCreator.restored': 'Yarım kalan gönderin geri getirildi',
  'meydanCreator.mediaGone': 'Bu dosyanın süresi doldu, kaldırıp yeniden ekle',
  'meydanCreator.mediaOnly': { one: '{count} fotoğraf ya da video', other: '{count} fotoğraf ya da video' },
  'meydanCreator.poll.add': 'Anket',
  'meydanCreator.poll.title': 'Anket',
  'meydanCreator.poll.label': 'Anket',
  'meydanCreator.poll.option': '{n}. seçenek',
  'meydanCreator.poll.addOption': 'Seçenek ekle',
  'meydanCreator.poll.removeOption': '{n}. seçeneği kaldır',
  'meydanCreator.poll.duration': 'Süre',
  'meydanCreator.poll.hours': { one: '{count} saat', other: '{count} saat' },
  'meydanCreator.poll.days': { one: '{count} gün', other: '{count} gün' },
  'meydanCreator.poll.remove': 'Anketi kaldır',
  'meydanCreator.poll.noMedia': 'Anket, fotoğraf ya da videoyla birlikte eklenemez',
  'meydanCreator.poll.incomplete': 'Anketin her seçeneğini doldur (aynı seçenek iki kez olamaz)',
  'meydanCreator.poll.votes': { one: '{count} oy', other: '{count} oy' },
  'meydanCreator.poll.closed': 'Sona erdi',
  'meydanCreator.poll.left.days': { one: '{count} gün kaldı', other: '{count} gün kaldı' },
  'meydanCreator.poll.left.hours': { one: '{count} saat kaldı', other: '{count} saat kaldı' },
  'meydanCreator.poll.left.minutes': { one: '{count} dakika kaldı', other: '{count} dakika kaldı' },
  'meydanCreator.poll.yourVote': 'Senin oyun',
  'meydanCreator.poll.resultsAfter': 'Sonuçlar anket bitince görünür',
  'meydanCreator.drafts.title': 'Taslaklar',
  'meydanCreator.drafts.lead': 'Kaydettiğin taslaklar bütün cihazlarında burada. Birine dokunup kaldığın yerden devam et.',
  'meydanCreator.drafts.empty': 'Henüz taslağın yok. Yazdığın bir gönderiyi “Taslağı kaydet” ile buraya ekleyebilirsin.',
  'meydanCreator.drafts.save': 'Taslağı kaydet',
  'meydanCreator.drafts.update': 'Taslağı güncelle',
  'meydanCreator.drafts.saved': 'Taslak kaydedildi, diğer cihazlarında da açabilirsin',
  'meydanCreator.drafts.nothing': 'Kaydedecek bir şey yok, önce bir şeyler yaz',
  'meydanCreator.drafts.delete': 'Taslağı sil',
  'meydanCreator.drafts.open': 'Açık',
  'meydanCreator.drafts.fromDraft': 'Taslaktan',
  'meydanCreator.schedule.button': 'Zamanla',
  'meydanCreator.schedule.title': 'Gönderiyi zamanla',
  'meydanCreator.schedule.date': 'Gün',
  'meydanCreator.schedule.time': 'Saat',
  'meydanCreator.schedule.zone': 'Saat dilimi',
  'meydanCreator.schedule.willPost': '{when} tarihinde paylaşılacak',
  'meydanCreator.schedule.hint': 'Zamanı gelince gönderin kendiliğinden paylaşılır; o ana kadar Zamanlananlar’dan değiştirebilir ya da iptal edebilirsin.',
  'meydanCreator.schedule.problem.past': 'Bu zaman geçti, ileri bir zaman seç',
  'meydanCreator.schedule.problem.tooSoon': 'En az birkaç dakika sonrası için zamanla',
  'meydanCreator.schedule.problem.tooFar': 'En çok {days} gün sonrası için zamanlayabilirsin',
  'meydanCreator.schedule.set': 'Zamanı ayarla',
  'meydanCreator.schedule.clear': 'Zamanlamayı kaldır',
  'meydanCreator.schedule.chip': 'Zamanlandı: {when}',
  'meydanCreator.schedule.send': 'Zamanla',
  'meydanCreator.schedule.update': 'Güncelle',
  'meydanCreator.schedule.done': 'Hazır! Gönderin {when} tarihinde paylaşılacak',
  'meydanCreator.schedule.minor': 'Zamanlanan gönderilerin yalnızca yakın çevrene gider.',
  'meydanCreator.scheduled.title': 'Zamanlananlar',
  'meydanCreator.scheduled.empty': 'Zamanlanmış gönderin yok. Yazarken saat simgesiyle bir zaman seçebilirsin.',
  'meydanCreator.scheduled.chip': 'Zamanlandı',
  'meydanCreator.scheduled.failedChip': 'Paylaşılamadı',
  'meydanCreator.scheduled.edit': 'Düzenle',
  'meydanCreator.scheduled.cancel': 'İptal et',
  'meydanCreator.scheduled.cancelConfirm': 'Evet, iptal et',
  'meydanCreator.scheduled.editing': 'Zamanlanmış gönderiyi düzenliyorsun',
  'meydanCreator.scheduled.failed.FORBIDDEN': 'Zamanı geldiğinde bu kitleyle paylaşılamadı (örneğin halka açık gönderi kapatılmış). Düzenleyip yeniden zamanlayabilirsin.',
  'meydanCreator.scheduled.failed.POLICY_LOCKED': 'Bu kitle hesabın için kullanılamıyor. Kitleyi değiştirip yeniden zamanla.',
  'meydanCreator.scheduled.failed.VALIDATION_FAILED': 'Gönderideki bir fotoğraf ya da video artık yok. Düzenleyip yeniden zamanla.',
  'meydanCreator.scheduled.failed.EMAIL_NOT_VERIFIED': 'E-posta adresin doğrulanmadığı için paylaşılamadı.',
  'meydanCreator.scheduled.failed.FEATURE_NOT_ENABLED': 'Bu özellik şu an kapalı olduğu için paylaşılamadı.',
  'meydanCreator.scheduled.failed.other': 'Zamanı geldiğinde paylaşılamadı. Düzenleyip yeniden dene.',
  'meydanCreator.insights.open': 'İstatistikleri gör',
  'meydanCreator.insights.title': 'İstatistikler',
  'meydanCreator.insights.tab': 'İstatistikler',
  'meydanCreator.insights.postTitle': 'Gönderi istatistikleri',
  'meydanCreator.insights.range': 'Zaman aralığı',
  'meydanCreator.insights.days': { one: 'Son {count} gün', other: 'Son {count} gün' },
  'meydanCreator.insights.last30': { one: 'Son 30 günde {count} gösterim', other: 'Son 30 günde {count} gösterim' },
  'meydanCreator.insights.impressions': 'Gösterim',
  'meydanCreator.insights.visits': 'Profil ziyareti',
  'meydanCreator.insights.followers': 'Takipçi',
  'meydanCreator.insights.posts': 'Gönderi',
  'meydanCreator.insights.likes': 'Beğeni',
  'meydanCreator.insights.comments': 'Yorum',
  'meydanCreator.insights.reposts': 'Paylaşım',
  'meydanCreator.insights.quotes': 'Alıntı',
  'meydanCreator.insights.saves': 'Kaydetme',
  'meydanCreator.insights.pollVotes': 'Anket oyu',
  'meydanCreator.insights.top': 'En çok görülen gönderilerin',
  'meydanCreator.insights.noPosts': 'Bu aralıkta gönderin yok. Paylaştıkça burada nasıl karşılandığını göreceksin.',
  'meydanCreator.insights.private': 'Bu sayıları yalnızca sen görürsün; kimin baktığı hiç kimseye gösterilmez.',
  'meydanCreator.tags.follow': 'Takip et',
  'meydanCreator.tags.following': 'Takip ediliyor',
  'meydanCreator.tags.followHint': 'Takip edersen bu etiketin gönderileri akışına da gelir',
  'meydanCreator.tags.followingHint': 'Bu etiketin gönderileri akışında',
  'meydanCreator.tags.title': 'Takip ettiğin etiketler',
  'meydanCreator.tags.lead': 'Bu etiketlerin gönderileri “Takip ettiklerin” akışına da gelir. Bir etiketi takip etmek için etiket sayfasını aç.',
  'meydanCreator.tags.none': 'Henüz bir etiket takip etmiyorsun.',
  'meydanCreator.tags.unfollow': '#{tag} takibini bırak',
  'meydanCreator.settings.title': 'Meydan',
  'meydanCreator.settings.body': 'Takip ettiğin etiketler ve doğrulanmış hesap rozeti.',
  'meydanCreator.verify.title': 'Doğrulanmış hesap',
  'meydanCreator.verify.lead': 'Tanınan bir kişi, kurum ya da içerik üreticisiysen mavi tik isteyebilirsin. Ekibimiz başvurunu inceler ve sonucu sana bildirir.',
  'meydanCreator.verify.verified': 'Hesabın doğrulandı, adının yanında mavi tik görünüyor.',
  'meydanCreator.verify.minor': 'Doğrulama başvurusu 18 yaşından büyükler içindir.',
  'meydanCreator.verify.cannotPost': 'Başvuru için hesabının doğrulanmış ve paylaşıma açık olması gerekir.',
  'meydanCreator.verify.start': 'Doğrulama iste',
  'meydanCreator.verify.category': 'Hesap türü',
  'meydanCreator.verify.cat.person': 'Tanınan kişi',
  'meydanCreator.verify.cat.creator': 'İçerik üreticisi',
  'meydanCreator.verify.cat.journalist': 'Gazeteci',
  'meydanCreator.verify.cat.organization': 'Kurum ya da dernek',
  'meydanCreator.verify.cat.school': 'Okul',
  'meydanCreator.verify.cat.business': 'İşletme',
  'meydanCreator.verify.cat.government': 'Kamu kurumu',
  'meydanCreator.verify.cat.other': 'Diğer',
  'meydanCreator.verify.reason': 'Neden doğrulanmalı?',
  'meydanCreator.verify.reasonHint': 'Kim olduğunu ve neden tanındığını birkaç cümleyle anlat (en az 10 karakter).',
  'meydanCreator.verify.links': 'Seni tanıtan bağlantılar (isteğe bağlı)',
  'meydanCreator.verify.link': '{n}. bağlantı',
  'meydanCreator.verify.addLink': 'Bağlantı ekle',
  'meydanCreator.verify.removeLink': '{n}. bağlantıyı kaldır',
  'meydanCreator.verify.note': 'Gösterebileceğin belgeler (isteğe bağlı)',
  'meydanCreator.verify.noteHint': 'Belge yükleme. Yalnızca ekip isterse neler gösterebileceğini yaz; kimlik fotoğrafı istenmez.',
  'meydanCreator.verify.send': 'Başvuruyu gönder',
  'meydanCreator.verify.pending': 'Başvurun inceleniyor',
  'meydanCreator.verify.withdraw': 'Başvuruyu geri çek',
  'meydanCreator.verify.rejected': 'Başvurun onaylanmadı',
  'meydanCreator.verify.cooldown': '{date} tarihinden sonra yeniden başvurabilirsin.',
  'meydanCreator.push.verificationApproved': 'Hesabın doğrulandı, artık adının yanında mavi tik var',
  'meydanCreator.push.verificationRejected': 'Doğrulama başvurun onaylanmadı',
  'adminMeydanCreator.title': 'İçerik araçları',
  'adminMeydanCreator.desc': 'Taslaklar, zamanlanmış gönderiler, anketler, etiket takibi, istatistikler ve doğrulama başvuruları. Reşit olmayanlarla ilgili kurallar her zaman sunucuda uygulanır.',
  'adminMeydanCreator.stats': 'İçerik araçları sayıları',
  'adminMeydanCreator.s.drafts': 'Sunucudaki taslaklar',
  'adminMeydanCreator.s.scheduled': 'Bekleyen zamanlanmış',
  'adminMeydanCreator.s.failed': { one: '{count} paylaşılamadı', other: '{count} paylaşılamadı' },
  'adminMeydanCreator.s.polls': 'Açık anketler',
  'adminMeydanCreator.s.votes': { one: '7 günde {count} oy', other: '7 günde {count} oy' },
  'adminMeydanCreator.s.tags': 'Takip edilen etiketler',
  'adminMeydanCreator.s.tagPeople': { one: '{count} kişi', other: '{count} kişi' },
  'adminMeydanCreator.s.impressions': 'Bugünkü gösterim',
  'adminMeydanCreator.s.visits': { one: '{count} profil ziyareti', other: '{count} profil ziyareti' },
  'adminMeydanCreator.s.verification': 'Bekleyen doğrulama',
  'adminMeydanCreator.drafts': 'Taslaklar',
  'adminMeydanCreator.draftsHelp': 'Kişiler taslaklarını sunucuya kaydedip başka cihazda açabilir (yerel otomatik kayıt her zaman açık).',
  'adminMeydanCreator.maxServer': 'Kişi başına taslak',
  'adminMeydanCreator.mediaKeepDays': 'Taslak medyası (gün)',
  'adminMeydanCreator.mediaKeepDaysHelp': 'Bir taslağın fotoğraf ve videoları son değişiklikten bu kadar gün sonra temizlenir.',
  'adminMeydanCreator.scheduled': 'Zamanlanmış gönderiler',
  'adminMeydanCreator.scheduledHelp': 'Kapalıyken yeni zamanlama yapılamaz, bekleyenler açılana kadar bekler.',
  'adminMeydanCreator.maxPending': 'Kişi başına bekleyen',
  'adminMeydanCreator.maxDaysAhead': 'En fazla kaç gün sonrası',
  'adminMeydanCreator.polls': 'Anketler',
  'adminMeydanCreator.pollsHelp': '2–4 seçenek, 1 saat ile 7 gün arası, tek seçim; kim neye oy verdi gösterilmez.',
  'adminMeydanCreator.insights': 'İstatistikler',
  'adminMeydanCreator.insightsHelp': 'Gönderi sahibine gösterim, etkileşim, profil ziyareti ve takipçi sayıları (kim olduğu asla gösterilmez).',
  'adminMeydanCreator.followTags': 'Etiket takibi',
  'adminMeydanCreator.followTagsHelp': 'Takip edilen etiketlerin gönderileri takip akışına katılır ve “Senin için”de öne çıkar. Gündem kuralları değişmez.',
  'adminMeydanCreator.maxPerUser': 'Kişi başına etiket',
  'adminMeydanCreator.feedCap': 'Sayfa başına etiket gönderisi',
  'adminMeydanCreator.feedCapHelp': 'Takip akışının her sayfasında yalnızca etiketten gelen en fazla bu kadar gönderi olur.',
  'adminMeydanCreator.verification': 'Doğrulama başvuruları',
  'adminMeydanCreator.verificationHelp': 'Yetişkinler mavi tik isteyebilir; onayı yalnızca ekip verir.',
  'adminMeydanCreator.cooldownDays': 'Reddedilince bekleme (gün)',
  'adminMeydanCreator.undo': 'Değişiklikleri geri al',
  'adminMeydanCreator.defaults': 'Varsayılanlar',
  'adminMeydanCreator.saveTitle': 'İçerik araçları kaydedilsin mi?',
  'adminMeydanCreator.saveBody': 'Değişiklik herkes için hemen geçerli olur ve denetim kaydına yazılır.',
  'adminMeydanCreator.readOnly': 'İçerik araçlarının ayarlarını yalnızca Meydan yöneticileri değiştirebilir.',
  'adminMeydanCreator.queue': 'Doğrulama başvuruları',
  'adminMeydanCreator.queueDesc': 'En eski başvuru en üstte. Onay mavi tik rozetini verir (Rozetler yetkisi gerekir); ret gerekçesi kişiye iletilir.',
  'adminMeydanCreator.queueEmpty': 'Bekleyen başvuru yok',
  'adminMeydanCreator.none': 'Bu durumda başvuru yok',
  'adminMeydanCreator.status.pending': 'Bekliyor',
  'adminMeydanCreator.status.approved': 'Onaylandı',
  'adminMeydanCreator.status.rejected': 'Reddedildi',
  'adminMeydanCreator.status.withdrawn': 'Geri çekildi',
  'adminMeydanCreator.status.all': 'Tümü',
  'adminMeydanCreator.hasTick': 'Mavi tik var',
  'adminMeydanCreator.context': '{days} günlük hesap · {followers} takipçi · {posts} gönderi',
  'adminMeydanCreator.note': 'Gösterebileceği belgeler: {note}',
  'adminMeydanCreator.decision': 'Karar notu: {reason} ({by})',
  'adminMeydanCreator.approve': 'Onayla',
  'adminMeydanCreator.approveTitle': 'Mavi tik verilsin mi?',
  'adminMeydanCreator.approveBody': '{name} doğrulanmış rozetini alacak ve bildirim gidecek.',
  'adminMeydanCreator.reject': 'Reddet',
  'adminMeydanCreator.rejectReason': 'Ret gerekçesi (kişiye iletilir)',
  'adminMeydanCreator.needBadges': 'Onaylamak için Rozetler yetkisi gerekir. Bir yöneticiden onaylamasını iste.',
  // ---- end Meydan içerik araçları ----
  // ---- Eğitim modülü (docs/EDU_MODULE.md) ----
  'nav.edu': 'Okul',
  'admin.tab.edu': 'Eğitim',
  'edu.home.desc': 'Çocukların, sınıfların ve kurumların tek yerde.',
  'edu.home.open': 'Kurum aç',
  'edu.home.emptyTitle': 'Henüz bir kuruma bağlı değilsin',
  'edu.home.empty': 'Okulun ya da kursun sana bir davet bağlantısı gönderdiğinde burada görünür. Kurum yöneticisiysen kendi kurumunu açabilirsin.',
  'edu.home.manage': 'Yönettiğin kurumlar',
  'edu.home.stepsLeft': { one: 'Kurulumda {count} adım kaldı', other: 'Kurulumda {count} adım kaldı' },
  'edu.home.setupDone': 'Kurulum tamam',
  'edu.home.pendingGuardians': { one: '{count} veli isteği bekliyor', other: '{count} veli isteği bekliyor' },
  'edu.home.teaching': 'Derslerim',
  'edu.home.learning': 'Sınıflarım',
  'edu.home.duties': 'Görevlerim',
  'edu.verification.unverified': 'Doğrulanmadı',
  'edu.verification.pending': 'Doğrulama bekliyor',
  'edu.verification.verified': 'Doğrulandı',
  'edu.verification.rejected': 'Doğrulama reddedildi',
  'edu.family.title': 'Tüm çocuklarım',
  'edu.family.pick': 'Çocuk seç',
  'edu.family.all': 'Hepsi',
  'edu.family.institutions': { one: '{count} kurum', other: '{count} kurum' },
  'edu.family.noGroup': 'Henüz bir sınıfa yerleştirilmedi.',
  'edu.family.openSource': '{child}, {org}: ayrıntıları aç',
  'edu.family.sourceError': 'Bu kurumun bilgisi şu an alınamadı. Diğer kurumlar etkilenmez; biraz sonra yeniden dene.',
  'edu.family.waiting': 'Kurumun onayı bekleniyor',
  'edu.family.waitingHint': 'Kurum velilik bağını doğrulayınca çocuğunun bilgileri burada görünür.',
  'edu.child.title': 'Çocuğum',
  'edu.child.switch': 'Çocuk ve kurum',
  'edu.child.gone': 'Bu bağlantı artık yok: kurum kaldırmış ya da kayıt sona ermiş olabilir. Tüm çocuklarım sayfasına dön.',
  'edu.child.at': '{org} bilgileri',
  'edu.child.name': 'Ad soyad',
  'edu.child.institution': 'Kurum',
  'edu.child.relation': 'Yakınlık',
  'edu.child.groups': 'Sınıflar ve gruplar',
  'edu.child.homeroom': 'Sınıf öğretmeni: {names}',
  'edu.child.comingNext': 'Ödevler, duyurular, yoklama ve görüşmeler bu kurumda kullanıma açıldığında burada listelenecek.',
  'edu.child.removeTitle': 'Bu kurumla bağımı kaldır',
  'edu.child.removeBody': 'Yalnızca {org} ile olan velilik bağın kalkar. Çocuğunun diğer kurumları ve kaydı etkilenmez. Yeniden bağlanmak için kurumdan yeni davet gerekir.',
  'edu.child.remove': 'Bağı kaldır',
  'edu.child.removeConfirm': 'Evet, bağı kaldır',
  'edu.new.title': 'Kurum aç',
  'edu.new.desc': 'Önce temel bilgileri gir; kalan adımları kurum sayfasından istediğin zaman sürdürebilirsin.',
  'edu.new.kind': 'Kurum türü',
  'edu.new.kind.school': 'Okul',
  'edu.new.kind.schoolDesc': 'Tek bir okul; istersen kampüs ekleyebilirsin.',
  'edu.new.kind.chain': 'Okul grubu',
  'edu.new.kind.chainDesc': 'Bir merkez altında birden çok okul, bölge ve kampüs.',
  'edu.new.kind.course': 'Kurs merkezi',
  'edu.new.kind.courseDesc': 'Dershane, etüt ya da kurs; kurs grupları ile.',
  'edu.new.name': 'Kurum adı',
  'edu.new.city': 'Şehir (isteğe bağlı)',
  'edu.new.verifyHint': 'Kurumu açınca kurulum yetkisi sende olur. Öğrenci eklemek ve veli davet etmek için kurumun DijitalApp ekibi tarafından doğrulanması gerekir.',
  'edu.new.submit': 'Kurumu aç',
  'edu.new.notAllowed': 'Kurum açmak için e-postası doğrulanmış, reşit bir hesap gerekir; yeni kurum açma da şu an açık olmalı.',
  'edu.join.title': 'Davet',
  'edu.join.staff': 'Seni bu kurumda “{role}” görevine davet ediyorlar.',
  'edu.join.guardian': 'Bu davet {child} için {relation} olarak velilik isteği oluşturur.',
  'edu.join.guardianHint': 'Davet tek başına yetki vermez: kurum velilik bağını yüz yüze ya da belgeyle doğruladıktan sonra çocuğunun bilgilerini görürsün.',
  'edu.join.whichChild': 'Hangi çocuğunun kartında görünsün?',
  'edu.join.autoChild': 'Otomatik (aynı adlı kart ya da yeni kart)',
  'edu.join.student': 'Bu davet {child} öğrenci kaydını hesabına bağlar.',
  'edu.join.accept': 'Daveti kabul et',
  'edu.join.again': 'Zaten kabul ettin, sonucu göster',
  'edu.join.pendingDone': 'İsteğin kuruma iletildi. Kurum onaylayınca Tüm çocuklarım sayfasında göreceksin.',
  'edu.join.done': 'Davet kabul edildi.',
  'edu.join.continue': 'Devam et',
  'edu.org.title': 'Kurum',
  'edu.org.sections': 'Kurum bölümleri',
  'edu.org.readOnly': 'Bu kurum şu an salt okunur: bilgiler görünür ama değişiklik yapılamaz. Veriler silinmez.',
  'edu.org.unverified': 'Kurum henüz doğrulanmadı. Yapıyı kurabilirsin; öğrenci eklemek ve veli davet etmek doğrulamadan sonra açılır.',
  'edu.org.tab.status': 'Durum',
  'edu.org.tab.setup': 'Kurulum',
  'edu.org.tab.structure': 'Yıl ve dersler',
  'edu.org.tab.groups': 'Sınıflar',
  'edu.org.tab.students': 'Öğrenciler',
  'edu.org.tab.people': 'Personel',
  'edu.org.tab.guardians': 'Veliler',
  'edu.org.groups': 'Sınıf ve grup',
  'edu.org.enrolled': 'Kayıtlı öğrenci',
  'edu.org.subjects': 'Ders',
  'edu.org.noGroupsForYou': 'Sana atanmış bir sınıf yok. Görevlendirme yapılınca burada görünür.',
  'edu.setup.profile': 'Temel bilgiler',
  'edu.setup.verification': 'Kurum doğrulaması',
  'edu.setup.structure': 'Okul ve kampüs yapısı',
  'edu.setup.year': 'Eğitim yılı',
  'edu.setup.groups': 'Sınıflar ve dersler',
  'edu.setup.people': 'Personel ve öğrenciler',
  'edu.setup.done': 'tamamlandı',
  'edu.setup.todo': 'yapılacak',
  'edu.setup.verifyBody': 'DijitalApp ekibi kurumu inceler. Kurumu tanımamıza yardımcı olacak bir not bırak (ör. kurum kodu, resmî web sitesi, iletişim yolu). Belgeleri bu forma yükleme; ekip seninle iletişime geçer.',
  'edu.setup.verifyNote': 'Not',
  'edu.setup.verifySend': 'Doğrulama iste',
  'edu.setup.verifyPending': 'İsteğin alındı. İnceleme bitince bu sayfa güncellenir.',
  'edu.setup.plan': 'Paket ve kullanım',
  'edu.setup.planBody': 'Paket: {plan}. Öğrenci: {students} / {maxStudents}. Kurum birimi: {orgs} / {maxOrgs}.',
  'edu.setup.noBilling': 'Bu modülde şu an ödeme alınmıyor; paketi DijitalApp ekibi atar. Paket düşse de veriler silinmez, yalnızca yeni ekleme durur.',
  'adminEdu.menuLabel': 'Menüdeki ad',
  'adminEdu.menuLabelHelp': 'Menüde ve telefonun alt sekmesinde görünen kısa ad (2–20 karakter). Boş bırakılırsa “Okul” yazar.',
  'adminEdu.guardianMethods': 'Veli doğrulama yöntemleri',
  'adminEdu.guardianMethodsHelp': 'Kurumların bir velilik isteğini onaylarken seçebileceği yollar. En az biri açık kalır; kapatılan yöntemle onay verilemez.',
  'adminEdu.privacy': 'Aydınlatma ve saklama',
  'adminEdu.privacyHelp': 'Metnin kendisini hukuk danışmanınız hazırlar; burada yalnızca bağlantısı ve kısa bir not girilir. Bu ayarlar tek başına mevzuata uyum sağlamaz.',
  'adminEdu.privacyUrl': 'Aydınlatma metni bağlantısı',
  'adminEdu.privacyUrlHelp': 'https ile başlayan adres. Kurum açarken ve davet kabul edilirken gösterilir.',
  'adminEdu.privacyNote': 'Kısa not',
  'adminEdu.retention': 'Kapanan kurumların verisi',
  'adminEdu.retentionHelp': 'Açıksa, kapatılan bir kurumun tüm kayıtları ve dosyaları bu süre dolunca kalıcı olarak silinir (geri alınamaz). Kapalıyken hiçbir şey silinmez.',
  'adminEdu.retentionOn': 'Süre dolunca sil',
  'adminEdu.days': 'gün',
  'adminEdu.priceMonthly': 'Aylık fiyat (₺, 0 = gösterme)',
  'adminEdu.plansNote': 'Paket notu',
  'adminEdu.plansNoteHelp': 'Kurumların paket kartında görünür (ör. paket nasıl alınır).',
  'edu.setup.planPrice': 'Bu paketin aylık fiyatı: {price}',
  'edu.privacy.link': 'Aydınlatma metni',
  'edu.setup.orgs': 'Kurum yapısı',
  'edu.setup.parent': 'Bağlı olduğu birim',
  'edu.setup.orgKind': 'Birim türü',
  'edu.setup.orgName': 'Birim adı',
  'edu.setup.addOrg': 'Birim ekle',
  'edu.orgKind.head': 'Genel merkez',
  'edu.orgKind.region': 'Bölge',
  'edu.orgKind.school': 'Okul',
  'edu.orgKind.campus': 'Kampüs',
  'edu.orgKind.course': 'Kurs merkezi',
  'edu.structure.years': 'Eğitim yılları',
  'edu.structure.noYears': 'Henüz eğitim yılı yok. Sınıf açmadan önce bir yıl ekle.',
  'edu.structure.archived': 'Arşivde',
  'edu.structure.archive': 'Arşivle',
  'edu.structure.archiveConfirm': 'Yıl ve sınıfları arşive taşınır, kayıtlar silinmez.',
  'edu.structure.newYear': 'Yeni eğitim yılı',
  'edu.structure.yearName': 'Yıl adı',
  'edu.structure.starts': 'Başlangıç',
  'edu.structure.ends': 'Bitiş',
  'edu.structure.term1End': '1. dönem bitişi (isteğe bağlı)',
  'edu.structure.term2Start': '2. dönem başlangıcı (isteğe bağlı)',
  'edu.structure.term1': '1. dönem',
  'edu.structure.term2': '2. dönem',
  'edu.structure.addYear': 'Yılı ekle',
  'edu.structure.subjects': 'Dersler',
  'edu.structure.noSubjects': 'Henüz ders yok.',
  'edu.structure.subjectName': 'Ders adı',
  'edu.structure.addSubject': 'Ders ekle',
  'edu.groups.empty': 'Henüz sınıf yok. Aşağıdan ilk sınıfını aç.',
  'edu.groups.new': 'Yeni sınıf ya da grup',
  'edu.groups.needYear': 'Önce “Yıl ve dersler” bölümünden bir eğitim yılı ekle.',
  'edu.groups.year': 'Eğitim yılı',
  'edu.groups.kind': 'Tür',
  'edu.groups.name': 'Ad',
  'edu.groups.grade': 'Sınıf düzeyi (isteğe bağlı)',
  'edu.groups.add': 'Sınıfı aç',
  'edu.groups.roster': 'Öğrenci listesi',
  'edu.groups.noStudents': 'Bu sınıfta henüz öğrenci yok.',
  'edu.groupKind.class': 'Sınıf',
  'edu.groupKind.section': 'Şube',
  'edu.groupKind.course_group': 'Kurs grubu',
  'edu.group.students': { one: '{count} öğrenci', other: '{count} öğrenci' },
  'edu.teaching.assign': 'Öğretmen görevlendir',
  'edu.teaching.noTeachers': 'Kurumda öğretmen yok. Personel bölümünden öğretmen davet et.',
  'edu.teaching.subject': 'Ders',
  'edu.teaching.noSubject': 'Belirli bir ders yok',
  'edu.teaching.kind': 'Görev',
  'edu.teaching.subjectTeacher': 'Ders öğretmeni',
  'edu.teaching.homeroom': 'Sınıf öğretmeni',
  'edu.teaching.assistant': 'Yardımcı öğretmen',
  'edu.teaching.assignSubmit': 'Görevlendir',
  'edu.teaching.end': 'Görevi bitir',
  'edu.teaching.endConfirm': 'Öğretmen bu sınıfı artık görmez. Geçmiş kayıt kalır.',
  'edu.students.new': 'Öğrenci ekle',
  'edu.students.given': 'Ad',
  'edu.students.family': 'Soyad',
  'edu.students.no': 'Okul numarası (isteğe bağlı)',
  'edu.students.group': 'Sınıf',
  'edu.students.noGroup': 'Sınıfsız',
  'edu.students.minimal': 'Yalnızca eğitim için gereken bilgiler istenir. T.C. kimlik numarası, sağlık ya da ayrıntılı aile bilgisi girme.',
  'edu.students.add': 'Öğrenciyi ekle',
  'edu.students.search': 'Öğrenci ara',
  'edu.students.noMatch': 'Aramana uyan öğrenci yok.',
  'edu.students.empty': 'Henüz öğrenci yok.',
  'edu.students.guardians': { one: '{count} doğrulanmış veli', other: '{count} doğrulanmış veli' },
  'edu.students.hasAccount': 'hesabı bağlı',
  'edu.students.moveTo': 'Sınıf değiştir…',
  'edu.students.enrollIn': 'Sınıfa yerleştir…',
  'edu.students.archive': 'Kaydı kapat',
  'edu.students.archiveConfirm': 'Öğrencinin bu kurumdaki kaydı ve veli bağları kapanır; geçmiş silinmez. Diğer kurumlardaki kayıtları etkilenmez.',
  'edu.invite.link': 'Davet bağlantısı',
  'edu.invite.once': 'Bu bağlantı yalnızca şimdi gösterilir. Kişiye güvenli bir yoldan gönder; süresi dolunca ya da iptal edince çalışmaz.',
  'edu.invite.relation': 'Veli davetinde yakınlık',
  'edu.invite.guardian': 'Veli daveti',
  'edu.invite.student': 'Öğrenci hesabı daveti',
  'edu.people.invite': 'Personel davet et',
  'edu.people.role': 'Görev',
  'edu.people.uses': 'Kaç kişi kullanabilir',
  'edu.people.inviteHint': 'Davet süresi panel ayarına göre dolar. Yalnızca reşit hesaplar personel davetini kabul edebilir.',
  'edu.people.createInvite': 'Davet bağlantısı oluştur',
  'edu.people.title': 'Personel',
  'edu.people.end': 'Görevi bitir',
  'edu.people.endConfirm': '{name} bu görevle kurumu artık göremez. Geçmiş kayıt kalır.',
  'edu.people.invites': 'Davetler',
  'edu.people.used': '{used}/{max} kullanıldı',
  'edu.people.revoke': 'İptal et',
  'edu.people.revokeConfirm': 'Bağlantı hemen çalışmaz olur.',
  'edu.people.revoked': 'İptal edildi',
  'edu.people.closed': 'Kapandı',
  'edu.guardians.filter': 'Veli bağları',
  'edu.guardians.pending': 'Onay bekleyen',
  'edu.guardians.verified': 'Doğrulanmış',
  'edu.guardians.howTo': 'Davet kodu, soyadı ya da telefon tek başına velilik kanıtı değildir. Onaylamadan önce kişiyi yüz yüze, belgeyle ya da okul kaydıyla doğrula ve nasıl doğruladığını seç.',
  'edu.guardians.method': 'Doğrulama yolu',
  'edu.guardians.nonePending': 'Onay bekleyen veli isteği yok.',
  'edu.guardians.noneVerified': 'Doğrulanmış veli bağı yok.',
  'edu.guardians.of': '{student} için {relation}',
  'edu.guardians.verify': 'Doğrula',
  'edu.guardians.reject': 'Reddet',
  'edu.guardians.rejectConfirm': 'İstek reddedilir; kişi çocuğun bilgilerini görmez.',
  'edu.guardians.end': 'Bağı kaldır',
  'edu.guardians.endConfirm': 'Veli bu kurumdaki bilgileri artık görmez. Diğer kurumlardaki bağları etkilenmez.',
  'edu.method.in_person': 'Yüz yüze',
  'edu.method.document': 'Belge ile',
  'edu.method.school_record': 'Okul kaydı ile',
  'edu.relation.mother': 'anne',
  'edu.relation.father': 'baba',
  'edu.relation.legal_guardian': 'yasal temsilci',
  'edu.relation.other': 'diğer yakın',
  'edu.role.owner': 'Kurum sahibi',
  'edu.role.admin': 'Kurum yöneticisi',
  'edu.role.org_admin': 'Okul/kampüs yöneticisi',
  'edu.role.coordinator': 'Koordinatör',
  'edu.role.teacher': 'Öğretmen',
  'edu.role.counselor': 'Rehberlik uzmanı',
  'edu.role.staff': 'İdari personel',
  'edu.pick': 'Seç',
  'edu.saved': 'Kaydedildi',
  'edu.error.unverified': 'Kurum henüz doğrulanmadı. Kurulum › Kurum doğrulaması adımından doğrulama iste.',
  'edu.error.limit': 'Paketinin sınırına ulaştın. Daha fazlası için DijitalApp ekibiyle paketini görüş; mevcut veriler korunur.',
  'edu.error.invite': 'Bu davet geçersiz, süresi dolmuş, iptal edilmiş ya da kullanılmış. Kurumdan yeni bir davet iste.',
  'edu.error.off': 'Bu özellik şu an kapalı.',
  'edu.error.notFound': 'Bulunamadı ya da artık görme yetkin yok.',
  'edu.error.forbidden': 'Bu işlem için yetkin yok. Kurum yöneticinle görüş.',
  'edu.error.duplicate': 'Aynı adla ya da numarayla bir kayıt zaten var.',
  'edu.error.notTeacher': 'Bu kişinin kurumda öğretmen görevi yok. Önce öğretmen olarak davet et.',
  'adminEdu.title': 'Eğitim',
  'adminEdu.intro': 'Eğitim modülü: kurumlar, okul ve kampüsler, sınıflar, öğrenci kayıtları ve doğrulanmış veli bağları. Personel burada kurumları doğrular ve ayarları yönetir; öğrenci ya da veli bilgisi bu ekranda gösterilmez.',
  'adminEdu.system': 'Modül',
  'adminEdu.systemDesc': 'Kapalıyken menüde görünmez ve tüm istekler reddedilir. Kişiye, plana ya da bölgeye göre açmak için Yapılandırma › bayraklar.',
  'adminEdu.on': 'Açık',
  'adminEdu.off': 'Kapalı',
  'adminEdu.enable': 'Aç',
  'adminEdu.disable': 'Kapat',
  'adminEdu.enableTitle': 'Eğitim modülü herkese açılsın mı?',
  'adminEdu.enableBody': 'Menüde “Okul” bölümü görünür ve reşit hesaplar kurum açabilir (aşağıdaki ayara göre). Kurumlar doğrulanmadan öğrenci eklenemez.',
  'adminEdu.settings': 'Ayarlar',
  'adminEdu.settingsDesc': 'Görünen ad, açılıp kapanabilen bölümler, kurum açma, davet süresi ve paket sınırları.',
  'adminEdu.displayName': 'Görünen ad',
  'adminEdu.displayNameHelp': 'Modülün sayfa başlığında görünür (2–40 karakter). Teknik adlar bu ada bağlı değildir.',
  'adminEdu.module.guardians': 'Veli bağlantıları',
  'adminEdu.module.guardiansDesc': 'Kurumlar veli daveti gönderebilir; veliler Tüm çocuklarım sayfasını kullanır.',
  'adminEdu.module.student_accounts': 'Öğrenci hesapları',
  'adminEdu.module.student_accountsDesc': 'Öğrenci kaydı, öğrencinin kendi DijitalApp hesabına bağlanabilir.',
  'adminEdu.module.courses': 'Kurs merkezleri',
  'adminEdu.module.coursesDesc': 'Kurs merkezi türünde kurum ve birim açılabilir.',
  'adminEdu.openRegistration': 'Herkes kurum açabilir',
  'adminEdu.openRegistrationHelp': 'Kapalıysa yeni kurum açılamaz; mevcut kurumlar çalışmaya devam eder.',
  'adminEdu.maxOwned': 'Bir kişinin açabileceği kurum',
  'adminEdu.inviteDays': 'Davet süresi (gün)',
  'adminEdu.plans': 'Paketler',
  'adminEdu.plansHelp': 'Ödeme alınmaz; paket kuruma elle atanır. Sınırlar sunucuda, eş zamanlı isteklerde de korunur. Paket düşerse veri silinmez.',
  'adminEdu.plan.trial': 'Deneme',
  'adminEdu.plan.standard': 'Standart',
  'adminEdu.plan.plus': 'Plus',
  'adminEdu.maxStudents': 'Öğrenci',
  'adminEdu.maxOrgs': 'Birim',
  'adminEdu.saved': 'Kaydedildi',
  'adminEdu.queue': 'Kurumlar',
  'adminEdu.queueDesc': 'Doğrulama istekleri ve tüm kurumlar. Belge kontrolü bant dışında yapılır.',
  'adminEdu.all': 'Tümü',
  'adminEdu.empty': 'Bu filtrede kurum yok.',
  'adminEdu.counts': '{orgs} birim, {students} öğrenci',
  'adminEdu.note': 'Not: {note}',
  'adminEdu.verify': 'Doğrula',
  'adminEdu.reject': 'Reddet',
  'adminEdu.verifyTitle': '{name} doğrulansın mı?',
  'adminEdu.verifyBody': 'Kurum öğrenci ekleyebilir ve veli davet edebilir. Kurumu bant dışında kontrol ettiğinden emin ol.',
  'adminEdu.rejectTitle': '{name} reddedilsin mi?',
  'adminEdu.rejectBody': 'Kurum yeniden doğrulama isteyebilir. Kurulum verileri silinmez.',
  'adminEdu.suspend': 'Askıya al',
  'adminEdu.resume': 'Yeniden aç',
  'adminEdu.suspended': 'Askıda',
  'adminEdu.suspendTitle': '{name} askıya alınsın mı?',
  'adminEdu.suspendBody': 'Kurum salt okunur olur: veriler görünür, değişiklik yapılamaz. Hiçbir şey silinmez.',
  'edu.push.announcement': '{org}: yeni bir duyuru var',
  'edu.push.assignment': '{org}: yeni bir ödev var',
  'edu.push.feedback': '{org}: ödeve geri bildirim geldi',
  'edu.push.guardianVerified': '{org} velilik bağını onayladı',
  'edu.org.tab.announcements': 'Duyurular',
  'edu.ann.title': 'Duyuru',
  'edu.ann.new': 'Yeni duyuru',
  'edu.ann.list': 'Duyurular',
  'edu.ann.none': 'Henüz duyuru yok.',
  'edu.ann.scope': 'Kime',
  'edu.ann.scopeOrg': '{org} geneli',
  'edu.ann.audience': 'Okuyacaklar',
  'edu.ann.aud.guardians': 'Veliler',
  'edu.ann.aud.students': 'Öğrenciler',
  'edu.ann.aud.staff': 'Personel ve öğretmenler',
  'edu.ann.fieldTitle': 'Başlık',
  'edu.ann.fieldBody': 'Metin',
  'edu.ann.requiresAck': 'Okuyanlardan “okudum, onaylıyorum” iste',
  'edu.ann.urgentBox': 'Acil: sessiz saatlerde de bildirim gönder',
  'edu.ann.urgent': 'Acil',
  'edu.ann.when': 'Ne zaman',
  'edu.ann.when.now': 'Şimdi yayınla',
  'edu.ann.when.later': 'İleri bir zamanda yayınla',
  'edu.ann.when.draft': 'Taslak olarak kaydet',
  'edu.ann.at': 'Yayın zamanı ({zone} saatiyle)',
  'edu.ann.pickTime': 'Yayın için ileri bir tarih ve saat seç.',
  'edu.ann.submit.now': 'Yayınla',
  'edu.ann.submit.later': 'Zamanla',
  'edu.ann.submit.draft': 'Taslağı kaydet',
  'edu.ann.status.draft': 'Taslak',
  'edu.ann.status.scheduled': 'Zamanlandı',
  'edu.ann.status.published': 'Yayında',
  'edu.ann.status.archived': 'Arşivde',
  'edu.ann.forChild': '{child} için',
  'edu.ann.publishedAt': '{when} · {author}',
  'edu.ann.scheduledFor': '{when} tarihinde yayınlanacak',
  'edu.ann.edited': { one: 'Yayından sonra düzenlendi ({when}).', other: 'Yayından sonra {count} kez düzenlendi (son: {when}).' },
  'edu.ann.editHint': 'Yayındaki duyuruyu düzenlersen okuyanlar “düzenlendi” notunu görür; yeniden bildirim gönderilmez.',
  'edu.ann.edit': 'Düzenle',
  'edu.ann.publishNow': 'Şimdi yayınla',
  'edu.ann.archive': 'Arşivle',
  'edu.ann.ackAsk': 'Bu duyuru okuduğunu onaylamanı istiyor.',
  'edu.ann.ackAgain': 'Onayından sonra duyuru değişti. Yeni hâlini okuyup yeniden onayla.',
  'edu.ann.ack': 'Okudum, onaylıyorum',
  'edu.ann.acked': '{when} tarihinde onayladın.',
  'edu.ann.stats': 'Alıcı: {recipients} · Açan: {viewed} · Onaylayan: {acknowledged}',
  'edu.files.title': 'Ekler',
  'edu.files.add': 'Dosya ekle',
  'edu.files.limit': 'Dosya başına en fazla 20 MB. Çalıştırılabilir dosya, HTML ve arşiv kabul edilmez.',
  'edu.files.uploading': 'Yükleniyor…',
  'edu.files.done': 'Yüklendi',
  'edu.files.remove': '{name} dosyasını kaldır',
  'edu.files.fixFirst': 'Yüklenemeyen dosyayı yeniden dene ya da kaldır; sonra gönderebilirsin.',
  'edu.hw.title': 'Ödev',
  'edu.hw.list': 'Ödevler',
  'edu.hw.none': 'Bu sınıfta henüz ödev yok.',
  'edu.hw.new': 'Yeni ödev',
  'edu.hw.instructions': 'Yönerge',
  'edu.hw.dueField': 'Son teslim ({zone} saatiyle, isteğe bağlı)',
  'edu.hw.latePolicy': 'Geç teslim',
  'edu.hw.lateMarked': 'Geç teslim kabul edilir, işaretlenir',
  'edu.hw.lateRefused': 'Son teslimden sonra kabul edilmez',
  'edu.hw.pointsOptional': 'Puan (isteğe bağlı)',
  'edu.hw.pointsOf': 'Puan (en fazla {max})',
  'edu.hw.saveDraft': 'Taslak kaydet',
  'edu.hw.publish': 'Yayınla',
  'edu.hw.archive': 'Arşivle',
  'edu.hw.status.draft': 'Taslak',
  'edu.hw.status.published': 'Yayında',
  'edu.hw.status.archived': 'Arşivde',
  'edu.hw.handedIn': '{submitted}/{students} teslim',
  'edu.hw.due': 'Son teslim: {when}',
  'edu.hw.noDue': 'Son teslim tarihi yok',
  'edu.hw.maxPoints': 'En fazla {points} puan',
  'edu.hw.mine': 'Teslimim',
  'edu.hw.answer': 'Cevabın',
  'edu.hw.submit': 'Teslim et',
  'edu.hw.resubmit': 'Yeniden teslim et',
  'edu.hw.received': 'Teslim alındı: {when} ({attempt}. deneme)',
  'edu.hw.closed': 'Öğretmenin teslimini geri verdi; değiştirmek için öğretmeninden düzeltme istemesini bekle.',
  'edu.hw.tooLate': 'Son teslim zamanı geçti ve bu ödev geç teslim kabul etmiyor.',
  'edu.hw.lateNote': 'Son teslim zamanı geçti: teslimin “geç” olarak işaretlenecek.',
  'edu.hw.revisionAsked': 'Öğretmenin düzeltme istedi. Geri bildirimi oku ve yeniden teslim et.',
  'edu.hw.feedback': 'Geri bildirim',
  'edu.hw.points': '{points} puan',
  'edu.hw.childState': '{child} için durum',
  'edu.hw.guardianNote': 'Veliler teslimin durumunu, geri bildirimi ve puanı görür; öğrencinin cevabını görmez.',
  'edu.hw.follow': 'Sınıfın durumu',
  'edu.hw.open': 'Aç',
  'edu.hw.askRevision': 'Düzeltme iste',
  'edu.hw.return': 'Geri ver',
  'edu.state.not_submitted': 'Teslim edilmedi',
  'edu.state.missing': 'Eksik (süre geçti)',
  'edu.state.submitted': 'Teslim edildi',
  'edu.state.late': 'Geç teslim',
  'edu.state.returned': 'Geri verildi',
  'edu.state.revision_requested': 'Düzeltme istendi',
  'edu.ch.title': 'Sınıf kanalları',
  'edu.ch.hint': 'Kanallar normal DijitalApp gruplarıdır. Üyeler kurum kayıtlarından gelir; kimse sessizce eklenmez, uygun olanlar Okul sayfasından katılır. Kaydı ya da velilik bağı biten kanaldan çıkar.',
  'edu.ch.kind.announcements': 'Duyuru kanalı',
  'edu.ch.kind.guardians': 'Veli–öğretmen grubu',
  'edu.ch.kind.class_room': 'Sınıf etkileşim alanı',
  'edu.ch.kind.staff_room': 'Öğretmenler odası',
  'edu.ch.ready': '“{title}” hazır.',
  'edu.ch.open': 'Sohbeti aç',
  'edu.ch.join': 'Katıl',
  'edu.ch.joined': 'Üyesin',
  'edu.quiet.title': 'Sessiz saatler',
  'edu.quiet.body': 'Bu saatlerde gönderilenler uygulamada hemen görünür; telefona bildirim sessiz saat bitince gider (acil duyurular hariç). Saatler {zone} saatine göre.',
  'edu.quiet.on': 'Sessiz saatleri kullan',
  'edu.quiet.start': 'Başlangıç',
  'edu.quiet.end': 'Bitiş',
  'edu.home.today': 'Bugün önemli',
  'edu.home.dueTitle': 'Yaklaşan ve eksik ödevler',
  'edu.home.unreadTitle': 'Okunmamış duyurular',
  'edu.home.channels': 'Sınıf kanalları',
  'edu.home.bell': { one: '{count} yeni bildirim', other: '{count} yeni bildirim' },
  'edu.home.bellNone': 'Bildirimler',
  'edu.notif.title': 'Bildirimler',
  'edu.notif.none': 'Henüz bildirim yok.',
  'edu.notif.readAll': 'Tümünü okundu say',
  'edu.notif.kind.announcement': 'Duyuru',
  'edu.notif.kind.assignment': 'Ödev',
  'edu.notif.kind.feedback': 'Geri bildirim',
  'edu.notif.kind.guardian_verified': 'Velilik onaylandı',
  'edu.child.announcements': 'Duyurular',
  'edu.child.homework': 'Ödevler',
  'edu.child.noAnnouncements': 'Bu kurumdan duyuru yok.',
  'edu.child.noHomework': 'Bu kurumda ödev yok.',
  'adminEdu.module.channels': 'Sınıf kanalları',
  'adminEdu.module.channelsDesc': 'Öğretmenler sınıf duyuru kanalı, veli–öğretmen grubu ve öğretmenler odası açabilir. Üyelik kayıtlardan gelir.',
  'adminEdu.module.class_rooms': 'Öğrenci etkileşim alanları',
  'adminEdu.module.class_roomsDesc': 'Öğretmen ve öğrencilerin yazıştığı sınıf grupları. Reşit olmayanlar içerdiği için varsayılan kapalı; açmadan önce kurum politikasını belirle.',
  'edu.org.tab.curriculum': 'Kazanımlar',
  'adminEdu.module.curriculum': 'Müfredat ve kazanımlar',
  'adminEdu.module.curriculumDesc': 'Kurumlar kendi kazanım listelerini tutar, sınıfların yıllık planını yapar ve işlenen konuları işaretler; veliler son işlenen konuları görür.',
  'edu.org.tab.assessments': 'Değerlendirme',
  'adminEdu.module.assessments': 'Sınav ve değerlendirme',
  'adminEdu.module.assessmentsDesc': 'Öğretmenler sınav, yazılı, proje ve sözlü notlarını puanla ya da rubrikle girer; öğrenci ve veli yalnızca kendi sonucunu görür. Resmî e-Okul kaydı değildir.',
  'edu.org.tab.forms': 'Formlar',
  'adminEdu.module.forms': 'İzin ve bilgi formları',
  'adminEdu.module.formsDesc': 'Kurumlar gezi izni, fotoğraf izni ya da bilgi toplama formlarını velilere ya da öğrencilere gönderir; her öğrenci için bir yanıt toplanır. Islak ya da elektronik imza yerine geçmez.',
  'edu.org.tab.requests': 'Talepler',
  'adminEdu.module.requests': 'Personel talepleri ve onay zinciri',
  'adminEdu.module.requestsDesc': 'Personel izin dilekçesi, materyal ya da etkinlik onayı gibi talepler açar; talep, kurumun tanımladığı sırayla rollerin onayından geçer. Kimse kendi talebini onaylayamaz.',
  'edu.push.request': '{org}: bir talep sizi bekliyor ya da sonuçlandı',
  'edu.notif.kind.request': 'Talep',
  'edu.req.title': 'Talep',
  'edu.req.intro': 'Personel talepleri: izin dilekçesi, materyal ya da etkinlik onayı. Her talep türünün kurumun belirlediği bir onay zinciri vardır; sıra gelen rolü taşıyan kişi onaylar ya da gerekçeyle reddeder.',
  'edu.req.boxes': 'Talep kutuları',
  'edu.req.box.todo': 'Onayımı bekleyenler',
  'edu.req.box.mine': 'Taleplerim',
  'edu.req.box.all': 'Tümü',
  'edu.req.empty.todo': 'Onayınızı bekleyen talep yok.',
  'edu.req.empty.mine': 'Henüz talep açmadınız.',
  'edu.req.empty.all': 'Henüz talep yok.',
  'edu.req.waitingFor': '{role} onayında',
  'edu.req.new': 'Yeni talep',
  'edu.req.type': 'Talep türü',
  'edu.req.chain': 'Onay sırası: {roles}',
  'edu.req.body': 'Açıklama',
  'edu.req.startsOn': 'Başlangıç',
  'edu.req.endsOn': 'Bitiş (isteğe bağlı)',
  'edu.req.submit': 'Talebi gönder',
  'edu.req.noTypes': 'Kurumunuz henüz talep türü tanımlamadı.',
  'edu.req.noTypesAdmin': 'Talep açılabilmesi için aşağıdan en az bir talep türü tanımlayın.',
  'edu.req.types': 'Talep türleri ve onay zincirleri',
  'edu.req.typesHint': 'Her tür için onay sırasını belirleyin. Değişiklik yalnızca yeni taleplere uygulanır; süren talepler açıldıkları andaki sırayla ilerler.',
  'edu.req.archiveTypeConfirm': '“{title}” arşivlensin mi? Yeni talep açılamaz; süren talepler devam eder.',
  'edu.req.newType': 'Yeni talep türü',
  'edu.req.typeTitle': 'Tür adı',
  'edu.req.typeDescription': 'Açıklama (isteğe bağlı)',
  'edu.req.askDates': 'Tarih aralığı iste (izin, etkinlik)',
  'edu.req.chainTitle': 'Onay zinciri',
  'edu.req.remove': 'Kaldır',
  'edu.req.removeStep': '{n}. adımı kaldır',
  'edu.req.addStep': 'Adım ekle',
  'edu.req.by': '{who}, {when}',
  'edu.req.approvedBy': '{who} onayladı ({when})',
  'edu.req.rejectedBy': '{who} reddetti ({when})',
  'edu.req.waiting': 'Onay bekliyor',
  'edu.req.noApprover': 'Şu anda bu adımın rolünü taşıyan kimse yok; talep ilerleyemez. Kurum yöneticisi rolü birine atayabilir.',
  'edu.req.decide': 'Kararınız',
  'edu.req.note': 'Not (reddederken zorunlu)',
  'edu.req.reject': 'Reddet',
  'edu.req.approve': 'Onayla',
  'edu.req.withdraw': 'Talebi geri çek',
  'edu.req.withdrawConfirm': 'Talep geri çekilsin mi?',
  'edu.req.status.pending': 'Onay bekliyor',
  'edu.req.status.approved': 'Onaylandı',
  'edu.req.status.rejected': 'Reddedildi',
  'edu.req.status.withdrawn': 'Geri çekildi',
  'edu.push.form': '{org}: yanıt bekleyen bir form var',
  'edu.notif.kind.form': 'Form',
  'edu.form.title': 'Form',
  'edu.form.intro': 'İzin ve bilgi formları: sınıfın öğretmenleri kendi sınıfına, duyuru yetkisi olanlar birimin tamamına gönderir. Her öğrenci için bir yanıt alınır (velilerinden biri ya da öğrencinin kendisi); form açıkken yanıt değiştirilebilir.',
  'edu.form.none': 'Henüz form yok.',
  'edu.form.new': 'Yeni form',
  'edu.form.wholeOrg': 'Tüm birim',
  'edu.form.wholeOrgOf': '{org} (tüm birim)',
  'edu.form.toGuardians': 'Velilere',
  'edu.form.toStudents': 'Öğrencilere',
  'edu.form.dueShort': 'son: {when}',
  'edu.form.due': 'Son yanıt: {when}',
  'edu.form.answeredN': { one: '{count} yanıt', other: '{count} yanıt' },
  'edu.form.status.draft': 'Taslak',
  'edu.form.status.open': 'Açık',
  'edu.form.status.closed': 'Kapandı',
  'edu.form.body': 'Açıklama',
  'edu.form.to': 'Kime',
  'edu.form.audience': 'Kim yanıtlar',
  'edu.form.dueField': 'Son yanıt zamanı (isteğe bağlı, {zone})',
  'edu.form.askDecision': '“Onaylıyorum / Onaylamıyorum” kararı iste',
  'edu.form.questions': 'Sorular',
  'edu.form.noQuestions': 'Soru eklemeden yalnızca onay kararı istenebilir.',
  'edu.form.questionN': '{n}. soru',
  'edu.form.questionLabel': 'Soru',
  'edu.form.questionType': 'Tür',
  'edu.form.type.yesno': 'Evet / Hayır',
  'edu.form.type.choice': 'Seçenekli',
  'edu.form.type.text': 'Metin',
  'edu.form.type.date': 'Tarih',
  'edu.form.type.check': 'Onay kutusu',
  'edu.form.options': 'Seçenekler (her satıra bir tane)',
  'edu.form.required': 'Zorunlu',
  'edu.form.removeQuestion': 'Soruyu kaldır',
  'edu.form.addQuestion': 'Soru ekle',
  'edu.form.notSignature': 'Bu form ıslak ya da elektronik imza yerine geçmez; yanıtlayan kişi ve zaman kayıt altına alınır.',
  'edu.form.saveDraft': 'Taslak olarak kaydet',
  'edu.form.answers': 'Yanıtlar',
  'edu.form.questionsN': { one: '{count} soru', other: '{count} soru' },
  'edu.form.draftHint': 'Taslak: kimse görmüyor. Gönderince velilere ya da öğrencilere bir kez bildirim gider; gönderdikten sonra sorular değiştirilemez.',
  'edu.form.counts': '{total} öğrenciden {answered} tanesi için yanıt geldi.',
  'edu.form.countsDecision': '{total} öğrenciden {answered} yanıt: {approved} onay, {declined} ret.',
  'edu.form.decision': 'Karar',
  'edu.form.approved': 'Onaylandı',
  'edu.form.declined': 'Onaylanmadı',
  'edu.form.pending': 'Bekliyor',
  'edu.form.respondedBy': 'Yanıtlayan',
  'edu.form.csv': 'CSV indir',
  'edu.form.send': 'Gönder',
  'edu.form.sendConfirm': 'Form gönderilsin mi? Bildirim bir kez gider ve sorular artık değiştirilemez.',
  'edu.form.close': 'Formu kapat',
  'edu.form.closeConfirm': 'Form kapatılsın mı? Yeni yanıt ve değişiklik alınmaz.',
  'edu.form.yes': 'Evet',
  'edu.form.no': 'Hayır',
  'edu.form.yourAnswer': 'Yanıtınız',
  'edu.form.answeredAt': '{who} {when} tarihinde yanıtladı.',
  'edu.form.notOpen': 'Bu form artık yanıt almıyor.',
  'edu.form.approve': 'Onaylıyorum',
  'edu.form.decline': 'Onaylamıyorum',
  'edu.form.thanks': 'Yanıtınız kaydedildi',
  'edu.form.update': 'Yanıtı güncelle',
  'edu.form.submit': 'Gönder',
  'edu.form.mine': 'Formlar',
  'edu.form.waiting': 'Yanıt bekliyor',
  'edu.form.answered': 'Yanıtlandı',
  'edu.push.assessment': '{org}: yeni bir değerlendirme sonucu var',
  'edu.notif.kind.assessment': 'Değerlendirme',
  'edu.asm.intro': 'Kurumun kendi değerlendirmeleri; resmî e-Okul notu değildir. Rubrikler bu birimde ve alt birimlerinde kullanılabilir. Bir sınav rubriğin o anki kopyasını saklar; rubrik sonradan değişse de verilen notlar değişmez.',
  'edu.asm.title': 'Değerlendirmeler',
  'edu.asm.rubrics': 'Rubrikler',
  'edu.asm.rubric': 'Rubrik',
  'edu.asm.noRubrics': 'Henüz rubrik yok.',
  'edu.asm.newRubric': 'Yeni rubrik',
  'edu.asm.rubricTitle': 'Rubrik adı',
  'edu.asm.rubricArchiveConfirm': '“{title}” arşivlensin mi? Onu kullanan sınavlardaki notlar korunur.',
  'edu.asm.criteriaCount': { one: '{count} ölçüt', other: '{count} ölçüt' },
  'edu.asm.maxPoints': 'en çok {points} puan',
  'edu.asm.criterion': 'Ölçüt',
  'edu.asm.criterionN': '{n}. ölçüt',
  'edu.asm.levels': 'Düzeyler',
  'edu.asm.levelLabel': '{n}. düzey adı',
  'edu.asm.levelPoints': '{n}. düzeyin puanı',
  'edu.asm.addLevel': 'Düzey ekle',
  'edu.asm.removeLevel': 'Son düzeyi kaldır',
  'edu.asm.addCriterion': 'Ölçüt ekle',
  'edu.asm.removeCriterion': 'Ölçütü kaldır',
  'edu.asm.none': 'Bu sınıfta henüz değerlendirme yok.',
  'edu.asm.new': 'Yeni değerlendirme',
  'edu.asm.create': 'Oluştur',
  'edu.asm.draft': 'Taslak',
  'edu.asm.markedOf': '{marked}/{students} not girildi',
  'edu.asm.kindField': 'Tür',
  'edu.asm.kind.exam': 'Sınav',
  'edu.asm.kind.quiz': 'Kısa sınav',
  'edu.asm.kind.project': 'Proje',
  'edu.asm.kind.oral': 'Sözlü',
  'edu.asm.kind.performance': 'Performans görevi',
  'edu.asm.heldOn': 'Tarih',
  'edu.asm.markWith': 'Puanlama',
  'edu.asm.withPoints': 'Puanla',
  'edu.asm.withRubric': 'Rubrikle',
  'edu.asm.maxPointsField': 'En yüksek puan',
  'edu.asm.pickRubric': 'Rubrik seç',
  'edu.asm.achievement': 'Kazanımlara göre başarı',
  'edu.asm.achievementNone': 'Bu derste kazanıma bağlı yayınlanmış değerlendirme yok.',
  'edu.asm.achievementHint': 'Yayınlanmış değerlendirmelerdeki ortalama yüzde. {min} öğrenciden azının notu varsa ortalama gösterilmez; öğrenciler sıralanmaz.',
  'edu.asm.tooFew': 'Yeterli not yok',
  'edu.asm.average': { one: 'ortalama %{percent} ({count} değerlendirme)', other: 'ortalama %{percent} ({count} değerlendirme)' },
  'edu.asm.notOfficial': 'Bu not kurumun kendi değerlendirmesidir; resmî e-Okul kaydı değildir.',
  'edu.asm.result': 'Sonuç',
  'edu.asm.notMarked': 'Not girilmedi',
  'edu.asm.absent': 'Girmedi',
  'edu.asm.scoreLine': '{points} / {max} (%{percent})',
  'edu.asm.comment': 'Not',
  'edu.asm.marks': 'Notlar',
  'edu.asm.draftHint': 'Taslak: notları kaydedebilirsiniz, öğrenci ve veliler yayınlayana kadar görmez.',
  'edu.asm.publishedHint': 'Yayında: yaptığınız düzeltmeleri öğrenci ve veliler hemen görür; yeniden bildirim gitmez.',
  'edu.asm.noStudents': 'Bu sınıfta kayıtlı öğrenci yok.',
  'edu.asm.student': 'Öğrenci',
  'edu.asm.points': 'Puan (en çok {max})',
  'edu.asm.absentCol': 'Girmedi',
  'edu.asm.levelFor': '{name} için {criterion} düzeyi',
  'edu.asm.pointsFor': '{name} için puan',
  'edu.asm.absentFor': '{name} girmedi',
  'edu.asm.commentFor': '{name} için not',
  'edu.asm.saveMarks': 'Notları kaydet',
  'edu.asm.publish': 'Yayınla',
  'edu.asm.publishConfirm': 'Yayınlansın mı? Öğrenciler ve veliler yalnızca kendi sonuçlarını görür ve bir kez bildirim alır.',
  'edu.asm.results': 'Değerlendirme sonuçları',
  'edu.cur.pickSubject': 'Ders seç',
  'edu.cur.noSubjects': 'Önce Yıl ve dersler sekmesinden bir ders ekleyin.',
  'edu.cur.intro': 'Kurumunuzun kendi kazanım listesi: üniteler ve kazanımlar, kod ve sınıf düzeyiyle. MEB ya da başka bir kaynaktan otomatik veri gelmez; elle ya da kendi CSV dosyanızla eklersiniz.',
  'edu.cur.empty': 'Bu derste henüz kazanım yok.',
  'edu.cur.loose': 'Ünitesiz kazanımlar',
  'edu.cur.archive': 'Arşivle',
  'edu.cur.archiveOne': '{code} kazanımını arşivle',
  'edu.cur.archiveConfirm': '{code} arşivlensin mi? Planlarda ve ödevlerde görünmeye devam eder, yeni seçimlerde çıkmaz.',
  'edu.cur.archiveUnitConfirm': '“{title}” ünitesi ve içindeki kazanımlar arşivlensin mi?',
  'edu.cur.gradeLabel': '{grade}. sınıf',
  'edu.cur.unitEmpty': 'Bu ünitede kazanım yok.',
  'edu.cur.addUnit': 'Ünite ekle',
  'edu.cur.unitTitle': 'Ünite adı',
  'edu.cur.grade': 'Sınıf düzeyi (isteğe bağlı)',
  'edu.cur.add': 'Ekle',
  'edu.cur.addOutcome': 'Kazanım ekle',
  'edu.cur.unit': 'Ünite',
  'edu.cur.noUnit': 'Ünitesiz',
  'edu.cur.code': 'Kod',
  'edu.cur.text': 'Kazanım',
  'edu.cur.importTitle': 'CSV ile kazanım aktar',
  'edu.cur.importHint': 'Sütunlar: Ünite; Kod; Kazanım; Sınıf (Excel’in Türkçe CSV’si de okunur). Önce kontrol edilir; tek bir satırda hata varsa hiçbiri eklenmez.',
  'edu.cur.importFile': 'CSV dosyası',
  'edu.cur.importErrors': { one: '{count} satırda sorun var; düzeltip yeniden yükleyin.', other: '{count} satırda sorun var; düzeltip yeniden yükleyin.' },
  'edu.cur.importReady': { one: '{count} satır hazır.', other: '{count} satır hazır.' },
  'edu.cur.importApply': { one: '{count} kazanımı ekle', other: '{count} kazanımı ekle' },
  'edu.cur.imported': '{outcomes} kazanım ve {units} yeni ünite eklendi.',
  'edu.cur.line': 'Satır',
  'edu.cur.problem': 'Sorun',
  'edu.cur.err.code': 'Kod boş ya da çok uzun',
  'edu.cur.err.text': 'Kazanım boş ya da çok uzun',
  'edu.cur.err.unit': 'Ünite adı çok uzun',
  'edu.cur.err.grade': 'Sınıf düzeyi çok uzun',
  'edu.cur.err.duplicate_in_file': 'Bu kod dosyada iki kez var',
  'edu.cur.err.exists': 'Bu kod zaten listede',
  'edu.cur.coverage': 'Sınıflara göre ilerleme',
  'edu.cur.coverageHint': 'Her sınıfta bu dersin kaç kazanımının plana alındığı ve işlendi olarak işaretlendiği.',
  'edu.cur.coverageNone': 'Bu birimde etkin sınıf yok.',
  'edu.cur.class': 'Sınıf',
  'edu.cur.planned': 'Planda',
  'edu.cur.done': 'İşlendi',
  'edu.cur.ofTotal': '{n} / {total}',
  'edu.cur.openPlan': 'Yıllık planı aç',
  'edu.cur.planTitle': '{group} yıllık planı',
  'edu.cur.planSummary': '{total} kazanımdan {planned} tanesi planda, {done} tanesi işlendi.',
  'edu.cur.weekOf': '{code} için hafta',
  'edu.cur.covered': 'İşlendi',
  'edu.cur.pickerTitle': 'Bu ödevin kazanımları (isteğe bağlı)',
  'edu.cur.pickerEmpty': 'Bu dersin kazanım listesi boş.',
  'edu.cur.practises': 'Kazanımlar',
  'edu.cur.topicsTitle': 'Son işlenen konular',
  'adminEdu.storageMb': 'Depolama (MB)',
  'edu.org.tab.timetable': 'Ders programı',
  'edu.tt.title': 'Haftalık ders programı',
  'edu.tt.group': 'Sınıf',
  'edu.tt.period': 'Ders saati',
  'edu.tt.day': 'Gün',
  'edu.tt.room': 'Derslik',
  'edu.tt.noRoom': 'Derslik yok',
  'edu.tt.noTeacher': 'Öğretmen seçilmedi',
  'edu.tt.noPeriods': 'Önce aşağıdan ders saatlerini (zil çizelgesi) gir.',
  'edu.tt.noPeriodsRead': 'Bu kurumun ders saatleri henüz girilmedi.',
  'edu.tt.add': 'Programa ders ekle',
  'edu.tt.addSubmit': 'Dersi ekle',
  'edu.tt.validHint': 'Ders {year} eğitim yılı boyunca her hafta tekrarlanır.',
  'edu.tt.remove': '{what} dersini programdan çıkar',
  'edu.tt.removeShort': 'Çıkar',
  'edu.tt.clash.teacher': 'Öğretmen bu saatte {group} sınıfında derste.',
  'edu.tt.clash.room': 'Derslik bu saatte {group} sınıfına ayrılmış.',
  'edu.tt.clash.group': 'Sınıfın bu saatte zaten dersi var ({group}).',
  'edu.tt.bells': 'Ders saatleri',
  'edu.tt.starts': '{n}. ders başlangıcı',
  'edu.tt.ends': '{n}. ders bitişi',
  'edu.tt.addPeriod': 'Ders saati ekle',
  'edu.tt.removePeriod': '{n}. ders saatini kaldır',
  'edu.tt.rooms': 'Derslikler',
  'edu.tt.noRooms': 'Henüz derslik yok.',
  'edu.tt.roomName': 'Derslik adı',
  'edu.tt.addRoom': 'Derslik ekle',
  'edu.tt.today': 'Bugünkü derslerim',
  'edu.att.title': 'Yoklama · {group}',
  'edu.att.titlePlain': 'Yoklama',
  'edu.att.notOfficial': 'Bu, kurumun kendi yoklama kaydıdır; resmî (e-Okul) devamsızlık kaydı değildir.',
  'edu.att.day': 'Gün',
  'edu.att.present': 'Var',
  'edu.att.absent': 'Yok',
  'edu.att.late': 'Geç',
  'edu.att.excused': 'İzinli',
  'edu.att.markFor': '{name} için yoklama',
  'edu.att.take': 'Yoklama al',
  'edu.att.taken': 'Yoklama alındı',
  'edu.att.takenBy': '{when} tarihinde {who} aldı.',
  'edu.att.save': 'Yoklamayı kaydet',
  'edu.att.saveChanges': 'Değişiklikleri kaydet',
  'edu.att.reason': { one: 'Kayıtlı {count} işaret değişiyor: düzeltme nedeni', other: 'Kayıtlı {count} işaret değişiyor: düzeltme nedeni' },
  'edu.att.history': { one: '{count} düzeltme', other: '{count} düzeltme' },
  'edu.att.child': 'Son 30 günün yoklaması',
  'edu.att.allPresent': 'Son 30 günde devamsızlık ya da gecikme yok.',
  'edu.att.periodN': '{n}. ders',
  'edu.att.corrected': 'düzeltildi',
  'edu.att.notifyTitle': 'Yoklama bildirimleri',
  'edu.att.notifyBody': 'Velilere hangi durumda bildirim gitsin? Her işaret için en fazla bir bildirim gider; metin çocuğun adını kilit ekranında göstermez.',
  'edu.att.notify.off': 'Bildirim gönderme',
  'edu.att.notify.absent': 'Yalnız devamsızlıkta',
  'edu.att.notify.absent_late': 'Devamsızlık ve gecikmede',
  'edu.meet.title': 'Görüşmeler',
  'edu.meet.desc': 'Öğretmen ve okul ile görüşme talepleri, uygun saatler ve görüşme notları.',
  'edu.meet.book': 'Görüşme iste',
  'edu.meet.topicField': 'Konu (isteğe bağlı)',
  'edu.meet.request': 'Bu saati iste',
  'edu.meet.noFree': 'Şu an boş görüşme saati yok. Öğretmen yeni saat açınca burada görünür.',
  'edu.meet.mine': 'Görüşmelerim',
  'edu.meet.none': 'Henüz görüşme yok.',
  'edu.meet.upcoming': 'Yaklaşan görüşmeler',
  'edu.meet.withGuardian': '{guardian} ({child} için)',
  'edu.meet.withHost': '{host} ile ({child} için)',
  'edu.meet.topic': 'Konu: {topic}',
  'edu.meet.mode.in_person': 'Yüz yüze',
  'edu.meet.mode.online': 'Çevrim içi',
  'edu.meet.modeField': 'Görüşme şekli',
  'edu.meet.status.requested': 'Onay bekliyor',
  'edu.meet.status.accepted': 'Kabul edildi',
  'edu.meet.status.declined': 'Reddedildi',
  'edu.meet.status.cancelled': 'İptal edildi',
  'edu.meet.note.requested': 'Yeni görüşme talebi',
  'edu.meet.note.accepted': 'Görüşme kabul edildi',
  'edu.meet.note.declined': 'Görüşme reddedildi',
  'edu.meet.note.cancelled': 'Görüşme iptal edildi',
  'edu.meet.note.reminder': 'Görüşme yaklaşıyor',
  'edu.meet.cancelReason': 'İptal nedeni: {reason}',
  'edu.meet.accept': 'Kabul et',
  'edu.meet.decline': 'Reddet',
  'edu.meet.cancel': 'İptal et',
  'edu.meet.cancelConfirm': 'Görüşmeyi iptal et',
  'edu.meet.move': 'Başka saate al',
  'edu.meet.moveHere': 'Bu saate al',
  'edu.meet.summary': 'Ortak özet',
  'edu.meet.privateNote': 'Özel not',
  'edu.meet.field.cancel': 'İptal nedeni (isteğe bağlı, karşı taraf görür)',
  'edu.meet.field.summary': 'Ortak özet',
  'edu.meet.field.note': 'Özel not',
  'edu.meet.summaryHint': 'Özeti görüşmenin iki tarafı da görür.',
  'edu.meet.privateHint': 'Özel not yalnız sende görünür; veli ve kurum yöneticileri görmez.',
  'edu.meet.slots': 'Görüşme saatlerim',
  'edu.meet.day': 'Gün',
  'edu.meet.start': 'İlk görüşme ({zone} saatiyle)',
  'edu.meet.minutes': 'Süre (dakika)',
  'edu.meet.count': 'Kaç görüşme',
  'edu.meet.place': 'Yer (isteğe bağlı)',
  'edu.meet.addSlots': 'Saatleri aç',
  'edu.meet.pickDay': 'Gün ve başlangıç saati seç.',
  'edu.meet.noSlots': 'Açık görüşme saatin yok.',
  'edu.meet.withdraw': 'Geri çek',
  'edu.cal.title': 'Takvim',
  'edu.cal.prev': 'Önceki hafta',
  'edu.cal.next': 'Sonraki hafta',
  'edu.cal.prevShort': 'Önceki',
  'edu.cal.nextShort': 'Sonraki',
  'edu.cal.thisWeek': 'Bu hafta',
  'edu.cal.empty': 'Bu gün için kayıt yok.',
  'edu.cal.kind.lesson': 'Ders',
  'edu.cal.kind.due': 'Ödev teslimi',
  'edu.cal.kind.meeting': 'Görüşme',
  'edu.notif.kind.attendance': 'Yoklama',
  'edu.notif.kind.meeting': 'Görüşme',
  'edu.push.attendance': '{org}: yoklama bilgisi var',
  'edu.push.meeting': '{org}: görüşmenle ilgili bir gelişme var',
  'adminEdu.support.title': 'Destek erişimlerim',
  'adminEdu.support.desc': 'Bir kurumun içini yalnızca kurum onaylarsa, seçtiğin süre boyunca ve salt okunur görebilirsin. Her okuma denetim kaydına yazılır; kurum kaç okuma yapıldığını görür.',
  'adminEdu.support.empty': 'Henüz bir destek erişimi istemedin.',
  'adminEdu.support.ask': 'Destek erişimi iste',
  'adminEdu.support.asked': 'İstek kuruma gönderildi',
  'adminEdu.support.askHint': '{name} yöneticilerine bildirim gider; onaylarlarsa erişim başlar. Değişiklik yapamazsın, yalnızca okursun.',
  'adminEdu.support.reason': 'Neden gerekiyor?',
  'adminEdu.support.reasonHelp': 'Kurum bu metni görür. Talep numarası ya da sorunu kısaca yaz (en az 10 karakter).',
  'adminEdu.support.hours': 'Süre',
  'adminEdu.support.hoursN': { one: '{count} saat', other: '{count} saat' },
  'adminEdu.support.send': 'İsteği gönder',
  'adminEdu.support.until': '{time} saatine kadar',
  'adminEdu.support.reads': { one: '{count} okuma', other: '{count} okuma' },
  'adminEdu.support.open': 'Kurumu aç (salt okunur)',
  'adminEdu.support.end': 'Erişimi bitir',
  'adminEdu.support.endTitle': 'Erişim şimdi bitirilsin mi?',
  'adminEdu.support.withdraw': 'İsteği geri çek',
  'adminEdu.support.withdrawTitle': 'İstek geri çekilsin mi?',
  'adminEdu.support.state.requested': 'Onay bekliyor',
  'adminEdu.support.state.active': 'Açık',
  'adminEdu.support.state.expired': 'Süresi doldu',
  'adminEdu.support.state.denied': 'Reddedildi',
  'adminEdu.support.state.revoked': 'Kurum geri aldı',
  'adminEdu.support.state.cancelled': 'Bitirildi',
  'edu.support.title': 'Destek erişimi',
  'edu.support.intro': 'DijitalApp destek ekibi, kurumunun içini yalnızca sen onaylarsan görebilir: seçilen süre boyunca, salt okunur ve hiçbir şeyi değiştiremeden. Her okuma kayıt altına alınır; erişimi istediğin an geri alabilirsin.',
  'edu.support.none': 'Destek ekibinden bir istek yok.',
  'edu.support.who': '{name} (DijitalApp destek)',
  'edu.support.approve': { one: '{count} saatliğine onayla', other: '{count} saatliğine onayla' },
  'edu.support.deny': 'Reddet',
  'edu.support.revoke': 'Erişimi geri al',
  'edu.support.viewing': 'Destek erişimiyle bakıyorsun: salt okunur, {time} saatinde biter. Gördüğün her sayfa kurumun denetim kaydına yazılır.',
  'edu.notif.kind.support': 'Destek isteği',
  'edu.push.support': '{org}: destek ekibi erişim istiyor',
  'edu.org.tab.import': 'İçe aktar',
  'edu.org.tab.reports': 'Raporlar',
  'edu.imp.title': 'Öğrenci listesini içe aktar',
  'edu.imp.body': 'Kurumun hazırladığı bir CSV dosyasından öğrenci kaydı oluşturur. Resmî sistemlere (e-Okul, MEBBİS) bağlanılmaz ve oradan veri çekilmez.',
  'edu.imp.template': 'Şablonu indir',
  'edu.imp.upload': 'CSV dosyası seç',
  'edu.imp.hint': 'En fazla 2000 satır ve 2 MB. Excel’in Türkçe CSV’si de okunur. T.C. kimlik numarası, sağlık ya da aile bilgisi sütunu ekleme.',
  'edu.imp.limit': 'Dosyadaki geçerli satırlar paketin öğrenci sınırını aşıyor; hiçbir kayıt oluşturulmadı. Satır sayısını azalt ya da paketini görüş.',
  'edu.imp.sameFile': 'Bu dosya daha önce içe aktarıldı. Satırları yeniden kontrol edildi: var olanlar yinelenen olarak gösteriliyor.',
  'edu.imp.summary': '{total} satır: {valid} geçerli, {errors} hatalı, {duplicates} yinelenen.',
  'edu.imp.applied': '{created} öğrenci kaydı oluşturuldu. Satırlardaki adlar içe aktarma kaydından silindi; özet saklanıyor.',
  'edu.imp.field.givenName': 'Ad sütunu',
  'edu.imp.field.familyName': 'Soyad sütunu',
  'edu.imp.field.studentNo': 'Okul no sütunu (isteğe bağlı)',
  'edu.imp.field.group': 'Sınıf sütunu (isteğe bağlı)',
  'edu.imp.none': 'Yok',
  'edu.imp.rows': 'Satır kontrolü',
  'edu.imp.line': 'Satır',
  'edu.imp.check': 'Kontrol',
  'edu.imp.status.ok': 'Uygun',
  'edu.imp.status.error': 'Hatalı',
  'edu.imp.status.duplicate': 'Yinelenen',
  'edu.imp.issue.givenName.required': 'ad boş',
  'edu.imp.issue.givenName.too_long': 'ad 60 karakteri aşıyor',
  'edu.imp.issue.familyName.required': 'soyad boş',
  'edu.imp.issue.familyName.too_long': 'soyad 60 karakteri aşıyor',
  'edu.imp.issue.studentNo.too_long': 'okul no 30 karakteri aşıyor',
  'edu.imp.issue.group.unknown': 'bu adla açık bir sınıf yok',
  'edu.imp.issue.studentNo.exists': 'bu okul numarası zaten kayıtlı',
  'edu.imp.issue.studentNo.inFile': 'aynı okul numarası {line}. satırda da var',
  'edu.imp.issue.name.exists': 'bu sınıfta aynı adla kayıt var',
  'edu.imp.issue.name.inFile': 'aynı ad ve sınıf {line}. satırda da var',
  'edu.imp.more': '{count} satır daha var; özet hepsini sayar.',
  'edu.imp.discard': 'Vazgeç',
  'edu.imp.apply': { one: '{count} kaydı oluştur', other: '{count} kaydı oluştur' },
  'edu.imp.history': 'İçe aktarma geçmişi',
  'edu.imp.noHistory': 'Henüz içe aktarma yok.',
  'edu.imp.state.preview': 'Önizleme',
  'edu.imp.state.applied': 'Uygulandı',
  'edu.imp.state.discarded': 'Vazgeçildi',
  'edu.imp.created': { one: '{count} kayıt', other: '{count} kayıt' },
  'edu.imp.open': 'Aç',
  'edu.rep.title': 'Temel rapor',
  'edu.rep.from': 'Başlangıç',
  'edu.rep.to': 'Bitiş',
  'edu.rep.source': 'Kaynak: DijitalApp Eğitim kayıtları · oluşturulma: {when} · {min} öğrenciden küçük sınıflarda oranlar gösterilmez.',
  'edu.rep.students': 'Öğrenci',
  'edu.rep.attendance': 'Devam',
  'edu.rep.homework': 'Ödev teslimi',
  'edu.rep.ack': 'Duyuru onayı',
  'edu.rep.missing': 'Eksik veri',
  'edu.rep.missing.attendance': 'yoklama yok',
  'edu.rep.missing.homework': 'ödev yok',
  'edu.rep.small': 'Küçük grup',
  'edu.rep.total': 'Kurum geneli',
  'edu.rep.noRanking': 'Rapor sınıfları sıralamaz ve kimseyi etiketlemez; oranlar yalnız kayıtlı veriyi gösterir, eksik veri ayrıca belirtilir.',
  'edu.rep.export': 'CSV olarak indir',
  'edu.rep.noExport': 'Dışa aktarma paketin gelişmiş raporlar hakkıyla açılır.',
  'adminEdu.advancedReports': 'Gelişmiş rapor',
  'adminEdu.reportMinGroup': 'Raporda en küçük grup',
  'adminEdu.reportMinGroupHelp': 'Bu sayıdan az öğrencisi olan sınıflarda oran gösterilmez (dolaylı tanınmayı önler).',
  // ---- end Eğitim modülü ----
} satisfies Record<string, Entry>;

export type MessageKey = keyof typeof tr;
